var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _g, _path14, _g2, _g3, _g4, _g5, _g6, _line, _polyline, _polyline2, _line2, _polyline3, _polyline4, _polyline5, _polyline6, _line3, _polyline7, _polyline8, _polyline9, _line4, _polyline0, _polyline1, _line5, _line6, _polyline10, _polyline11, _polyline12, _polyline13, _path15, _polyline14, _line7, _path16, _line8, _path17, _path18, _path19, _line9, _line0, _polyline15, _polyline16, _polyline17, _path20, _polyline18, _polyline19, _polyline20, _line1, _polyline21, _line10, _polyline22, _line11, _polyline23, _line12, _line13, _path21, _polyline24, _line14, _polyline25, _line15, _path22, _polyline26, _polyline27, _polyline28, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _polyline29, _line23, _line24, _line25, _path23, _line26, _polyline30, _line27, _polyline31, _line28, _polyline32, _polyline33, _polyline34, _line29, _path24, _polyline35, _line30, _polyline36, _line31, _polyline37, _line32, _polyline38, _line33, _polyline39, _line34, _polyline40, _polyline41, _polyline42, _polyline43, _line35, _line36, _polyline44, _line37, _polyline45, _line38, _polyline46, _line39, _polyline47, _line40, _polyline48, _line41, _line42, _line43, _polyline49, _polyline50, _polyline51, _polyline52, _line44, _polyline53, _polyline54, _line45, _polyline55, _polyline56, _line46, _polyline57, _polyline58, _line47, _line48, _polyline59, _polyline60, _polyline61, _line49, _polyline62, _line50, _line51, _polyline63, _line52, _path25, _polyline64, _line53, _polyline65, _line54, _line55, _polyline66, _polyline67, _line56, _polyline68, _path26, _line57, _line58, _line59, _line60, _line61, _line62, _line63, _polyline69, _line64, _polyline70, _polyline71, _line65, _polyline72, _polyline73, _polyline74, _line66, _line67, _polyline75, _line68, _polyline76, _polyline77, _polyline78, _polyline79, _path27, _line69, _polyline80, _polyline81, _polyline82, _polyline83, _polyline84, _line70, _line71, _polyline85, _line72, _polyline86, _polyline87, _path28, _polyline88, _line73, _polyline89, _line74, _polyline90, _line75, _line76, _polyline91, _polyline92, _line77, _polyline93, _line78, _polyline94, _polyline95, _line79, _polyline96, _polyline97, _path29, _polyline98, _polyline99, _line80, _polyline100, _path30, _path31, _path32, _line81, _path33, _polyline101, _line82, _polyline102, _line83, _polyline103, _polyline104, _line84, _polyline105, _polyline106, _polyline107, _polyline108, _line85, _polyline109, _polyline110, _line86, _polyline111, _polyline112, _polyline113, _polyline114, _polyline115, _polyline116, _polyline117, _line87, _polyline118, _line88, _line89, _polyline119, _line90, _line91, _polyline120, _polyline121, _polyline122, _polyline123, _path34, _path35, _polyline124, _line92, _polyline125, _line93, _polyline126, _line94, _polyline127, _path36, _line95, _polyline128, _path37, _line96, _line97, _polyline129, _polyline130, _path38, _path39, _polyline131, _polyline132, _polyline133, _line98, _polyline134, _line99, _polyline135, _line100, _polyline136, _line101, _line102, _line103, _line104, _line105, _line106, _polyline137, _path40, _polyline138, _line107, _polyline139, _polyline140, _polyline141, _line108, _line109, _polyline142, _line110, _path41, _polyline143, _polyline144, _line111, _line112, _line113, _line114, _line115, _line116, _polyline145, _polyline146, _polyline147, _line117, _line118, _polyline148, _line119, _polyline149, _line120, _line121, _polyline150, _polyline151, _line122, _polyline152, _line123, _polyline153, _line124, _line125, _line126, _polyline154, _line127, _path42, _polyline155, _polyline156, _line128, _path43, _polyline157, _line129, _line130, _polyline158, _polyline159, _polyline160, _polyline161, _polyline162, _polyline163, _polyline164, _path44, _polyline165, _line131, _polyline166, _path45, _polyline167, _line132, _line133, _polyline168, _line134, _line135, _polyline169, _line136, _polyline170, _polyline171, _line137, _polyline172, _polyline173, _line138, _path46, _line139, _line140, _polyline174, _polyline175, _line141, _path47, _polyline176, _path48, _line142, _line143, _line144, _line145, _line146, _line147, _line148, _line149, _polyline177, _polyline178, _path49, _path50, _line150, _line151, _line152, _line153, _line154, _line155, _line156, _polyline179, _polyline180, _path51, _polyline181, _polyline182, _line157, _polyline183, _line158, _polyline184, _polyline185, _polyline186, _line159, _polyline187, _polyline188, _polyline189, _polyline190, _polyline191, _polyline192, _line160, _polyline193, _line161, _polyline194, _line162, _polyline195, _path52, _polyline196, _line163, _line164, _line165, _line166, _polyline197, _polyline198, _path53, _polyline199, _polyline200, _polyline201, _polyline202, _polyline203, _polyline204, _line167, _polyline205, _polyline206, _polyline207, _line168, _polyline208, _line169, _polyline209, _polyline210, _polyline211, _line170, _polyline212, _polyline213, _polyline214, _line171, _polyline215, _polyline216, _line172, _polyline217, _polyline218, _polyline219, _polyline220, _line173, _polyline221, _polyline222, _line174, _polyline223, _path54, _polyline224, _line175, _polyline225, _polyline226, _polyline227, _line176, _polyline228, _polyline229, _line177, _polyline230, _polyline231, _polyline232, _line178, _polyline233, _line179, _polyline234, _polyline235, _path55, _polyline236, _line180, _polyline237, _line181, _polyline238, _line182, _line183, _polyline239, _polyline240, _path56, _path57, _line184, _polyline241, _line185, _polyline242, _polyline243, _line186, _polyline244, _polyline245, _polyline246, _path58, _line187, _line188, _polyline247, _line189, _line190, _line191, _polyline248, _line192, _line193, _polyline249, _polyline250, _line194, _line195, _line196, _line197, _polyline251, _line198, _line199, _line200, _line201, _line202, _line203, _line204, _path59, _polyline252, _line205, _line206, _polyline253, _line207, _polyline254, _polyline255, _line208, _line209, _line210, _line211, _polyline256, _line212, _line213, _line214, _polyline257, _polyline258, _polyline259, _line215, _line216, _line217, _line218, _line219, _polyline260, _polyline261, _polyline262, _line220, _line221, _line222, _line223, _line224, _line225, _line226, _line227, _line228, _line229, _line230, _line231, _line232, _line233, _line234, _line235, _line236, _line237, _line238, _line239, _line240, _line241, _line242, _line243, _line244, _line245, _line246, _line247, _line248, _line249, _line250, _line251, _polyline263, _line252, _line253, _line254, _line255, _polyline264, _polyline265, _polyline266, _polyline267, _line256, _line257, _line258, _line259, _path60, _polyline268, _polyline269, _line260, _line261, _line262, _line263, _line264, _line265, _line266, _line267, _line268, _line269, _line270, _line271, _path61, _line272, _polyline270, _line273, _line274, _polyline271, _line275, _line276, _line277, _line278, _polyline272, _line279, _line280, _line281, _line282, _line283, _path62, _line284, _line285, _line286, _path63, _polyline273, _line287, _line288, _line289, _line290, _line291, _line292, _line293, _line294, _line295, _line296, _line297, _polyline274, _polyline275, _line298, _line299, _line300, _line301, _line302, _line303, _path64, _line304, _line305, _line306, _line307, _polyline276, _line308, _line309, _polyline277, _line310, _line311, _line312, _line313, _line314, _line315, _line316, _line317, _path65, _line318, _line319, _line320, _line321, _line322, _line323, _line324, _line325, _line326, _line327, _line328, _line329, _line330, _line331, _polyline278, _polyline279, _polyline280, _line332, _line333, _polyline281, _line334, _line335, _line336, _polyline282, _line337, _line338, _polyline283, _polyline284, _polyline285, _polyline286, _polyline287, _path66, _line339, _polyline288, _path67, _polyline289, _line340, _line341, _line342, _line343, _polyline290, _line344, _line345, _line346, _line347, _polyline291, _line348, _line349, _line350, _path68, _polyline292, _line351, _polyline293, _polyline294, _line352, _path69, _polyline295, _line353, _polyline296, _line354, _line355, _path70, _line356, _line357, _polyline297, _line358, _path71, _line359, _line360, _line361, _polyline298, _line362, _line363, _polyline299, _line364, _line365, _line366, _line367, _line368, _line369, _polyline300, _line370, _line371, _line372, _line373, _line374, _path72, _line375, _path73, _line376, _line377, _line378, _polyline301, _polyline302, _line379, _line380, _line381, _line382, _line383, _polyline303, _line384, _line385, _line386, _line387, _line388, _line389, _line390, _line391, _line392, _line393, _line394, _line395, _line396, _polyline304, _polyline305, _path74, _path75, _path76, _line397, _line398, _line399, _line400, _line401, _line402, _line403, _line404, _line405, _line406, _line407, _line408, _line409, _line410, _line411, _line412, _line413, _line414, _line415, _line416, _line417, _line418, _line419, _line420, _line421, _line422, _line423, _line424, _line425, _line426, _line427, _line428, _line429, _line430, _line431, _line432, _line433, _line434, _line435, _line436, _line437, _line438, _line439, _line440, _line441, _line442, _line443, _line444, _line445, _line446, _line447, _line448, _line449, _line450, _line451, _line452, _line453, _line454, _line455, _line456, _line457, _line458, _line459, _line460, _line461, _line462, _line463, _line464, _line465, _line466, _line467, _line468, _line469, _line470, _line471, _line472, _line473, _line474, _line475, _line476, _line477, _line478, _line479, _line480, _line481, _line482, _line483, _line484, _line485, _line486, _line487, _line488, _line489, _line490, _line491, _line492, _line493, _line494, _line495, _line496, _line497, _line498, _line499, _line500, _line501, _line502, _line503, _line504, _line505, _line506, _line507, _line508, _line509, _line510, _line511, _line512, _line513, _line514, _line515, _line516, _line517, _line518, _line519, _line520, _line521, _line522, _line523, _path77, _path78, _polyline306, _polyline307, _line524, _line525, _line526, _line527, _line528, _line529, _line530, _line531, _line532, _line533, _line534, _line535, _line536, _line537, _line538, _line539, _line540, _line541, _line542, _line543, _line544, _line545, _path79, _line546, _line547, _line548, _polyline308, _line549, _polyline309, _path80, _path81, _path82, _path83, _line550, _path84, _line551, _line552, _line553, _line554, _line555, _line556, _line557, _line558, _line559, _line560, _line561, _line562, _polyline310, _path85, _path86, _path87, _polyline311, _polyline312, _path88, _polyline313, _line563, _line564, _line565, _line566, _line567, _line568, _line569, _line570, _line571, _line572, _line573, _line574, _line575, _line576, _line577, _line578, _line579, _line580, _line581, _line582, _line583, _line584, _line585, _line586, _line587, _line588, _line589, _line590, _line591, _line592, _line593, _line594, _line595, _line596, _line597, _line598, _line599, _line600, _line601, _line602, _line603, _line604, _line605, _line606, _line607, _line608, _line609, _line610, _line611, _line612, _line613, _line614, _line615, _line616, _line617, _line618, _line619, _line620, _line621, _polyline314, _polyline315, _path89, _path90, _path91, _path92, _polyline316, _line622, _line623, _line624, _line625, _line626, _line627, _line628, _line629, _line630, _line631, _line632, _line633, _g7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg005(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 365.4 1224",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #d7d7d7;\n      }\n\n      .st1 {\n        fill: #f6f6f6;\n      }\n\n      .st2 {\n        fill: #fff;\n      }\n\n      .st3 {\n        fill: #f0f0f0;\n      }\n\n      .st4 {\n        fill: #e9e9e9;\n      }\n\n      .st5 {\n        fill: #e5e5e5;\n      }\n\n      .st6 {\n        fill: #fbfbfb;\n      }\n\n      .st7 {\n        fill: #f9f9f9;\n      }\n\n      .st8 {\n        stroke: #000;\n        stroke-width: .25px;\n      }\n\n      .st8, .st9 {\n        fill: none;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .st10 {\n        fill: #d8d8d8;\n      }\n\n      .st11 {\n        fill: #f1f1f1;\n      }\n\n      .st12 {\n        fill: #efefef;\n      }\n\n      .st13 {\n        fill: #eee;\n      }\n\n      .st14 {\n        fill: #d6d6d6;\n      }\n\n      .st15 {\n        fill: #ebebeb;\n      }\n\n      .st16 {\n        fill: #f5f5f5;\n      }\n\n      .st17 {\n        fill: #dcdcdc;\n      }\n\n      .st18 {\n        fill: #ececec;\n      }\n\n      .st19 {\n        fill: #fefefe;\n      }\n\n      .st20 {\n        fill: #e7e7e7;\n      }\n\n      .st21 {\n        fill: #ededed;\n      }\n\n      .st22 {\n        fill: #fafafa;\n      }\n\n      .st23 {\n        fill: #eaeaea;\n      }\n\n      .st24 {\n        fill: #f8f8f8;\n      }\n\n      .st25 {\n        fill: #f7f7f7;\n      }\n\n      .st9 {\n        stroke: #767676;\n        stroke-width: .18px;\n      }\n\n      .st26 {\n        fill: #e8e8e8;\n      }\n\n      .st27 {\n        fill: #e6e6e6;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M192.3,390.63l1.11,2.25c.21.68-.52.83-2.19.45-.21.17-.38.3-.41.27-.36-.3-.27-3.37-.05-3.93.07-1.58,1.13-.02,1.54.96Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M224.23,255.62c-.02.4-.21.67-.59.84l-3.43,1.57c-.06-.31-.54-.62-.85-.53,1.42-1.06,3.27-1.32,4.87-1.89h0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M219.36,257.51c-1.24,1.11-3.15,1.78-4.78,1.98,1.28-1.04,3.2-1.52,4.78-1.98Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M205.1,262.89c-.52.87-1.51.55-2.3.76.72-.41,1.29-1.02,2.3-.76Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M202.8,263.65c-2.43,1.4-5.41,1.76-8.33,2.7l-1.86,3.39c-.25.03-.3-.15-.3-.28,0-.23.11-.71.24-.88,1.92-2.45,1.76-7.42-.42-8.61.26-.16.39-.28.46-.47,1.64,1.52,2.34,3.6,1.83,6.3l8.38-2.15h0Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M206.24,262.52c-.28.32-.72.5-1.14.37.26-.43.75-.24,1.14-.37Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M214.58,259.49c-.62.5-1.17.73-2.08,1.02l-6.26,2c.72-.84,2.03-.93,3.15-1.35,1.82-.68,3.38-1.48,5.19-1.68h0Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M169.67,1124.25c-.03.08,0,.26.07.39-.32.35-.75.55-1.28.59l-.02,85.83c.5.34.88.44,1.16.32l.06-84.87.76-.47c.22.46.67.67.76,1.26-.31.04-.44.23-.44.81v84.48c-1.27.31-2.4.16-3.39-.79v-87.42c-.66-.24-1.11-.17-1.57-.26,1.23-.33,2.7-.58,3.92.12h-.03Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M201.53,415.28l-.27,27.34c0,.12-.15.24-.29.22l-.04-28.69c-.95-.13-1.69-.13-2.64,0v26.96c0,.11-.21.25-.35.21l-.04-36.64c-.65-.51-1.31-.39-1.89-.54v-.53l2.19.51.11,9.09c.99.54,1.86.65,3.07.42-.54-1.06-.37-2.06-.6-3.21-.19-.9-.94-1.71-.46-2.83,1.17,2.41,1.22,4.85,1.19,7.69h.02Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M201.37,172.62l-.06,30.75c0,.11-.2.25-.34.22l-.03-32.42c-.95-.23-1.72-.31-2.65-.06v31.13c0,.11-.21.25-.35.22l-.03-39.52c0-.13.22-.24.3-.2l.11,7.52c.98.44,1.93.52,2.93.2-.12-1.12-.41-1.84-.16-2.84.72,1.59.28,3.19.27,5.01h.01Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M177.54,1140.12l-.02,70.96c.19-.13.31.03.38.48.25.11.24.24,0,.39-.32-.01-.65.09-1.14-.13v-72.89c.39.32.61.75.77,1.19h.01Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M200.49,630.29l.4-.39c.96,2.54.51,5.46.49,8.3l-.11,17.03c-.1.03-.32-.08-.31-.21v-18.98l-2.64-.48-.06,18.54c-.12.04-.34-.09-.34-.21l.04-28.94c.15,0,.27.08.34.21v9.9c1.07.33,1.96.57,2.92.3-.09-1.97-.18-3.58-.73-5.07Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M201.44,862.32l-.16,17.2c0,.13-.16.24-.29.21l-.05-19.65c-.9-.02-1.62.1-2.6-.36l-.05,18.29c0,.11-.2.25-.34.21v-27.64c.15,0,.28.07.35.21v8.44l2.94.51-.62-5.43c1.4,2.58.84,5.21.82,8h0Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M198.23,1078.55l.42-.4c.24.51.37,1.12.41,1.68l-.23.21-.6-1.5h0Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M177.93,1141.24l-.03,70.32c-.19.11-.76.11-.76-.44v-70.54c0-.36.24-.47.39-.47l.4,1.12h0Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M152.76,991.54l4.4,8.01c-.96,2.61-.52,6.1,1.82,7.56.75.47,1.86.38,2.34,1.05l-.04.43c-.75-.43-1.6-.88-2.67-.79l.03,72.15c-.34.05-.77-.26-.77-.74l.05-68.67c0-1.99.48-3.73-1.17-5.01v73.39c-.17.02-.36-.13-.36-.24l-.09-70.03-.23-8.97c-.02-.66-1.63-1-2.34-.85l-.02,75.67c-.84-.31-1.11-1.04-1.11-1.75l-.02-80.21c-1.03-.14-1.79-.1-2.26-.6-.13-.2,0-.32.4-.37.64,0,1.39.47,2.04-.05v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M171.43,1027.55c-.23-.12-.41.11-.31.32l-.77-.72-.03,61.61c-.15.02-.34-.13-.35-.23l-.05-65.81c-.04-.62-1.69-.86-2.62-.98v64.65c-.33.04-.74-.27-.74-.73v-60.75c0-1.41.86-2.67-.35-4.01l-.05,64.84c-.15.02-.36-.14-.36-.24v-69.26c-.87-.53-1.67-.69-2.64-.8v67.8c-.01.11-.21.26-.36.23v-66.88c0-1.11-.16-1.7-1.08-2.61.16-.33.4-.35.7-.08.76,1.08,2.14,1.31,3.56,1.67.32.93.26,1.92.18,2.86-.15,1.79.89,3.06,2.67,3.06,2.69,0,.35,3.56,2.6,6.06h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M149.94,991.59c.17.32,0,.47-.38.38l-.75-.72v77.33c-.9.23-1.64.24-2.31-.11l1.93-.26v-83.08c.18,0,.31.1.38.23l.06,4.3c.01.81.73,1.4,1.07,1.94h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M150.71,991.59l-.4.37c-.17.17-.38.28-.38.81v75.96c-.16.02-.36-.13-.37-.23v-76.53c0-.22.15-.38.38-.38h.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M162.42,1013.9c.06.19-.34.59-.7.08l-.09,68.33c-.13.06-.35-.06-.35-.19v-73.51l.04-.43c.92,1.27-.42,3.57,1.1,5.73h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M197.56,1079.5c.21.3.51,0,.21-.2.19.27.31.32.43.36l.11,9.74,2.76.25-.78-6.54c1.47,3.08,1.15,6.58,1.11,10.14l-.15,13.25c-.08.03-.29-.06-.29-.2l-.02-15.98c-.96-.3-1.69-.44-2.63-.45v14.92c0,.12-.21.25-.34.21l-.04-25.15-.35-.35h-.02Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M198.66,1078.15c.09.52.06.67-.42.4l-2.75-6.06-.2.19-.04,30.82c-.13.04-.35-.1-.35-.21v-30.35c-.55-.13-.96-.13-1.51,0l-.04,29.81c-.13.04-.34-.1-.34-.21l-.04-34.5c-.18-.52-1.35-.58-1.74-.4-.53.24-.21,1.23-.21,1.86l.08,32.11h-.73l.04-31.35-.14-7.28c0-.3.06-.81.25-.85l.7-.15-2.4-4.75v43.09c0,.17-.49.57-.59.49-.11-.1-.15-.4-.15-.77l-.02-43.16-2.34-.43.09,3.24-.02,39.66c-.23-.04-.47-.04-.72,0v-38.91l-.11-10.23c-.71-.41-1.94-.63-2.55-.12l-.02,47.75c-.14.05-.35-.1-.35-.21v-54l-3.06-.63c.51.87.06,1.46.06,2.33l-.05,49.87c-.14.03-.35-.12-.35-.22v-58.26c-1.07-.47-1.91-.85-3.02-.88l-.02,57.1c-.15.03-.35-.13-.35-.23l-.02-57.28c-.14-.03-.35.12-.36.23l-.02,56.53c-.14.03-.36-.12-.36-.23v-62.81l-2.62-.87c-.61.96-.05,1.7-.05,2.71v58.93c-.24-.05-.49-.05-.73,0l.02-59.3c0-1.08.38-1.9,0-2.73-.6-.62-.39-.84.31-.32.9.46,1.87.84,2.88.71l.2-.22c-.28-.75-1.3-1.36-.97-2.53,3.09,4.23,5.57,8.58,7.71,13.43l15.11,34.27,2.3,4.95v-.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "185.54 1049.47 182.55 1049.24 182.55 1043.39 185.54 1049.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M188.51,1056.13c-.83.13-2.53.03-2.77-.59l.13-5.16,2.63,5.75h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M193.24,1067.08c-1.05.15-1.6.08-2.36-.19l.38-4.27,1.98,4.46h0Z"
  })))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M169.74,1124.64l.67,1.4-.06,86.22c-.99.11-1.82-.17-2.64-.83v-87.08c.81-.25,1.46,0,2.04.29h-.01Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M122.41,723.01l-8.28-5.87c-3.96-2.81,2.23-6.77,6.23-9.91l14.21-10.65,17.79-8.87-.1,72.88-12.73-20.15-6.94-8.94c-2.92-3.39-6.42-5.83-10.19-8.5h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M161.92,756.69c-.38.64-.3,1.24-.29,2.13-1.2.15-2.15-.09-3.36-.61v-73.02l6.44-2.86v74.9c-.88.28-1.55.14-2.8-.54h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M157.26,760.77c-1.37.4-2.42-.02-3.42-.61l-.02-73.06,3.43-1.32v75h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M167.54,754.23l-.03-73.15c.64-.89,1.95-1.26,3-1.63v75.53c-1.12.29-1.93.1-2.97-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M161.4,777.29c.18.34.66.65.56,1.2.18,1.78.48,3.51.92,5.2l.9.97c3.26.66,3.4,4.63,3.2,7.32.76.63-.3,1.01-.74.08l-.1,67.63c-.13.05-.34-.09-.34-.2l-.02-72.85-2.63-.61-.02,71.42c-.15.02-.36-.13-.36-.24v-70.41c0-1.12-.31-1.94-1.13-2.35v71.63c-.02.1-.21.25-.36.23l-.09-77.36c-.36-.87-2.17-1.41-2.61-1.02-.46.91.03,1.9.03,2.83v73.18c-.33.04-.77-.25-.77-.74l.06-72.81c0-1.85.61-3.22-1.12-4.97.26-.08.52.04.77.35.58,1.5,2.37,2.24,3.83,1.53h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M131.06,773.53c.72-.76.89-1.8.89-3.07l-.02-37.03c1.27,1.14,3.84,2.29,3.87,4.24l.09,5.26-.05,28.04c-1.51.02-2.44-.27-3.59-.54l-.14,3.01c-.24.18-.87.15-1.05.11v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M153.74,848.99c-.96-.03-1.18-1.06-1.18-2.22l.08-83.89.98,5.78.12,80.33h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M170.33,793.55c-.11.33-.23.32-.37,0l-2.61-.79c-.46,1.14-.03,1.94-.03,3.13v64.59c-.25-.05-.5-.05-.74,0v-64.23c-.01-1.52.64-2.69-.33-4.17.38.48.72.15.74-.08,1.02-.75,3.15.27,3.34,1.55h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M177.54,686.96c-.09.56-.21,1.8.36,1.14.61.43.57,1.28.82,1.87-.2,0-.45.1-.45.48v63.7c-.55.17-.96.17-1.51,0v-68.31h.37l.4,1.13h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M157.57,775.77c-.11.04-.47.19-.77-.35l-.07,78.01-.41.48.06-84.57c.16,0,.29.07.36.22l.09,4.29.74,1.93h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M148.96,762.43l-.15-2.16c.81.72,1.12,1.7,1.12,3.11v79.72c-.15.02-.35-.13-.37-.23v-79.12c0-.82-.44-1-.61-1.31h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M171.19,799.27c-.02.2-.18.33-.36.4,0-.16-.18-.48-.49-.37v63.22c-.02.1-.21.25-.36.23l-.02-69.2h.37c.54,1.55.93,3.18,1.18,4.9l-.33.82h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M131.92,733.43l.76,1.35.02,35.42-.6.26c.18,1.6-.17,2.62-1.04,3.07l.1,1.84,5.35-3.58c.92-.61,1.34-.86,1.41-1.87s-.59-1.31-1.54-1.79l.03-29.44,1.73,2.37c.52.72,1.54.76,1.99,1.46.38,7.75.47,15.54.26,23.38-.11-6.49,0-12.89.32-19.21,1.23,3.47,4.46,1.68,4.53,4.12l.11,3.88,3.18,1.03c.5,1.56.19,3.08.29,4.54.62,1.01.67,1.73.15,2.16l-.2,81.58c-1.32.21-2.34-.26-3.34-.58-.1.65-.2,1.42-.32,2.29-.94-.09-2.28-.1-3.08-.85l-.03-59.21c-.54.23-1.47.6-1.73,1.2l-.04,47.38c-.81.23-2.37-.22-2.37-1.04l-.04-44.66-6.74,5.09-.04,27.77c0,.39-.73.64-.91.52s-.54-.36-.54-.83v-26.43l-5.98,2.54-.16,9.58c-.01.81-1.4,1.34-2.25,1.09l-.06-9.41-2.11.84.95-6.69-3.85-.98c-.32,1.43-1.47,2.03-2.82,1.85l-.08-7.49c-.07,0-.21.04-.29.2l-.12,4.86c-1.29.18-2.39.31-3.52.14l.02-74.09,4.55,3.37c6.4,3.97,12.57,8.02,18.08,12.97h-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M145.41,843.43c0,.77.25,1.77-.32,2.29l-.05-80.94c.15-.02.34.13.36.24v78.41h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M140.7,746.7l-.18,19.55c1.18.38,1.75.88,1.51,2.15-.12.64-1.07,1.36-1.79,1.06l-.04-22.68-.08-4.26c.17.27.36.46.4,1.12l.18,3.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M123.52,778.56l1.87-.12.03-2.77,3.17.29.51-3.14c.87,1.3.52,2.42.48,3.75l-5.96,4.68c-.24-1.01-.15-1.58-.1-2.69h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M116.13,787.31c-.47-1.57-.17-2.57-.18-3.99,1.1.2,1.89.4,3,.32l.02-2.85c.77,0,1.64.05,1.97.36s.43,1.78.07,2.08l-4.89,4.08h.01Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M177.9,688.1l-.02,65.79c-.24-.05-.49-.05-.72,0l-.02-66.47c0-.35.25-.47.4-.46.13.36.36.73.36,1.14h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M185.32,821.55c-.1-.71.06-.59.5-.04l5.41,11.22,7.25,16.09c-.26.09-.39.28-.41.3l-2.34-4.4c-.42,1.5-.49,2.64-.41,4l.55.91-.57.69-.06,26.77c-.12.04-.33-.1-.33-.21l-.02-32.71c0-.59-1.45-.55-1.46.07l-.08,31.72c-.12.04-.35-.1-.35-.22l.05-36.46c.21,0,.3-.1.34-.19-.39-1.53-1.05-2.7-2.21-4.62l-.09,40.34-.7.02-.03-40.84c-.41-.46-1.31-.43-1.63-.13-.37.35.05,1.21.05,1.68l.05,38.54c-.24-.04-.48-.04-.72,0v-36.27l-.11-8.67-2.17-.4c-.55,1.03-.01,1.92-.01,3.02v40.8c-.25-.04-.49-.04-.75,0l.1-41.92-.16-8c-.92.06-1.72.04-2.58-.32l-.03,48.74c-.14.03-.35-.12-.35-.23v-54.62c-.96-.59-.44-1.12.49-.44l.7,3.05c-.47,1.98.23,2.88,2.07,2.72h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M185.32,821.55c.12.11,0,.62-.16.6l-2.72-.3.11-6.08,2.77,5.78h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M188.29,828.69c-.88-.05-1.83-.03-2.75-.66l.38-4.78,2.56,5.22c.04.08.11.19.27.31.07.05-.57-.11-.08.55-.17-.48-.37-.61-.39-.64h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M190.64,833.08c-.44.13-1,.11-1.83.02-.41-1.1-.14-2.28.23-3.33.92,1,.95,1.86,1.6,3.3h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M164.35,780.18c-.2.08-.42.06-.78.25l8.57,14.38c4.34,7.29,8.08,14.6,11.64,22.3l2.04,4.42-.5.04c-.31.13-.58.08-.86-.05-.57-.25-1.85-4.71-1.91-5.72-.33.03-.49.2-.49.44l-3.02-.73-.02,54.06c-.14.03-.35-.13-.36-.23v-60.51l-3-.9-.05,59c-.14.02-.34-.13-.35-.23l-.02-59c-.24.02-.37.22-.37.42v58.44c-.16.02-.35-.13-.37-.23v-65.31l-2.64-.63c-.55,1.08-.02,1.91-.02,3.07v60.44c-.25-.05-.5-.05-.74,0l.04-61.56c0-1.11.31-1.88-.31-2.64-.42-.49-.23-.66.36-.4.86-.42,2.67.15,3.11,1.08l.27-.24c-2.18-.78-3.56-4.58-4.2-6.86-2.29-1.64-3.42-4.4-4.26-7.02-1.53-1.54-2.77-3.38-3.7-5.53l.4-.83,1.53.31v-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M162.81,779.87l3.24,5.88,8.52,14.36c-.1.11-.02.25.12.24l.19.19c.06.06.13.12.17.2l3.59,7.02c-.73.21-2.98.11-3.4-.87-.83-1.91-.16-4.12-.37-5.94-.04-.09-.11-.17-.19-.21-.08-.05-.15-.11-.18-.19-.04-.11-.14-.19-.21-.19-1.08-.05-2.36-.2-3.11-1.08-.38-.44-.82-1.2-.83-1.93l-.03-3.79c0-.98-2.36-.52-3.34-1.55-1.6-1.68-.2-4.65-1.15-5.81-.37-.45-1.25-.39-1.9-.61-2.45-.84-2.81-4.45-1.98-7.08.53.31.59.9.85,1.37h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M182.43,815.45c-1.21.09-2.14-.19-3.38-.48l.33-5.82,3.05,6.3h0Z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M174.48,574.72c.28.41.27.52-.03.35l-2.6-.73c-.49,1.1,0,1.9,0,3.08v61.95c-.25-.05-.49-.05-.74,0v-61.96c-.01-1.6.76-3.06-.75-4.36l-.02,64.96c-.01.1-.21.25-.35.23l-.07-69.08c-.46-.63-1.85-.99-2.63-.91l.04,67.61c-.35.04-.76-.26-.76-.73v-63.77c0-1.42.86-2.67-.35-4.01l-.05,67.86c-.15.02-.34-.14-.35-.25l-.02-71.35c-.92-.19-1.48-.26-1.88-.62-.47-.35-.34-.47.39-.35l1.29.43c1.22.41-.02,2.72,1.17,4.04s3.96.28,3.59,3.03c-.31,2.28,1.17,4.13,3.43,4.13.35,0,.63.26.69.44h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M186.13,594.39l-.31.35-3.68-7.66-2.73-4.76c-.37,1.15-.38,1.89-.38,3.05l-.03,59.31c-.14.03-.35-.12-.36-.23v-62.34c-1.1-.45-1.96-.69-3.02-.53l-.02,60.83c-.15.03-.35-.13-.36-.23l-.02-61.06c-.15-.03-.35.12-.36.23l-.02,60.31c-.15.03-.35-.12-.35-.23l-.07-66.34c-.5.17-.39-.53.03-.35.08-.03.16-.03.21-.01l.19-.22-5.68-8.16c2.25,2.27,4.3,4.64,5.91,7.41l7.05,12.18,3.97,8.47.03-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M155.26,550.03c.57.2.42.35-.45.46-.28-.14-.59-.37-1.1-.26v74c-.99-.33-1.14-1.2-1.14-2.33v-75.09c.01-.62-.21-.92-.38-1.18-.06-.22.09-.22.45,0,.68.99.21,2.33.46,3.5l2.16.91h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M157.21,555.5c-.09-.3.02-.4.33-.3.92,1.16,2.31,1.56,3.96,1.88l.21,4.91-.08,69.82c-.14.02-.34-.13-.34-.23l-.03-73.76c-.34-.69-2-.89-2.61-.91-.39,1.15-.02,1.93-.02,3.13v69.4c-.34.04-.76-.26-.76-.74l.05-69.05c0-1.7.65-3.04-.7-4.15h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M157.15,550.63c-.7,1.48-.61,3.3.39,4.58-.05.12-.19.22-.33.3,0-.16-.16-.48-.46-.35l-.02,74.03c-.15.02-.36-.13-.36-.24l-.03-77.88c0-.48-1.48-.63-1.53-.57l.45-.46c.38.04.81,0,1.13-.34l.75.94h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M164.3,562.65l-.39.35c-.14-.09-.75-.05-.75.42l-.02,69.52c-.15.02-.35-.13-.36-.23l-.03-69.92c0-.32-.99-1.02-.69-1.28.8.56,1.41.86,2.24,1.13h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M183.59,594.53c-.23.2-.51.29-1.15.42v51.76c0,.11-.22.26-.37.23l.02-58.29c.72,1.56.24,3.05.3,4.6.08.55.18.99,1.2,1.28Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M200.89,629.9c.06.5.06.66-.4.39l-4.43-12.16-2.57-5.3-.14,39.01c-.13.03-.33-.11-.33-.22l-.03-38.96c-.35-.52-1.34-.55-1.72-.42-.64.21-.23,1.21-.22,1.82l.07,36.65h-.73v-34.39c0-3.29.39-6.36-.22-9.37-.86-.27-1.62.03-1.56.45l.19,1.37.04,40.8c-.24-.04-.48-.04-.73,0v-38.91l-.09-8.66-2.29-.24.09,3.24v42.25c.01.64-.14,1.03-.76,1.11l.03-43.37-.08-8.39c0-.84.36-1.42.81-1.86-.15-.35-.07-.46.31-.35l9.38,21.26,5.37,14.25h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M188.28,601.53c-.81-.08-1.82-.1-2.69-.68l.37-5.43,2.54,5.93c.03.08.09.15.17.19l.19.56.18.21,1.59,4.06c-.76.05-1.17.01-1.43-.1-.4-.17-.65-.71-.59-1.3l.25-2.48-.19-.19-.19-.57-.2-.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M193.03,611.47c-.17.52-1.84.49-1.99-.07-.31-1.16-.12-2.25.19-3.61l1.8,3.68Z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M155.59,336.32c-.18-1.05.39-1.05.79-.11-.21.7,3.1,3.69.51,1.9-.18,1.2-.42,2.57.48,3.66,1.61,1.95,3.08,1.32,3.93,1.98.02.28,0,.41-.07.4l-2.58-.75c-.47,1.12-.02,1.89-.02,3.09v71.67c-.33.05-.77-.25-.76-.74l.08-71.68c0-1.67.58-3.13-1.2-3.88v75.86c0,.15-.71.21-.91.15-.59-.19.53-.69.53-.96v-78.54l-2.63-.53-.02,76.39c-.84-.32-1.11-1.06-1.11-1.75l-.02-78.66-2.64-.51v75.14c-.15.02-.36-.13-.37-.24v-56.79c0-.37-.24-.48-.47-.37.44-.55.49-1.2.49-1.96l-.02-14.26c-1.06-.8-.89-1.82-.78-2.93,1.12.78,2.44,1.26,4.01,1.49l.47,3.26c.64.88,2.09.96,3.11,1.05-.38-.51-.6-.9-.78-1.38h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M185.58,376.83c-.05.13-.15.33-.16.49-.27.11-.68.24-.82.06-1.07-1.25-1.79-3.75-2.23-5.33-.1-.31-.3-.26-.17.09l-.15.38-3.02-.73v60.62c-.01.1-.21.26-.36.23l-.02-66.77c-1.12-.31-1.95-.57-3.02-.51v65.53c0,.1-.22.26-.36.23l-.02-65.98c0-.1-.21-.26-.36-.23l-.02,65.22c0,.1-.22.26-.37.24l.02-70.71.66,4.62c1.05.63,2.29.68,3.72.99l-4.76-7.96c3.5,3.75,5.74,8.27,8.04,12.81l3.4,6.73v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M166.65,352.23c.79.65.59.8-.36.53l-.1,70.95c-.01.1-.21.26-.36.23l-.02-74.42c-.86-.52-1.67-.69-2.64-.79l-.02,72.94c-.15.02-.36-.13-.36-.24v-71.93c.01-1.02-.28-1.62-1.13-1.9l-.02,72.93c-.15.02-.34-.13-.35-.24l-.06-76.15c-.54.08-.28-.57.07-.4.55.43.35,1.17.34,1.94-.02,2.88,3.8,2.65,4.38,3.38.48.61-.3,2.14.63,3.15v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M169.41,353.84c-.06-.27.11-.37.54-.31.94.32-.57,2.96,1.91,4.76l-.02,69.8c-.24-.05-.49-.05-.73,0v-68.75c-.01-.86.02-1.34-.77-1.53l-.02,69.15c-.15.02-.36-.13-.36-.24v-71.56c0-.8-.08-1.05-.55-1.33h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M193.41,392.88c-.67-.51-1.11-1.4-1.11-2.25.7.39,1.43,1.65,1.11,2.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M192.3,390.63c-.47-.19-.69-.43-1.02-1.25-.34,1.01-.43,1.92-.58,3.29.5.42,2.12.84,2.71.21.65.5,1.24,1.22,1.08,2.43l-1-1.44c-.18,1.44-.2,2.3-.01,3.58.26-.11,1.76.07,1.76.49l.04,42.04c0,.11-.22.26-.36.22l-.03-41.9c-.54-.15-.96-.15-1.5,0l-.03,41.14c-.14.03-.35-.12-.35-.22v-45.4c-.83-.25-1.47-.3-2.27-.06l-.02,44.55c-.14.03-.35-.12-.36-.22v-48.53c0-.48-.18-.67-.39-.77l.39-.4c-.22-.65-.25-.72.38-.38l.38-.37c.5.97,1.17,1.89,1.18,3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M169.95,353.54l-.54.31c-.64-.11-1.35-.26-2.05-.65-.45,1.16-.05,1.92-.05,3.13v68.27c-.34.04-.76-.26-.76-.74l.04-67.91c0-1.29.71-2.33-.31-3.19l.36-.53c.87.96,2.15.92,3.3,1.31h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M185.43,377.32c-.01.24,0,.51-.12.69l-2.73-.4-.38-5.47c-.94-.57-1.95-.66-3.15-.81-.04-1.76-.16-3.39.34-5.19l6.03,11.19h.01Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M185.43,377.32c-.1-.25-.12-.4.16-.49,1.03,2.03,2.27,4,2.9,6.18-.06.06-.27.15-.41-.1l-2.11-3.99-.35,4.68,2.66.6.22-.17c-.09-.32-.14-.73.29-.99l2.35,4.59c.24.63.22.73-.38.37h-.19l-.19.19v.19c.46.58.25.79-.39.4-.1-.07-.86-.1-1.1.12l-.04,48.26c-.23-.04-.47-.04-.71,0l-.05-52.71-2.23-.2c-.54.92-.02,1.68-.02,2.67v48.73c-.24-.04-.48-.04-.74,0l.06-49.09-.11-7.81-2.59-.53-.02,56.31c-.14.03-.35-.13-.36-.23v-61.78c-.26-.23-.21-.35.15-.38.75,1.39,1.14,3,1.16,4.83,1.04.31,1.73.43,2.06.36h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M190.74,388l-.38.38c.04-.07.04-.15,0-.19l-.2-.21c-.26.17-1.22.09-1.26-.28-.13-1.01-.12-1.76.09-2.77l1.39,2.87.18.19h.19,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st7",
    x: 188.53,
    y: 388.03,
    width: 0.27,
    height: 0.27,
    transform: "translate(-219.19 247.03) rotate(-44.99)"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M67.86,603.67l24.22,4.47-2.04,13.23,24.98,4.51-1.08,6.93-1.11,8.96-15.27-13.12-3.21-2.88c-3.26-2.93-7.15-4.89-11.5-5.88l-15.42-3.5c-.47-.24-.85-.54-1.13-.89v-5.67c-.29-.05-.53-.12-.57-.25-.13-.46-.08-6.05.21-6.14l1.94.24h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M68.97,830.04l22.66,4.11-1.32,8.32c-.65,1.44-1.33,3.69.05,4.74.23,2.15-.38,2.93-1.81,2.31l-12.72-3.78-8.43-2.25-.66-.46c-.15-2.22-.21-4.46-.17-6.7-.29-.02-.54-.07-.62-.22-.32-.56-.38-6.88,1.69-6.1l1.34.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M67.7,397.69l23.71,4.29c-.29,5.01-2.19,9.74-1.96,15.16-3.63-1.82-7.31-3.04-11.32-3.77l-11.68-2.12c-.22-2.31-.28-4.64-.19-6.99-.31-.08-.55-.17-.56-.27-.14-2.07-.06-4.57.29-6.59l1.71.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M68.97,830.04c-.78.05-1.44.29-1.8.67-.43.46-.55,1.05-.54,1.75l.18,9.85c0,.54.49.97.58,1.19-.34-.09-.76.04-.98-.42v-6.77l-11.51-1.32.04-26.72,20.09,3.78-8.85,4.28-.03,13.47c1.05-.3,1.85.06,2.82.24h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M67.86,603.67c-.51.04-.89-.02-1.41.12l.03,11.56c.64.27.93.65.94,1.04l-1.34-.19.03-6.41-11.24-.88.02-26.74,20.06,3.68-8.97,4.38-.06,12.9c.63.36,1.24.41,1.94.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M67.7,397.69c-.34.04-.73-.03-1.23.12l-.02,13.44c-.25-.21-.39-.49-.39-.91v-6.1l-11.2-.39v-26.79l20.16,3.73-9.04,4.43.04,12.13,1.69.33h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M115.25,864.46l26.9,4.87-1.84,12.05-.26,4.04-13.16-9.08-13.21-8.65c-.74-2.61-.22-3.68,1.57-3.22h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M116.81,639.56l25.27,4.57-1.14,8.07c-.61,1.4-.94,2.69-.71,4.24l-.14,2.21-.23.48c-.9-.08-1.84-.36-2.82-.86l-4.96-3.32-18.42-12.52c-.61-2.94-.05-3.84,1.69-2.69l1.45-.17h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M111.35,432.26c.1-.84.21-1.88.33-3.11l.84-.42c.03.55.02,1.12.19,1.35l29.66,5.25-.63,4.24c-.91,3.33-1.61,6.52-1.67,10.12l-24.13-14.39-4.59-3.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M88.55,849.53c.25.01.65.15.76.04.18-.16.84-3.79-.68-4.9,1.43-.67.95-1.97,1.68-2.2-.23,1.46-.56,2.82-.4,4.37l24.97,4.52c-.09,5.03-2.13,10.07-2.04,15.73l-17.56-13.2c-2.18-1.64-4.16-3.6-6.75-4.37h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M112.52,428.73c-.57,2.93-.08,4.08-1.18,3.53l-10.88-7.98c-3.51-2.57-6.82-5.09-10.66-6.99l.12-3.53,24.62,4.57-2.02,10.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M116.81,639.56c-.59.28-.97.51-1.75,1.01-.36-.4-.4-.97-1.22-1.31l-.18,3.16c-.83-.53-.17-1.83-.42-3.48l3.56.62h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M143.61,882.61c-.78.19-1.42.81-2.58.59l-.19,2.71c-.22-.14-.42-.42-.4-.86l.08-2.88c1.04-.12,2.09.25,3.1.44h-.01Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "140.1 658.64 140.11 660.3 137.04 658.25 140.1 658.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M140.24,656.43c-.11-.72-.38-1.23-.92-1.85.94-.76,1.05-1.67,1.63-2.38l-.71,4.24h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M141.98,450.85c-.75-.31-1.48-.8-1.53-1.46-.07-.89-.18-1.66.41-2.22-.58,2.71,1.46,2.29,1.12,3.67h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M115.25,864.46l-1.55.2-.02,3.02c-.7-1.08-.72-3.38.16-3.51.41-.06.95.21,1.4.29h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M163.16,225.47c-.43,0-.92.06-1.15-.34.42-.11.92-.05,1.15.34Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M163.61,661.3c.13.24.29.63.29,1.09v13.57c0,.24-.13.42-.3.43-6.78-3.83-13.05-8.4-19.43-13.11l-3.69-2.72.09-3.43,23.04,4.16h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M172.27,675.24l.05.78c-.19-.36-.67-.57-.48-1.15.19.08.33.21.43.37h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M302.56,700.62c.49.6.07.72-.61.78-36.57,3.99-73.1,8.78-109.6,14.36l-3.53.98-.32-.33-3.81-11.02c.03-.22.06-.4.15-.42,1.2-.36,2.57-.62,3.82-.76l19.81-.14c24.94-1.36,49.9-2.62,74.89-3.76.03-.29.13-.74.33-.76,4.89-.45,13.4-.19,18.35.3l.53.77h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M305.28,701.63c.59-.91,1.69-.89,3.32.06,1.29.51,6.69,4.03,6.28,5.22-.17.47-3.38.26-4.03.09-2.35.04-4.92.14-7.36-.6-4.4-1.34-8.72-1.72-13.29-1.94-2.09-.1-3.95.23-5.87.64-.86.56-1.82.92-2.87,1.07l-1.93.21c-5.84,1.39-11.64,2.56-17.42,3.49-.5.57-2.41.95-3.39.76,0,.15-.02.27-.06.28-6.29,1.53-12.88,3.14-19.16,4.12v.28l-14.29,2.99c-7.93,2.15-15.91,3.9-23.95,5.23-3,.37-6.04.84-9.13,1.4l-.65-.55-2.64-7.23c-.04-.22-.06-.39-.02-.41.93-.38,2.37-.73,3.39-.96,36.78-5.53,73.57-10.41,110.4-14.61l2.67.46h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M257.61,696.79c2.83-.22,5.71-.3,8.66-.24.2-.8.48-.52.79.26.48,0,1.01-.04,1.47.08.1-.28.29-.68.51-.66,1.94.21,8.29,1.69,10.07,2.39l.36.86,1.18.33c.15-.32.28-.3.4.04l.13.42c-24.21,1.29-48.45,2.55-72.72,3.8l-19.63.14-4.2.81-.29-.33-3.47-9.72-.08-.53c5.43-.11,10.86.19,16.27.91l57.36,1.06c1.12-.02,2.19.11,3.19.39h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M180.53,755.37c.52,0,.73.42.64,1.26l.16,20.91c.16.19.01.63-.43,1.32-.81,1.09-2.62,1.35-4.19,1.35l-12.37-.03c-.71.26-1.22.16-1.53-.31-.56.24-.84-.22-.85-1.37-.68.08-1.07-.66-.56-1.2l-7.55-13.9,16.17-7.16c3.35-1.48,7.08-1.13,10.51-.86h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M251.51,692.22l.61-.71c.99-.14,13.95,3.44,14.35,4.07.25.39.24.71-.14.97s-7.8-.03-8.74-.1c-20.15-.4-40.39-.77-60.71-1.11-5.39-.77-10.77-1.06-16.14-.87l-.27-.3-1.77-4.21c-.42-.25-.7-.87-.82-1.87-.54-.05-.61-.7-.36-1.14-.57.3-.63-.66-.4-1.13l-.37-.4-.07-.71c24.67,2.46,49.53,4.85,74.58,7.17l.23.33h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M310.85,706.99l3.61-.06c-2.44-2.49-6.35-5.38-9.19-5.3l-2.58-.5-.14-.51-10.95-.32h-8.27c-1.05.16-1.81.01-2.29-.45l-.4-.04-1.18-.33-10.94-2.6.12-3.78,17.39-10.08-.81,13.74,22.41-13.17-.95,13.88,8.76-5.17.06,14.77c-1.58.45-3.31.49-4.66-.09h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M267.05,696.81l-9.44-.02c-.33-.07-.33-.18,0-.34l8.76-.16-11.21-3.51c-1.32-.41-2.45-.45-3.64-.56-.69-.29-1.06-.65-1.1-1.07-4.25-.59-8.48-1.7-12.7-3.31l-.81-.94c-.51-.28-.94-.57-1.28-.88-3.34-.83-6.63-1.82-9.87-2.98l-.24-.9.09-3.53,14.71-8.76-.92,13.82,14.95-8.68-.92,13.8,15.72-9.2-.74,10.62-.19,6.08c-.4.07-.77-.05-.97-.08-.25-.03-.3.42-.18.59h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M207.39,681.52c9.76,1.4,19.53,3.11,29.3,5.13l.21.27c1.97.36,3.78.96,5.86,1.66l7.65,2.58v.53c-24.58-2.02-49.5-4.34-73.82-7.35l-4.26-8.31c-.24-.38-.26-.64-.05-.78l.2-.48c11.67,2.22,23.31,4.48,34.92,6.76h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M193.73,674.29l-.53.69c-4.41-.9-8.86-1.28-13.36-1.14-2.49.55-4.92.68-7.28.39.17.8-.52.59-.81-.01-4.45.65-6.53,3.1-8.15,2.19l-.43-.55c0-4.62-.02-9.24-.09-13.86l.53-.68c.31.06.81-.05,1.18-.27l8.67-4.97-.9,13.74,22.23-13.06-1.04,14.34-.02,3.21v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M225.16,682.11l-1.44.07c-9.5-2.71-19.08-5.11-28.73-7.19l-1.25-.7c.75-1.24.28-2.51.44-3.92l17.4-10.14-1.23,17.09.33.22.23-3.68,15.43-9.03-1.16,17.29h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M193.73,674.29c10.7,1.59,21.13,4.51,31.43,7.82.11-.1.29-.04.35.04l10.11,3.88c-.05.17-.1.31-.12.3-9.23-1.55-18.72-3.27-27.72-5.21-11.48-1.82-22.95-3.82-34.43-6.02-.62-.11-1.16-.21-.79-.88,4.41-.78,8.91-1.75,13.56-1.06l7.62,1.13h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M187.69,743.27c.72.4,1.03,1.22.94,2.46.62.44.58,1.22-.11,2.34l-1.49,6.4-.37.16c-.17,2.76-.77,6.05-1.73,8.64.15.08.26.16.25.22-.66,4.53-1.54,9.43-2.78,13.84l-.34.35c-.18.28-.72.33-.72.16-.17-6.87-.19-13.88-.15-20.77-.12-.94-.05-1.88.21-2.81l-2.05-12.26,8.34,1.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M305.28,701.63l-5.31.15-14.05,1.83-34.11,4-24.82,3.17-34.72,5.22-3.43,1.14-.35-.74,3.36-.82,37.02-5.55,24.81-3.18,31.48-3.65,14.75-1.92c1-.13,2.07.04,2.64-.67.95.03,1.93.5,2.72,1.01h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M193.76,734.37c.97.43.97.74.01,1.1l-2.39,5.21c-.43,1.63-1.08,3.27-1.96,4.93.42.46.32.83-.3.81-.58-.03-1.04-2.65-.25-2.85l-1.96-13.56c2.37.13,4.68.58,6.62,1.8.46.6.23,1.9.23,2.57h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M283.34,700.31c-.59,0-1.41.51-2.3.31-1.7-.38-3.31.18-4.9.26l-6.8.35-7.93.4-6.81.39-6.24.25-7.6.35-8.24.41-8.67.39-6.99.28-4.21.33-7.16.42c-1.81.11-3.18.06-4.97.04l-11.28-.11c-1.63-.02-3.16.65-4.55,1.01l-.34-.71,3.79-.65,20.32-.17,4.59-.35,4.9-.3c1.43-.09,2.79-.25,4.18-.3l7.38-.25,8.67-.39,7.87-.41,7.22-.35,6.24-.26,7.18-.4,7.21-.34c1.87-.09,3.69-.69,5.67-.26.6.13,1.17-.29,1.48-.42.7-.09,1.58.29,2.29.46v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M250.41,691.15c.57.19,1.16.31,1.1,1.07l-32.05-3.01-21.14-2.21-4.17-.32-5.29-.41-12.15-1.55c.01-.14-.06-.29-.11-.39l3.05.13,9.95,1.3,3.77.36,5.29.4,18.54,1.93,28.67,2.76c1.63.16,3.22.65,4.54-.07h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M257.61,696.45v.34l-6.99-.19-17.79-.37-19.19-.4-18.23-.33-8.15-.88-5.6-.13c-.44-.01-.69.18-.78.46l-.38-.79,3.05-.28,3.83.29,9.55.96,22.75.33,19.95.39,14.94.24,3.05.35h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M182.06,777.68c.09-.25.21-.25.37-.02-.05.14-.37.44-.32.59.07.22.65.25.79.21-.15.15-.42.42-.63.33-.29-.11-.53-.27-.78-.73l-.57.78.03-21.6c0-.77-.09-1.39-.4-1.89.26,0,.55-.15.66-.32.17-.27.17-.59.21-.79l.36,23.3c0,.12.18.18.29.12v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M172.56,674.22c.13.21.46.49.86.57l8.29,1.57,26.07,4.75c.29.27.16.4-.39.4l-27.37-4.96-7.75-1.32c-.19.16-.34.04-.43-.37.05-.16-.05-.47-.1-.66h.81v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M284.33,705.09c-.53,1.02-1.93,1.31-2.9,1.54-.62-.21-.74-.21-.36.01-.32.34-.76.34-1.15.43l-.42-.17c-5.46,1.41-10.93,2.76-16.41,4.05l-.59-.65c-.43,0-.6,0-.4-.43l22.23-4.78h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M201.26,723.53c.72-.16.75.13.06.44l-.25.79s-2.96.27-8.87.82l-.72-1.2c1.81.23,3.5-.13,5.39-.67l4.39-.18h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M194.53,731.59c-.5-.35-.47-1.05-.32-1.61,1.24.19,1.35.91.32,1.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M281.43,706.63h-.36c-.15.01-.47.16-.77-.15-.09-.1.38-.38.53-.27l.6.42h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M194.15,733.83c-.11-.44-.07-.97.39-1.17,1.17.58.87,1.47-.39,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M279.92,707.07c-5.86,1.23-11.32,3.47-17.06,5.45l-10.92,3.75.45.29-.47.13-.24-.26-.88.18.49.36c-.53-.38-.34.37-.45.11-.19-.09-.24-.19-.29-.25-.12-.03-.5.02-.63.18-.09.12-.13.29-.2.66-3.53,1.06-6.63,2.58-9.62,4.37l-3.28,1.1.12-.87c.08-.51-.78-.75-1.01-.29-.27.53-.43.93-.89,1.14s-.69-.98-3.54.06c-.06-.32-.49-.38-.96-.21l-15.78,5.81c-6.82,2.51-13.63,4.77-20.57,5.73-.05-.38-.02-.57-.05-.69.43-.22.39-.73.39-1.17v-1.07c0-.64-.09-1.1-.32-1.61l-2.01-4.41c.01-.17,0-.48.08-.61.16-.27.76-.14,1.07-.17l7.97-.82c12.52-3.07,25.22-5.95,38.08-8.64l.5.17c0-.16.01-.28.05-.29,6.29-1.54,12.87-3.12,19.16-4.13.5-.57,2.41-.95,3.4-.77l17-3.67c.27-.06.47.21.42.44h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st27",
    points: "177.14 685.83 176.77 685.83 176.77 685.44 177.14 685.83"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M236.83,723.15l.13.29c1.76-.81,2.38-.76,1.86.17-3.93,4.23-5.9,9.61-9.73,13.85-2.55,2.82-4.53,5.96-5.96,9.46-1.6,3.92-4.24,6.43-7.59,8.76l-17.16,11.9-13.37,9.67c-.71.51-1.51,1-2.12,1.24-.98.46-2.08-1.02-.47-.8,1-4.41,1.9-8.82,2.69-13.21l.34-.76c-.33-.11-.33-.23,0-.38-.4-.03-.31-.52,0-.76l.36-.77c-.15-.06-.27-.12-.26-.16.29-2.03.74-4.43,1.41-6.25l.37-.78c-.16-.09-.29-.18-.28-.24.92-4.78,2.25-9.7,4.82-13.73.61-1.72,1.25-3.49,1.93-5.29,4.33-1.06,8.64-2.22,12.95-3.48,8.29-3.04,16.55-5.93,24.77-8.67.03-1.59,2.23-1.21,3.45-.96,1.04-2.47,4.14-.54,1.88.91h-.02Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M231.51,723.19l-20.78,7.57c-5.56,2.03-10.93,3.6-16.82,4.72-.43,1.99-1.31,3.51-2.04,5.14-.18.31-.3.36-.49.05l1.58-3.48c.43-.94.8-1.77.8-2.83.13-.16.41-.17.44.15l1.68-1.02,6.22-1.37c9.63-3.04,19.04-6.33,28.23-9.87,1.02-.14,1.62-.22,1.18.93h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M191.87,740.63l-1.87,4.18c-.13.3-.46.61-.41.94s.41.66.79.79c-1.09.46-1.57,1.14-1.79,2.17l-1.26,5.89c-.09.33-.21.34-.37.02-.05.33-.15.33-.31.02l.78-3.36c.96-2.63,1.36-5.52.25-8.01.43.06.81.19,1.18.29.11.78-.22,1.56.16,2.44l2.34-5.33.49-.05h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M240.11,722.04c-.15.8-.86,1.1-1.28,1.55-.07-.29-.41-.48-.77-.32l-5.9,2.7s-.07-.17-.23-.28l4.91-2.56c.07-1.18,2.52-2.1,3.28-1.1h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M217.19,733.26l-15.63,7.81c-.16.02-.43,0-.61-.2l15.62-7.85c.15-.07.52.03.62.25h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M185.45,763.31v.38l-.34.76-1.49,9.85c-.19,1.28-.65,2.38-1.2,3.36-.1-.01-.28-.03-.37.02.93-2.3,1.21-4.82,1.66-7.42l1.21-6.99c.17-.64.41-.65.53.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M200.95,741.19l-10.34,5.2-.33-.37,10.06-5.07c.15-.08.51.03.61.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M228.9,727.6l-9.59,4.77c-.15.05-.43,0-.59-.19l9.56-4.83c.15-.08.51.02.61.24h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M186.97,755.38l-1.15,6.41-.36.77v.76l-.53-.03,1.73-8.64.31-.02c.3.09.17.48,0,.76h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M185.11,764.45c.04-.29-.07-.65.34-.76,0,.31-.07.64-.34.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M185.45,762.55c0-.32.06-.64.36-.77-.06.31.01.64-.36.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M186.97,755.38v-.76l.37-.02c-.07.31,0,.65-.37.78Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M239.89,715.49l-14.61,3.04-16.02,3.94-7.94,1.49-.06-.44c2-.78,4.14-.68,6.34-1.23l15.1-3.73,16.8-3.55c.65-.04.79.12.4.47h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M258.71,710.63c.45,0,.62,0,.39.44l-19.21,4.42-.4-.47,19.22-4.4h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "262.1 709.87 262.5 710.3 259.1 711.07 258.71 710.63 262.1 709.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M280.65,699.81c-.43,0-.91.02-1.18-.33.35.08.99-.25,1.18.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M235.62,686.03c.54.1,1.2.06,1.28.88l-29.51-5.39.39-.4,11.71,2.03,16.13,2.88Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M133.86,957.81c-3.77-7.98-9.27-12.44-15.9-17.73-3.07-2.45-6.52-5.99-4.33-8.26l10.88-8.79c7.22-5.84,14.74-10.86,23.59-14.25l-.09,73.84-9.51-16.26-4.64-8.57v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M161.6,979.75c-1.21.03-2.27-.08-3.33-.72v-74.95l3.62-1.71v74.71l-.29,2.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M148.49,982.82c-.08-24.35.05-48.69.38-73.02.16-.28-.02-1.26.21-1.46.89-.59,2.04-1.06,3.24-1.35v76.94c-1.52.21-2.55-.29-3.83-1.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M153.84,981.15v-75.06l3.41-1.39v77.01c-1.2.17-2.05-.03-3.41-.55h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M143.61,882.61l20.41,3.8-.04,15.24-6.88-4.17c-5.82-3.52-11.27-7.26-16.27-11.58-.19-.99-.22-2.01-.07-3.07l2.84-.22h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M166.48,900.82l1.2-.39.76.27.02,73.68,1.13.53c.05-25.1.03-50.18-.07-75.22l1.63-.65c-.19.26-.42.55-.42,1.16v75.83c-1.25.2-2.34-.02-3.4-.79v-73.91c0-.55-.6-.56-.84-.5h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M148.49,982.82l-.08-71.3c0-.86.15-1.18.46-1.72l-.38,73.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M177.55,910.32c-.11,21.32-.07,42.55.12,63.7l.22.56c.17-.13.28,0,.33.4-.46-.03-.42.28-.54.35s-.53-.05-.91-.31l-.02-65.83c.11-.33.24-.33.4-.01l.39,1.13h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M178.67,912.61c-.11,0-.38.07-.38.46l-.06,61.92-.33-.4-.3-.07c-.09-21.05-.11-42.11-.07-63.18l.39-.26.75,1.54h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M136.33,965.47l-.18,1.54c-.05-.85.15-1.09.6-.73.41.77.46,2.1,1.42,2.75.56.38,1.92.38,1.95,1.46l.13,4.99.02,14.97c1.43-.13,1.75-.73,1.83-1.66.08-.99-.78-1.2-1.52-1.68l-.06-11.49c.13-.49.68-.14.47.29.62,1.17,1.26,1.9,2.5,2.11,2.88.48,1.19,3.67,1.79,5.03s.14,2.01.14,3.35v80.66c.01,1.18-.12,1.96-.43,3.15-.88.1-2.42-.03-2.97-.76l-.03-62.3-1.73.99-.04,49.8c-.8.13-2.36-.29-2.36-1l-.05-47.22-6.74,4.99-.04,29.67c0,.3-1.15.36-1.25.12-.07-.16-.2-.35-.2-.79v-28.06l-6.04,2.48-.11,10.49c0,.74-1.45,1.27-2.25,1.08l-.1-10.47-1.77.68c.37-2.29.84-4.33.71-6.57l-4.06-.97c.28,1.41-1.78,2.41-2.54,1.76l-.24-7.04s-.21-.01-.26.17l-.04,4.6c-1.32.2-2.45.4-3.61.09v-76.34c1.39,2.02,2.91,3.32,4.67,4.68l7.88,6.09,5.11,5.09,7.44,9.94c.96,1.29,1.27,2.77,1.95,4.04v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M136.75,966.28c-.28.03-.42.3-.42.74l.04,22.16c.78.15,1.31.43,1.42.8s.21,1.59-.15,1.84l-6.35,4.32c-.38-.35-.25-.82-.25-1.31s1.76-.33,1.1-3.63c1.36.38,2.37.71,3.69.58l.15-25.51c0-.42.11-.75.36-.81l.43.81h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M123.48,999.58c.66-.2,1.16-.18,1.92-.15l.02-2.94,3.37.38c.08-1.17-.35-2.1.39-3.32.68,1.29.41,2.42.43,3.8l-6.02,4.8-.12-2.58h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M116.03,1008.27l-.06-4.14c1.04.3,1.94.46,2.94.32l.18-2.57c.23-.35,1.44-.17,1.76.08.39.3.64,1.7.18,2.09l-5,4.22Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M177.92,911.07l-.02,63.51c-.19.11-.76.11-.76-.43v-63.37c0-.35.24-.47.41-.47l.37.75h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M303,922.88l-.04.43c-26.86,3.26-53.75,6.37-80.68,9.36-11.2,1.72-22.34,3.79-33.43,6.19l-.35-.21-3.82-10.62c.01-.22.03-.4.09-.41,1.95-.46,4.45-.92,6.44-1.13,19.89-.38,39.83-1.26,59.8-2.62,9.98-.05,19.91-.51,29.78-1.38l.24.39c.52-.12.81-.38.89-.78l14.5-.34c2.56-.32,4.76.06,6.58,1.12h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M178.64,976.17c1.16-.08,2,.14,2.54.66l.18,22.21c.16.15.02.6-.42,1.32-1.13,1.71-5.99,1.6-9.46,1.46l-13.33-.55-.99-1.71c-.23.1-.42.16-.53.09-1.21-.86-3.37-5.64-3.8-7.25-.51-.17-.5-.5-.07-.86l-2.82-5.5,16.95-7.73c3.79-1.73,7.74-2.6,11.75-2.14h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M305.62,923.95c1.56-1.38,4.71.69,6.23,1.83,1.92,1.44,5.17,4.36.87,3.45l-14.74-2.22c-5.98-.23-11.97-.54-17.68.75-1.67.85-3.41,1.25-5.05,1.31-15.54,3.75-31.08,6.93-46.75,9.8-12.24,3.34-23.85,6.29-36.48,7.32-.24.02-.44-.16-.57-.33l-2.65-6.79,1.82-.73s10.4-1.88,31.21-5.63c27.14-3,54.2-6.15,81.17-9.46l2.61.69h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M267.05,919.45c-.7.06-1.76.04-1.52-.76-3.68-.24-7.32-.99-10.9-2.26-1.52,0-2.57-.41-3.13-1.2-.83-.29-1.32-.65-1.46-1.08-3.48-.34-6.89-1.17-10.22-2.5l-4.76-.96-.36-.84c-.6-.76,1.23-.44,1.18-.37s-1.7.01-1.36-.57c-7.11-1.72-14.2-3.72-21.25-5.75-.92-.26-1.74-.8-2.52-1.34l.11-3.98,15.45-9-.89,13.4,14.88-8.68-.92,13.45,14.93-8.69-.9,13.48,15.76-9.2-1,14.54c-.08,1.18.11,1.91-1.13,2.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M267.57,919.54l.62-.13.77.37c.09-.28.27-.7.48-.68,1.92.2,9.31,1.49,10.81,2.13l.4.85c-.29.52-.91.77-1.88.74-24.74,1.08-49.48,2.21-74.22,3.39-6.73-.23-13.37.25-19.91,1.43l-.31-.34-3.46-9.35-.1-.54c28.94.63,57.87,1.34,86.79,2.12h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M312.72,929.23c.43-.02.92.2,1.77-.11-2.76-2.69-5.22-4.75-8.87-5.17-1.11-.21-1.98-.57-2.62-1.07-4.64-.58-9.22-.32-14.03-.2l-7.94.2c-.27-.2-.4-.47-.39-.8l-11.69-2.31-.39-.36-.02-3.47,17.49-10.26-.79,13.38,22.45-13.07-1.01,13.5,8.8-5.04-.09,14.79c-.16.7-2.35.57-2.66,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M251.5,915.24c1.31.12,2.5.22,3.95.63l10.08,2.83.22.55c-28.24-.51-56.5-1.1-84.8-1.77l-.44-.34-1.84-4.53c-.41.12-.66-.39-.75-1.54-.55.24-.64-.3-.37-.75-.58.3-.65-.67-.39-1.13-.21-.14-.35-.39-.41-.76l-.03-.33c23.68,2.09,47.54,4.3,71.58,6.63,1.29-.22,2.35-.05,3.19.51h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M276.03,929.65l-19.25,6.42-.44.48c-16.9,5.43-33.77,11.04-50.62,16.84l-11.22,2.73-.1-1.64c.25-1.51-.07-3.18-.83-4.63l-1.7-3.22.1-.41c12.24-1.02,24.22-3.93,36.27-7.27,16.25-3.1,32.28-6.39,48.07-9.86l-.29.57h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M175.61,899.55c.06-.14.12-.25.16-.25,6.48.76,13.3,1.99,19.52,3.4,6.5.76,13.94,2.04,20.35,3.65,5.89.64,12.18,1.88,18.14,3.06.64-.11.95.03.92.44l5.31,1.07,10.02,3.23c-.07.62-.68.81-1.83.56-23.9-2.2-47.69-4.47-71.36-6.8l-.22-.22-4.39-8.72c.24-.75.87-.93,1.87-.54.15.48.65.85,1.51,1.1v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M193.74,898.38l-1.44.5c-5.55-1.03-11.29-.97-16.87-.23-.02,0,.07.16.19.37.67.09.68.37-.01.53-1.13-.18-2.2-.61-3.37-.56l-1.1.04c-.61.98-.99,1.18-1.16.6l-.47.05c.3,1.08-1.25,1.65-1.83.74-.19.88-.31,1.25-.77.33l-.43.06c-.64.21-1.76,1.1-2.5.83l-.75-.97.03-13.82.76-.45,9.46-5.54-.93,13.49,22.18-13-.69,10.06-.3,6.95v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M210.35,901.75c-.02.18-.05.35-.13.49-.41.72-14.4-2.56-16.2-3.02l-.28-.83c.76-1.19.23-2.49.47-3.78l17.39-10.11-1.24,17.25h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M188.51,964.7c.83,1.54.87,2.87.13,3.98l-2.95,12.98.12,1.26c.14.25-.19.63-.28.84-1.06,4.32-1.95,8.75-2.68,13.3l-.89,2.42-.48-.22c-.32-7.98-.34-15.94-.06-23.89l-2.06-12.2,9.16,1.54h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M305.62,923.95l-3.06-.35-4.91.42-18.49,2.52-15.91,1.57-24.67,3.21-11.36,1.12c-7.17.71-14.14,1.39-21.1,3.48-5.99.6-11.69,1.53-17.3,3.16l-.31-.44c.85.07,1.69-.47,2.67-.65l15.38-2.85,15.69-2.75,13.85-1.31,25.64-3.32,19.29-1.94,15.15-2.15,3.74-.44c1.13-.13,2.15.14,3.07-.34.75-.12,1.93.68,2.62,1.07h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M193.66,956.53c-.03,1-3.62,10.07-4.13,10.28-.79.32-.88-1.9-.59-2.53l-2.06-12.8c2.46.09,4.61.69,6.71,1.75.25,1.11.32,2.27.07,3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M281.03,922.88c-1.17.03-2.39.48-3.78.3s-2.54.27-3.81.31l-8.83.26-11.88.28c-1.52.04-3.01.21-4.57.29l-6.01.31-6.44.35-6.42.38-6.81.4-5.88.24-10.19.37-15.19.33-6.56,1.32-.35-.72,6.08-1.02,14.13-.28,9.44-.37,6.63-.25,6.42-.4,6.42-.38,6.44-.35,5.63-.31c1.42-.08,2.8-.26,4.18-.3l10.4-.26,11.01-.32,3.13-.3c2.24-.21,4.46-.06,6.41-.7.36.07.84-.28,1.21.27-.53.16-.7.29-.83.52l.02.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M280.3,927.76c-.83.76-1.93,1.21-3.03,1.52-.51-.38-.64-.38-.39,0-.15.33-.53.43-.85.37.02-.29-.29-.52-.63-.44l-14.74,3.48-19.71,4.09c-8.48,1.76-16.83,2.93-25.1,5.5-5.47,1.69-10.62,2.77-16.35,3.31l-3.49.33-4.12.7-.42-.75,8-.79,9.63-1.36,19.36-5.14,23.22-4.35,28.64-6.46h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M265.53,918.7c.56.16,1.02.48,1.52.76.12.06.4.04.52.08-1.98.43-4.15.1-6.36.04l-13.26-.34-12.44-.37-26.05-.44-13.61-.34-5.27-.4-8.92-.21c-.44-.01-.71.2-.79.47l-.36-.81,11.93.16,4.92.42,24.55.38,18.51.38,11.3.37,13.07.25c.41,0,.72-.23.73-.39h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M250.04,914.16c.63.2,1.42.28,1.46,1.08l-40.32-3.76-16.69-1.57-4.89-.42-4.54-.36-3.76-.38-4.57-.64c-.01-.14-.05-.28-.1-.39l6.17.69,3.45.33,5.31.41,54.92,5.15c1.37.13,2.57.57,3.58-.13h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M185.53,983.75c-.11.25-.07.75-.06,1.04l-.39.76v1.13l-.38.76-.74,5.29c-.38,2.72-1.02,5.18-1.94,7.56-.1-.07-.35-.72-.54-.68s-.43.58-.54.75v-23.88c-.98.24-1.72-.24-2.3-.31.85-.14,1.73-.22,2.59.31l.18-1.12.37,23.83c.92-1.69,1.16-3.62,1.52-5.61l1.92-10.69c.38.32.27.68.31.86h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M277.27,929.29c-.11.03-.27,0-.39,0-.02,0-.41-.15-.36-.26.1-.2.41-.25.54-.17.18.11.23.26.2.43h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M268.95,919.77c-.29-.06-.63.01-.77-.37h.38c.19.01.34.2.39.37h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M177.17,909.19h-.4v-.76c.31.17.32.48.41.76h-.01Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M244.36,940.94l-4.17,2.42c-.75.27-1.1.72-1.43,1.44-2,2.02-3.49,4.43-5.29,6.78l-4.76,6.21c-2.05,2.68-4.3,5.07-5.86,8.09-1.92,3.74-4.83,6.39-8.09,8.95l-14.38,11.31-10.87,8.37-3.77,3.43c-1.11,1.01-2.38,2.11-3.73,2.34-.34-.43-.23-1.01.35-1.74.91-3.73,1.68-7.43,2.32-11.11l.39-.76c-.44,0-.27-.82,0-1.13l.39-.76c-.46-.16-.33-.81.06-1.04,0-.42.08-.7.28-.84-.18-.36-.17-.61.03-.77l.32-.77-.29-.13,3.33-14.67c.25,0,.45,0,.48-.09,1.36-3.26,2.78-6.55,4.19-9.8.04-.09.16-.14.3-.19,5.13-1.35,10.25-2.77,15.36-4.29,11.63-4.16,23.21-8.08,34.73-11.75l.11.49h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M256.79,936.06c.05.75-.64,1-1.33,1.22l-11.1,3.66c-.24-.27-.74-.24-1.19-.08l-24.14,8.36c-8.33,2.88-16.43,5.57-24.87,7.27l.25-2.02c.09.35.03.71.21,1.3,6.02-1.06,11.77-2.61,17.58-4.7l15.59-5.59,29-9.42h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M186.15,981.37l-.32.77-.03.77c-.25-.34-.47-.8-.32-1.43l2.12-9.3c.59-2.59,1.16-4.91.91-7.48.17.03.4-.04.43-.42.19.65-.08,1.3.46,2.11l1.59-3.64c.92-2.11,2.12-3.98,2.67-6.21.21-.09.4-.07.5-.03-.26,1-.67,2.25-1.16,3.34l-3.5,7.73c.63-.18.93-.77,1.7-.39l-2.26,1.52-2.79,12.68v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M240.2,943.36l-1.43,1.44c-.02-.35-.46-.58-.76-.43l-12.62,6.18c-.03-.1-.1-.23-.26-.33l11.18-5.63c1.29-.65,2.57-1.1,3.89-1.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M211.15,957.39l-11.86,5.91c-.15.04-.44,0-.59-.19l11.83-5.96c.15-.07.52.03.62.25h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M223.61,951.34l-11.1,5.53c-.15.04-.43,0-.59-.19l11.08-5.59c.15-.07.51.03.61.25h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M198.68,963.43l-7.32,3.68-.33-.35,7.04-3.56c.16-.08.5.01.61.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M185.07,985.55c0-.32.06-.64.39-.76.01.32-.07.63-.39.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M185.83,982.14c0-.32.06-.64.32-.77-.06.25.12.67-.32.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M184.69,987.44c.04-.31.03-.62.39-.76,0,.32-.06.64-.39.76Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M193.74,898.38l16.61,3.36.4.09c8.1,1.73,16.01,4.19,23.77,7.09l.21.49c-6.2-.88-12.8-1.91-18.69-3.52l-.39.2c-6.89-1.1-13.67-2.39-20.34-3.86-6.22-.82-13.06-1.79-19.47-2.92-.09-.02-.15-.14-.21-.3-.39-.05-1,.15-1.55-.4,6.37-1.82,13.18-1.55,19.67-.23h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M234.52,908.92c.49.18,1.08.11,1.61.55l-1.44.39-19.06-3.5c-.34-.31-.21-.47.39-.47l17.78,3.27c.42.08.73-.07.71-.24h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M216.04,905.89l-.39.47-20.35-3.65c-.64-.17-.65-.33.02-.47l20.73,3.66h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st27",
    points: "195.31 902.23 195.29 902.71 175.61 899.55 175.62 899.01 183.94 900.17 195.31 902.23"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M169.51,899.68c.19.02.45-.03.83.22v75.76c-.99.1-1.81-.18-2.65-.83l-.02-74.41,1.83-.74h.01Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M314.65,1158.91l-10.95,5.04-13.57,6.43-1.18.64c-5.06,1.1-10.1,2.12-15.12,3.03-3.18,1.04-7.11,1.9-10.58,2.22.02.14.04.24.03.25-11.06,2.68-22.21,5.3-33.35,7.83-.09.02-.2-.07-.31-.19l-27.73,7.75c-1.62.43-10.05,2.4-10.46,2.06-.33-.28-1.59-7.54-1.71-8.53l-1.31-7.11c2.74-1.2,5.53-2.47,8.39-3.8,1.72-.92,3.47-1.58,5.25-1.97,2.6-1.43,6.14-2.56,9.1-2.98.22-.34.53-.4.9-.45,6.58-.94,13.05-1.16,19.57-1.34,23.91-3.74,47.83-7.38,71.78-10.9.16-.54.71-.3,1.12.01l.69-.81c1.7-.01,8.7.91,9.61,1.88.18.2,0,.63-.14.94h-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M288.9,1171.48l-20.66,20.44-2.11,1.84-71.6,22.45-.44-.54c.56-7.23-.34-14.43-2.73-21.58l10.92-2.29c8.97-3.04,18.09-5.41,27.35-7.12,0-.15.01-.27.05-.28,11.14-2.81,22.69-5.52,33.93-7.71,3.13-1.09,7.1-1.88,10.58-2.26,4.76-1.37,9.7-2.53,14.84-3.5l-.14.55h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M302.56,1156.03c.49.12.91.35,1.24.69-24.05,3.67-48.06,7.36-72.03,11.06-6.99.11-13.88.54-20.67,1.29-2.99,1.29-6.28,2.28-9.43,3.14-1.51.86-3.14,1.64-4.88,2.32l-7.34,3.41c-.6.23-1.06.22-1.31-.41l-3.55-17.29c-.09-.85.12-.98.94-.99,20.8,0,41.55-.96,62.24-2.85l26.3-.99c2.55-.32,5.03-.46,7.43-.43.46-.93,1.39-1.26,2.78-1l17.88,1.27.4.79h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M182.84,1147.65l.21-.29c4.09.81,8.19,1.53,12.32,2.16,19.67-.1,39.28.29,58.85,1.18,3.86-.2,7.77-.26,11.74-.19.31-.86.8-.58,1.1.25.36,0,.77,0,1.11.08.07-.28.25-.7.44-.67,3.26.62,8.02,1.82,11.13,2.88,1.25.07,1.91.51,1.98,1.29l-.35.36c-11.15.89-22.32,1.45-33.52,1.68-20.54,2.19-41.22,2.54-61.9,2.84-1.01.35-1.57.3-1.68-.16l-.82-3.4.1-.79c-.67-2.04-1.34-4.41-2.02-7.09.35-.23.79-.27,1.32-.13h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M250.44,1145.4c.58-.1,1.06-.34,1.44-.73l.45.76c.37,0,.74.02,1.09.15.13-.27.38-.65.58-.59,1.46.45,11.81,3.93,12.11,4.5.19.37.22.71-.08,1.01-3.98.09-7.91.04-11.81-.13-19.43-.51-39.02-.79-58.77-.85l-13.66-2.38c-.62.13-1.05.06-1.31-.19l-1.8-4.16c-.41.12-.66-.4-.74-1.54-.58.31-.64-.64-.4-1.12-.38.07-.63-.33-.77-1.19,0-.18.06-.49-.02-.65-.09-.56.46-.75,1.66-.55,8.97,1.8,18.01,2.78,27.11,2.95,14.82,1.86,29.75,3.16,44.69,4.43l.23.28h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M314.65,1158.91c-.3-.54-.97-.68-1.72-.84-2.86-.6-5.67-1.5-8.43-1.18-.68-.21-1.32-.5-1.94-.87l-18.12-1.29c-.98-.07-2.22,0-2.94.23-.87-.07-.57-.42.22-.63l-13.55-3.5.05-3.6,17.78-10.41-1.22,14.6,22.78-13.42-1.17,11.19c-.26,2.52-.71,4.88-.25,7.22.45-1.31.14-2.46.24-3.79l9.06-5.21.07,10.1c0,.72-.39,1.18-.85,1.39h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M191.08,1131.23l.11-.24c14.6,2.87,29.17,5.46,43.72,7.78l.16.52c.91-.18,1.75-.3,2.53-.36l.35.82.62.1c.42.13.71.02.9-.46l11.48,4.41.24.9c.21.09.2.21,0,.36-.29.31-.79.28-.81-.18-.05.14-.1.25-.14.25-14.97-1.17-29.98-2.66-44.79-4.44-8.87-.18-17.72-1.14-26.55-2.89-1.02.05-1.88-.06-2.58-.3l-4.57-9.1c6.14.08,13.22,1.51,19.31,2.85l.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M193,1125.43c-.82.25-1.67.48-2.54.43-6.15-.4-12.17-.68-18.33-.91-.86-.03-1.68-.37-2.47-.7-1.14-.37-1.9-.26-2.29.33-.2-.52-.75-.67-1.63-.45-.7.19-1.66.09-2.26-.27l-.32-.75.11-11.6.76-.54,9.02-5.25-1.28,11.7c-.25,2.26-.59,4.4-.15,6.5l.3-3.71,22.55-13.16-1.16,12.3-.32,6.09h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M67.49,1051.53l24.15,4.45-1.32,8.65c-.8,1.64-1.29,3.87.06,5.17.03.93-.27,1.64-.9,2.14-.91-.69-1.71-.85-2.39-.48l-12.26-4.37-6.29-2.2-2.15-1.44-.11-5.59-.55-.49c-.11-1.97-.07-3.93.13-5.88.8.15,1.27,0,1.39-.47l.23.51h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M67.49,1051.53c-.27,0-.7-.04-.83.06s-.22.51-.22.83l.12,10.86c1.05.25,1.81.79,1.99,1.6-.77-.27-1.61-.37-2.31-.84l-.17-6.31-11.16-1.88.02-26.71,20.34,3.72-9.33,4.37.06,13.7c0,.35,1.16.65,1.49.58v.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "140.33 1100.66 139.29 1109.35 112.94 1090.95 112.97 1087.69 141.64 1092.9 140.33 1100.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M193,1125.43l.38.02c.48-1.13,3.97-.44,4.14.75.09-.24.22-.24.37-.01.51-.52.77-.41.78.33l23.36,6.85c.34.1.69.54,1.18.4.15-.23.27-.2.37.07l11.34,4.45c.48.55.3.73-.38.61-14.31-2.46-28.86-5.17-43.23-7.87-.09-.02-.15-.14-.21-.3l-.22.22c-6.41-1.09-12.78-2.06-19.11-2.93-.18-.17-.58-.48-.63-.72-.41,0-.66-.41-.76-1.26-1.03.42-1.5-.7-.67-1.4-.22-.09-.24-.22-.07-.39,7.77-.23,15.59.07,23.33,1.18h.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M87.09,1071.46c.01-.31.1-.9.51-.88.76.04,1.3.49,1.76.87.22-1.38.57-2.7-.09-3.66l-.55-.81c-.19-.29.53-.64.7-.97l.89-1.38c-.25,1.64-.56,3.15-.45,4.88l24.68,4.6-1.44,9.16-.65,7.29-10.68-8.45c-4.12-3.26-7.88-6.71-12.36-9.5l-2.33-1.16h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M164.04,1110.96l-.12,12.5c0,.29-.31.41-.43.4l-23.66-14.11c-.2-1.11-.11-2.08-.03-3.32l24.23,4.52h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M198.68,1126.51c-.23-.07-.65.09-.78-.33.17-.41-.17-.16-.37.01l-4.14-.75.21-4.04,17.69-10.3-1.3,17.74-9.96-2.52c-.49-.35-1.2-.22-1.35.19h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M267.05,1150.76l-12.84-.06c-.33-.07-.32-.18,0-.32l11.8-.12-12.6-4.67.2-3.74,15.43-8.99-1.21,15.61c-.08.99.05,1.83-.79,2.3h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M252.32,1145.43l-1.88-.03c-.65-.11-.69-.32-.03-.52.17.22.59.22.81.18.21-.11.2-.26,0-.36l-12.62-4.85c1.61.07.45-1.63,1.07-3.67l14.58-8.6-1.15,15.58c-.07.97.12,1.82-.76,2.26h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M189.57,1186.62c.71,2.12,1.29,4.41,1.74,6.85.87.37.91.64.11.81,2.24,6.87,3.15,13.85,2.73,20.96l-.49.45c-1.14-.74-3.24-1.54-4.74-1.48-.42.03-.5-.29-.24-.96-.1-5-.13-9.97-.09-14.92l-1.84-12.07,2.81.37h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M188.08,1200.23l.35.14c.33,4.58.34,9.11.03,13.61l-.77-.1-6.46-1.21-2.12-13.82,8.97,1.37h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M281.71,1154.34c-.37.17-.27.46-.22.63-1.36.43-2.69.18-4.25.32s-2.95.55-4.53.33c-1.33-.18-2.54.27-3.81.31l-9.25.26-8.85.29-6.05.36-4.17.37-10.9,1.03-3.85.32-16.18.17c-1.25.01-2.49.58-3.81.29-1.21-.26-2.31.33-3.42.34l-16.61.05c-.66,0-1.04.34-1.24.82l-.32-1.17,16.86-.21,6.06-.39,15.86-.38,7.58-.33,13.37-1.33,3.84-.3,7.76-.27,10.9-.41,6.61-.25,5.32-.34,3.3-.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M250.41,1144.88l.03.52-25.7-2.26-19.24-2.19-4.97-.31c-7.25-.45-14.27-.76-21.39-2.57-.85-.22-1.91-.42-2.39.21l-.39-.79,2.61.09c4.55.9,8.98,1.85,13.65,2.16l4.61.31,5.94.18,3.84.33,15.12,1.82,28.29,2.51h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M254.21,1150.37v.32l-8.87-.18-14.01-.36-10.18-.36-15.13-.03-10.71.08-9.83-1.83-2.66-.36c-1.18.54-1.6.61-1.27.19l-.69.27-.4-1.17c1.88-.09,3.84.18,5.76.7,5.72,1.55,11.28,1.8,17.17,1.79l20.76-.02,11.32.36,14.91.27,3.81.32h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M229.61,1184.16c.73-.03.74.25.03.52-7.62,1.74-15.12,3.55-22.73,6.02-5.2,1.69-10.27,2.74-15.38,3.56l1.52,5.58,1.35,6.17.13,10.21c-.24.08-.67-.4-.87-.53,1.28-5.55.1-10.49-1.16-16.08l-2.94-12.98.14-1.2,1.83,8.23c4.98-.68,9.95-1.71,15-3.37,7.72-2.52,15.3-4.67,23.08-6.14h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M178.67,1142.78c-.1,0-.4.07-.4.46v68.56c0,.19-.31.16-.37.15v-.39l-.3-.07c-.09-23.32-.11-46.65-.06-69.99l.39-.26.74,1.54h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M191.11,1130.72c.64.15.66.39-.03.51l-15.43-2.47-3.88-.38c.04-.11.03-.26.01-.37l3.39.13,15.94,2.58h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M182.84,1147.65c-.16.02-.76.08-.7.21l.26.61c.18,4.93,3.55,6.76,1.05,7.18l-2.57-7.54c-.11-.54.19-1,.63-.86l1.33.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M290.13,1170.38l-1.23,1.1c.05-.29-.25-.35-.53-.21l-14.16,3.16c-.33,0-.48-.02-.38-.37l16.3-3.67h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M188.94,1214.2c-.56.02-.85-.25-1.25-.32.2.09.79,0,.79-.42v-11.75c.01-.62-.17-1.12-.4-1.48.47-.52.51-1.25.53-1.91l.33,15.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M196.78,1174.52c-1.37,1.22-3.27,1.67-5.04,2.51-1.14.55-2.12,1.34-3.35,1.29l-.27-.8c.21.26.76.44,1.23.21l4.88-2.33c.99-.48,1.64-.75,2.54-.87h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M304.5,1156.9l-2.32.27-28.49,4.33-34.99,5.76-7.51.78-7.21.31c-4.45.19-8.77-.11-12.85,1.23-.73.03-.73-.25-.03-.51l9.7-1.18,10.95-.3,11.89-1.74,24.33-4.02,31.12-4.76,4.29-.32-.82-.71c.75.05,1.51,0,1.94.87h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M263.25,1176.27c.4,0,.57,0,.39.42l-25.36,6.02-8.62,1.97-.03-.52,19.3-4.71,14.33-3.18h-.01Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "273.83 1174.05 274.21 1174.43 263.63 1176.69 263.25 1176.27 273.83 1174.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M211.1,1169.06l.03.51-9.1,2.98c-.39.06-.51.05-.37-.35,3.04-1.41,6.23-2.34,9.43-3.14h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M201.67,1172.2l.37.35c-1.71.56-3.45,1.67-5.25,1.97,1.37-1.21,3.26-1.56,4.88-2.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M234.93,1138.27c.52.2,1.05.22,1.61.62l-1.46.4-12.59-2.24-31.41-5.81.03-.51,32.46,6.01,10.95,1.84c.25.04.45-.13.4-.3h.01Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M237.96,1139.75l-2.88-.47-.15-1.02c-3.8-.72-7.5-1.9-11.1-3.54l-.24-.91c-.12-.26-.24-.29-.37-.07-.21,1.23-1.45.79-1.18-.4l.75-.2-12.23-4.15c-.25-1.23-.21-2.31-.04-3.58l15.64-9.21-1.08,14.52,15.12-8.8-1.15,15.93c-.03.41.2.9,0,1.26-.13.24-.59.33-.89.23l-.19.2s.04.12,0,.19v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M223.59,1133.83c-.09-.05-.27-.1-.37-.07-.03-.53.5-.4.37.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M197.9,1126.18c-.11.02-.26.03-.37.01-.03-.18.03-.31.2-.43.15-.1.49.03.53.17.04.12-.35.25-.36.25h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M251.22,1145.06v-.36c.36-.15.48.43,0,.36Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M118.37,287.5c-3.75-3.8-7.59-7.91-3.83-10.94l13.35-10.76c3.21-2.52,6.26-4.92,9.96-6.69,5.25-2.52,9.95-5.52,14.46-9.59v82.44l-13.16-17.44-3.96-5.89c-2.17-4.81-4.96-9.09-8.67-12.85l-8.15-8.27h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M292.36,236c-3.04.06-6.08.17-9.12.34l-.25-.5c-1.19.08-2.21-.07-3.06-.46-9.41-.12-18.85-.27-28.3-.45l-.43-.76c-.33-.11-.33-.23,0-.38.02-.66.48-.92,1.38-.78l-8.07-1.13-.34-.81c-.62-.72,1.95-.53,1.85-.46-.13.09-2.4.2-2.01-.53-2.47-.08-5.17-.53-7.64-1-.25-.05-.34-.46-.37-.78-3.46-.93-7.02-1.73-10.69-2.41l.41-.59c-.15-1.1-.02-2.03.37-2.82l13.55-7.77.14,10.94,13.82-8.06.17,10.97,14.59-8.57.15,10.94,16.64-9.71.11,14.18c.68-1.18.16-2.29.4-3.41l20.69-12.18-.03,14.43-7.14.64c-1.12-.33-1.88.31-2.76.64-1.34.49-2.81.32-4.06.47h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M292.36,236l-19.69,2.33-.53.33c-18.72,2.41-37.7,4.9-56.93,7.47-6.56,1.02-13.09,2.14-19.59,3.38,0,.14-.01.25-.05.26-.86.24-6.41,1.77-6.79,1.76-.11,0-.22-.15-.33-.34l-3.4-8.65-.02-.84c23.68-2.45,47.41-3.85,71.19-4.18,8.12-.31,16.19-.91,24.2-1.8l2.57.12,7.9-.17c.62,0,1.24-.08,1.48.33h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M251.19,234.18l16.96.17,11.78,1.03-.26.44c-21.81,1.66-43.63,2.74-65.47,3.23-9.87.48-19.63,1.41-29.29,2.78l-.31-.45-3.35-7.9c-.19-.52-.14-.83.16-.94,23.2.36,46.38.84,69.54,1.43l.24.21h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M164.77,293.9c1.29-.45,1.52,1.17.3,1.51-.18-.04-.36.11-.36.39v8.19c-1.22.02-1.95-.34-3.05-.71,0,.88.04,1.42-.22,2.21-1.11-.13-2.05-.21-3.14-.72l-.09-61.52c2.39-3.2,4.79-6.68,6.45-10.74l.11,61.39h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M268.62,239.86l-6.94,1.84-1.93.93c-22.51,6.24-45.11,10.96-67.81,14.16-.12.61-.52.49-1.19-.36l-1.93-4.44c-.1-.2-.16-.38-.1-.5.17-.32,6.12-1.61,6.92-1.48,6.99-1.92,14.12-3.3,21.38-4.13l50.53-6.76c1.02-.2,1.38.05,1.07.73h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M244.16,231.08l15.84,2.21,2.54.25-.2.29-11.15-.04c-23.26-.45-46.63-.83-70.12-1.15l-.25-.33-2.1-4.22c-.39.02-.66-.48-.8-1.5-.59.25-.66-.26-.38-.75-.57.12-.58-.63-.35-1.09l.17-.49c22.16,2.65,44.37,4.75,66.6,6.29l.2.51v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M148.78,331.9l.69.75c.32,5.59.41,11.24.29,16.96.1.95-.12,1.43-.66,1.44-.21.27-.32.55-.32,1.07v56.95c-1.22.16-2.33-.02-3.38-.78l-.05-73.16c0-2.93-.75-5.36-.16-7.99,1.09.84,2.32.87,3.46,1.32.18,1.19.25,2.28.14,3.44h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M256.87,244.05l-13.66,4.82-18.98,6.75c-1.31.93-3.31,1.75-4.87,1.89l-4.78,1.98c-2.8.96-5.58,1.97-8.34,3.03l-1.14.37-2.3.76c-2.86,1-5.79,1.83-8.77,2.5l.04-3.59c-.39-1.11-.89-2.13-1.47-3.05l-.71-1.11-.59-1.61c21.97-2.84,43.88-7.34,65.73-13.51.32.23.23.5-.16.78h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M220.21,258.04l-12.12,6.69-3.7,1.93-1.18.81c-.09.04-.28.05-.38.05.05.21.08.39.02.43-1.27.85-5.97,3.74-7.2,4l-.82-.43c.03.16.05.28.01.3-1.53.77-3.84,1.87-5.42,2.44-.16.06.7-2.02,1.38-1.95-.93-.68.73-3,1.81-2.58.38-1.2.89-2.48,1.52-3.84l8.67-2.25,2.3-.76,1.14-.37c2.75-1.06,5.53-2.07,8.34-3.03l4.78-1.98c.87-.39,1.38-.43.85.53h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M153.84,317.96v-70.01l3.41-3.3.02,73.82c-1.22.28-2.14.02-3.43-.51h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M163.61,214.57c.35.03.82.09.94.37.28.67.26,8.71.17,9.99l-.75.54h-.8l-1.15-.34-18.95-2.58-.02-11.7,20.57,3.71h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M194.19,222.83c.23-1.4,2.3-1.03,1.84.35l-2.21.61c-5.42.03-10.82,0-16.2-.12.1.74-.54.82-.91.22-1.12-.43-2.34-.07-3.92.24-.33-1.03-.15-2.03-.18-3.34l21.21-12.46-.07,14.11c0,.32.22.51.45.38h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M210.76,224.35l-.31.73-14.04-1.11-.38-.79c-.4-.49-1.21-.51-1.84-.35l.08-3.66,16.44-9.62c.11,4.9.3,9.75.56,14.54l-.5.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M211.13,220.2l13.98-8,.36-.15c.33,4.41.42,8.89.29,13.44l.29.55c-4.99-.51-9.98-1.15-14.98-1.9-.17-1.37-.15-2.69.07-3.94h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M163.96,225.47l-.05-9.46c0-.59-.11-1.08-.3-1.44.34,0,.79-.03,1.19-.27l7.43-4.36v14.33c-1.88,0-3.44.73-5.03.88l-3.23.31h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M186.56,269.68c.72.15,1.35.38,1.9.69l.16,3.54c.58.06.51.55-.22,1.49l.4.72c-1.63,1.92-2.88,3.46-3.74,4.62-.51.86-1.38,1.58-2.53,1.66-.38.51-.6.98-1.17,1.36l.05-5.13-1.99-10.02,7.14,1.08h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M168.16,304.24l-.86,1.73-6.72,17.43-.48.14c-.05-1.86-.18-3.68-.38-5.46,0-.3-.12-.77-.02-1.05l-.28-2.01c-.79-2.16-1.23-4.51-1.39-6.9l8.78-4.14c.24-.3.13-1.22.14-1.46.78-.15,1.19.42,1.21,1.72h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M174.98,292.29c-.36-1.96-.39-4.17-1.23-6.33-.74-1.91-1.37-3.81-1.43-5.86,2.95-.74,5.67-.66,8.6-.2l.06,4.55-5.99,7.85h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M168.16,304.24l-.89.23c.29-.89-.18-1.43-.32-1.94l-1.88-7.12c-.1-.4.21-1.13-.3-1.51,3.07-1.39,5.9-2.84,9.51-3.11.24.54.47,1.86.03,2.56-2.31,3.6-4.3,7.19-6.15,10.89h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M156.38,336.21l-.79.11c-.11-.31-.65-.71-.62-1.29.16-2.88,0-5.66-.65-8.48-.41-1.79-.78-3.52-.63-5.34l5.75-2.49-.08,7.66-2.98,9.83h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M192.13,259.97c.27-.24.43-.18.63.1,1.41,1.98,1.68,3.05,1.36,5.51-.01.09.15.21.37.33-.73,1.04-1.77,2.54-1.88,3.82l-1.81,2.58c-.41.03-.81.45-1.22,1.28-1.01,2.25-1.2-2.15-1.14-3.27,0-.09.19-.16.42-.24l-.04-1.48-.36-1.56-1.6-8.33c1.94.32,3.85.48,5.27,1.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M282.98,235.84l-2.7.29-4.54.4-4.93.36c-2.19.16-4.2.23-6.42.38l-4.9.31c-1.55.1-3.04.24-4.56.28l-8.52.25-11.31.4-10.5.41-7.79.25c-2.06.07-3.98.21-6.08.36l-5.64.41-4.92.37-4.47.4-9.5,1.03c-.66.07-1.03.24-1.17.8l-.44-1.17,14.07-1.46,4.15-.36,5.65-.4c2.22-.16,4.25-.31,6.43-.39l6.63-.25,9.42-.38,11.01-.37,10.49-.42,7.42-.24,5.69-.36,6.04-.38,4.17-.36c1.43-.12,2.93-.33,4.15-.62,1-.24,2.02.32,3.06.46h.01Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "315.47 233.47 306.74 234.25 306.75 230.74 315.39 225.62 315.47 233.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M272.66,238.33c-.04.33-.25.63-.7.74l-3.34.79c-.19-.31-.64-.48-1.2-.4l-21.9,3.03-21.18,2.66c-9.8,1.23-19.32,2.61-28.71,4.86-.73,0-.74-.28-.03-.49,12.44-3.03,25.15-4.3,38.04-6.07l37.53-5.15,1.48.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M177.19,224.77c.2.32.26.74.35,1.09-.16.8-.03,1.05.38.75.49.34.55,1.01.8,1.5-.16.04-.37.11-.44.47v50.11c-.55.15-.96.15-1.51,0v-54.36c.57-.49.78-.24.42.45h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M261.69,241.7c.11.45-.07.72-.57.9l-4.25,1.46c.05-.28-.12-.36-.27-.38-.29-.06-.39.05-.77.15-19.35,5.25-38.75,9.62-58.6,12.61l-5.55.69c-.17.48.13.9.21,1.27-.41-.64-.82-1.26-1.13-1.97,1.61.19,3.06-.06,4.97-.33,22.44-3.15,44.24-8.65,65.96-14.41h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M177.62,223.68c7.76.63,15.54,1.4,23.34,2.32,14.41.97,28.75,2.34,43.03,4.1l2.01.53-1.85.46-8.89-.95-4.47-.39-4.15-.38-4.54-.38-4.92-.37-4.91-.37-4.53-.38-4.53-.38-4.92-.44-21.11-2.27c-.11-.17-.27-.32-.42-.45l-.06-.42c.29-.19.59-.18.91-.22h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M251.19,233.8v.38l-6.62-.18-18.17-.37-21.83-.41-18.71-.27c-2.01-.03-4.75-1.1-4.62.52l-.43-1.16,10.87.15,20.44.37,21.45.4,15.71.22,1.91.33v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M185.06,280.73c-.13-.09-.25-.23-.29-.35-.05-.15.02-.31.18-.51l3.45-4.48c.12-.91.35-1.28.68-1.09,2.05-.69,3.97-1.62,5.75-2.77l8-4,.57.53-18.34,12.68h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M211.13,220.2l.14,3.72,14.3,1.81-.12-13.35c0-.12-.26-.21-.34-.18.22-.71,1.07-.24.74.32l.23,9.97c.02.97-.65,2.31-.01,3.3l9.7,1.94c.3-.29.98.15.22.56l-.46.65c-8.11-1.45-16.25-2.71-24.43-3.79l-.34-.81-.06-14.8c.12-.07.45.12.45.41l-.03,10.23v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M188.86,270.08l.02,3.9c.72-.6,1.03-1.23,1.58-2.02.21-.04.36.14.33.35-.34.49-.82.87-1.16,1.61l5.19-2.4c.71.22.18.75-.14.51l-4.45,2.07c-.76.36-1.41.71-1.84,1.28-.08-1.61.05-3.52-.41-5.17-.47-.14-1.17-.2-1.42-.55.78.12,1.54.12,2.3.4v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M195.61,249.52l.03.49-6.13,1.47c-.34.08-.56.31-.69.51l-.39-.79,7.18-1.68h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M160.58,323.4c-.16.41-.26.91-.75,1.5l-.12-6.82c.29.02.46.3.45.73l-.05,3.84c0,.43.19.68.46.75h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M159.7,317.03c-.38-.59-.38-1.31-.28-2.01.24.66.57,1.17.28,2.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M188.82,268.6c-.5-.4-.26-1.05-.36-1.56.55.33.34,1.02.36,1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M204.39,266.66c-.32.39-.73.64-1.18.81.12-.69.72-.57,1.18-.81Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M140.2,320.7l.05,17.57c.51.13,1.06-.2,1.79-.56l-.02,20.83c0,.39-1.17.65-1.75.67l-.07,40.87c-.45.5-1.35.1-1.68-.13-.48-.34-.8-.88-.81-1.74-1.67.55-3.26.8-5.21.74l.97-5.51,1.24-6.39c-1.15-.26-2.58-.33-3.5.32-.22.16-.27.91-.22,1.17.07.4-1.32.54-1.33-.01l-.1-24.8-6.01,2.44-.14,8.59c-.01.67-1.44,1.14-2.2,1.05l-.08-8.54-2.09.8.92-6.66-3.77-1.05c-.36,1.33-1.44,2.07-2.89,1.92l-.16-7.55-.35,5.1-3.49.21v-78.27c1.76,2.66,3.78,4.45,5.92,6.47l5.65,5.34c5.23,4.93,9.45,10.64,13.9,16.24,1.16,1.46,1.17,2.33,1.16,4.17l-.11,25.77c-1.43.04-2.44-.27-3.58-.55l-.11,2.68-.99.72c-.31.22-.2,1.17.12,1.53l6.39-4.28c.36-.26.23-1.38.18-1.85s-.79-.71-1.47-1.05l.08-23.9c.71,1.66,1.39,3.21,3.53,3.32l.49,4.12.25.25,1.54,2.11-.15,12.6c-.35.29-1.49-.07-1.49-.43l-.07-14.07-.35-.22v-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M123.52,347.32l1.87-.11.03-2.76,3.17.29.51-3.16c.87,1.3.52,2.43.48,3.75l-5.96,4.67c-.25-1.02-.15-1.58-.1-2.68h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M116.11,356.05c-.43-1.53-.15-2.56-.17-3.96,1.11.23,1.9.43,2.99.32l.04-2.8c.79-.02,1.63.04,1.97.33s.42,1.75.07,2.04l-4.91,4.06h.01Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M196.03,223.18l14.74,1.17,19.1,2.77,6.13,1.18,8.01,1.78c-.83.68-2.03.21-3.16.1l-16.52-1.57-5.25-.39-4.91-.38-4.53-.38-4.54-.39-4.2-.34-4.86-.46-17.36-2.04c-.59-.07-.98-.11-1.06-.57,6.13-.8,12.27-.98,18.41-.49h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M177.92,226.61l-.04,51.82c-.23-.04-.48-.04-.71,0l-.03-51.77c0-.51.14-.73.4-.8.05.21.21.63.38.75h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "220.78 257.23 220.97 257.42 220.78 257.65 220.59 257.42 220.78 257.23"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M134.59,514.48c-6.57-14.96-15.97-18.41-20.9-25.52-1.14-1.65-1-3.36.43-4.52l7.51-6.11,14.24-10.68,2.91-1.64,9.42-4.43-.03,76.28-8.01-13.82-5.56-9.56h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M193.75,460.96l-.28.5c-.77-.32-1.57-.36-2.38-.11-1.34.56-2.87.66-4.57.3l-11,.62-1.38-.6c-.25,1.09-2.75,1.52-3.49.76-.15,1.22-2.55,2.5-3.39,1.5l-1.62.61c-.62.23-1.16.7-1.69.55-.4-.26-.63-.51-.75-.96-.2-.78-.14-11.21.06-12.25l.76-.44,9.44-5.48-.91,12.57,22.32-13.12-1.14,15.56h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M148.8,543.66c.42.57.42.85-.01.84l-.03,74.62c-1.35.26-2.36-.29-3.35-.45-.15-26.44-.15-52.99-.01-79.65.97.02,2.69.08,3.15,1.02.55,1.15.27,2.61.26,3.62h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M152.33,536.7c-1.23.49-2.28.07-3.33-.44v-75.02c1.08-.59,1.97-1.18,3.32-1.39v76.85h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M170.66,462.42l.76.26.04,65.93.86.89-3.41.97c.31-.24.51-.62.38-.91-.37-.76-1.95-.75-1.95-1.41l-.06-64.23c.99-.37,2.35-1.05,3.39-1.5h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M164.03,451.43l-.06,13.65c-.52-.15-1.07-.46-1.51-.76-.48.82-.87.56-1.15-.78-.88.97-2.49-.34-2.64-1.49-.2.24-.35.13-.42-.34l-16.26-10.86c-1-1.1-1.9-2.1-1.12-3.67l23.17,4.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M158.66,462.05l.76,1.03c-.07,22.85-.05,45.64.09,68.37.36.19.7.23,1.02.11l.02-67.56.76-.46,1.15.78c-.16,0-.42.11-.42.48v64.14c0,.85-.07,1.29.75,1.77-.4.06-.99.19-1.03.48l-.24,1.45c-.78.32-2.22.06-3.25-.43l-.02-70.5.42.34h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M152.65,545.63h-.45l-2.25-.36-.02,72.94c-.15.02-.35-.13-.36-.24v-72.65c0-.59-.53-.79-.78-.82v-.84c1.45,1.68,3.3,1.15,3.86,1.97h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M145.39,539.02l-.13,80.72-.2,1.03c-1.17.07-2.21-.15-3.06-.81l-.02-60.69c-.54.29-1.35.67-1.73,1.21l-.03,48.53c-.81.26-2.37-.23-2.37-1.08l-.05-45.75-6.74,5.39-.03,28.56c0,.22-.78.37-.92.26s-.5-.24-.5-.65l-.11-27.22-5.95,2.52-.13,9.72c-.01.78-1.72,1.19-2.28.89v-9.22c-.66.25-1.02.71-1.92.78l.88-6.78-4.15-1.14c.34,1.39-1.89,2.59-2.47,1.83l-.3-7.16s-.2,0-.25.17l-.04,4.71c-1.23.2-2.33.33-3.6.17v-76.5c1.79,2.9,4.05,4.88,6.58,6.9,5.82,4.66,10.69,9.85,14.99,15.98l4.21,5.99c1.03,1.46.86,2.68.85,4.42l-.11,22.89c-1.26.3-2.4-.07-3.59-.6-.06,1.01.26,1.94-.23,2.87-.25.21-.89.45-.94.75-.08.45-.12,1.18.38,1.34l5.94-3.97c.57-.38.56-1.28.48-1.91-.07-.51-.61-.85-1.47-1.04l.05-21.22,1.64,2.94,2.04,1.05.16,5.33.03,13.13c1.42-.05,1.83-.76,1.8-1.74-.02-.75-.49-1.22-1.53-1.37l.11-10.28c1.32,4.4,4.46,2.05,4.58,4.99l.16,4.03-.03.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M145.4,618.67c0,.73.26,2.07-.34,2.11l.33-81.75v79.65h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M123.5,552.51l1.9-.12.02-3c1.23.26,2.11.5,3.38.37.03-1.08-.23-2.19.25-3.04.71.85,1,3.18.21,3.82l-5.63,4.62-.12-2.65h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M116.06,561.18c-.37-1.43-.14-2.48-.11-3.89l2.81.27c.37-.94.13-1.91.24-2.76.48-.21,1.47-.04,1.83.12.43.19.58,1.62.23,2.06-1.29,1.62-3.15,2.63-5,4.21h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M194.91,482.9c.33.05.32.14,0,.29l-3.14.3-7.19.76,1.33,3.48c-.25.52-.27,1.14-.07,1.87v19.69l.06-18.9.76-.45,1.45,3.86.71,1.96,2.65,7.12c1.01.03,1.15.04.4.81,1.43,2.93,3.07,4.33,2.61,6.75.16.71.06,1.09-.31,1.15.35.03.33.1-.03.23-.91.32-1.11-.12-1.13-.97.25-2.22.14-2.45-2.02-3.08-.47-.14-3.01-.73-3.1-.6l.6,4.17-.67.64c.56,4.42-.74,6.15-3.88,5.18l-.31-.72-.1-32.43.75-.46,3.91-.58,6.72-.07h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M185.9,487.73c.27.7.75,1.37.75,2.21l-.09,25.38c0,.55-1.16,1.1-1.46.84-.51-.95-.03-2.11-.03-3.07v-25.64c.38-.03.58.2.83.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M174.14,461.67c1.39.13,3.26,3.47,2.49,4.59.37.05.4.18.08.39.34.04.34.15.03.33.14.29.28.57.01.77l.21.07c-.03,20.01-.04,40.06-.02,60.14l.96.07c.14-19.08.23-38.22.26-57.43l.5.16c1.18-.28,2.69,2.93,1.83,3.78.97-.05,1.12.21.44.8l3.32,8.2.1,33.15c.89.39,1.59.02,2.2-.4,1.11-.76.26-2.95,1.24-4.31,1.19-.04,1.7,2.88.66,3.38l.36,1.93c1.11-.12,1.1,1.14.06,1.44-.39-.18-.77-.28-1.18-.34l-.44.7-6.91-.99,1.69,9.09-.64.68c0,.51-.09,1.08-.48,1.48-2.87-.46-5.8-.64-8.6.16-.48-.1-.97.02-1.62-.16l-.04-66.92c1.21-.52,2.23-.61,3.49-.76h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M161.3,463.54l-.02,68.74c-.96.25-1.75.13-2.65-.45l.03-69.78,2.64,1.49h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M177.52,468.51c-.16,1.17-.04,1.55.38,1.14.4.28.57.71.78,1.13-.1,0-.4.09-.4.46v56.9c-.55.16-.96.16-1.51,0v-60.38c.11-.33.24-.33.4,0l.36.76h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M177.16,467.75h-.39v-.77c.27.18.27.49.4.77h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M177.9,469.64l-.02,58.23c-.24-.05-.49-.05-.72,0l-.02-58.91c0-.34.25-.47.39-.45.16.34.38.74.38,1.14h-.01Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M238.25,504.08c-3.29,2.8-6.1,6.05-8.69,9.69-6.2,8.71-13.49,14.14-22.35,19.99-7.61,5.02-14.68,10.27-21.69,16.02-1.2.99-3.13,1.1-3.86-.01-.16-.85.2-1.83,1.08-2.91,2.43-7.79,4.39-15.61,5.89-23.48.31-.44.64-.46,1-.05,3.52-1.1,6.89-2.8,10.12-5.08,12.34-5.16,24.75-10.01,37.23-14.54,1.43-.5,1.85-.38,1.25.37h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M301.82,480.35l-6.77.63c-5.44,1.19-11.16,2-16.76,2.33-30.07,3.37-59.96,7.12-89.66,11.25l-.52-.76-.8-.14-.64-3.72c-1.03-.03-1.32-1.53-.75-2.21-.97.3-1.67-3.1-1.48-3.55.32-.77,9.09-1.15,10.48-.99,2.51.02,5.1.07,7.79.15,24.43-1.15,48.83-2.34,73.19-3.58l.27.31.16-.31,3.46-.18.2-.49c7.18-.37,14.37-.38,21.58-.02.85.23.95.71.28,1.28h-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M180.91,529.35l.26.07.16,15.79c.36,1.92.23,3.55-.39,4.87-1.87,2.75-4.89,4.16-8.05,3.86-4.36,1.47-8.89.11-13.38.04l-2.35-3.34c-.46.5-1.28-.41-.75-.94l-7.23-10.3,19.74-8.92c.58-1.16,1.21-1.44,1.89-.84l1.52-.12c.65-1.49,3.46-1.59,4.71-.93,1.79-.57,3.08-.32,3.89.77h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M266.68,477.23c-.04.29-.13.74-.34.75-1.01.09-8.88.15-9.31-.04-.29-.12-.43-.46-.55-.76-.33-.11-.33-.23,0-.38.32-.77,1.23-1.04,2.72-.8l-5.93-1.35c-1.34.2-2.17-.09-2.5-.86l-.69-.41c-.74-.03-1.13-.25-1.15-.66-5.05-.35-10.98-1.61-16.11-2.85-.7-.17-1.3-.59-1.86-1.02-.58-.6.94-.68,1.41-.55.19.06-3.8.26-3.48-.87-5.85-.88-12-1.98-17.81-3.37-.2-.05-.27-.39-.31-.69l.09-3.23,15.49-9.04-.92,12.6,14.86-8.82-.89,12.6,14.92-8.71-.89,12.66,15.69-9.35-.97,14.64c-.72.02-1.18.15-1.48.49v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M256.48,477.19l10.2.04c.61,0,1.25-.05,1.86.05.08-.29.26-.71.47-.69,1.32.14,10.64,1.66,11.02,2.08s.35.62-.1.91c-.3.2-3.47.33-3.79-.1l-.24.29c-25,1.29-50.02,2.49-75.06,3.59-2.02-.04-3.99-.19-5.93-.46-3.42.27-6.87.59-10.35.98l-.29-.33c-.29.08-.72.16-.83-.02-.71-1.3-1.78-4.1-2.26-5.58-.72-1.11-.8-1.97-.23-2.59-.12-.62.5-.87,1.87-.76,4.21.29,8.41.67,12.59,1.14l57.97,1.08c1.07.03,2.11.15,3.1.38h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M279.49,483.99l-6.01,1.16v.32c-5.34,1.32-10.87,2.5-16.27,3.32-17.09,4.02-34.29,8.05-51.6,12.09l-.49-.15c-4.34.92-8.79,1.76-13.35,2.52l-.31-.36c-.29.07-.7.14-.83-.05-.3-.45-2.23-5.67-2.34-6.3l.52-.77-.26-1.37c29.87-3.94,59.85-7.64,89.94-11.11.78-.07,1.47-.13,1.01.7h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M258.72,491.18c-6.24,3.04-12.1,6.71-17.79,10.88-.43.31-.82.34-1.17.47-.77.72-1.7,1.12-2.8,1.19,0,0-11.11,4.25-33.33,12.75-4.2,2.08-8.33,4.24-12.39,6.48-1.49.42-3.5.89-1.96-.75l1.46-3.8c.48-1.65,1.25-3.04,2.31-4.17-.81-.78-.19-1.59.87-1.66.51-.48,1.12-.91,1.83-1.3-.02-.17-.03-.3.01-.32,3.33-1.4,7.12-2.68,10.51-3.39,3.09-1.32,7.16-2.44,10.58-3.02,13.25-4.69,26.65-9.24,40.19-13.65,1.42-.58,1.98-.48,1.68.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M301.82,480.35c.08-.17-.1-.54-.39-.55l-15.48-.3-9.8.57c-.73-.05-.73-.35-.02-.59,1.18-.11,2.42.23,3.81-.22l-11.4-1.97.07-2.76,17.44-10.2-.89,12.48,20.86-12.2-.04,15.07-4.16.67h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M268.18,487.4l-4.7,1.71c-.89.32-1.78.46-2.56.56-1.09.69-2.39,1.09-3.91,1.22-13.43,4.64-26.82,9.03-40.19,13.16-3.25,1.32-7.33,2.5-10.95,3.1l-.03.28c-3.78,1.24-7.53,2.55-11.25,3.91-.3-.1-.34-.4-.13-.89-.25-.61-.43-1.36-.53-2.24l-1.08-1.22c-1.08-1.25-1.41-2.35-1-3.28-.05-.11-.09-.22-.08-.31.12-.69,12.18-2.17,13.73-2.22,0-.15.02-.27.06-.28,17.12-4.29,34.7-8.29,52.02-11.7.69-.44,10.8-2.92,10.84-2.35.01.18-.1.37-.24.56h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M210.36,463.29c0,.32-.11.61-.33.58-5.08-.73-10.21-1.5-15.27-2.33-.09-.01-.16-.1-.23-.21-.39-.1-.51-.23-.38-.39l-.02-3.08,17.47-10.12-1.24,15.54h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M295.04,480.98c-1.5.92-3.32,1-5.16,1.3l-10.39,1.71c-.12-.29-.58-.48-1.11-.42l-26.66,3.22-29.83,3.41-19.81,2.81-12.11,1.59c-.3.04-.9-.21-1.08.21-.11.24-.06.67-.07.95-1.08.35-1.63-1.4-.71-1.96.7.67,1.5.31,2.42.18l20.22-2.8,14.39-1.87,25.47-2.88,44.44-5.45h-.01Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "306.41 479.8 306.41 476.45 315.41 471.11 315.44 479.94 306.41 479.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M194.53,461.33l15.83,1.95.41.09,18.12,4.06c.73.72.06.78-.8.61l-34.65-6.33c-.07-.73.6-.78,1.09-.39h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M260.92,489.66c-.09,1.16-1.4,1.12-2.2,1.51-.12-.3-.5-.35-.93-.21l-19.06,6.26-11.34,3.79-10.54,3.52c-.7.03-.67-.22-.02-.48l33.16-11.01c3.79-1.26,7.16-2.87,10.94-3.37h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M193.75,460.96l.4-.02c.24-.01.43.14.38.39-.15-.03-.48-.14-.76.22l34.34,6.23c.46.08.79-.17.78-.34l3.48.87-1.41.55-.39.7c-12.42-2.28-24.84-4.57-37.26-6.86l-.32-.83c-.35-.34-.71-.45-1.12-.16-.49.94-.94.67-.78-.35.72-.64,1.79-.35,2.66-.39h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M273.48,485.15c.12.05.23.59.07.64l-5.37,1.61c.02-.22-.38-.46-.77-.37l-9.83,2.17c-.49.03-.62-.1-.39-.4l16.27-3.64h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M276.12,479.48l.02.59-6.24.37-8.74.34-7.87.41-7.6.34-6.23.25c-1.65.07-3.2.51-4.9.32-1.46-.17-2.79.27-4.19.3l-9,.17c-1.39.03-2.76.22-4.18.3l-5.63.32-6.09.33h-7.13l-3.44-.33v-.29l4.46.07c2.06.51,3.73.1,5.74,0l7.54-.39,5.68-.37,7.04-.25,9.05-.4,8.25-.41,8-.34,8.24-.42,7.22-.33,6.24-.23c1.34-.05,2.55-.6,3.77-.34h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M250.77,473.8l2.61.12,12.23,2.77-9.13.13c-20.3-.34-40.66-.7-61.08-1.08-4.88-.74-9.76-1.05-14.61-.91l-.27-.27-1.83-3.78c-.37.13-.63-.25-.78-1.13-.53-.05-.59-.69-.38-1.14-.51.36-.62-.32-.36-.76-.21-.13-.35-.38-.41-.77l-.03-.33c24.39,2.22,48.93,4.48,73.63,6.79l.43.36h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M191.09,461.35l.78.35c.28-.34.88-.18,1.12.16l37.97,6.99c5.27.65,10.43,1.88,15.68,3.44l2.29.42c.11.59-.39.78-1.49.56-23.72-2.15-47.33-4.49-70.8-7.02l-2.49-4.59c5.59-.64,11.36-1.27,16.95-.31h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M248.93,472.72c.72.13,1.81.19,1.84,1.08l-32.82-3.03-22.69-2.32-5.28-.42-4.84-.39-8.42-.99c-.01-.13-.03-.29-.08-.39l10.3,1.06,5.7.37,26.82,2.7,26.59,2.48c1.05.1,2.14.55,2.89-.15h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M256.48,476.81v.38l-8.12-.18-17.4-.37-16.57-.38-20.1-.34-7.4-.88-5.55-.1c-.29,0-.44.21-.37.41l-.44-.8,2.34-.34,12.56,1.32,23.87.36,17.71.37,16.44.24c1.08.02,2.09.56,3.05.31h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M257.2,488.79l.39.4-26.7,5.89-17.44,4.45-7.94,1.64c-.46.01-.59-.13-.39-.44l15.44-3.52,16.95-4.2,19.7-4.23h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M205.51,501.17l-10.61,1.72c-1.11.18-2.33-.11-3.04.81l-.4-.81,13.66-2.16.39.44h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M194.12,511.83c.74.17.49.64-.21.74-.18.63-.56,1.11-.87,1.66-.28.09-.57.49-.95,1.17-.54.96-1.01,1.95-1.35,3-.63,1.11-1.12,2.3-1.66,3.86-.6-1.2-.15-2.38-.2-3.53l-.06-1.44-.36-1.93-.66-3.38-.83-5.73c2.27.4,4.62.53,6.49,1.9.79.58-.22,2.95.65,3.68h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M206.27,507.56l-10.52,3.71c-.52.54-1.24,1.19-1.6.34-.17-.45.25-.83.31-1.15.04.12-.03.41.05.56.24.44.55-.12.72-.17l6.03-2.27,4.61-1.42c.56-.07.69.07.39.41h.01Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "216.83 504.05 216.85 504.53 206.27 507.56 205.88 507.15 216.83 504.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M193.05,514.23l-2.31,4.17c.13-1.86,2.19-5.26,2.31-4.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M193.92,512.56l.21-.74c.02-.06.05-.17.03-.23l1.6-.34c-.32.83-.87,1.61-1.83,1.3h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M187.7,518.39c.72,2.11.84,4.68.3,7.03l-2.2,9.59c-1.07,4.64-1.99,9.22-4,13.41l-.4-20.54-2-10.67,8.3,1.19h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M239.77,502.53c-.21.82-.97,1.09-1.52,1.55,0-.42-.26-.37-.44-.34l-.77.13-29.17,11.22c-4.61,1.77-8.88,3.63-12.95,6.37-1.83,1.23-3.71,2.1-5.96,2.33l-2.74,11.64c-1.18,5.02-2.21,9.94-4.56,14.36l-.73.3c.16-1.53.21-3.12-.02-4.85v-15.88c-.59-.76-.48-1.25.48-1.48l.76.33.35,16.45c2.22-7.43,3.91-14.9,5.07-22.43-.36-1.51-.32-2.79.12-3.84.58-1.06.93-.69,1.18.34.61.54.68.54.91-.16l.95-.17c-.11,1.57-1.04,2.86-1.54,4.62,2.29-.19,4.14-1.27,5.96-2.47,3.08-2.04,6.11-3.5,9.58-4.83l23.73-9.1,11.32-4.09h-.01Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "181.49 549.01 181.71 549.2 181.49 549.46 181.22 549.2 181.49 549.01"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M192.99,461.87l-1.12-.16c0-.33.25-.48.58-.4.21.05.55.11.54.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M188.82,517.29c-.48-.52-.24-1.3-.36-1.93.59.45.33,1.28.36,1.93Z"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M92.19,183.94c.28.55.2.85-.24.88v13.09c-.15.25-.72.14-.97,0l-50.19-9.14v-26.49l66.73,12.21-15.33,9.44h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M93.86,184.66l48.27,8.74.04,23.65-20.5-1.89c-10.08-1.25-19.78-3.27-29.58-5.28l.04-11.76c-.55.2-.61.05-.2-.45v-13.06c.47-.26,1.11-.25,1.93.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M93.86,184.66l-1.72.07v13.39c-.44.2-.85.07-1.17-.2.03.03.65.03.77-.12l.02-13.16c-.07-.41.19-.68.43-.7l1.68.73h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M152.6,93.87c.2.23.85.46.69.92-.24.69-.8,2.51.13,2.85l3.41,1.26c-.71,2.63.84,4.8,3.47,5.13,2.45.31.44,2.43,2.11,4.28.2.12.19.25,0,.38-.18-.09-.4-.34-.75-.29l-.02,73.65c-.15.02-.35-.13-.36-.24v-76.82c-.84-.62-1.7-.66-2.67-.92-.37,1.21.03,1.97.03,3.18v72.52c-.25-.05-.49-.05-.75,0l.05-73.28c0-1.68.6-3.16-1.19-3.9v77.59c-1.14.41-1.33-.61-.37-.71l-.04-80.37-2.6-.52v77.7c-.44,0-1.12-.6-1.12-1.23l-.03-80.12c-.85-.16-1.69.08-1.93-.92.76.23,1.59.56,1.96-.17l-.02.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M183.36,132.03l-.19.48-.43.14c-.32-.86-.51-1.04-.58-.53l-.12.39-3.02-.73-.02,61.99c-.15.03-.35-.13-.36-.23v-66.8c-1.18-.42-1.99-.68-3.02-.6l-.02,66.13c-.15.02-.35-.13-.36-.24l-.02-66.35c-.15-.03-.36.12-.36.23l-.02,65.98c-.14.03-.37-.12-.37-.23l.04-71.29.62,4.38c.67,1.13,2.61,1.11,3.77,1.35l-4.06-6.87c2.36,2.31,3.63,5.19,5.45,7.87,1.14,1.68,2.18,3.3,3.06,4.95v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M165.43,109.84c-.21-.22-.08-.35.39-.39.88.18-.41,2.58,1.44,4.01l.06,72.74c-.25-.05-.5-.05-.74,0v-64.59c-.42-2.86.79-5.36-.33-8.25l-.09,72.48c-.14.02-.34-.14-.35-.25v-74.55c0-.63-.22-.92-.38-1.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M145.59,171.82c-.2.66-.2,1.37-.21,2.22-1.03.08-1.87.29-2.89-.28.84-.73,1.31-.14,2.52.04l.06-85.44c1.11,1.17.74,1.34.74,2.28l-.02,80.97c.01.06.08.17.19.21.65-.03,1.24.19,2.43.46l.06-71.83.06-9.92c.22,1.4.54,2.26,1.07,3.35.44,1.44.31,3.26.31,5.06l.04,71.16c0,.1-.22.26-.37.23l-.04-71.87c-.23.06-.48.05-.71,0l-.02,74.04c-1.16.25-2.11-.13-3.01-.51-.08-.03-.15-.1-.2-.18h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M165.82,109.45c0,.19-.2.43-.39.39l-2.25-.46-.02,73.58c0,.1-.21.25-.36.23v-72.55c-.01-.91-.06-1.41-.39-1.95v-.38c1.04.64,2.22.9,3.41,1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M170.4,118.93l-.09,69.92c-.13.03-.35-.12-.35-.23l-.02-74.48c.49.3.38.63.39.78l.06,4.02h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M183.18,132.51c-.11-.28-.15-.42.19-.48l10.2,19.09c-.22.08-.38.28-.38.29l-2.08-3.17v50.81c-.24-.05-.49-.04-.72,0l-.05-51.07c0-.49-1.39-.51-1.6-.14-.28.51.06,1.12.06,1.72l.04,48.35c-.25-.04-.49-.04-.72,0l-.03-45.71-.1-8.26c0-.49-1.83-.76-2.12-.36-.54.76-.04,1.95-.04,2.96l-.02,50.24c-.23-.04-.48-.04-.72,0v-48.73l-.11-10.14c-.84-.17-1.64-.22-2.55-.02l-.02,57.39c-.15.03-.36-.13-.36-.23v-62.54c-.28-.21-.24-.34.12-.39.15,0,.3.04.42.11.96.6.36,3.85.26.7,0-.14.14-.28.32-.42h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M183.18,132.51l2.33,4.88-3.09-.39c-.11-1.73.33-3.41-.25-4.89-.89-.55-1.91-.59-3-.95-.24-1.55-.21-2.97.18-4.55l3.82,5.89h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M188.26,143.07c-.53.06-2.01.19-2.41-.44-.45-1.44-.03-2.92.13-4.47l2.52,4.71c.04.07.1.16.16.22l1.99,4.07c-.78.06-1.18,0-1.44-.11-.92-.4-.32-1.99-.74-3.77l-.21-.21Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M153.29,94.79c-.54.04-1.03-.38-.69-.92-1.54-1.78-3.14-4.17-5.38-5.5-2.8-1.67-5.99-2.45-9.29-2.82l-24.74-2.78-31.59-3.54c-3.58-.4-6.89-.27-10.55-1.58,4.75-3.04,8.83-6.07,13.07-9.51l30.25-22.25,49.87-36,.02,78.65c-1.22.18-2.16-.07-3.36-.29l-.06,2.75-3.34-.17-.06,2.68c-1.2.14-2.14-.11-3.31-.35l-.12,1.97c-.25-.3-.43-.34-.73-.34h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M166.68,97.68c-.76,3.04-1.68,5.77-3.38,8.1l-8.06-9.01,12.21-8.83c.15,3.34-.16,6.4-.77,9.74Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M121.55,85.77c.71-.02,1.36.07,1.96.25l1.44.07,1.95.33,15.32,1.05-.11,15.88c-.7.05-1.07-.09-1.65-.24l-.2,3.16-.04,58.26c-.83.28-2.37-.21-2.37-1.03l-.05-38.21-6.76,4.92.02,34.44c0,.73-1.44.71-1.44.26l-.06-33.62-6.29,4.53-.07,27.3c0,.9-1.65,1.54-2.3,1.11l-.03-26.57-6.06,4.37v19.6c0,1.01-.82,1.84-2.07,1.68l-.07-19.66-5.77,4.06v13.17c.01.98-.99,1.85-1.86,1.4l-.08-13.13-5.92,4.25-.03,6.71c0,.57-.32.92-.53,1.2-.17.23-1.15.42-1.17.1l-.3-6.63-5.76,4.47c-.66.51-1.02,2-2.21,1.27.14-.5.2-1.79-.22-1.91l-5.66-.47c-.12,1.06-1.07,1.95-1.9,1.54l-.21-1.86-5.8-.62c-.15.67-.43,1.06-.66,1.4-.27.39-1.33.47-1.35.07l-.23-5.22c-.13,0-.39-.13-.38-.13-.56.61-.31,1.4-.38,2.3-1.35.22-2.26.09-3.56-.24v-75.84c2.71.62,5.27,1.06,7.99,1.21,5.13.29,9.92.97,15.03,1.56l29.86,3.45h-.02Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M123.51,86.01c-.66-.03-1.4.13-1.96-.25.55.06,1.54-.56,1.96.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M126.91,86.41c-.64-.04-1.4.19-1.95-.33.66.03,1.5-.28,1.95.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M127.19,115.53l.05-2.48c.56-.06,1.59-.14,2.15.35.4.35.38,1.9-.02,2.26l-6.15,4.45c.17-11.54-.59-22.56.27-34.06l.41,28.98c1.06.4,1.88.48,3.31.5h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M114.8,122.49l1.89.1.07-2.64,3.18.2c.1-.99-.3-2.05.67-3.05.47,1.74.22,3.12.26,4.88l-6.01,4.25-.06-3.74h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M131.04,110.98h2.36l.14-2.85c1.25.25,2.12.46,3.24.3l.1-2.67c1.18-.56,1.07,1.19.83,3.9l-6.6,4.68-.08-3.38v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M107.02,131.91c-.38-1.77.27-3.05.29-4.79l2.97.13.08-2.66,2.15.41c.38,1.05.34,2.15-.16,3.09l-5.33,3.81h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M99,134.54l1.82-.13.02-2.6,3.03.3c.2-.92.16-1.61.1-2.57.2-.13.75-.13.96.04v3.96l-5.84,4.05-.09-3.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M90.99,143.54c.04-1.71.39-3,.33-4.54,1.21.19,1.95.36,3.1.24.03-.96-.13-1.83.15-2.56,1.23-.09,2.4.12,2.59.88.25,1.02-.19,1.78-1.02,2.36l-5.16,3.62h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M75.2,155.2v-4.2l3.14.27.12-2.64,2.61.26c.17.69.15,1.3,0,2.05l-5.87,4.25h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M83.06,146.58l1.88-.16.04-2.63,3.04.32.14-2.51c.01-.2.62-.29.78-.07.12.17.21.35.19.78l-.14,2.88-5.8,4.1c-.23-1.01-.16-1.57-.12-2.73v.02Z"
  }))))))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 142.41,
    y1: 87.6,
    x2: 142.47,
    y2: 87.6
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "142.47 173.58 142.71 173.64 142.83 173.7 143.07 173.7 143.37 173.76 143.73 173.88 144.39 173.88 144.51 173.82 144.57 173.76 144.57 173.7"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "142.29 173.52 142.41 173.58 142.47 173.58"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 193.17,
    y1: 397.62,
    x2: 192.75,
    y2: 397.56
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "194.67 398.28 194.55 397.98 194.43 397.86 194.25 397.74 193.17 397.62"
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "185.61 267.6 185.79 267.48 185.85 267.48 186.27 267.06 186.33 267.06 186.33 267"
  })), _polyline5 || (_polyline5 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "184.11 267.84 184.17 267.9 184.29 267.96 184.89 267.96 185.01 267.9 185.07 267.84 185.25 267.78 185.55 267.66 185.61 267.6"
  })), _polyline6 || (_polyline6 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "145.95 327.84 145.47 327.66 145.23 327.54 144.99 327.54"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 146.13,
    y1: 327.9,
    x2: 145.95,
    y2: 327.84
  })), _polyline7 || (_polyline7 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "145.95 408.66 145.89 408.66 145.83 408.6 145.29 408.42 145.17 408.36 144.99 408.3"
  })), _polyline8 || (_polyline8 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "148.11 328.74 147.99 328.62 147.87 328.44 147.63 328.26 147.33 328.14 146.73 328.08 146.13 327.9"
  })), _polyline9 || (_polyline9 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "148.11 408.84 148.05 408.9 147.93 408.96 147.45 408.96 147.27 408.9 146.55 408.78 146.37 408.78 146.25 408.72 145.95 408.66"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 195.33,
    y1: 849.54,
    x2: 194.67,
    y2: 849.36
  })), _polyline0 || (_polyline0 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "197.55 1079.76 197.37 1079.34 197.19 1079.16 196.83 1079.04 196.11 1078.92 195.45 1078.74"
  })), _polyline1 || (_polyline1 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "150.15 333.06 149.97 333 149.49 332.88 149.31 332.76 149.19 332.76"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 150.21,
    y1: 333.12,
    x2: 150.15,
    y2: 333.06
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 187.89,
    y1: 833.1,
    x2: 188.07,
    y2: 833.1
  })), _polyline10 || (_polyline10 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "190.17 833.88 189.99 833.52 189.81 833.34 189.45 833.28 188.07 833.16"
  })), _polyline11 || (_polyline11 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "109.71 127.02 109.59 127.14 109.41 127.2 109.29 127.2 109.17 127.14 108.93 127.14 108.57 127.08 108.03 127.08 107.97 127.02 107.61 127.02 107.49 126.96 107.25 126.9 106.83 126.84 106.53 126.78"
  })), _polyline12 || (_polyline12 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "178.41 371.4 179.55 371.64 179.61 371.64 179.73 371.7"
  })), _polyline13 || (_polyline13 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "181.77 372.42 181.59 372.12 181.35 371.94 181.05 371.88 179.73 371.7"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M145.95,1068.12l.3.06c.59.02,1.22.42,1.8.12l.06-.06"
  })), _polyline14 || (_polyline14 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "144.99 1067.76 145.17 1067.82 145.29 1067.88 145.83 1068.06 145.89 1068.06 145.95 1068.12"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 144.99,
    y1: 983.88,
    x2: 145.05,
    y2: 983.94
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M77.73,150.9l-.12.12-.18.06h-.24l-.24-.06h-.36l-.36-.06h-.18c-.23.03-.52-.08-.78-.12l-.42-.06-.3-.06"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 136.77,
    y1: 964.14,
    x2: 136.77,
    y2: 964.08
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M108.03,933.54v-.48l.12-.42.24-.78.42-.6.54-.66,1.26-1.14,2.88-2.28c4.49-3.36,8.66-7.06,13.32-10.32l1.62-1.14,1.68-1.14"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M200.79,1090.14v.06c-.02.6.04,1.2-.06,1.8l-.12,1.2"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M169.89,1212.24l-.12.06-.18.06-.24.06-.12-.06h-.12l-.3-.12-.36-.06-.18-.06h-.12c-.32-.14-.57-.29-.96-.42l-.06-.06h-.06"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 169.89,
    y1: 1212.24,
    x2: 169.95,
    y2: 1212.24
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 124.77,
    y1: 346.98,
    x2: 124.83,
    y2: 346.98
  })), _polyline15 || (_polyline15 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "184.89 1055.88 185.67 1056.06 185.73 1056.06"
  })), _polyline16 || (_polyline16 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "187.17 1056.24 186.45 1056.18 185.73 1056.06"
  })), _polyline17 || (_polyline17 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "187.89 1056.9 187.71 1056.48 187.47 1056.3 187.17 1056.24"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M108.81,790.8v.12l.12.06c1.51.09,1.99-.11,3.3-.18l.06-.06"
  })), _polyline18 || (_polyline18 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "176.07 125.82 175.47 125.64 175.17 125.52 175.05 125.46 174.99 125.52"
  })), _polyline19 || (_polyline19 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "176.07 125.82 176.19 125.88 176.49 125.94"
  })), _polyline20 || (_polyline20 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "178.41 126.78 178.23 126.42 178.05 126.3 177.75 126.18 176.49 125.94"
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 128.13,
    y1: 775.5,
    x2: 128.13,
    y2: 775.56
  })), _polyline21 || (_polyline21 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "177.57 974.4 177.45 974.7 177.39 974.82 177.33 974.88 176.61 974.88 176.55 974.82 176.49 974.64 176.37 974.34"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 177.57,
    y1: 974.34,
    x2: 177.57,
    y2: 974.4
  })), _polyline22 || (_polyline22 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "158.73 777.48 158.25 777.3 157.95 777.18 157.83 777.18 157.77 777.24"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 158.79,
    y1: 777.48,
    x2: 158.73,
    y2: 777.48
  })), _polyline23 || (_polyline23 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "160.89 778.62 160.83 778.38 160.47 777.9 160.11 777.78 159.45 777.66 158.79 777.48"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 157.77,
    y1: 777.24,
    x2: 157.83,
    y2: 777.3
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 167.07,
    y1: 1211.64,
    x2: 167.07,
    y2: 1123.98
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M135.21,544.44l-.12.12c-.78.26-2.22-.28-3.06-.42l-.12-.06"
  })), _polyline24 || (_polyline24 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "118.29 783.24 118.11 783.42 117.93 783.48 117.75 783.42 116.85 783.36 116.01 783.18 115.23 783.06"
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 118.29,
    y1: 783.24,
    x2: 118.35,
    y2: 783.24
  })), _polyline25 || (_polyline25 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "135.21 991.44 134.97 991.56 134.73 991.62 134.49 991.56 133.53 991.44 132.63 991.26 132.27 991.14 132.03 991.08 131.91 991.02"
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 96.75,
    y1: 82.98,
    x2: 96.69,
    y2: 82.98
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M98.37,160.38v.06c-.26.57-.88,1.19-1.56.9l-.12-.06"
  })), _polyline26 || (_polyline26 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "192.39 950.58 192.63 950.52 192.75 950.4 192.93 950.34 193.23 950.16"
  })), _polyline27 || (_polyline27 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "190.83 950.76 190.89 950.82 191.01 950.82 191.25 950.88 191.55 950.88 191.67 950.82 191.79 950.82 191.97 950.76 192.21 950.64 192.33 950.64 192.39 950.58"
  })), _polyline28 || (_polyline28 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "177.57 1211.04 177.51 1211.16 177.45 1211.4 177.39 1211.46 177.15 1211.52 176.67 1211.52 176.55 1211.46 176.49 1211.34 176.43 1211.22 176.37 1211.1 176.37 1210.98"
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 177.57,
    y1: 1210.98,
    x2: 177.57,
    y2: 1211.04
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 176.37,
    y1: 1210.98,
    x2: 176.37,
    y2: 1138.74
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 115.11,
    y1: 941.64,
    x2: 115.17,
    y2: 941.64
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 115.11,
    y1: 929.94,
    x2: 115.11,
    y2: 937.74
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 131.91,
    y1: 954.84,
    x2: 131.91,
    y2: 916.92
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 121.53,
    y1: 924.9,
    x2: 121.53,
    y2: 943.14
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 135.03,
    y1: 963.54,
    x2: 134.97,
    y2: 963.42
  })), _polyline29 || (_polyline29 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "135.99 962.76 136.35 963.48 136.77 964.08"
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 122.61,
    y1: 519.9,
    x2: 122.37,
    y2: 520.14
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 122.79,
    y1: 519.42,
    x2: 122.85,
    y2: 519.54
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 122.85,
    y1: 518.34,
    x2: 122.85,
    y2: 518.28
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M120.63,581.46h.06c.52.38,1.06-.14,1.56-.3l.12-.06v-.06h.06l.3-.3.12-.06v-.06"
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 120.63,
    y1: 518.64,
    x2: 120.75,
    y2: 519.12
  })), _polyline30 || (_polyline30 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "120.75 519.18 120.69 519.36 120.63 519.48"
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 122.79,
    y1: 346.32,
    x2: 122.85,
    y2: 346.44
  })), _polyline31 || (_polyline31 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "121.47 347.04 121.35 346.8 121.35 346.5"
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 122.85,
    y1: 345.24,
    x2: 122.85,
    y2: 345.18
  })), _polyline32 || (_polyline32 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "120.63 375.48 120.69 375.54 120.75 375.54 120.99 375.6 121.41 375.6 121.59 375.48 121.95 375.36 122.13 375.24 122.37 375.12 122.37 375.06 122.43 375.06 122.73 374.76 122.85 374.7 122.85 374.64"
  })), _polyline33 || (_polyline33 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "120.63 345.48 120.75 346.02 120.69 346.26 120.63 346.38"
  })), _polyline34 || (_polyline34 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "145.95 89.88 145.47 89.7 145.23 89.58 144.99 89.58"
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 146.07,
    y1: 89.88,
    x2: 145.95,
    y2: 89.88
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M145.95,171.96l.3.12c.59.02,1.22.42,1.8.12l.06-.06"
  })), _polyline35 || (_polyline35 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "147.51 90.12 146.79 90.06 146.07 89.88"
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 147.75,
    y1: 90.18,
    x2: 147.51,
    y2: 90.12
  })), _polyline36 || (_polyline36 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "144.99 171.66 145.17 171.72 145.29 171.78 145.65 171.9 145.83 171.9 145.89 171.96 145.95 171.96"
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 166.59,
    y1: 113.58,
    x2: 166.47,
    y2: 113.52
  })), _polyline37 || (_polyline37 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "169.59 114.72 169.47 114.54 169.29 114.36 169.05 114.24 168.15 114.06 167.55 113.88"
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 132.87,
    y1: 32.22,
    x2: 132.75,
    y2: 32.28
  })), _polyline38 || (_polyline38 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "132.87 110.64 132.69 110.82 132.09 110.82 131.73 110.76 131.37 110.76 131.19 110.7 130.83 110.7 130.71 110.64 130.65 110.64 130.41 110.58"
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 122.85,
    y1: 519.54,
    x2: 122.61,
    y2: 519.9
  })), _polyline39 || (_polyline39 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "131.55 546.9 131.43 547.02 131.31 547.08 131.13 547.08 130.41 547.02"
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 131.55,
    y1: 546.9,
    x2: 131.61,
    y2: 546.9
  })), _polyline40 || (_polyline40 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "185.61 740.94 185.79 740.82 185.85 740.82 186.27 740.4 186.33 740.4 186.33 740.34"
  })), _polyline41 || (_polyline41 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "184.11 741.18 184.17 741.24 184.29 741.3 184.89 741.3 185.01 741.24 185.07 741.18 185.25 741.12 185.55 741 185.61 740.94"
  })), _polyline42 || (_polyline42 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "181.77 1049.22 182.67 1049.4 182.73 1049.4"
  })), _polyline43 || (_polyline43 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "184.89 1050.12 184.65 1049.64 184.47 1049.58 184.11 1049.52 182.73 1049.4"
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 122.85,
    y1: 346.44,
    x2: 122.61,
    y2: 346.8
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 120.63,
    y1: 518.64,
    x2: 120.63,
    y2: 500.04
  })), _polyline44 || (_polyline44 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "158.73 1007.34 158.55 1007.28 158.13 1007.16 157.89 1007.1 157.83 1007.04 157.77 1007.1"
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 158.79,
    y1: 1007.4,
    x2: 158.73,
    y2: 1007.34
  })), _polyline45 || (_polyline45 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "160.89 1008.48 160.83 1008.24 160.65 1008 160.47 1007.82 160.11 1007.7 159.45 1007.58 158.79 1007.4"
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 118.29,
    y1: 352.08,
    x2: 118.35,
    y2: 352.08
  })), _polyline46 || (_polyline46 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "100.17 134.16 100.11 134.28 99.93 134.34 99.45 134.34 98.97 134.28 98.73 134.28 98.55 134.22 98.37 134.22"
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 74.55,
    y1: 153.24,
    x2: 74.43,
    y2: 153.3
  })), _polyline47 || (_polyline47 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "176.01 807.72 175.47 807.54 175.17 807.42 175.05 807.42 174.99 807.48"
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 176.19,
    y1: 807.78,
    x2: 176.01,
    y2: 807.72
  })), _polyline48 || (_polyline48 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "178.41 808.74 178.23 808.32 177.99 808.14 177.63 808.08 176.19 807.78"
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 128.13,
    y1: 996.36,
    x2: 128.19,
    y2: 996.36
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 124.77,
    y1: 996.06,
    x2: 124.83,
    y2: 996.06
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 124.77,
    y1: 999,
    x2: 124.83,
    y2: 999
  })), _polyline49 || (_polyline49 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "124.77 996.06 125.13 996.18 125.55 996.3 126.45 996.42 127.41 996.54 127.71 996.6 127.95 996.54 128.13 996.36"
  })), _polyline50 || (_polyline50 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "152.25 95.1 152.13 94.92 151.95 94.74 151.71 94.56 151.35 94.5 150.75 94.38 150.15 94.2"
  })), _polyline51 || (_polyline51 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "122.25 518.88 122.55 519.12 122.79 519.42"
  })), _polyline52 || (_polyline52 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "158.73 343.32 158.25 343.14 158.01 343.02 157.89 342.96 157.77 342.96"
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 158.85,
    y1: 343.32,
    x2: 158.73,
    y2: 343.32
  })), _polyline53 || (_polyline53 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "160.89 344.16 160.65 343.8 160.35 343.68 159.45 343.5 158.85 343.32"
  })), _polyline54 || (_polyline54 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "129.21 164.34 129.15 164.46 129.15 164.52 129.21 164.52 129.21 164.64 129.27 164.82 129.33 164.94 129.51 165 130.05 165 130.17 164.94 130.23 164.88 130.29 164.7 130.35 164.58 130.35 164.52 130.41 164.46"
  })), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 161.01,
    y1: 305.1,
    x2: 161.07,
    y2: 305.1
  })), _polyline55 || (_polyline55 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "157.83 304.62 157.83 304.68 157.89 304.68 158.01 304.74 158.73 304.92 158.91 304.98 158.97 304.98 159.15 305.04 159.27 305.04 159.33 305.1 159.57 305.1 159.99 305.16 160.17 305.22 160.35 305.22 160.47 305.28 160.53 305.28 160.77 305.22 160.95 305.16 161.01 305.1"
  })), _polyline56 || (_polyline56 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "163.41 562.74 162.87 562.56 162.57 562.44 162.45 562.44"
  })), _line46 || (_line46 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 163.41,
    y1: 562.74,
    x2: 163.47,
    y2: 562.74
  })), _polyline57 || (_polyline57 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "165.51 563.64 165.27 563.28 164.97 563.1 164.67 563.04 164.01 562.92 163.41 562.74"
  })), _polyline58 || (_polyline58 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "163.41 348.54 162.87 348.3 162.57 348.24 162.45 348.18"
  })), _line47 || (_line47 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 163.41,
    y1: 348.54,
    x2: 163.47,
    y2: 348.54
  })), _line48 || (_line48 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 165.51,
    y1: 349.32,
    x2: 165.57,
    y2: 349.32
  })), _polyline59 || (_polyline59 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "164.67 348.78 164.01 348.66 163.41 348.54"
  })), _polyline60 || (_polyline60 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "165.51 349.32 165.21 349.02 164.97 348.84 164.67 348.78"
  })), _polyline61 || (_polyline61 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "190.17 147.84 189.99 147.48 189.69 147.36 189.39 147.36 188.01 147.18"
  })), _line49 || (_line49 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 190.17,
    y1: 147.84,
    x2: 190.17,
    y2: 198.84
  })), _polyline62 || (_polyline62 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "129.21 1043.7 129.15 1043.82 129.15 1043.88 129.21 1043.88 129.21 1044 129.27 1044.18 129.33 1044.3 129.51 1044.36 130.05 1044.36 130.17 1044.3 130.23 1044.24 130.29 1044.06 130.35 1043.94 130.35 1043.88 130.41 1043.82"
  })), _line50 || (_line50 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 122.61,
    y1: 752.16,
    x2: 122.37,
    y2: 752.34
  })), _line51 || (_line51 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 122.79,
    y1: 751.68,
    x2: 122.85,
    y2: 751.8
  })), _polyline63 || (_polyline63 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "121.47 752.4 121.35 752.16 121.35 751.86"
  })), _line52 || (_line52 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 122.85,
    y1: 750.6,
    x2: 122.85,
    y2: 750.54
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M122.85,806.76v.06l-.12.06-.3.3h-.06v.06l-.12.06c-.5.16-1.04.68-1.56.3h-.06"
  })), _polyline64 || (_polyline64 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "120.63 750.9 120.75 751.38 120.69 751.62 120.63 751.74"
  })), _line53 || (_line53 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 122.85,
    y1: 751.8,
    x2: 122.61,
    y2: 752.16
  })), _polyline65 || (_polyline65 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "161.01 532.38 160.95 532.44 160.77 532.56 160.29 532.56 159.39 532.38 158.55 532.2 158.13 532.08 157.95 532.02 157.83 531.96"
  })), _line54 || (_line54 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 161.01,
    y1: 532.38,
    x2: 161.07,
    y2: 532.38
  })), _line55 || (_line55 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 131.55,
    y1: 993.84,
    x2: 131.61,
    y2: 993.84
  })), _polyline66 || (_polyline66 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "128.19 993.54 128.25 993.6 128.37 993.6 128.61 993.66 129.15 993.78"
  })), _polyline67 || (_polyline67 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "130.41 993.96 131.13 994.02 131.31 994.02 131.43 993.96 131.55 993.84"
  })), _line56 || (_line56 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 148.53,
    y1: 762.24,
    x2: 148.53,
    y2: 760.8
  })), _polyline68 || (_polyline68 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "122.25 345.78 122.55 346.02 122.79 346.32"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M122.85,346.98l.18.06c.56-.04,1,.26,1.62.06l.12-.12"
  })), _line57 || (_line57 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 157.77,
    y1: 1007.22,
    x2: 155.91,
    y2: 1003.92
  })), _line58 || (_line58 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 128.13,
    y1: 919.68,
    x2: 128.13,
    y2: 949.44
  })), _line59 || (_line59 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 128.19,
    y1: 949.5,
    x2: 128.19,
    y2: 919.62
  })), _line60 || (_line60 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 140.07,
    y1: 969.48,
    x2: 140.07,
    y2: 912.18
  })), _line61 || (_line61 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 124.77,
    y1: 922.26,
    x2: 124.77,
    y2: 945.96
  })), _line62 || (_line62 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 131.55,
    y1: 917.22,
    x2: 131.55,
    y2: 954.24
  })), _line63 || (_line63 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 144.99,
    y1: 984.06,
    x2: 144.57,
    y2: 983.22
  })), _polyline69 || (_polyline69 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "133.83 961.38 133.95 961.56 134.01 961.74"
  })), _line64 || (_line64 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 122.61,
    y1: 346.8,
    x2: 122.37,
    y2: 346.98
  })), _polyline70 || (_polyline70 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "122.25 751.14 122.55 751.38 122.79 751.68"
  })), _polyline71 || (_polyline71 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "142.35 977.76 141.75 977.52 141.57 977.46 141.51 977.4 141.51 977.46"
  })), _line65 || (_line65 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 142.47,
    y1: 977.82,
    x2: 142.35,
    y2: 977.76
  })), _polyline72 || (_polyline72 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "142.47 1069.68 142.71 1069.8 142.83 1069.8 143.07 1069.86 143.37 1069.92 143.73 1069.98 143.91 1069.98 144.03 1070.04 144.39 1069.98 144.51 1069.92 144.57 1069.86"
  })), _polyline73 || (_polyline73 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "141.51 1069.32 141.63 1069.44 142.35 1069.68 142.47 1069.68"
  })), _polyline74 || (_polyline74 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "124.77 778.2 124.71 778.26 124.53 778.32 123.99 778.32 122.85 778.2"
  })), _line66 || (_line66 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 124.77,
    y1: 778.14,
    x2: 124.77,
    y2: 778.2
  })), _line67 || (_line67 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 156.63,
    y1: 318.3,
    x2: 156.69,
    y2: 318.3
  })), _polyline75 || (_polyline75 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "153.39 317.82 153.45 317.88 153.63 317.94 154.35 318.12 154.53 318.18 154.77 318.24 154.89 318.24 154.95 318.3 155.13 318.3 155.55 318.36 155.79 318.42 155.91 318.42 156.03 318.48 156.09 318.48 156.33 318.42 156.51 318.36 156.63 318.3"
  })), _line68 || (_line68 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 187.89,
    y1: 606.36,
    x2: 188.01,
    y2: 606.36
  })), _polyline76 || (_polyline76 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "190.17 607.14 189.93 606.66 189.75 606.6 189.39 606.54 188.01 606.36"
  })), _polyline77 || (_polyline77 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "197.55 635.1 198.39 635.34 198.57 635.34"
  })), _polyline78 || (_polyline78 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "200.61 635.94 200.55 635.7 200.43 635.58 199.77 635.52 198.57 635.34"
  })), _polyline79 || (_polyline79 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "135.87 336.9 135.93 336.96 136.47 337.14 136.77 337.2 136.95 337.26 137.31 337.32"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M103.35,131.76l-.18.18c-.92.02-1.8-.15-2.7-.3l-.3-.06"
  })), _line69 || (_line69 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 195.33,
    y1: 161.94,
    x2: 195.39,
    y2: 161.94
  })), _polyline80 || (_polyline80 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "197.55 162.9 197.43 162.6 197.31 162.48 197.13 162.36 195.99 162.12 195.33 161.94"
  })), _polyline81 || (_polyline81 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "181.77 377.76 182.67 377.94 182.73 377.94"
  })), _polyline82 || (_polyline82 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "184.89 378.6 184.71 378.24 184.65 378.18 184.47 378.12 184.11 378.06 182.73 377.94"
  })), _polyline83 || (_polyline83 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "190.17 1067.04 190.47 1067.1 190.53 1067.1 192.03 1067.22"
  })), _polyline84 || (_polyline84 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "192.57 1067.46 192.39 1067.28 192.03 1067.22"
  })), _line70 || (_line70 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 192.75,
    y1: 1067.88,
    x2: 192.57,
    y2: 1067.46
  })), _line71 || (_line71 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 129.75,
    y1: 34.44,
    x2: 129.57,
    y2: 34.56
  })), _polyline85 || (_polyline85 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "172.05 1028.1 171.27 1027.8 171.03 1027.74 170.91 1027.74"
  })), _line72 || (_line72 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 172.05,
    y1: 1028.1,
    x2: 172.11,
    y2: 1028.1
  })), _polyline86 || (_polyline86 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "174.21 1029.12 174.03 1028.76 173.79 1028.58 173.49 1028.46"
  })), _polyline87 || (_polyline87 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "173.43 1028.46 172.77 1028.34 172.05 1028.1"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M161.25,303l.12.12.6.24.24.12h.18l.06.06.18.06c.66.08.5.23,1.2.18l.18-.06.12-.06"
  })), _polyline88 || (_polyline88 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "131.55 773.04 131.43 773.16 131.31 773.16 131.13 773.22 130.41 773.1"
  })), _line73 || (_line73 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 131.55,
    y1: 772.98,
    x2: 131.55,
    y2: 773.04
  })), _polyline89 || (_polyline89 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "153.75 549.9 153.27 549.66 152.97 549.6 152.85 549.54 152.85 549.6"
  })), _line74 || (_line74 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 153.81,
    y1: 549.9,
    x2: 153.75,
    y2: 549.9
  })), _polyline90 || (_polyline90 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "155.91 550.8 155.85 550.62 155.49 550.26 155.19 550.2 154.05 549.96"
  })), _line75 || (_line75 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 153.99,
    y1: 549.96,
    x2: 153.81,
    y2: 549.9
  })), _line76 || (_line76 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 155.91,
    y1: 628.74,
    x2: 155.91,
    y2: 628.68
  })), _polyline91 || (_polyline91 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "185.61 962.1 185.79 961.98 185.85 961.98 186.27 961.56 186.33 961.56 186.33 961.5"
  })), _polyline92 || (_polyline92 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "184.11 962.34 184.17 962.4 184.29 962.46 184.89 962.46 185.01 962.4 185.07 962.34 185.25 962.28 185.55 962.16 185.61 962.1"
  })), _line77 || (_line77 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 118.29,
    y1: 1004.1,
    x2: 118.35,
    y2: 1004.1
  })), _polyline93 || (_polyline93 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "198.39 859.5 197.61 859.32 197.55 859.32"
  })), _line78 || (_line78 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 198.57,
    y1: 859.5,
    x2: 198.39,
    y2: 859.5
  })), _polyline94 || (_polyline94 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "200.61 859.92 200.55 859.8 200.49 859.68 200.31 859.62 200.07 859.62 198.57 859.5"
  })), _polyline95 || (_polyline95 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "167.43 792.6 166.89 792.48 166.65 792.36 166.47 792.36"
  })), _line79 || (_line79 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 167.55,
    y1: 792.66,
    x2: 167.43,
    y2: 792.66
  })), _polyline96 || (_polyline96 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "169.59 793.68 169.53 793.5 169.41 793.32 169.23 793.14 168.99 793.02 167.55 792.66"
  })), _polyline97 || (_polyline97 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "190.83 258.18 190.89 258.24 190.95 258.24 191.25 258.3"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M156.63,760.56l-.12.06c-.96.32-2.04-.26-3-.48l-.12-.06"
  })), _polyline98 || (_polyline98 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "140.07 334.98 140.13 335.04 140.19 335.04 140.49 335.16 141.03 335.34 141.15 335.34 141.51 335.4"
  })), _polyline99 || (_polyline99 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "118.29 557.16 118.11 557.28 117.93 557.34 117.75 557.34 116.85 557.22 116.01 557.1 115.23 556.92"
  })), _line80 || (_line80 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 118.29,
    y1: 557.16,
    x2: 118.35,
    y2: 557.16
  })), _polyline100 || (_polyline100 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "89.31 82.14 88.95 82.08 88.65 82.08"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M131.91,339h.06v.06h.12l.12.06c.37-.06.84.29,1.14.24l.06.06h.06c.5,0,.93.16,1.5.12l.24-.12"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M167.07,289.68h.06l.06.06c.38.13.64.28.96.42h.12l.54.18.3.06h.12l.12.06.24-.06.18-.06.12-.06"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M108.81,359.64v.12l.12.06c1.12.05,2.21-.04,3.3-.24l.06-.06"
  })), _line81 || (_line81 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 112.29,
    y1: 84.72,
    x2: 112.23,
    y2: 84.72
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M114.09,162.12l-.06.06-.18.3-.06.06v.06h-.06l-.06.12h-.06c-.33.33-.8.54-1.26.36l-.12-.06"
  })), _polyline101 || (_polyline101 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "158.73 103.98 158.25 103.8 158.01 103.68 157.77 103.68"
  })), _line82 || (_line82 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 158.85,
    y1: 103.98,
    x2: 158.73,
    y2: 103.98
  })), _polyline102 || (_polyline102 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "160.89 104.82 160.77 104.64 160.65 104.46 160.35 104.34 159.45 104.16 158.85 103.98"
  })), _line83 || (_line83 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 185.67,
    y1: 828.48,
    x2: 184.89,
    y2: 828.3
  })), _polyline103 || (_polyline103 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "187.89 829.26 187.71 828.84 187.59 828.78 187.41 828.72 187.05 828.66 185.67 828.48"
  })), _polyline104 || (_polyline104 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "145.95 755.1 145.47 754.92 145.17 754.86 145.05 754.8 144.99 754.86"
  })), _line84 || (_line84 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 146.01,
    y1: 755.1,
    x2: 145.95,
    y2: 755.1
  })), _polyline105 || (_polyline105 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "145.95 843.54 146.25 843.6 146.37 843.66 146.55 843.66 146.91 843.72 147.27 843.84 147.93 843.84 148.05 843.78 148.11 843.72"
  })), _polyline106 || (_polyline106 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "148.11 756.12 147.93 755.82 147.81 755.64 147.63 755.46 146.79 755.28 146.01 755.1"
  })), _polyline107 || (_polyline107 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "144.99 843.18 145.17 843.3 145.29 843.3 145.83 843.48 145.89 843.54 145.95 843.54"
  })), _polyline108 || (_polyline108 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "115.23 1003.86 116.01 1004.04 116.85 1004.16 117.75 1004.28 118.11 1004.28 118.29 1004.1"
  })), _line85 || (_line85 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 192.75,
    y1: 843.3,
    x2: 192.81,
    y2: 843.3
  })), _polyline109 || (_polyline109 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "194.67 844.02 194.55 843.66 194.37 843.48 194.07 843.42 192.81 843.3"
  })), _polyline110 || (_polyline110 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "164.13 530.94 164.01 531 163.83 531.06 163.59 531.12 163.35 531.06 162.57 530.88 162.15 530.76 161.85 530.58 161.25 530.34"
  })), _line86 || (_line86 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 164.13,
    y1: 530.94,
    x2: 164.19,
    y2: 530.94
  })), _polyline111 || (_polyline111 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "184.89 383.76 185.67 383.88 185.67 383.94"
  })), _polyline112 || (_polyline112 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "187.89 384.6 187.71 384.24 187.59 384.18 187.41 384.12 187.05 384.06 185.67 383.94"
  })), _polyline113 || (_polyline113 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "184.89 601.2 185.67 601.38 185.73 601.38 187.17 601.56"
  })), _polyline114 || (_polyline114 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "187.89 602.16 187.71 601.8 187.47 601.62 187.17 601.56"
  })), _polyline115 || (_polyline115 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "178.41 131.34 179.55 131.64 179.73 131.7"
  })), _polyline116 || (_polyline116 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "181.77 132.42 181.59 132.12 181.35 131.94 180.99 131.94 180.39 131.82 179.73 131.7"
  })), _polyline117 || (_polyline117 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "167.43 567.9 166.95 567.72 166.65 567.66 166.53 567.6 166.47 567.6"
  })), _line87 || (_line87 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 167.55,
    y1: 567.96,
    x2: 167.43,
    y2: 567.9
  })), _polyline118 || (_polyline118 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "169.59 568.8 169.29 568.5 169.05 568.32 168.15 568.14 167.55 567.96"
  })), _line88 || (_line88 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 122.61,
    y1: 966.3,
    x2: 122.37,
    y2: 966.48
  })), _line89 || (_line89 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 122.79,
    y1: 965.82,
    x2: 122.85,
    y2: 965.94
  })), _polyline119 || (_polyline119 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "121.47 966.54 121.35 966.3 121.35 966"
  })), _line90 || (_line90 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 122.85,
    y1: 964.74,
    x2: 122.85,
    y2: 964.68
  })), _line91 || (_line91 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 122.85,
    y1: 965.94,
    x2: 122.61,
    y2: 966.3
  })), _polyline120 || (_polyline120 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "120.63 1029.36 120.69 1029.42 120.75 1029.42 120.99 1029.48 121.41 1029.48 121.59 1029.36 121.95 1029.24 122.13 1029.12 122.37 1029 122.37 1028.94 122.43 1028.94 122.73 1028.64 122.85 1028.58 122.85 1028.52"
  })), _polyline121 || (_polyline121 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "120.63 964.98 120.75 965.52 120.69 965.76 120.63 965.88"
  })), _polyline122 || (_polyline122 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "122.25 965.28 122.55 965.52 122.79 965.82"
  })), _polyline123 || (_polyline123 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "112.29 564.6 112.23 564.66 111.93 564.72 111.45 564.78 110.49 564.84 109.47 564.9 108.93 564.9 108.81 564.78 108.81 564.72"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M116.13,122.22l-.18.12c-.52.19-.84-.13-1.56-.06l-.3-.06"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M129.21,595.5l-.06.12v.06h.06v.12l.06.18.06.12v.06h.18c.49.15.77,0,.84-.48l.06-.06"
  })), _polyline124 || (_polyline124 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "177.57 527.46 177.45 527.76 177.39 527.88 177.33 527.94 176.61 527.94 176.55 527.88 176.49 527.7 176.37 527.4"
  })), _line92 || (_line92 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 177.57,
    y1: 527.4,
    x2: 177.57,
    y2: 527.46
  })), _polyline125 || (_polyline125 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "167.43 353.16 166.59 352.86 166.47 352.86"
  })), _line93 || (_line93 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 167.55,
    y1: 353.22,
    x2: 167.43,
    y2: 353.16
  })), _polyline126 || (_polyline126 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "169.59 353.94 169.29 353.64 169.05 353.52 168.75 353.46 168.09 353.34 167.55 353.22"
  })), _line94 || (_line94 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 120.63,
    y1: 964.98,
    x2: 120.63,
    y2: 945.9
  })), _polyline127 || (_polyline127 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "135.21 770.58 134.97 770.7 134.73 770.76 134.49 770.7 133.53 770.58 132.63 770.4 132.27 770.28 132.03 770.22 131.91 770.16"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M106.23,161.22v.06l-.18.3-.06.06v.06l-.12.06v.06l-.12.06c-.43.33-.56.48-1.14.3l-.12-.06"
  })), _line95 || (_line95 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 177.57,
    y1: 277.98,
    x2: 177.57,
    y2: 277.92
  })), _polyline128 || (_polyline128 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "176.37 277.92 176.37 278.04 176.43 278.16 176.49 278.34 176.55 278.4 176.67 278.46 176.91 278.52 177.15 278.52 177.39 278.46 177.45 278.34 177.51 278.1 177.57 277.98"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M161.01,758.52l-.06.06c-.96.29-2.04-.3-3-.48l-.12-.06"
  })), _line96 || (_line96 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 151.71,
    y1: 331.56,
    x2: 151.71,
    y2: 331.5
  })), _line97 || (_line97 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 161.01,
    y1: 758.46,
    x2: 161.01,
    y2: 758.52
  })), _polyline129 || (_polyline129 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "197.55 170.46 198.39 170.64 198.57 170.64"
  })), _polyline130 || (_polyline130 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "200.61 170.94 200.55 170.76 200.31 170.7 199.77 170.7 198.57 170.64"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M93.81,138.96l-.18.12-.18.06h-.42l-.42-.06-.3-.06h-.18c-.23.03-.52-.08-.78-.12l-.42-.06-.3-.06"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M185.61,1197.78l.18-.06c.16-.16.32-.32.48-.48h.06"
  })), _polyline131 || (_polyline131 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "184.11 1198.02 184.17 1198.08 184.29 1198.14 184.65 1198.2 184.89 1198.14 185.01 1198.08 185.07 1198.08 185.25 1197.96 185.55 1197.84 185.61 1197.78"
  })), _polyline132 || (_polyline132 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "184.89 142.92 185.67 143.1 185.73 143.1"
  })), _polyline133 || (_polyline133 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "187.89 143.82 187.71 143.46 187.59 143.34 187.41 143.28 187.11 143.28 186.39 143.22 185.73 143.1"
  })), _line98 || (_line98 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 120.93,
    y1: 85.8,
    x2: 120.57,
    y2: 85.8
  })), _polyline134 || (_polyline134 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "122.61 163.26 122.49 163.38 122.31 163.5 122.19 163.62 122.13 163.68 122.07 163.74 121.95 163.8 121.89 163.86 121.65 163.92 121.35 164.1 121.17 164.16 121.11 164.22 120.69 164.22 120.51 164.16 120.39 164.1"
  })), _line99 || (_line99 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 135.33,
    y1: 311.76,
    x2: 135.27,
    y2: 311.64
  })), _polyline135 || (_polyline135 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "136.23 310.92 136.71 311.64 137.13 312.24"
  })), _line100 || (_line100 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 151.53,
    y1: 331.62,
    x2: 151.71,
    y2: 331.56
  })), _polyline136 || (_polyline136 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "200.85 414 200.73 415.2 200.61 416.28"
  })), _line101 || (_line101 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 166.47,
    y1: 352.86,
    x2: 165.51,
    y2: 351.78
  })), _line102 || (_line102 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 112.77,
    y1: 559.62,
    x2: 112.29,
    y2: 559.56
  })), _line103 || (_line103 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 186.33,
    y1: 1170.9,
    x2: 186.33,
    y2: 1185.96
  })), _line104 || (_line104 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 121.53,
    y1: 270.42,
    x2: 121.53,
    y2: 290.94
  })), _line105 || (_line105 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 112.83,
    y1: 84.78,
    x2: 112.29,
    y2: 84.72
  })), _line106 || (_line106 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 184.47,
    y1: 873.66,
    x2: 184.53,
    y2: 873.66
  })), _polyline137 || (_polyline137 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "130.77 467.1 132.87 465.84 135.21 464.52 137.67 463.32 140.31 462.12 145.47 459.72 150.75 457.26"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M112.23,124.74l-.78-.06c-.51.03-.93-.22-1.44-.24l-.3-.06"
  })), _polyline138 || (_polyline138 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "118.29 1001.28 119.43 1001.52 120.63 1001.64"
  })), _line107 || (_line107 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 135.21,
    y1: 467.76,
    x2: 135.21,
    y2: 516.42
  })), _polyline139 || (_polyline139 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "129.15 546.84 128.61 546.72 128.37 546.66 128.25 546.6 128.19 546.6"
  })), _polyline140 || (_polyline140 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "120.39 117.42 120.21 117.42 120.09 117.36 119.61 117.3 119.43 117.24 119.31 117.18"
  })), _polyline141 || (_polyline141 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "141.51 987.42 140.73 987.24 140.37 987.12 140.13 987.06 140.07 987"
  })), _line108 || (_line108 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 170.91,
    y1: 1027.86,
    x2: 169.59,
    y2: 1025.76
  })), _line109 || (_line109 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 177.57,
    y1: 1141.5,
    x2: 177.57,
    y2: 1210.98
  })), _polyline142 || (_polyline142 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "122.85 999.06 123.99 999.18 124.53 999.18 124.71 999.12 124.77 999"
  })), _line110 || (_line110 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 118.29,
    y1: 273,
    x2: 118.29,
    y2: 287.82
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M129.15,113.1l-.3-.06c-.68-.07-1.18-.1-1.86-.24l-.36-.12"
  })), _polyline143 || (_polyline143 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "120.63 780.84 119.43 780.66 118.29 780.42"
  })), _polyline144 || (_polyline144 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "120.63 554.7 119.43 554.58 118.29 554.34"
  })), _line111 || (_line111 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 118.29,
    y1: 927.48,
    x2: 118.29,
    y2: 940.62
  })), _line112 || (_line112 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 122.85,
    y1: 947.76,
    x2: 122.85,
    y2: 964.68
  })), _line113 || (_line113 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 157.77,
    y1: 343.02,
    x2: 155.91,
    y2: 340.92
  })), _line114 || (_line114 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 162.45,
    y1: 348.24,
    x2: 160.89,
    y2: 346.5
  })), _line115 || (_line115 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 170.91,
    y1: 358.38,
    x2: 169.59,
    y2: 356.52
  })), _line116 || (_line116 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 187.89,
    y1: 1056.9,
    x2: 187.89,
    y2: 1100.34
  })), _polyline145 || (_polyline145 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "122.37 520.14 122.19 520.2 121.95 520.2 121.47 520.14"
  })), _polyline146 || (_polyline146 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "122.37 346.98 122.19 347.04 121.95 347.1 121.47 347.04"
  })), _polyline147 || (_polyline147 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "122.37 752.34 122.19 752.4 121.95 752.46 121.47 752.4"
  })), _line117 || (_line117 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 120.63,
    y1: 750.9,
    x2: 120.63,
    y2: 725.16
  })), _line118 || (_line118 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 160.23,
    y1: 86.28,
    x2: 160.29,
    y2: 86.28
  })), _polyline148 || (_polyline148 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "122.37 966.48 122.19 966.54 121.95 966.6 121.47 966.54"
  })), _line119 || (_line119 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 144.99,
    y1: 327.54,
    x2: 144.57,
    y2: 326.94
  })), _polyline149 || (_polyline149 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "163.41 1015.2 162.87 1014.96 162.57 1014.9 162.45 1014.84 162.45 1014.9"
  })), _line120 || (_line120 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 163.41,
    y1: 1015.2,
    x2: 163.47,
    y2: 1015.2
  })), _line121 || (_line121 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 165.51,
    y1: 1016.22,
    x2: 165.51,
    y2: 1016.16
  })), _polyline150 || (_polyline150 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "163.41 1015.2 163.95 1015.32 164.67 1015.5"
  })), _polyline151 || (_polyline151 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "165.51 1016.16 165.27 1015.74 165.03 1015.56 164.67 1015.5"
  })), _line122 || (_line122 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 163.41,
    y1: 109.2,
    x2: 162.69,
    y2: 108.96
  })), _polyline152 || (_polyline152 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "162.45 108.9 162.45 108.84 162.69 108.96"
  })), _line123 || (_line123 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 163.41,
    y1: 109.2,
    x2: 163.47,
    y2: 109.2
  })), _polyline153 || (_polyline153 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "165.51 110.04 165.51 109.98 165.21 109.68 164.91 109.5 164.61 109.44 164.01 109.38 163.41 109.2"
  })), _line124 || (_line124 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 128.13,
    y1: 549.42,
    x2: 128.19,
    y2: 549.42
  })), _line125 || (_line125 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 155.91,
    y1: 179.82,
    x2: 155.91,
    y2: 179.76
  })), _line126 || (_line126 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 155.55,
    y1: 98.76,
    x2: 153.81,
    y2: 98.34
  })), _polyline154 || (_polyline154 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "155.91 99.18 155.79 98.94 155.55 98.76"
  })), _line127 || (_line127 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 152.85,
    y1: 97.98,
    x2: 152.91,
    y2: 97.98
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M74.43,157.74v.06l-.18.3-.06.12h-.06l-.06.12h-.06c-.51.26-.53.58-1.26.36l-.12-.06"
  })), _polyline155 || (_polyline155 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "178.41 1042.5 179.55 1042.74 179.67 1042.74"
  })), _polyline156 || (_polyline156 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "181.77 1043.52 181.59 1043.16 181.35 1042.98 180.99 1042.98 179.67 1042.74"
  })), _line128 || (_line128 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 84.27,
    y1: 67.68,
    x2: 84.15,
    y2: 67.8
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M84.27,146.16l-.12.12c-.49.19-.84-.12-1.62-.06l-.18-.06"
  })), _polyline157 || (_polyline157 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "142.41 532.92 141.93 532.74 141.57 532.56 141.51 532.56"
  })), _line129 || (_line129 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 141.51,
    y1: 532.62,
    x2: 141.57,
    y2: 532.62
  })), _line130 || (_line130 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 142.47,
    y1: 532.92,
    x2: 142.41,
    y2: 532.92
  })), _polyline158 || (_polyline158 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "142.47 620.28 142.71 620.34 142.83 620.4 143.07 620.4 143.37 620.46 143.73 620.52 143.91 620.58 144.39 620.58 144.51 620.52 144.57 620.46 144.57 620.4"
  })), _polyline159 || (_polyline159 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "141.51 619.92 141.63 619.98 142.35 620.22 142.47 620.28"
  })), _polyline160 || (_polyline160 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "164.13 977.88 164.01 977.94 163.83 978 163.59 978.06 163.35 978 162.57 977.82 162.15 977.7 161.85 977.58 161.25 977.28"
  })), _polyline161 || (_polyline161 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "106.53 129.42 106.47 129.48 106.23 129.54"
  })), _polyline162 || (_polyline162 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "176.13 1035.54 175.17 1035.18 175.05 1035.18 174.99 1035.24"
  })), _polyline163 || (_polyline163 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "176.13 1035.54 176.19 1035.54 176.31 1035.6"
  })), _polyline164 || (_polyline164 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "178.41 1036.56 178.23 1036.14 178.05 1035.96 177.69 1035.9 176.31 1035.6"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M156.63,534.42l-.12.12c-.4.27-2.45-.33-3-.48l-.12-.06"
  })), _polyline165 || (_polyline165 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "178.41 815.04 179.55 815.28 179.61 815.28 179.73 815.34"
  })), _line131 || (_line131 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 179.91,
    y1: 815.4,
    x2: 179.79,
    y2: 815.34
  })), _polyline166 || (_polyline166 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "181.77 816.12 181.59 815.76 181.47 815.58 181.17 815.52 179.91 815.4"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M156.81,93.24l-.24.12-.24.06-.12-.06h-.36l-.42-.06h-.3l-.48-.12c-.38.06-.7-.21-1.08-.18h-.06l-.12-.12"
  })), _polyline167 || (_polyline167 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "151.71 983.58 151.47 983.7 151.23 983.76 150.99 983.7 150.03 983.52 149.19 983.34 148.83 983.22 148.59 983.16 148.53 983.1"
  })), _line132 || (_line132 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 151.71,
    y1: 983.52,
    x2: 151.71,
    y2: 983.58
  })), _line133 || (_line133 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 142.89,
    y1: 87.78,
    x2: 142.95,
    y2: 87.78
  })), _polyline168 || (_polyline168 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "165.21 8.88 165.33 8.82 165.33 8.34 165.27 8.22 165.15 8.16 164.91 8.04 163.29 7.68 161.67 7.68"
  })), _line134 || (_line134 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 106.53,
    y1: 51.24,
    x2: 106.53,
    y2: 81.84
  })), _line135 || (_line135 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 156.63,
    y1: 534.42,
    x2: 156.69,
    y2: 534.42
  })), _polyline169 || (_polyline169 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "150.09 991.8 149.55 991.62 149.31 991.5 149.19 991.5 149.19 991.56"
  })), _line136 || (_line136 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 150.15,
    y1: 991.8,
    x2: 150.09,
    y2: 991.8
  })), _polyline170 || (_polyline170 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "152.25 992.94 152.19 992.7 152.07 992.52 151.89 992.28 151.65 992.1 150.15 991.8"
  })), _polyline171 || (_polyline171 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "167.43 1021.44 166.89 1021.26 166.65 1021.2 166.53 1021.14 166.47 1021.2"
  })), _line137 || (_line137 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 167.55,
    y1: 1021.44,
    x2: 167.43,
    y2: 1021.44
  })), _polyline172 || (_polyline172 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "169.59 1022.34 169.35 1021.98 169.17 1021.8 167.67 1021.5 167.55 1021.44"
  })), _polyline173 || (_polyline173 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "142.41 748.98 141.93 748.8 141.57 748.62 141.51 748.68"
  })), _line138 || (_line138 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 142.47,
    y1: 749.04,
    x2: 142.41,
    y2: 748.98
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M142.47,845.16l.24.06c.6.01,1.22.43,1.8.12l.06-.06"
  })), _line139 || (_line139 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 142.77,
    y1: 749.1,
    x2: 142.47,
    y2: 749.04
  })), _line140 || (_line140 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 144.57,
    y1: 845.28,
    x2: 144.63,
    y2: 845.28
  })), _polyline174 || (_polyline174 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "141.51 844.8 141.63 844.86 142.35 845.1 142.47 845.16"
  })), _polyline175 || (_polyline175 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "145.95 539.04 145.47 538.86 145.23 538.8 145.05 538.74 144.99 538.8"
  })), _line141 || (_line141 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 146.07,
    y1: 539.1,
    x2: 145.95,
    y2: 539.04
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M145.95,618.66l.3.12c.42.03,1.44.38,1.8.12l.06-.06"
  })), _polyline176 || (_polyline176 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "144.99 618.3 145.17 618.42 145.29 618.48 145.65 618.54 145.83 618.6 145.89 618.66 145.95 618.66"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M156.63,981.42l-.12.06c-.4.27-2.45-.33-3-.48l-.12-.06"
  })), _line142 || (_line142 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 156.63,
    y1: 981.36,
    x2: 156.63,
    y2: 981.42
  })), _line143 || (_line143 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 128.13,
    y1: 344.34,
    x2: 128.19,
    y2: 344.34
  })), _line144 || (_line144 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 134.07,
    y1: 733.8,
    x2: 134.01,
    y2: 733.74
  })), _line145 || (_line145 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 135.51,
    y1: 737.64,
    x2: 135.39,
    y2: 737.46
  })), _line146 || (_line146 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 144.33,
    y1: 748.38,
    x2: 144.33,
    y2: 691.2
  })), _line147 || (_line147 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 172.05,
    y1: 574.2,
    x2: 171.09,
    y2: 573.84
  })), _line148 || (_line148 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 171.03,
    y1: 573.84,
    x2: 170.91,
    y2: 573.84
  })), _line149 || (_line149 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 172.11,
    y1: 574.2,
    x2: 172.05,
    y2: 574.2
  })), _polyline177 || (_polyline177 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "174.21 575.16 174.03 574.8 173.79 574.62 173.43 574.5 172.77 574.38 172.11 574.2"
  })), _polyline178 || (_polyline178 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "90.63 141.36 90.51 141.48 90.33 141.54"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M126.63,115.2l-.18.18h-.54l-.18-.06h-.48l-.18-.06h-.06l-.48-.06c-.36-.02-.7-.22-1.08-.18l-.06-.06-.12-.06"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M161.01,979.32l-.06.12c-.99.22-2.04-.26-3-.48l-.12-.06"
  })), _line150 || (_line150 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 152.85,
    y1: 768,
    x2: 152.91,
    y2: 768
  })), _line151 || (_line151 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 161.01,
    y1: 979.32,
    x2: 161.07,
    y2: 979.32
  })), _line152 || (_line152 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 152.85,
    y1: 768.3,
    x2: 152.25,
    y2: 767.28
  })), _line153 || (_line153 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 115.11,
    y1: 711.06,
    x2: 115.11,
    y2: 718.2
  })), _line154 || (_line154 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 90.63,
    y1: 62.88,
    x2: 90.63,
    y2: 80.1
  })), _line155 || (_line155 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 143.25,
    y1: 86.58,
    x2: 143.25,
    y2: 24.72
  })), _line156 || (_line156 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 139.05,
    y1: 912.66,
    x2: 139.05,
    y2: 967.74
  })), _polyline179 || (_polyline179 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "200.91 859.62 200.79 861 200.61 862.32"
  })), _polyline180 || (_polyline180 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "197.55 404.64 197.37 404.22 197.31 404.1 197.13 404.04 196.77 403.98 196.11 403.86 195.39 403.68"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M160.23,90.72l-.24.12-.24.06c-.35-.05-.71-.12-1.08-.12h-.12l-.42-.06-.18-.06h-.18l-.18-.06-.48-.06-.12-.06h-.06l-.12-.06"
  })), _polyline181 || (_polyline181 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "181.77 821.88 182.61 822.06 182.73 822.06 184.17 822.24"
  })), _polyline182 || (_polyline182 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "184.77 822.42 184.53 822.24 184.17 822.24"
  })), _line157 || (_line157 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 184.89,
    y1: 822.78,
    x2: 184.77,
    y2: 822.42
  })), _polyline183 || (_polyline183 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "150.09 544.98 149.61 544.8 149.31 544.68 149.19 544.62 149.19 544.68"
  })), _line158 || (_line158 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 150.15,
    y1: 544.98,
    x2: 150.09,
    y2: 544.98
  })), _polyline184 || (_polyline184 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "152.25 545.88 152.19 545.76 151.95 545.4 151.71 545.28"
  })), _polyline185 || (_polyline185 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "151.65 545.28 150.87 545.16 150.15 544.98"
  })), _polyline186 || (_polyline186 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "177.57 753.54 177.45 753.9 177.39 753.96 177.33 754.02 176.85 754.08 176.61 754.02 176.55 753.96 176.49 753.78 176.37 753.48"
  })), _line159 || (_line159 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 177.57,
    y1: 753.48,
    x2: 177.57,
    y2: 753.54
  })), _polyline187 || (_polyline187 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "137.31 740.94 137.79 741.24 137.91 741.3"
  })), _polyline188 || (_polyline188 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "137.79 833.58 137.97 833.7 138.03 833.7 138.15 833.76 138.63 833.94 138.81 834.06 139.35 834.06 139.53 834 139.59 833.94"
  })), _polyline189 || (_polyline189 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "138.93 741.84 138.69 741.66 138.39 741.6 137.91 741.36"
  })), _polyline190 || (_polyline190 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "137.31 833.16 137.31 833.22 137.37 833.28 137.67 833.46 137.79 833.52 137.79 833.58"
  })), _polyline191 || (_polyline191 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "129.21 821.04 129.15 821.1 129.27 821.46 129.33 821.64 129.51 821.7 130.05 821.7 130.17 821.64 130.23 821.46 130.41 821.1"
  })), _polyline192 || (_polyline192 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "176.07 364.98 175.47 364.8 175.17 364.74 175.05 364.68 174.99 364.74"
  })), _line160 || (_line160 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 176.19,
    y1: 365.04,
    x2: 176.07,
    y2: 364.98
  })), _polyline193 || (_polyline193 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "178.41 365.88 178.23 365.52 177.93 365.34 177.63 365.28 176.19 365.04"
  })), _line161 || (_line161 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 182.73,
    y1: 137.34,
    x2: 181.77,
    y2: 137.16
  })), _polyline194 || (_polyline194 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "184.89 138 184.71 137.64 184.47 137.52 184.11 137.46 182.73 137.34"
  })), _line162 || (_line162 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 137.31,
    y1: 315.72,
    x2: 137.79,
    y2: 315.9
  })), _polyline195 || (_polyline195 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "137.79 399.6 137.97 399.72 138.03 399.72 138.63 400.02 138.81 400.08 138.87 400.08 138.93 400.14 139.35 400.08 139.53 400.02 139.59 399.96"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M139.59,317.16l-.06-.24c-.76-.7-.2-.6-1.26-.84l-.48-.18"
  })), _polyline196 || (_polyline196 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "137.31 399.18 137.31 399.24 137.37 399.3 137.67 399.54 137.79 399.6"
  })), _line163 || (_line163 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 137.79,
    y1: 524.1,
    x2: 137.67,
    y2: 524.04
  })), _line164 || (_line164 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 137.43,
    y1: 523.92,
    x2: 137.31,
    y2: 523.92
  })), _line165 || (_line165 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 137.67,
    y1: 524.04,
    x2: 137.43,
    y2: 523.92
  })), _line166 || (_line166 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 137.85,
    y1: 524.1,
    x2: 137.79,
    y2: 524.1
  })), _polyline197 || (_polyline197 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "137.79 608.4 137.97 608.52 138.03 608.52 138.15 608.58 138.63 608.76 138.81 608.88 139.35 608.88 139.53 608.82 139.59 608.76"
  })), _polyline198 || (_polyline198 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "137.31 607.98 137.31 608.04 137.37 608.1 137.67 608.28 137.79 608.34 137.79 608.4"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M190.83,505.68l.12.06c.34.13.59.06.9-.06l.36-.12"
  })), _polyline199 || (_polyline199 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "137.31 542.4 136.53 542.22 136.17 542.1 135.93 542.04 135.87 541.98"
  })), _polyline200 || (_polyline200 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "163.41 785.7 162.45 785.4 162.45 785.46"
  })), _polyline201 || (_polyline201 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "165.51 786.84 165.45 786.6 165.09 786.12 164.73 786 164.01 785.88 163.41 785.7"
  })), _polyline202 || (_polyline202 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "187.89 388.14 187.95 388.2 188.01 388.2"
  })), _polyline203 || (_polyline203 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "190.17 388.92 189.99 388.56 189.87 388.44 189.75 388.38 189.39 388.32 188.01 388.2"
  })), _polyline204 || (_polyline204 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "151.71 536.58 151.59 536.7 151.47 536.76 150.99 536.76 150.03 536.58 149.19 536.4 148.83 536.28 148.59 536.22 148.53 536.16"
  })), _line167 || (_line167 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 131.55,
    y1: 341.82,
    x2: 131.61,
    y2: 341.82
  })), _polyline205 || (_polyline205 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "128.19 341.52 128.25 341.58 128.31 341.58 128.49 341.64 129.15 341.76"
  })), _polyline206 || (_polyline206 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "164.13 757.02 164.01 757.14 163.83 757.2 163.59 757.2 163.35 757.14 162.57 756.96 162.15 756.84 161.85 756.72 161.25 756.42"
  })), _polyline207 || (_polyline207 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "192.39 729.12 191.61 729.36 191.43 729.42 191.19 729.42 190.95 729.36 190.83 729.3"
  })), _line168 || (_line168 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 139.71,
    y1: 105.72,
    x2: 139.59,
    y2: 105.78
  })), _polyline208 || (_polyline208 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "124.77 552.06 124.71 552.18 124.53 552.24 123.99 552.24 122.85 552.06"
  })), _line169 || (_line169 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 124.77,
    y1: 552.06,
    x2: 124.83,
    y2: 552.06
  })), _polyline209 || (_polyline209 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "190.17 393.12 190.41 393.12 190.53 393.18"
  })), _polyline210 || (_polyline210 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "192.75 393.84 192.57 393.48 192.27 393.3 191.97 393.3 190.59 393.18"
  })), _polyline211 || (_polyline211 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "172.05 800.16 171.45 799.98 171.09 799.86 170.97 799.8 170.91 799.86"
  })), _line170 || (_line170 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 172.05,
    y1: 800.16,
    x2: 172.11,
    y2: 800.16
  })), _polyline212 || (_polyline212 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "174.21 801.18 174.21 801.12 174.03 800.76 173.73 800.52 173.43 800.46 172.05 800.16"
  })), _polyline213 || (_polyline213 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "119.31 119.82 119.13 119.94 118.95 120 118.77 120 118.53 119.94 118.11 119.94 117.75 119.88 117.57 119.88 117.33 119.82 117.09 119.82 116.79 119.76 116.37 119.64 116.13 119.58"
  })), _polyline214 || (_polyline214 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "158.73 556.62 158.25 556.44 157.95 556.38 157.83 556.32 157.77 556.38"
  })), _line171 || (_line171 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 158.79,
    y1: 556.68,
    x2: 158.73,
    y2: 556.62
  })), _polyline215 || (_polyline215 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "160.89 557.58 160.83 557.4 160.65 557.22 160.41 557.04 160.11 556.92 158.91 556.68 158.79 556.68"
  })), _polyline216 || (_polyline216 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "197.55 1089.42 198.33 1089.6 198.57 1089.6"
  })), _line172 || (_line172 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 200.55,
    y1: 1090.5,
    x2: 200.61,
    y2: 1090.26
  })), _polyline217 || (_polyline217 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "200.61 1090.08 200.55 1089.9 200.43 1089.78 199.77 1089.72 198.57 1089.6"
  })), _polyline218 || (_polyline218 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "190.17 611.7 190.47 611.76 190.53 611.82 190.77 611.82"
  })), _polyline219 || (_polyline219 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "192.75 612.54 192.57 612.18 192.39 612 192.09 611.94 190.77 611.82"
  })), _polyline220 || (_polyline220 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "153.75 998.34 153.27 998.16 152.97 998.1 152.85 998.04 152.85 998.1"
  })), _line173 || (_line173 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 153.81,
    y1: 998.34,
    x2: 153.75,
    y2: 998.34
  })), _polyline221 || (_polyline221 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "155.91 999.54 155.85 999.3 155.49 998.82 155.13 998.7 153.81 998.34"
  })), _polyline222 || (_polyline222 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "176.07 581.16 175.11 580.8 174.99 580.86"
  })), _line174 || (_line174 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 176.19,
    y1: 581.16,
    x2: 176.07,
    y2: 581.16
  })), _polyline223 || (_polyline223 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "178.41 582.06 178.23 581.7 177.93 581.52 177.63 581.46 176.19 581.16"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M185.61,516.06l.18-.06c.16-.16.32-.32.48-.48h.06"
  })), _polyline224 || (_polyline224 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "184.11 516.36 184.17 516.36 184.29 516.42 184.65 516.48 184.89 516.42 185.01 516.36 185.07 516.36 185.25 516.24 185.55 516.12 185.61 516.06"
  })), _line175 || (_line175 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 193.17,
    y1: 1072.2,
    x2: 192.75,
    y2: 1072.14
  })), _polyline225 || (_polyline225 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "194.67 1072.92 194.55 1072.62 194.49 1072.44 194.25 1072.32 193.17 1072.2"
  })), _polyline226 || (_polyline226 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "137.79 163.92 137.91 164.04 138.03 164.04 138.09 164.1 138.27 164.16 138.63 164.34 138.81 164.4 138.93 164.4 139.05 164.46 139.35 164.4 139.53 164.34 139.59 164.28"
  })), _polyline227 || (_polyline227 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "137.31 163.5 137.31 163.56 137.37 163.62 137.67 163.86 137.79 163.92"
  })), _line176 || (_line176 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 194.67,
    y1: 1072.92,
    x2: 194.67,
    y2: 1103.4
  })), _polyline228 || (_polyline228 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "181.77 594.24 182.67 594.42 182.73 594.42"
  })), _polyline229 || (_polyline229 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "108.81 1011.66 108.81 1011.78 108.93 1011.84 110.49 1011.84 111.93 1011.66 112.23 1011.66 112.29 1011.54"
  })), _line177 || (_line177 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 136.77,
    y1: 519.12,
    x2: 136.71,
    y2: 519
  })), _polyline230 || (_polyline230 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "133.59 515.94 133.65 516.06 133.77 516.24"
  })), _polyline231 || (_polyline231 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "108.09 486.66 108.15 486.12 108.21 485.7 108.45 484.92 108.93 484.26 109.47 483.66 110.79 482.46 112.23 481.26 115.29 478.8 118.29 476.46 124.35 471.78 127.47 469.44 129.09 468.3 130.77 467.16"
  })), _polyline232 || (_polyline232 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "200.79 635.82 200.79 636.48 200.73 637.2 200.67 637.86 200.61 638.4"
  })), _line178 || (_line178 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 134.97,
    y1: 518.52,
    x2: 134.85,
    y2: 518.28
  })), _polyline233 || (_polyline233 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "142.41 322.98 141.57 322.56 141.51 322.62"
  })), _line179 || (_line179 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 142.47,
    y1: 322.98,
    x2: 142.41,
    y2: 322.98
  })), _polyline234 || (_polyline234 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "142.47 410.22 142.35 410.22 142.23 410.16 142.11 410.1"
  })), _polyline235 || (_polyline235 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "144.57 324.12 144.45 323.94 144.33 323.7 144.03 323.52 143.73 323.4 143.07 323.22 142.47 322.98"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M144.57,410.4l-.06.06c-.58.31-1.2-.11-1.8-.12l-.24-.12"
  })), _polyline236 || (_polyline236 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "141.51 397.86 141.57 397.86 141.63 397.92 141.69 397.92 141.81 397.98"
  })), _line180 || (_line180 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 144.57,
    y1: 410.4,
    x2: 144.63,
    y2: 410.4
  })), _polyline237 || (_polyline237 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "135.87 517.62 136.35 518.4 136.71 519"
  })), _line181 || (_line181 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 87.45,
    y1: 65.28,
    x2: 87.27,
    y2: 65.4
  })), _polyline238 || (_polyline238 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "87.45 143.76 87.27 143.88 87.09 143.94 86.91 143.94 86.67 143.88 86.25 143.88 85.95 143.82 85.71 143.82 85.53 143.76 85.23 143.76 84.99 143.7 84.57 143.58 84.27 143.52"
  })), _line182 || (_line182 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 152.85,
    y1: 337.2,
    x2: 152.91,
    y2: 337.2
  })), _line183 || (_line183 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 153.81,
    y1: 337.56,
    x2: 153.87,
    y2: 337.56
  })), _polyline239 || (_polyline239 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "155.91 338.4 155.79 338.22 155.67 338.04 155.37 337.86 155.01 337.8 153.81 337.56"
  })), _polyline240 || (_polyline240 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "155.91 417.42 155.85 417.48 155.67 417.6 155.19 417.6"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M129.21,387.96l-.06.12v.06h.06v.12l.06.18.06.12v.06h.18c.49.15.77,0,.84-.48l.06-.06"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M82.35,158.64v.06l-.18.3-.06.06v.06l-.12.06v.06l-.12.06c-.41.32-.59.47-1.14.3l-.12-.06"
  })), _line184 || (_line184 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 80.61,
    y1: 81.18,
    x2: 80.67,
    y2: 81.18
  })), _polyline241 || (_polyline241 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "137.79 969.12 137.31 969 137.31 969.06"
  })), _line185 || (_line185 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 137.79,
    y1: 969.12,
    x2: 137.85,
    y2: 969.12
  })), _polyline242 || (_polyline242 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "137.79 1057.2 137.97 1057.32 138.03 1057.32 138.63 1057.62 138.81 1057.68 139.35 1057.68 139.53 1057.62 139.59 1057.56"
  })), _polyline243 || (_polyline243 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "137.79 969.12 138.15 969.24 138.69 969.36"
  })), _line186 || (_line186 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 139.59,
    y1: 1057.56,
    x2: 139.65,
    y2: 1057.56
  })), _polyline244 || (_polyline244 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "137.31 1056.78 137.31 1056.84 137.37 1056.9 137.67 1057.14 137.79 1057.2"
  })), _polyline245 || (_polyline245 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "197.55 413.46 198.39 413.64 198.57 413.64"
  })), _polyline246 || (_polyline246 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "200.61 414.12 200.55 414 200.37 413.82 199.77 413.82 198.57 413.64"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M71.61,155.4l-.06.12c-.66.2-2.57-.12-3.3-.24l-.12-.06"
  })), _line187 || (_line187 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 87.45,
    y1: 65.28,
    x2: 87.45,
    y2: 79.74
  })), _line188 || (_line188 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 135.87,
    y1: 517.62,
    x2: 135.87,
    y2: 467.34
  })), _polyline247 || (_polyline247 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "130.41 341.94 130.83 342 131.37 342 131.55 341.82"
  })), _line189 || (_line189 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 124.77,
    y1: 475.38,
    x2: 124.77,
    y2: 500.28
  })), _line190 || (_line190 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 149.19,
    y1: 544.8,
    x2: 148.11,
    y2: 543.36
  })), _line191 || (_line191 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 174.99,
    y1: 581.28,
    x2: 174.21,
    y2: 579.84
  })), _polyline248 || (_polyline248 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "139.59 525.6 139.53 525.36 139.35 525 139.11 524.7 138.81 524.46 138.33 524.34 137.85 524.1"
  })), _line192 || (_line192 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 143.19,
    y1: 691.74,
    x2: 143.19,
    y2: 746.52
  })), _line193 || (_line193 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 71.61,
    y1: 76.92,
    x2: 71.61,
    y2: 77.94
  })), _polyline249 || (_polyline249 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "155.25 179.94 155.67 179.94 155.91 179.82"
  })), _polyline250 || (_polyline250 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "137.31 989.34 136.53 989.16 136.17 989.04 135.93 988.98 135.87 988.92"
  })), _line194 || (_line194 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 128.13,
    y1: 472.8,
    x2: 128.13,
    y2: 504.12
  })), _line195 || (_line195 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 170.91,
    y1: 119.52,
    x2: 169.59,
    y2: 117.54
  })), _line196 || (_line196 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 162.45,
    y1: 785.64,
    x2: 160.89,
    y2: 782.94
  })), _line197 || (_line197 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 170.91,
    y1: 800.1,
    x2: 169.59,
    y2: 797.64
  })), _polyline251 || (_polyline251 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "141.51 766.62 140.73 766.38 140.37 766.26 140.13 766.2 140.07 766.14"
  })), _line198 || (_line198 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 119.31,
    y1: 42,
    x2: 119.31,
    y2: 83.4
  })), _line199 || (_line199 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 143.13,
    y1: 24.78,
    x2: 143.13,
    y2: 86.58
  })), _line200 || (_line200 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 139.71,
    y1: 85.74,
    x2: 139.71,
    y2: 27.24
  })), _line201 || (_line201 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 140.07,
    y1: 741.6,
    x2: 140.07,
    y2: 693.24
  })), _line202 || (_line202 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 193.41,
    y1: 678.54,
    x2: 193.47,
    y2: 678.54
  })), _line203 || (_line203 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 170.91,
    y1: 573.9,
    x2: 169.59,
    y2: 571.8
  })), _line204 || (_line204 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 136.35,
    y1: 85.2,
    x2: 136.35,
    y2: 29.7
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M130.11,695.58l2.04-1.26c12.04-6.4,25.27-11.76,37.68-17.7l1.86-.96"
  })), _polyline252 || (_polyline252 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "144.57 750.24 144.51 750 144.39 749.82 144.21 749.58 143.91 749.4 142.77 749.1"
  })), _line205 || (_line205 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 124.77,
    y1: 344.04,
    x2: 124.83,
    y2: 344.04
  })), _line206 || (_line206 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 136.41,
    y1: 736.8,
    x2: 136.35,
    y2: 736.74
  })), _polyline253 || (_polyline253 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "133.83 735.48 133.95 735.6 134.07 735.78"
  })), _line207 || (_line207 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 151.71,
    y1: 536.58,
    x2: 151.77,
    y2: 536.58
  })), _polyline254 || (_polyline254 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "137.31 105.66 136.89 105.54 136.59 105.48 136.41 105.48 136.35 105.42"
  })), _polyline255 || (_polyline255 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "80.61 148.68 80.37 148.68 79.47 148.62 79.29 148.62 79.23 148.56 78.93 148.56 78.81 148.5 78.51 148.5 78.03 148.38 77.85 148.32 77.73 148.32"
  })), _line208 || (_line208 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 112.89,
    y1: 46.62,
    x2: 112.89,
    y2: 82.56
  })), _line209 || (_line209 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 112.29,
    y1: 1006.5,
    x2: 112.77,
    y2: 1006.56
  })), _line210 || (_line210 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 131.91,
    y1: 509.88,
    x2: 131.91,
    y2: 469.98
  })), _line211 || (_line211 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 135.21,
    y1: 914.82,
    x2: 135.21,
    y2: 961.38
  })), _polyline256 || (_polyline256 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "133.65 915.24 133.71 915.54 133.65 915.72 133.59 915.84"
  })), _line212 || (_line212 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 128.13,
    y1: 700.74,
    x2: 128.13,
    y2: 727.38
  })), _line213 || (_line213 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 122.85,
    y1: 502.2,
    x2: 122.85,
    y2: 518.28
  })), _line214 || (_line214 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 128.19,
    y1: 504.24,
    x2: 128.19,
    y2: 472.74
  })), _polyline257 || (_polyline257 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "115.23 351.84 115.53 351.9 115.95 352.02 116.13 352.08 116.37 352.08 116.61 352.14 116.85 352.14 117.63 352.26 117.99 352.26 118.11 352.2 118.29 352.08"
  })), _polyline258 || (_polyline258 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "72.63 153.3 72.45 153.24 72.33 153.24 72.03 153.18 71.61 153.12"
  })), _polyline259 || (_polyline259 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "149.19 762.48 148.77 762.36 148.59 762.3 148.53 762.24"
  })), _line215 || (_line215 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 143.19,
    y1: 910.68,
    x2: 143.19,
    y2: 975.24
  })), _line216 || (_line216 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 174.99,
    y1: 1035.6,
    x2: 174.21,
    y2: 1033.92
  })), _line217 || (_line217 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 81.03,
    y1: 70.2,
    x2: 81.03,
    y2: 79.08
  })), _line218 || (_line218 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 118.29,
    y1: 708.36,
    x2: 118.29,
    y2: 720.42
  })), _line219 || (_line219 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 122.49,
    y1: 39.72,
    x2: 122.49,
    y2: 83.82
  })), _polyline260 || (_polyline260 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "129.15 772.92 128.61 772.8 128.37 772.74 128.25 772.74 128.19 772.68"
  })), _polyline261 || (_polyline261 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "141.51 540.48 140.73 540.3 140.37 540.18 140.13 540.12 140.07 540.06"
  })), _polyline262 || (_polyline262 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "137.31 768.54 136.53 768.3 136.17 768.24 135.93 768.18 135.87 768.06"
  })), _line220 || (_line220 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 115.11,
    y1: 483,
    x2: 115.11,
    y2: 491.16
  })), _line221 || (_line221 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 140.07,
    y1: 524.52,
    x2: 140.07,
    y2: 465.12
  })), _line222 || (_line222 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 118.29,
    y1: 480.42,
    x2: 118.29,
    y2: 494.34
  })), _line223 || (_line223 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 103.35,
    y1: 53.58,
    x2: 103.35,
    y2: 81.48
  })), _line224 || (_line224 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 131.55,
    y1: 698.22,
    x2: 131.55,
    y2: 730.68
  })), _line225 || (_line225 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 139.05,
    y1: 693.72,
    x2: 139.05,
    y2: 740.16
  })), _line226 || (_line226 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 121.53,
    y1: 705.9,
    x2: 121.53,
    y2: 722.52
  })), _line227 || (_line227 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 135.21,
    y1: 695.82,
    x2: 135.21,
    y2: 735.24
  })), _line228 || (_line228 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 144.57,
    y1: 333.12,
    x2: 144.99,
    y2: 333.3
  })), _line229 || (_line229 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 144.63,
    y1: 538.26,
    x2: 144.57,
    y2: 538.2
  })), _line230 || (_line230 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 93.81,
    y1: 60.54,
    x2: 93.81,
    y2: 80.46
  })), _line231 || (_line231 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 162.45,
    y1: 1015.02,
    x2: 160.89,
    y2: 1012.5
  })), _line232 || (_line232 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 166.47,
    y1: 1021.2,
    x2: 165.51,
    y2: 1019.82
  })), _line233 || (_line233 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 135.87,
    y1: 736.08,
    x2: 135.87,
    y2: 695.46
  })), _line234 || (_line234 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 128.19,
    y1: 727.44,
    x2: 128.19,
    y2: 700.68
  })), _line235 || (_line235 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 131.91,
    y1: 731.1,
    x2: 131.91,
    y2: 697.98
  })), _line236 || (_line236 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 174.99,
    y1: 365.16,
    x2: 174.21,
    y2: 363.72
  })), _line237 || (_line237 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 109.71,
    y1: 48.9,
    x2: 109.71,
    y2: 82.2
  })), _line238 || (_line238 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 77.73,
    y1: 72.72,
    x2: 77.73,
    y2: 78.78
  })), _line239 || (_line239 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 149.19,
    y1: 991.8,
    x2: 148.11,
    y2: 989.88
  })), _line240 || (_line240 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 152.85,
    y1: 998.34,
    x2: 152.25,
    y2: 997.32
  })), _line241 || (_line241 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 131.55,
    y1: 470.28,
    x2: 131.55,
    y2: 509.22
  })), _line242 || (_line242 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 100.17,
    y1: 55.86,
    x2: 100.17,
    y2: 81.18
  })), _line243 || (_line243 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 74.55,
    y1: 75.06,
    x2: 74.55,
    y2: 78.42
  })), _line244 || (_line244 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 122.85,
    y1: 726.72,
    x2: 122.85,
    y2: 750.54
  })), _line245 || (_line245 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 124.77,
    y1: 703.32,
    x2: 124.77,
    y2: 724.8
  })), _line246 || (_line246 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 112.89,
    y1: 720.24,
    x2: 112.77,
    y2: 720.12
  })), _line247 || (_line247 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 121.53,
    y1: 477.9,
    x2: 121.53,
    y2: 497.16
  })), _line248 || (_line248 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 116.13,
    y1: 44.28,
    x2: 116.13,
    y2: 82.98
  })), _line249 || (_line249 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 152.85,
    y1: 337.32,
    x2: 152.25,
    y2: 336.66
  })), _line250 || (_line250 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 135.87,
    y1: 962.58,
    x2: 135.87,
    y2: 914.4
  })), _line251 || (_line251 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 112.29,
    y1: 354.48,
    x2: 112.77,
    y2: 354.54
  })), _polyline263 || (_polyline263 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "104.49 129.42 104.43 129.36 104.31 129.36 104.13 129.3 103.83 129.24 103.53 129.24 103.35 129.18"
  })), _line252 || (_line252 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 144.99,
    y1: 985.32,
    x2: 144.57,
    y2: 985.2
  })), _line253 || (_line253 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 80.91,
    y1: 70.26,
    x2: 80.97,
    y2: 70.26
  })), _line254 || (_line254 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 157.77,
    y1: 103.68,
    x2: 155.91,
    y2: 101.58
  })), _line255 || (_line255 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 115.11,
    y1: 275.58,
    x2: 115.11,
    y2: 284.28
  })), _polyline264 || (_polyline264 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "96.69 136.74 96.15 136.74 95.61 136.68 95.43 136.62 95.19 136.62 94.95 136.56 94.71 136.56 93.99 136.38 93.81 136.38"
  })), _polyline265 || (_polyline265 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "88.59 141.36 88.41 141.36 88.23 141.3 87.99 141.24 87.69 141.18 87.45 141.12"
  })), _polyline266 || (_polyline266 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "144.99 100.8 144.87 100.8 144.75 100.74 144.57 100.74"
  })), _polyline267 || (_polyline267 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "155.73 853.38 155.85 853.32 155.91 853.26"
  })), _line256 || (_line256 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 112.77,
    y1: 785.76,
    x2: 112.29,
    y2: 785.64
  })), _line257 || (_line257 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 174.99,
    y1: 808.02,
    x2: 174.21,
    y2: 806.4
  })), _line258 || (_line258 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 194.67,
    y1: 876.12,
    x2: 194.43,
    y2: 876.6
  })), _line259 || (_line259 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 139.05,
    y1: 465.6,
    x2: 139.05,
    y2: 522.78
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M141.51,103.26l-.3-.06c-.29-.04-1.3-.17-1.44-.3h-.06"
  })), _polyline268 || (_polyline268 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "193.23 728.7 192.87 728.94 192.39 729.12"
  })), _polyline269 || (_polyline269 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "149.19 98.34 148.47 98.28 148.11 98.28"
  })), _line260 || (_line260 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 155.79,
    y1: 1078.8,
    x2: 155.91,
    y2: 1078.74
  })), _line261 || (_line261 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 142.17,
    y1: 398.46,
    x2: 142.23,
    y2: 398.46
  })), _line262 || (_line262 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 144.99,
    y1: 764.46,
    x2: 144.57,
    y2: 764.34
  })), _line263 || (_line263 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 166.47,
    y1: 113.58,
    x2: 165.51,
    y2: 112.44
  })), _line264 || (_line264 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 174.99,
    y1: 125.88,
    x2: 174.21,
    y2: 124.62
  })), _line265 || (_line265 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 157.77,
    y1: 777.36,
    x2: 155.91,
    y2: 773.94
  })), _line266 || (_line266 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 166.47,
    y1: 792.42,
    x2: 165.51,
    y2: 790.8
  })), _line267 || (_line267 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 152.85,
    y1: 549.72,
    x2: 152.25,
    y2: 548.94
  })), _line268 || (_line268 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 162.45,
    y1: 562.56,
    x2: 160.89,
    y2: 560.58
  })), _line269 || (_line269 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 166.47,
    y1: 567.66,
    x2: 165.51,
    y2: 566.4
  })), _line270 || (_line270 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 144.99,
    y1: 89.58,
    x2: 144.57,
    y2: 89.16
  })), _line271 || (_line271 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 149.19,
    y1: 93.96,
    x2: 148.11,
    y2: 92.82
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M130.11,914.58l1.56-.96c8.84-5.23,18.64-8.6,27.72-13.38l.96-.48"
  })), _line272 || (_line272 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 194.67,
    y1: 398.28,
    x2: 194.67,
    y2: 439.98
  })), _polyline270 || (_polyline270 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "169.89 975.6 169.77 975.72 169.59 975.78 169.35 975.78 169.17 975.72 168.33 975.54 167.97 975.42 167.67 975.3 167.07 975"
  })), _line273 || (_line273 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 197.55,
    y1: 850.5,
    x2: 197.55,
    y2: 877.98
  })), _line274 || (_line274 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 197.55,
    y1: 1079.76,
    x2: 197.55,
    y2: 1104.72
  })), _polyline271 || (_polyline271 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "152.25 333.96 152.19 333.78 152.01 333.6 151.71 333.42 150.21 333.12"
  })), _line275 || (_line275 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 190.17,
    y1: 833.88,
    x2: 190.17,
    y2: 874.68
  })), _line276 || (_line276 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 109.71,
    y1: 84.42,
    x2: 109.71,
    y2: 127.02
  })), _line277 || (_line277 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 181.77,
    y1: 372.48,
    x2: 181.77,
    y2: 434.1
  })), _line278 || (_line278 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 77.73,
    y1: 80.94,
    x2: 77.73,
    y2: 150.9
  })), _polyline272 || (_polyline272 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "134.67 962.76 134.97 963.42 134.07 961.8 133.95 961.56 133.83 961.44 133.83 961.38"
  })), _line279 || (_line279 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 169.89,
    y1: 1125.96,
    x2: 169.89,
    y2: 1212.24
  })), _line280 || (_line280 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 124.77,
    y1: 267.78,
    x2: 124.77,
    y2: 294.24
  })), _line281 || (_line281 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 124.77,
    y1: 298.2,
    x2: 124.77,
    y2: 346.98
  })), _line282 || (_line282 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 112.29,
    y1: 719.82,
    x2: 112.29,
    y2: 790.74
  })), _line283 || (_line283 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 178.41,
    y1: 126.78,
    x2: 178.41,
    y2: 193.5
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M128.13,775.56l-.24.12c-.28.13-2.57-.27-3-.42l-.12-.06"
  })), _line284 || (_line284 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 194.67,
    y1: 617.4,
    x2: 194.67,
    y2: 652.44
  })), _line285 || (_line285 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 118.29,
    y1: 723.6,
    x2: 118.29,
    y2: 783.24
  })), _line286 || (_line286 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 97.35,
    y1: 83.04,
    x2: 96.75,
    y2: 82.98
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M121.47,520.14l-.12-.24c-.12-1.13.41-.39,1.2-1.38l.3-.18"
  })), _polyline273 || (_polyline273 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "121.35 346.5 121.35 346.26 121.47 346.14 122.19 345.78 122.55 345.42 122.85 345.24"
  })), _line287 || (_line287 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 122.85,
    y1: 296.1,
    x2: 122.85,
    y2: 345.18
  })), _line288 || (_line288 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 120.63,
    y1: 345.48,
    x2: 120.63,
    y2: 293.88
  })), _line289 || (_line289 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 132.87,
    y1: 86.94,
    x2: 132.87,
    y2: 110.64
  })), _line290 || (_line290 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 184.89,
    y1: 1050.12,
    x2: 184.89,
    y2: 1098.96
  })), _line291 || (_line291 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 118.29,
    y1: 291.72,
    x2: 118.29,
    y2: 352.08
  })), _line292 || (_line292 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 100.17,
    y1: 83.34,
    x2: 100.17,
    y2: 134.16
  })), _line293 || (_line293 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 74.55,
    y1: 80.64,
    x2: 74.55,
    y2: 153.24
  })), _line294 || (_line294 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 178.41,
    y1: 808.74,
    x2: 178.41,
    y2: 869.16
  })), _line295 || (_line295 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 124.77,
    y1: 949.62,
    x2: 124.77,
    y2: 999
  })), _line296 || (_line296 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 192.75,
    y1: 839.16,
    x2: 192.75,
    y2: 875.82
  })), _line297 || (_line297 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 157.77,
    y1: 417.9,
    x2: 157.77,
    y2: 343.02
  })), _polyline274 || (_polyline274 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "121.35 751.86 121.35 751.62 121.47 751.5 122.19 751.14 122.55 750.78 122.85 750.6"
  })), _polyline275 || (_polyline275 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "144.57 979.02 144.51 978.84 144.33 978.6 144.09 978.36 143.79 978.18 142.47 977.82"
  })), _line298 || (_line298 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 124.77,
    y1: 728.1,
    x2: 124.77,
    y2: 778.2
  })), _line299 || (_line299 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 190.17,
    y1: 607.14,
    x2: 190.17,
    y2: 650.4
  })), _line300 || (_line300 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 135.87,
    y1: 336.9,
    x2: 135.87,
    y2: 313.02
  })), _line301 || (_line301 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 135.87,
    y1: 310.32,
    x2: 135.87,
    y2: 259.86
  })), _line302 || (_line302 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 103.35,
    y1: 83.7,
    x2: 103.35,
    y2: 131.76
  })), _line303 || (_line303 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 197.55,
    y1: 162.9,
    x2: 197.55,
    y2: 202.2
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M118.29,349.26l.24.06c.61.08,1.11.24,1.74.3h.36"
  })), _line304 || (_line304 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 184.89,
    y1: 378.6,
    x2: 184.89,
    y2: 435.54
  })), _line305 || (_line305 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 192.75,
    y1: 1067.88,
    x2: 192.75,
    y2: 1102.56
  })), _line306 || (_line306 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 118.29,
    y1: 944.1,
    x2: 118.29,
    y2: 1004.1
  })), _line307 || (_line307 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 115.23,
    y1: 941.76,
    x2: 115.23,
    y2: 1013.28
  })), _polyline276 || (_polyline276 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "112.77 939.78 112.77 1014 112.89 1014.06 113.07 1014.12 113.31 1014.18 113.55 1014.12 114.21 1013.88 114.57 1013.7 114.75 1013.58 115.23 1013.28"
  })), _line308 || (_line308 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 166.47,
    y1: 860.22,
    x2: 166.47,
    y2: 792.36
  })), _line309 || (_line309 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 115.23,
    y1: 721.68,
    x2: 115.23,
    y2: 792.42
  })), _polyline277 || (_polyline277 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "112.77 793.14 112.89 793.26 113.07 793.26 113.31 793.32 113.55 793.26 114.21 793.02 114.57 792.84 114.75 792.72 115.23 792.42"
  })), _line310 || (_line310 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 181.77,
    y1: 588.6,
    x2: 181.77,
    y2: 646.56
  })), _line311 || (_line311 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 190.83,
    y1: 258.18,
    x2: 190.83,
    y2: 257.52
  })), _line312 || (_line312 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 156.63,
    y1: 760.56,
    x2: 156.69,
    y2: 760.56
  })), _line313 || (_line313 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 140.07,
    y1: 334.98,
    x2: 140.07,
    y2: 320.52
  })), _line314 || (_line314 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 118.29,
    y1: 498.06,
    x2: 118.29,
    y2: 557.16
  })), _line315 || (_line315 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 88.65,
    y1: 82.08,
    x2: 88.59,
    y2: 82.08
  })), _line316 || (_line316 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 90.33,
    y1: 82.26,
    x2: 90.33,
    y2: 159.48
  })), _line317 || (_line317 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 88.59,
    y1: 160.38,
    x2: 88.59,
    y2: 82.08
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M90.33,159.48l-.06.12c-.15.62-.9,1.01-1.56.9l-.12-.12"
  })), _line318 || (_line318 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 135.21,
    y1: 260.28,
    x2: 135.21,
    y2: 309.24
  })), _line319 || (_line319 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 135.21,
    y1: 311.46,
    x2: 135.21,
    y2: 339.42
  })), _line320 || (_line320 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 131.91,
    y1: 339,
    x2: 131.91,
    y2: 307.02
  })), _line321 || (_line321 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 131.91,
    y1: 303.3,
    x2: 131.91,
    y2: 262.38
  })), _line322 || (_line322 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 197.55,
    y1: 624.96,
    x2: 197.55,
    y2: 653.76
  })), _line323 || (_line323 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 194.67,
    y1: 156.66,
    x2: 194.67,
    y2: 200.88
  })), _line324 || (_line324 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 112.29,
    y1: 286.08,
    x2: 112.29,
    y2: 359.52
  })), _line325 || (_line325 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 190.17,
    y1: 1061.94,
    x2: 190.17,
    y2: 1101.36
  })), _line326 || (_line326 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 187.89,
    y1: 829.26,
    x2: 187.89,
    y2: 873.6
  })), _line327 || (_line327 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 194.67,
    y1: 844.02,
    x2: 194.67,
    y2: 876.72
  })), _line328 || (_line328 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 187.89,
    y1: 384.6,
    x2: 187.89,
    y2: 436.86
  })), _line329 || (_line329 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 187.89,
    y1: 602.16,
    x2: 187.89,
    y2: 649.38
  })), _line330 || (_line330 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 181.77,
    y1: 132.42,
    x2: 181.77,
    y2: 195
  })), _line331 || (_line331 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 166.47,
    y1: 635.64,
    x2: 166.47,
    y2: 567.6
  })), _polyline278 || (_polyline278 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "163.59 88.32 163.41 88.44 162.81 88.44 162.39 88.38 162.03 88.38 161.91 88.32 161.49 88.32 161.43 88.26 161.19 88.26 160.77 88.14 160.59 88.08 160.41 88.08 160.29 88.02 160.23 88.02"
  })), _polyline279 || (_polyline279 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "169.89 528.66 169.77 528.72 169.59 528.78 169.35 528.84 169.17 528.78 168.33 528.6 167.97 528.48 167.67 528.3 167.07 528.06"
  })), _polyline280 || (_polyline280 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "121.35 966 121.35 965.76 121.47 965.64 122.19 965.28 122.55 964.92 122.85 964.74"
  })), _line332 || (_line332 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 115.23,
    y1: 495.42,
    x2: 115.23,
    y2: 566.28
  })), _line333 || (_line333 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 112.77,
    y1: 567.06,
    x2: 112.77,
    y2: 493.26
  })), _polyline281 || (_polyline281 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "115.23 566.28 114.75 566.58 114.57 566.76 114.21 566.88 113.55 567.18 113.07 567.18 112.89 567.12 112.77 567.06"
  })), _line334 || (_line334 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 112.29,
    y1: 492.84,
    x2: 112.29,
    y2: 564.6
  })), _line335 || (_line335 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 116.13,
    y1: 85.2,
    x2: 116.13,
    y2: 122.22
  })), _line336 || (_line336 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 166.47,
    y1: 424.38,
    x2: 166.47,
    y2: 352.86
  })), _polyline282 || (_polyline282 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "105.15 83.88 104.79 83.82 104.61 83.82 104.49 83.76"
  })), _line337 || (_line337 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 93.81,
    y1: 82.68,
    x2: 93.81,
    y2: 138.96
  })), _line338 || (_line338 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 187.89,
    y1: 143.82,
    x2: 187.89,
    y2: 197.82
  })), _polyline283 || (_polyline283 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "120.57 85.8 120.45 85.74 120.39 85.74"
  })), _polyline284 || (_polyline284 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "141.51 322.68 140.55 321.3 139.59 319.86"
  })), _polyline285 || (_polyline285 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "137.31 315.84 136.65 314.7 136.05 313.38 135.51 312.24 134.91 310.92 135.27 311.64"
  })), _polyline286 || (_polyline286 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "134.43 307.92 134.73 308.46 134.97 308.88 135.09 309 135.15 309.18 135.33 309.42 135.39 309.54 135.69 310.08 136.23 310.92"
  })), _polyline287 || (_polyline287 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "135.27 311.64 134.67 310.56 134.31 310.02 134.13 309.78 134.07 309.66 134.01 309.6 134.13 309.78 134.25 309.96"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M134.55,310.38l-1.62-2.1-1.68-2.16c-4.56-6.23-9.52-11.41-15.24-16.56l-1.02-.96-.96-.9c-2.08-2.02-4.41-3.97-5.64-6.66l-.24-.72-.06-.72"
  })), _line339 || (_line339 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 130.23,
    y1: 259.92,
    x2: 130.41,
    y2: 259.86
  })), _polyline288 || (_polyline288 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "133.83 260.52 133.89 260.88 133.77 261.12"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M128.13,549.42l-.24.18c-1.02.04-2.01-.24-3-.42l-.12-.06"
  })), _polyline289 || (_polyline289 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "153.81 98.34 153.27 98.16 152.97 98.04 152.85 97.98"
  })), _line340 || (_line340 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 74.43,
    y1: 80.64,
    x2: 74.43,
    y2: 157.74
  })), _line341 || (_line341 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 72.63,
    y1: 158.64,
    x2: 72.63,
    y2: 80.46
  })), _line342 || (_line342 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 181.77,
    y1: 1043.52,
    x2: 181.77,
    y2: 1097.58
  })), _line343 || (_line343 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 84.27,
    y1: 81.54,
    x2: 84.27,
    y2: 146.16
  })), _polyline290 || (_polyline290 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "144.57 534.24 144.51 534 144.33 533.76 144.15 533.46 143.79 533.34 142.47 532.92"
  })), _line344 || (_line344 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 106.53,
    y1: 84,
    x2: 106.53,
    y2: 129.36
  })), _line345 || (_line345 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 178.41,
    y1: 1036.56,
    x2: 178.41,
    y2: 1095.06
  })), _line346 || (_line346 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 181.77,
    y1: 816.12,
    x2: 181.77,
    y2: 870.84
  })), _line347 || (_line347 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 143.13,
    y1: 88.08,
    x2: 142.17,
    y2: 87.48
  })), _polyline291 || (_polyline291 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "141.81 87.3 142.29 87.54 142.89 87.78"
  })), _line348 || (_line348 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 129.57,
    y1: 34.56,
    x2: 126.63,
    y2: 36.66
  })), _line349 || (_line349 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 70.83,
    y1: 77.7,
    x2: 70.83,
    y2: 77.46
  })), _line350 || (_line350 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 140.01,
    y1: 85.8,
    x2: 140.07,
    y2: 85.8
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M143.55,86.7v.06h.12c.41.18.84.32,1.26.54l.18.06"
  })), _polyline292 || (_polyline292 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "200.85 170.64 200.79 171.18 200.73 171.6 200.61 172.38"
  })), _line351 || (_line351 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 185.01,
    y1: 188.94,
    x2: 184.89,
    y2: 189.06
  })), _polyline293 || (_polyline293 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "142.89 87.78 142.35 87.6 141.69 87.42 142.17 87.54 142.47 87.6 142.65 87.6"
  })), _polyline294 || (_polyline294 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "120.57 85.8 116.79 85.32 114.87 85.02 112.83 84.78"
  })), _line352 || (_line352 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 104.55,
    y1: 83.82,
    x2: 97.35,
    y2: 83.04
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M96.75,82.98l-4.08-.42c-3.33-.38-6.64-.77-9.96-1.2l-2.1-.18"
  })), _polyline295 || (_polyline295 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "130.41 259.86 132.15 259.98 133.41 260.34 133.65 260.4 133.83 260.52"
  })), _line353 || (_line353 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 166.47,
    y1: 1086.12,
    x2: 166.47,
    y2: 1021.2
  })), _polyline296 || (_polyline296 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "148.11 540.06 147.99 539.88 147.87 539.7 147.63 539.46 147.33 539.4 146.67 539.28 146.07 539.1"
  })), _line354 || (_line354 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 192.75,
    y1: 152.46,
    x2: 192.75,
    y2: 200.04
  })), _line355 || (_line355 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 128.13,
    y1: 302.16,
    x2: 128.13,
    y2: 344.34
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M124.77,344.04h.06l.06.06h.12l.12.06.48.12h.18l.12.06h.12l.18.06h.18c.48.08.99.14,1.5.12l.18-.06.06-.12"
  })), _line356 || (_line356 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 149.19,
    y1: 761.88,
    x2: 148.11,
    y2: 760.14
  })), _line357 || (_line357 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 144.99,
    y1: 754.92,
    x2: 144.57,
    y2: 754.2
  })), _polyline297 || (_polyline297 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "136.35 736.74 136.95 737.46 137.37 738"
  })), _line358 || (_line358 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 115.23,
    y1: 288.84,
    x2: 115.23,
    y2: 361.2
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M112.77,286.5v75.48l.12.06.18.06h.36l.18-.06.6-.24h.12l.12-.06c.22-.13.44-.27.66-.42l.06-.06.06-.06"
  })), _line359 || (_line359 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 90.63,
    y1: 82.32,
    x2: 90.63,
    y2: 141.36
  })), _line360 || (_line360 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 126.63,
    y1: 86.46,
    x2: 126.63,
    y2: 115.2
  })), _line361 || (_line361 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 123.27,
    y1: 83.88,
    x2: 123.27,
    y2: 39.12
  })), _polyline298 || (_polyline298 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "126.63 36.66 126.57 36.72 126.33 36.9"
  })), _line362 || (_line362 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 197.55,
    y1: 404.64,
    x2: 197.55,
    y2: 441.24
  })), _line363 || (_line363 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 184.89,
    y1: 822.78,
    x2: 184.89,
    y2: 872.28
  })), _polyline299 || (_polyline299 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "139.59 742.74 139.53 742.5 139.35 742.26 138.93 741.84"
  })), _line364 || (_line364 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 178.41,
    y1: 365.88,
    x2: 178.41,
    y2: 432.6
  })), _line365 || (_line365 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 184.89,
    y1: 138,
    x2: 184.89,
    y2: 196.44
  })), _line366 || (_line366 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 190.83,
    y1: 505.68,
    x2: 190.83,
    y2: 502.86
  })), _line367 || (_line367 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 190.17,
    y1: 388.92,
    x2: 190.17,
    y2: 437.94
  })), _line368 || (_line368 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 131.55,
    y1: 262.62,
    x2: 131.55,
    y2: 302.7
  })), _line369 || (_line369 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 131.55,
    y1: 306.54,
    x2: 131.55,
    y2: 341.82
  })), _polyline300 || (_polyline300 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "139.71 85.74 139.71 27.24 139.59 27.3"
  })), _line370 || (_line370 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 124.77,
    y1: 504.3,
    x2: 124.77,
    y2: 552.06
  })), _line371 || (_line371 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 192.75,
    y1: 393.84,
    x2: 192.75,
    y2: 439.08
  })), _line372 || (_line372 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 119.31,
    y1: 85.62,
    x2: 119.31,
    y2: 119.82
  })), _line373 || (_line373 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 192.75,
    y1: 612.54,
    x2: 192.75,
    y2: 651.6
  })), _line374 || (_line374 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 136.23,
    y1: 29.76,
    x2: 136.23,
    y2: 85.2
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M136.23,108.18l-.18.18h-.54l-.18-.06h-.48l-.18-.06h-.06l-.48-.06c-.36-.02-.7-.22-1.08-.18l-.06-.06-.12-.06"
  })), _line375 || (_line375 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 178.41,
    y1: 582.06,
    x2: 178.41,
    y2: 644.58
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M169.89,754.8l-.12.06c-.54.25-1.55-.23-2.1-.42l-.6-.3"
  })), _line376 || (_line376 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 184.89,
    y1: 595.2,
    x2: 184.89,
    y2: 648
  })), _line377 || (_line377 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 112.29,
    y1: 939.42,
    x2: 112.29,
    y2: 1011.54
  })), _line378 || (_line378 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 144.99,
    y1: 538.86,
    x2: 144.57,
    y2: 538.14
  })), _polyline301 || (_polyline301 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "134.55 517.62 134.61 517.68 134.67 517.8 134.67 517.92 134.73 517.92 134.85 518.28 134.19 517.08 133.83 516.42 133.77 516.3 133.65 516.12 133.59 516 133.59 515.94"
  })), _polyline302 || (_polyline302 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "141.81 397.98 142.05 398.1 142.11 398.28 142.17 398.46"
  })), _line379 || (_line379 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 87.45,
    y1: 81.96,
    x2: 87.45,
    y2: 143.76
  })), _line380 || (_line380 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 153.81,
    y1: 337.56,
    x2: 152.85,
    y2: 337.2
  })), _line381 || (_line381 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 81.39,
    y1: 81.24,
    x2: 81.33,
    y2: 81.24
  })), _line382 || (_line382 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 82.35,
    y1: 81.36,
    x2: 82.35,
    y2: 158.64
  })), _line383 || (_line383 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 80.61,
    y1: 159.54,
    x2: 80.61,
    y2: 81.18
  })), _polyline303 || (_polyline303 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "139.59 970.56 139.47 970.26 139.29 969.9 139.05 969.54 138.87 969.42 138.69 969.36"
  })), _line384 || (_line384 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 71.61,
    y1: 80.34,
    x2: 71.61,
    y2: 155.4
  })), _line385 || (_line385 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 144.57,
    y1: 88.14,
    x2: 144.57,
    y2: 173.76
  })), _line386 || (_line386 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 141.51,
    y1: 164.22,
    x2: 141.51,
    y2: 87.48
  })), _line387 || (_line387 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 169.89,
    y1: 899.34,
    x2: 169.89,
    y2: 975.6
  })), _line388 || (_line388 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 167.07,
    y1: 975,
    x2: 167.07,
    y2: 900.42
  })), _line389 || (_line389 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 186.33,
    y1: 247.32,
    x2: 186.33,
    y2: 267.06
  })), _line390 || (_line390 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 184.11,
    y1: 267.84,
    x2: 184.11,
    y2: 241.74
  })), _line391 || (_line391 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 148.11,
    y1: 328.74,
    x2: 148.11,
    y2: 408.84
  })), _line392 || (_line392 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 144.99,
    y1: 408.3,
    x2: 144.99,
    y2: 327.54
  })), _line393 || (_line393 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 152.25,
    y1: 333.96,
    x2: 152.25,
    y2: 412.92
  })), _line394 || (_line394 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 149.19,
    y1: 408.06,
    x2: 149.19,
    y2: 332.76
  })), _line395 || (_line395 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 148.11,
    y1: 985.26,
    x2: 148.11,
    y2: 1068.24
  })), _line396 || (_line396 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 144.99,
    y1: 1067.76,
    x2: 144.99,
    y2: 983.88
  })), _polyline304 || (_polyline304 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "141.51 977.7 140.55 976.02 139.59 974.22"
  })), _polyline305 || (_polyline305 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "137.31 969.24 135.93 966.06 135.33 964.44 134.67 962.76"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M133.59,915.84l-2.64,1.8-2.46,1.8-2.4,1.86c-4.26,3.6-9.05,6.65-13.02,10.56l-.3.48-.24.48c-.46.9.42,2.42.96,3.06l.72.9.84.9.96.9,1.02.96c6,4.79,10.77,8.24,14.7,15l1.44,2.64.6,1.26c.37.86.87,2.04,1.38,2.82l.06.12.3.54.48.84"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M136.77,964.08l.78,1.26.42.66.42.6c3.6,6.84,7.57,12.96,11.22,19.68l2.22,4.26,4.68,8.4c5.29,9.72,10.37,18.49,16.92,27.36l2.34,3.66,1.02,1.86,1.02,1.92,1.92,3.78c5.31,10.82,10.33,21.99,14.82,33.18l1.62,3.72,1.68,3.78c1.55,3.77,2.86,6.87,2.94,11.04v.9"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M134.31,962.16l-1.5-2.1-1.62-2.22c-5.03-7.27-8.2-10.55-15.42-15.66l-2.04-1.62-1.8-1.5c-1.36-1.09-2.8-2.64-3.6-4.2l-.18-.66-.12-.66"
  })), _line397 || (_line397 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 108.81,
    y1: 790.8,
    x2: 108.81,
    y2: 717
  })), _line398 || (_line398 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 174.99,
    y1: 191.94,
    x2: 174.99,
    y2: 125.52
  })), _line399 || (_line399 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 128.13,
    y1: 730.68,
    x2: 128.13,
    y2: 775.56
  })), _line400 || (_line400 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 177.57,
    y1: 911.46,
    x2: 177.57,
    y2: 974.34
  })), _line401 || (_line401 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 176.37,
    y1: 974.34,
    x2: 176.37,
    y2: 908.64
  })), _line402 || (_line402 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 160.89,
    y1: 778.62,
    x2: 160.89,
    y2: 856.02
  })), _line403 || (_line403 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 157.77,
    y1: 853.68,
    x2: 157.77,
    y2: 777.24
  })), _line404 || (_line404 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 135.21,
    y1: 519.18,
    x2: 135.21,
    y2: 544.44
  })), _line405 || (_line405 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 131.91,
    y1: 544.08,
    x2: 131.91,
    y2: 513.72
  })), _line406 || (_line406 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 135.21,
    y1: 964.08,
    x2: 135.21,
    y2: 991.44
  })), _line407 || (_line407 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 131.91,
    y1: 991.02,
    x2: 131.91,
    y2: 958.86
  })), _line408 || (_line408 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 98.37,
    y1: 83.16,
    x2: 98.37,
    y2: 160.38
  })), _line409 || (_line409 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 96.69,
    y1: 161.28,
    x2: 96.69,
    y2: 82.98
  })), _line410 || (_line410 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 190.83,
    y1: 950.76,
    x2: 190.83,
    y2: 945.6
  })), _line411 || (_line411 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 122.85,
    y1: 519.54,
    x2: 122.85,
    y2: 580.62
  })), _line412 || (_line412 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 120.63,
    y1: 581.46,
    x2: 120.63,
    y2: 519.48
  })), _line413 || (_line413 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 122.85,
    y1: 346.44,
    x2: 122.85,
    y2: 374.64
  })), _line414 || (_line414 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 120.63,
    y1: 375.48,
    x2: 120.63,
    y2: 346.38
  })), _line415 || (_line415 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 148.11,
    y1: 90.54,
    x2: 148.11,
    y2: 172.14
  })), _line416 || (_line416 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 144.99,
    y1: 171.66,
    x2: 144.99,
    y2: 89.58
  })), _line417 || (_line417 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 169.59,
    y1: 114.72,
    x2: 169.59,
    y2: 188.46
  })), _line418 || (_line418 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 166.47,
    y1: 186.12,
    x2: 166.47,
    y2: 113.58
  })), _line419 || (_line419 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 132.87,
    y1: 32.16,
    x2: 132.87,
    y2: 84.9
  })), _line420 || (_line420 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 131.55,
    y1: 513.18,
    x2: 131.55,
    y2: 546.9
  })), _line421 || (_line421 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 128.19,
    y1: 546.6,
    x2: 128.19,
    y2: 508.62
  })), _line422 || (_line422 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 186.33,
    y1: 711.78,
    x2: 186.33,
    y2: 740.4
  })), _line423 || (_line423 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 184.11,
    y1: 741.18,
    x2: 184.11,
    y2: 705.36
  })), _line424 || (_line424 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 174.21,
    y1: 359.52,
    x2: 174.21,
    y2: 430.2
  })), _line425 || (_line425 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 170.91,
    y1: 427.74,
    x2: 170.91,
    y2: 358.26
  })), _line426 || (_line426 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 160.89,
    y1: 1008.48,
    x2: 160.89,
    y2: 1081.92
  })), _line427 || (_line427 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 157.77,
    y1: 1079.64,
    x2: 157.77,
    y2: 1007.1
  })), _line428 || (_line428 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 174.99,
    y1: 866.58,
    x2: 174.99,
    y2: 807.48
  })), _line429 || (_line429 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 128.13,
    y1: 953.64,
    x2: 128.13,
    y2: 996.36
  })), _line430 || (_line430 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 152.25,
    y1: 95.1,
    x2: 152.25,
    y2: 175.14
  })), _line431 || (_line431 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 149.19,
    y1: 170.22,
    x2: 149.19,
    y2: 93.9
  })), _line432 || (_line432 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 160.89,
    y1: 344.16,
    x2: 160.89,
    y2: 420.18
  })), _line433 || (_line433 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 130.41,
    y1: 86.76,
    x2: 130.41,
    y2: 164.46
  })), _line434 || (_line434 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 129.15,
    y1: 164.46,
    x2: 129.15,
    y2: 86.7
  })), _line435 || (_line435 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 161.01,
    y1: 238.56,
    x2: 161.01,
    y2: 305.1
  })), _line436 || (_line436 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 157.83,
    y1: 304.62,
    x2: 157.83,
    y2: 242.94
  })), _line437 || (_line437 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 165.51,
    y1: 563.64,
    x2: 165.51,
    y2: 634.92
  })), _line438 || (_line438 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 162.45,
    y1: 632.64,
    x2: 162.45,
    y2: 562.44
  })), _line439 || (_line439 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 151.71,
    y1: 687.78,
    x2: 151.71,
    y2: 760.5
  })), _line440 || (_line440 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 148.53,
    y1: 755.1,
    x2: 148.53,
    y2: 689.22
  })), _line441 || (_line441 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 165.51,
    y1: 349.32,
    x2: 165.51,
    y2: 423.66
  })), _line442 || (_line442 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 162.45,
    y1: 421.38,
    x2: 162.45,
    y2: 348.18
  })), _line443 || (_line443 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 130.41,
    y1: 956.76,
    x2: 130.41,
    y2: 1043.82
  })), _line444 || (_line444 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 129.15,
    y1: 1043.82,
    x2: 129.15,
    y2: 955.08
  })), _line445 || (_line445 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 122.85,
    y1: 751.8,
    x2: 122.85,
    y2: 806.76
  })), _line446 || (_line446 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 120.63,
    y1: 807.6,
    x2: 120.63,
    y2: 751.74
  })), _line447 || (_line447 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 140.07,
    y1: 987,
    x2: 140.07,
    y2: 975.06
  })), _line448 || (_line448 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 161.01,
    y1: 463.68,
    x2: 161.01,
    y2: 532.38
  })), _line449 || (_line449 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 157.83,
    y1: 531.96,
    x2: 157.83,
    y2: 461.76
  })), _line450 || (_line450 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 153.39,
    y1: 17.4,
    x2: 153.39,
    y2: 95.04
  })), _line451 || (_line451 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 150.03,
    y1: 91.2,
    x2: 150.03,
    y2: 19.86
  })), _line452 || (_line452 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 131.55,
    y1: 958.32,
    x2: 131.55,
    y2: 993.84
  })), _line453 || (_line453 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 128.19,
    y1: 993.54,
    x2: 128.19,
    y2: 953.76
  })), _line454 || (_line454 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 144.57,
    y1: 979.02,
    x2: 144.57,
    y2: 1069.86
  })), _line455 || (_line455 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 141.51,
    y1: 1069.32,
    x2: 141.51,
    y2: 977.46
  })), _line456 || (_line456 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 156.63,
    y1: 244.38,
    x2: 156.63,
    y2: 318.3
  })), _line457 || (_line457 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 153.39,
    y1: 317.82,
    x2: 153.39,
    y2: 247.86
  })), _line458 || (_line458 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 200.61,
    y1: 635.94,
    x2: 200.61,
    y2: 655.14
  })), _line459 || (_line459 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 139.05,
    y1: 258.24,
    x2: 139.05,
    y2: 314.82
  })), _line460 || (_line460 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 129.75,
    y1: 34.44,
    x2: 129.75,
    y2: 84.6
  })), _line461 || (_line461 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 174.21,
    y1: 1029.12,
    x2: 174.21,
    y2: 1091.94
  })), _line462 || (_line462 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 170.91,
    y1: 1089.48,
    x2: 170.91,
    y2: 1027.74
  })), _line463 || (_line463 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 164.13,
    y1: 232.44,
    x2: 164.13,
    y2: 303.66
  })), _line464 || (_line464 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 161.25,
    y1: 303,
    x2: 161.25,
    y2: 238.2
  })), _line465 || (_line465 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 131.55,
    y1: 733.44,
    x2: 131.55,
    y2: 773.04
  })), _line466 || (_line466 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 128.19,
    y1: 772.68,
    x2: 128.19,
    y2: 730.74
  })), _line467 || (_line467 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 155.91,
    y1: 550.8,
    x2: 155.91,
    y2: 628.68
  })), _line468 || (_line468 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 152.85,
    y1: 623.88,
    x2: 152.85,
    y2: 549.6
  })), _line469 || (_line469 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 186.33,
    y1: 934.2,
    x2: 186.33,
    y2: 961.56
  })), _line470 || (_line470 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 184.11,
    y1: 962.34,
    x2: 184.11,
    y2: 928.08
  })), _line471 || (_line471 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 143.19,
    y1: 463.62,
    x2: 143.19,
    y2: 530.16
  })), _line472 || (_line472 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 140.07,
    y1: 540.06,
    x2: 140.07,
    y2: 529.98
  })), _line473 || (_line473 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 135.87,
    y1: 768.06,
    x2: 135.87,
    y2: 738.36
  })), _line474 || (_line474 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 200.61,
    y1: 859.92,
    x2: 200.61,
    y2: 879.36
  })), _line475 || (_line475 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 169.59,
    y1: 793.68,
    x2: 169.59,
    y2: 862.5
  })), _line476 || (_line476 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 112.77,
    y1: 793.14,
    x2: 112.77,
    y2: 720.12
  })), _line477 || (_line477 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 156.63,
    y1: 685.56,
    x2: 156.63,
    y2: 760.56
  })), _line478 || (_line478 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 153.39,
    y1: 760.08,
    x2: 153.39,
    y2: 687.06
  })), _line479 || (_line479 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 143.19,
    y1: 256.02,
    x2: 143.19,
    y2: 320.7
  })), _line480 || (_line480 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 140.07,
    y1: 316.2,
    x2: 140.07,
    y2: 257.7
  })), _line481 || (_line481 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 169.89,
    y1: 224.58,
    x2: 169.89,
    y2: 290.28
  })), _line482 || (_line482 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 167.07,
    y1: 289.68,
    x2: 167.07,
    y2: 225.06
  })), _line483 || (_line483 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 108.81,
    y1: 359.64,
    x2: 108.81,
    y2: 281.88
  })), _line484 || (_line484 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 114.09,
    y1: 84.96,
    x2: 114.09,
    y2: 162.12
  })), _line485 || (_line485 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 112.23,
    y1: 163.02,
    x2: 112.23,
    y2: 84.66
  })), _line486 || (_line486 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 160.89,
    y1: 104.82,
    x2: 160.89,
    y2: 181.92
  })), _line487 || (_line487 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 157.77,
    y1: 179.58,
    x2: 157.77,
    y2: 103.68
  })), _line488 || (_line488 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 148.11,
    y1: 756.12,
    x2: 148.11,
    y2: 843.72
  })), _line489 || (_line489 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 144.99,
    y1: 843.18,
    x2: 144.99,
    y2: 754.86
  })), _line490 || (_line490 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 164.13,
    y1: 465.18,
    x2: 164.13,
    y2: 530.94
  })), _line491 || (_line491 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 161.25,
    y1: 530.34,
    x2: 161.25,
    y2: 463.8
  })), _line492 || (_line492 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 169.59,
    y1: 568.8,
    x2: 169.59,
    y2: 637.98
  })), _line493 || (_line493 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 163.59,
    y1: 10.08,
    x2: 163.59,
    y2: 88.26
  })), _line494 || (_line494 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 169.89,
    y1: 462.54,
    x2: 169.89,
    y2: 528.66
  })), _line495 || (_line495 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 167.07,
    y1: 528.06,
    x2: 167.07,
    y2: 463.68
  })), _line496 || (_line496 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 122.85,
    y1: 965.94,
    x2: 122.85,
    y2: 1028.52
  })), _line497 || (_line497 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 120.63,
    y1: 1029.36,
    x2: 120.63,
    y2: 965.88
  })), _line498 || (_line498 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 108.81,
    y1: 564.72,
    x2: 108.81,
    y2: 488.76
  })), _line499 || (_line499 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 130.41,
    y1: 511.62,
    x2: 130.41,
    y2: 595.62
  })), _line500 || (_line500 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 129.15,
    y1: 595.62,
    x2: 129.15,
    y2: 509.94
  })), _line501 || (_line501 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 177.57,
    y1: 469.62,
    x2: 177.57,
    y2: 527.4
  })), _line502 || (_line502 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 176.37,
    y1: 527.4,
    x2: 176.37,
    y2: 467.16
  })), _line503 || (_line503 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 169.59,
    y1: 353.94,
    x2: 169.59,
    y2: 426.72
  })), _line504 || (_line504 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 135.21,
    y1: 737.22,
    x2: 135.21,
    y2: 770.58
  })), _line505 || (_line505 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 131.91,
    y1: 770.16,
    x2: 131.91,
    y2: 733.8
  })), _line506 || (_line506 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 106.23,
    y1: 84,
    x2: 106.23,
    y2: 161.22
  })), _line507 || (_line507 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 104.49,
    y1: 162.12,
    x2: 104.49,
    y2: 83.82
  })), _line508 || (_line508 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 147.57,
    y1: 461.64,
    x2: 147.57,
    y2: 537.54
  })), _line509 || (_line509 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 144.33,
    y1: 532.26,
    x2: 144.33,
    y2: 463.08
  })), _line510 || (_line510 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 177.57,
    y1: 226.98,
    x2: 177.57,
    y2: 277.92
  })), _line511 || (_line511 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 176.37,
    y1: 277.92,
    x2: 176.37,
    y2: 224.58
  })), _line512 || (_line512 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 161.01,
    y1: 683.52,
    x2: 161.01,
    y2: 758.52
  })), _line513 || (_line513 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 157.83,
    y1: 758.04,
    x2: 157.83,
    y2: 685.02
  })), _line514 || (_line514 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 151.71,
    y1: 249.48,
    x2: 151.71,
    y2: 331.56
  })), _line515 || (_line515 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 148.53,
    y1: 327.72,
    x2: 148.53,
    y2: 252.24
  })), _line516 || (_line516 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 147.57,
    y1: 253.02,
    x2: 147.57,
    y2: 326.52
  })), _line517 || (_line517 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 144.33,
    y1: 322.38,
    x2: 144.33,
    y2: 255.3
  })), _line518 || (_line518 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 200.61,
    y1: 170.94,
    x2: 200.61,
    y2: 203.46
  })), _line519 || (_line519 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 186.33,
    y1: 1186.86,
    x2: 186.33,
    y2: 1197.24
  })), _line520 || (_line520 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 184.11,
    y1: 1198.02,
    x2: 184.11,
    y2: 1160.64
  })), _line521 || (_line521 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 122.61,
    y1: 86.04,
    x2: 122.61,
    y2: 163.26
  })), _line522 || (_line522 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 120.39,
    y1: 164.1,
    x2: 120.39,
    y2: 85.74
  })), _line523 || (_line523 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 149.19,
    y1: 332.82,
    x2: 148.11,
    y2: 331.5
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M133.77,261.12l-1.38.9-1.32.96-2.46,1.86c-4.58,3.64-9.86,7.49-14.22,11.4l-.9.96-.42.48-.3.48-.18.48-.06.24-.06.12v.72l.18.78c.8,1.82,1.35,2.4,2.58,3.96l1.92,2.16,1.02,1.08c5.09,5.02,9.43,8.96,13.38,14.94l1.56,2.64.66,1.26.66,1.38"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M137.13,312.3l1.62,2.1,1.44,2.04,1.38,1.92c3.44,5.21,7.39,9.88,11.22,14.82l1.2,1.56,1.26,1.56c6.13,7.4,12.94,14.36,18.96,21.72l1.08,1.5,2.04,3.12,1.86,3.24,1.68,3.18c4.23,8.28,8.38,16.61,12.6,24.9l3.06,6.48,1.5,3.24c1.41,3.17,2.85,6.31,2.82,9.84v.48"
  })), _polyline306 || (_polyline306 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "153.27 459 148.23 461.28 143.31 463.56 140.79 464.76 138.45 465.9 136.23 467.1 134.25 468.36"
  })), _polyline307 || (_polyline307 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "108.09 279.6 108.09 279.06 108.15 278.64 108.45 277.86 108.81 277.14 109.35 276.48 109.95 275.88 110.55 275.22 111.93 274.02 117.93 269.22 123.81 264.54 126.93 262.2 128.55 261.06 130.23 259.92"
  })), _line524 || (_line524 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 165.51,
    y1: 1016.22,
    x2: 165.51,
    y2: 1085.4
  })), _line525 || (_line525 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 162.45,
    y1: 1083.12,
    x2: 162.45,
    y2: 1014.9
  })), _line526 || (_line526 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 165.51,
    y1: 110.04,
    x2: 165.51,
    y2: 185.4
  })), _line527 || (_line527 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 162.45,
    y1: 183.12,
    x2: 162.45,
    y2: 108.9
  })), _line528 || (_line528 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 128.13,
    y1: 508.5,
    x2: 128.13,
    y2: 549.42
  })), _line529 || (_line529 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 155.91,
    y1: 99.18,
    x2: 155.91,
    y2: 179.76
  })), _line530 || (_line530 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 152.85,
    y1: 176.04,
    x2: 152.85,
    y2: 97.98
  })), _line531 || (_line531 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 135.87,
    y1: 988.92,
    x2: 135.87,
    y2: 965.82
  })), _line532 || (_line532 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 84.27,
    y1: 67.68,
    x2: 84.27,
    y2: 79.38
  })), _line533 || (_line533 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 144.57,
    y1: 534.24,
    x2: 144.57,
    y2: 620.46
  })), _line534 || (_line534 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 141.51,
    y1: 619.92,
    x2: 141.51,
    y2: 532.62
  })), _line535 || (_line535 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 164.13,
    y1: 901.74,
    x2: 164.13,
    y2: 977.88
  })), _line536 || (_line536 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 161.25,
    y1: 977.28,
    x2: 161.25,
    y2: 902.28
  })), _line537 || (_line537 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 147.57,
    y1: 908.7,
    x2: 147.57,
    y2: 982.44
  })), _line538 || (_line538 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 144.33,
    y1: 977.22,
    x2: 144.33,
    y2: 910.14
  })), _line539 || (_line539 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 174.99,
    y1: 1092.54,
    x2: 174.99,
    y2: 1035.24
  })), _line540 || (_line540 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 156.63,
    y1: 461.04,
    x2: 156.63,
    y2: 534.42
  })), _line541 || (_line541 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 153.39,
    y1: 534,
    x2: 153.39,
    y2: 459.06
  })), _line542 || (_line542 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 156.81,
    y1: 14.94,
    x2: 156.81,
    y2: 93.18
  })), _line543 || (_line543 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 153.39,
    y1: 92.88,
    x2: 153.39,
    y2: 17.4
  })), _line544 || (_line544 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 151.71,
    y1: 906.78,
    x2: 151.71,
    y2: 983.58
  })), _line545 || (_line545 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 148.53,
    y1: 983.1,
    x2: 148.53,
    y2: 908.22
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M130.29,259.92l1.86-1.2c12.8-5.8,24.68-15.95,29.16-29.64l1.38-3.66"
  })), _line546 || (_line546 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 162.45,
    y1: 108.96,
    x2: 160.89,
    y2: 107.22
  })), _line547 || (_line547 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 152.85,
    y1: 98.1,
    x2: 152.25,
    y2: 97.44
  })), _line548 || (_line548 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 165.21,
    y1: 8.88,
    x2: 129.75,
    y2: 34.44
  })), _polyline308 || (_polyline308 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "126.63 36.66 97.11 58.08 87.45 65.28"
  })), _line549 || (_line549 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 87.27,
    y1: 65.4,
    x2: 84.27,
    y2: 67.68
  })), _polyline309 || (_polyline309 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "84.15 67.8 77.55 72.84 75.87 74.1 74.07 75.36 73.05 75.96 72.03 76.62 71.19 77.22 70.89 77.52 70.83 77.64 70.83 77.7"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M70.83,77.46l.06.12.18.12.36.18c4.98,1.1,10.9,1.11,15.96,1.86l2.22.24,2.28.3c11.22,1.1,22.26,2.48,33.42,3.84l2.16.24,4.56.42,2.28.24c2.86.19,5.73.71,8.46,1.44l.36.12.42.12"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M145.11,87.36l.18.06.3.12.36.18c2.73,1.44,4.47,4.13,6.54,6.3l2.28,2.58,4.56,5.1c6.66,7.75,13.69,14.54,18.9,23.4l1.68,2.64,1.68,2.58,1.5,2.52,2.7,5.22c3.75,7.37,7.66,13.79,10.98,21.42l1.44,2.94.72,1.44c.96,1.99,1.96,4.35,1.92,6.6v.18"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M166.77,225.12l-1.32,3.78-1.44,3.72c-1.3,3.7-3.21,6.43-5.52,9.54l-2.16,2.58-2.28,2.46c-4.85,5.06-9.91,8.7-16.26,11.64l-2.1,1.14-1.92,1.14"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M143.13,87.72l-.9-.18c-6.14-.46-12-.55-18.24-1.38l-3.06-.36"
  })), _line550 || (_line550 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 112.29,
    y1: 84.72,
    x2: 105.15,
    y2: 83.88
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M80.61,81.18l-1.02-.12-.96-.06-1.8-.12c-2.8-.25-5.34-.45-8.04-1.14l-.6-.3-.48-.3-.36-.36-.12-.36-.06-.18v-.36l.12-.42.12-.36c.67-1.29,2.98-2.95,4.2-3.84l1.38-.96.78-.54.42-.3.54-.36,3.12-2.4,3-2.34,3.18-2.4,12.72-9.42,12.9-9.36,25.98-18.78,26.04-18.72"
  })), _line551 || (_line551 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 147.57,
    y1: 689.7,
    x2: 147.57,
    y2: 753.48
  })), _line552 || (_line552 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 152.25,
    y1: 992.94,
    x2: 152.25,
    y2: 1073.22
  })), _line553 || (_line553 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 149.19,
    y1: 1068.3,
    x2: 149.19,
    y2: 991.56
  })), _line554 || (_line554 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 169.59,
    y1: 1022.34,
    x2: 169.59,
    y2: 1088.46
  })), _line555 || (_line555 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 144.57,
    y1: 750.24,
    x2: 144.57,
    y2: 845.28
  })), _line556 || (_line556 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 141.51,
    y1: 844.8,
    x2: 141.51,
    y2: 748.68
  })), _line557 || (_line557 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 148.11,
    y1: 540.06,
    x2: 148.11,
    y2: 618.84
  })), _line558 || (_line558 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 144.99,
    y1: 618.3,
    x2: 144.99,
    y2: 538.8
  })), _line559 || (_line559 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 156.63,
    y1: 904.56,
    x2: 156.63,
    y2: 981.42
  })), _line560 || (_line560 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 153.39,
    y1: 980.94,
    x2: 153.39,
    y2: 906.06
  })), _line561 || (_line561 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 128.13,
    y1: 265.14,
    x2: 128.13,
    y2: 298.02
  })), _line562 || (_line562 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 141.51,
    y1: 748.92,
    x2: 139.59,
    y2: 745.44
  })), _polyline310 || (_polyline310 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "137.31 741 136.17 738.96 135.63 737.88 134.97 736.8 134.97 736.86 135.09 736.98 135.09 737.04 135.15 737.1 135.39 737.46"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M133.59,696.84l-1.62,1.08-1.56,1.08-2.94,2.22-5.7,4.5-5.7,4.44-1.32,1.14-1.14,1.14-.48.6-.36.54-.3.54-.06.3c-.23.51.16,1.36.48,1.74l.42.48.54.54.66.54.72.54c4.23,3.31,9.13,5.67,13.2,9.36l1.56,1.44,1.5,1.62c1.36,1.39,2.4,3.03,3.66,4.5l.12.12.42.54.66.9"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M137.37,738l.9,1.14.9,1.2.78,1.14c4.42,6.76,8.83,13.88,12.84,20.88l2.34,4.02,2.28,4.08c5.7,11.07,11.93,20.92,18.18,31.5l1.98,3.72,1.92,3.78,1.74,3.66,1.68,3.66c3.02,7.1,6.64,13.92,9.84,20.94l3.12,7.32,1.68,3.54c1.66,3.12,3.14,6.49,3.3,10.08l.06.54v.42"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M162.93,901.44l-3.66,1.86c-7.99,4-16.49,7-24.18,11.58l-1.5.96"
  })), _polyline311 || (_polyline311 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "135.39 737.46 134.61 736.44 134.19 735.9 133.95 735.66 133.83 735.48"
  })), _polyline312 || (_polyline312 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "134.49 736.14 132.27 734.1 129.87 732.06 127.41 730.08 124.83 728.16 122.37 726.36 119.85 724.62 117.27 722.94 114.75 721.38 112.41 719.88 111.33 719.16 110.31 718.44 109.47 717.72 108.75 717 108.27 716.28 108.03 715.56 107.97 714.84 107.97 714.42 108.03 714.12 108.27 713.52 108.57 712.98 109.35 711.96 110.31 710.94 111.39 709.92 112.53 708.96 114.99 706.98 119.85 703.2 124.77 699.36 127.29 697.5 130.05 695.64"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M130.11,914.58h.42c1.4-.06,1.7.16,2.94.48l.18.18"
  })), _polyline313 || (_polyline313 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "130.05 695.64 130.35 695.58 130.59 695.58 131.13 695.64 131.67 695.64 132.21 695.76 133.23 696 133.53 696.12 133.65 696.18 133.71 696.36 133.71 696.6 133.65 696.78 133.59 696.84"
  })), _line563 || (_line563 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 152.25,
    y1: 763.02,
    x2: 152.25,
    y2: 847.86
  })), _line564 || (_line564 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 149.19,
    y1: 842.94,
    x2: 149.19,
    y2: 761.7
  })), _line565 || (_line565 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 174.21,
    y1: 575.16,
    x2: 174.21,
    y2: 641.46
  })), _line566 || (_line566 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 170.91,
    y1: 639,
    x2: 170.91,
    y2: 573.84
  })), _line567 || (_line567 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 96.99,
    y1: 58.2,
    x2: 96.99,
    y2: 80.82
  })), _line568 || (_line568 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 146.61,
    y1: 22.26,
    x2: 146.61,
    y2: 88.14
  })), _line569 || (_line569 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 126.63,
    y1: 36.66,
    x2: 126.63,
    y2: 84.3
  })), _line570 || (_line570 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 123.27,
    y1: 114.9,
    x2: 123.27,
    y2: 86.1
  })), _line571 || (_line571 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 161.01,
    y1: 902.4,
    x2: 161.01,
    y2: 979.32
  })), _line572 || (_line572 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 157.83,
    y1: 978.9,
    x2: 157.83,
    y2: 904.02
  })), _line573 || (_line573 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 155.91,
    y1: 769.44,
    x2: 155.91,
    y2: 853.26
  })), _line574 || (_line574 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 152.85,
    y1: 848.76,
    x2: 152.85,
    y2: 768
  })), _line575 || (_line575 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 160.23,
    y1: 12.48,
    x2: 160.23,
    y2: 90.72
  })), _line576 || (_line576 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 156.81,
    y1: 90.42,
    x2: 156.81,
    y2: 14.94
  })), _line577 || (_line577 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 152.25,
    y1: 545.88,
    x2: 152.25,
    y2: 622.98
  })), _line578 || (_line578 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 149.19,
    y1: 618.06,
    x2: 149.19,
    y2: 544.68
  })), _line579 || (_line579 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 177.57,
    y1: 688.38,
    x2: 177.57,
    y2: 753.48
  })), _line580 || (_line580 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 176.37,
    y1: 753.48,
    x2: 176.37,
    y2: 685.44
  })), _line581 || (_line581 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 139.59,
    y1: 742.74,
    x2: 139.59,
    y2: 833.94
  })), _line582 || (_line582 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 137.31,
    y1: 833.16,
    x2: 137.31,
    y2: 740.94
  })), _line583 || (_line583 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 135.87,
    y1: 541.98,
    x2: 135.87,
    y2: 520.74
  })), _line584 || (_line584 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 130.41,
    y1: 732.48,
    x2: 130.41,
    y2: 821.1
  })), _line585 || (_line585 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 129.15,
    y1: 821.1,
    x2: 129.15,
    y2: 731.46
  })), _line586 || (_line586 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 174.99,
    y1: 430.8,
    x2: 174.99,
    y2: 364.74
  })), _line587 || (_line587 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 139.59,
    y1: 317.16,
    x2: 139.59,
    y2: 399.96
  })), _line588 || (_line588 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 137.31,
    y1: 399.18,
    x2: 137.31,
    y2: 315.72
  })), _line589 || (_line589 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 139.59,
    y1: 525.6,
    x2: 139.59,
    y2: 608.76
  })), _line590 || (_line590 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 137.31,
    y1: 607.98,
    x2: 137.31,
    y2: 523.92
  })), _line591 || (_line591 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 139.71,
    y1: 102.9,
    x2: 139.71,
    y2: 87.36
  })), _line592 || (_line592 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 165.51,
    y1: 786.84,
    x2: 165.51,
    y2: 859.5
  })), _line593 || (_line593 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 162.45,
    y1: 857.16,
    x2: 162.45,
    y2: 785.46
  })), _line594 || (_line594 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 151.71,
    y1: 459.72,
    x2: 151.71,
    y2: 536.58
  })), _line595 || (_line595 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 148.53,
    y1: 536.16,
    x2: 148.53,
    y2: 461.16
  })), _line596 || (_line596 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 128.19,
    y1: 341.52,
    x2: 128.19,
    y2: 302.28
  })), _line597 || (_line597 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 128.19,
    y1: 298.08,
    x2: 128.19,
    y2: 265.08
  })), _line598 || (_line598 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 140.07,
    y1: 766.14,
    x2: 140.07,
    y2: 746.28
  })), _line599 || (_line599 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 164.13,
    y1: 682.14,
    x2: 164.13,
    y2: 757.02
  })), _line600 || (_line600 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 161.25,
    y1: 756.42,
    x2: 161.25,
    y2: 683.46
  })), _line601 || (_line601 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 190.83,
    y1: 729.3,
    x2: 190.83,
    y2: 723.96
  })), _line602 || (_line602 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 139.71,
    y1: 87.36,
    x2: 139.71,
    y2: 105.72
  })), _line603 || (_line603 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 136.35,
    y1: 105.42,
    x2: 136.35,
    y2: 87.18
  })), _line604 || (_line604 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 174.21,
    y1: 801.18,
    x2: 174.21,
    y2: 865.98
  })), _line605 || (_line605 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 170.91,
    y1: 863.52,
    x2: 170.91,
    y2: 799.86
  })), _line606 || (_line606 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 160.89,
    y1: 557.58,
    x2: 160.89,
    y2: 631.44
  })), _line607 || (_line607 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 157.77,
    y1: 629.16,
    x2: 157.77,
    y2: 556.38
  })), _line608 || (_line608 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 200.61,
    y1: 1090.08,
    x2: 200.61,
    y2: 1106.1
  })), _line609 || (_line609 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 149.97,
    y1: 19.86,
    x2: 149.97,
    y2: 91.2
  })), _line610 || (_line610 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 155.91,
    y1: 999.54,
    x2: 155.91,
    y2: 1078.74
  })), _line611 || (_line611 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 152.85,
    y1: 1074.12,
    x2: 152.85,
    y2: 998.1
  })), _line612 || (_line612 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 136.23,
    y1: 87.18,
    x2: 136.23,
    y2: 108.18
  })), _line613 || (_line613 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 174.99,
    y1: 642.06,
    x2: 174.99,
    y2: 580.86
  })), _line614 || (_line614 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 186.33,
    y1: 490.2,
    x2: 186.33,
    y2: 515.52
  })), _line615 || (_line615 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 184.11,
    y1: 516.36,
    x2: 184.11,
    y2: 484.32
  })), _line616 || (_line616 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 169.89,
    y1: 679.38,
    x2: 169.89,
    y2: 754.74
  })), _line617 || (_line617 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 167.07,
    y1: 754.14,
    x2: 167.07,
    y2: 680.82
  })), _line618 || (_line618 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 139.59,
    y1: 87.36,
    x2: 139.59,
    y2: 164.28
  })), _line619 || (_line619 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 137.31,
    y1: 163.5,
    x2: 137.31,
    y2: 87.24
  })), _line620 || (_line620 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 108.81,
    y1: 1011.66,
    x2: 108.81,
    y2: 935.64
  })), _line621 || (_line621 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 157.77,
    y1: 556.44,
    x2: 155.85,
    y2: 553.8
  })), _polyline314 || (_polyline314 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "141.51 532.86 140.55 531 139.59 529.08"
  })), _polyline315 || (_polyline315 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "137.31 524.04 135.93 520.92 134.55 517.68"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M134.25,468.36l-2.64,1.86-2.52,1.86-4.92,3.78c-3.57,3.27-8.24,5.63-11.28,9.48l-.24.48-.12.48c-.42,1.52,1.61,3.65,2.4,4.74l1.98,1.98,2.28,2.04,2.28,2.1c5.12,4.44,9.16,9.53,11.94,15.72l.66,1.44.12.3.12.12.06.18.24.48.06.06.54.9.06.24.12.12.24.42.24.48"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M136.71,519l2.34,3.78.72,1.2c2.66,4.85,5.42,9.82,8.34,14.52l1.2,1.8,2.52,3.54c7.09,10.06,14.37,19.21,21.84,28.86l1.14,1.68,2.04,3.54,1.98,3.48,1.92,3.36c5.2,9.84,9.35,21.45,14.46,31.74l1.44,3.72,2.88,7.74c.78,2.45,1.47,5.1,1.26,7.68v.18"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M172.77,677.76l-1.8,1.02c-11.43,6.02-24.13,10.56-35.4,16.86l-1.98,1.2"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M134.07,516.72l-.36-.48-.12-.24c-3.73-4.96-7.13-10.36-11.64-14.7l-2.04-1.92-4.26-3.6c-1.97-1.74-6.24-5.1-7.2-7.8l-.24-.66-.12-.66"
  })), _polyline316 || (_polyline316 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "130.77 467.16 131.01 467.1 131.25 467.1 131.79 467.16 132.33 467.16 133.95 467.52 134.31 467.7 134.37 467.82 134.37 468.3 134.25 468.36"
  })), _line622 || (_line622 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 144.57,
    y1: 324.12,
    x2: 144.57,
    y2: 410.4
  })), _line623 || (_line623 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 141.51,
    y1: 397.8,
    x2: 141.51,
    y2: 322.62
  })), _line624 || (_line624 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 155.91,
    y1: 338.4,
    x2: 155.91,
    y2: 417.42
  })), _line625 || (_line625 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 152.85,
    y1: 413.82,
    x2: 152.85,
    y2: 337.2
  })), _line626 || (_line626 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 130.41,
    y1: 305.04,
    x2: 130.41,
    y2: 388.08
  })), _line627 || (_line627 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 129.15,
    y1: 388.08,
    x2: 129.15,
    y2: 303.48
  })), _line628 || (_line628 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 139.59,
    y1: 970.56,
    x2: 139.59,
    y2: 1057.56
  })), _line629 || (_line629 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 137.31,
    y1: 1056.78,
    x2: 137.31,
    y2: 969.06
  })), _line630 || (_line630 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 174.21,
    y1: 120.48,
    x2: 174.21,
    y2: 191.58
  })), _line631 || (_line631 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 170.91,
    y1: 189.48,
    x2: 170.91,
    y2: 119.34
  })), _line632 || (_line632 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 200.61,
    y1: 414.12,
    x2: 200.61,
    y2: 442.62
  })), _line633 || (_line633 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 68.13,
    y1: 155.22,
    x2: 68.13,
    y2: 79.44
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_21"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 91.47,
    y1: 184.14,
    x2: 107.55,
    y2: 174.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 65.79,
    y1: 816.3,
    x2: 65.79,
    y2: 829.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 180.87,
    y1: 778.62,
    x2: 180.87,
    y2: 755.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 180.87,
    y1: 549.66,
    x2: 180.87,
    y2: 529.14
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "162.69 780.12 168.21 780.3 170.91 780.36 173.67 780.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M239.85,1181.82l-3.96.96c-8,1.86-16.19,3.39-24.06,5.76l-4.02,1.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M289.47,1170.54l-6.24,1.32-6.18,1.44c-12.46,2.78-24.57,4.93-36.9,8.46l-6.12,1.44-6.18,1.38c-11.67,1.89-22.53,6.89-33.9,8.82l-1.56.24-1.56.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M305.73,1156.32l-7.44.9-7.38,1.14-7.5,1.2-7.38,1.14-14.88,2.16-7.44,1.14-14.88,2.76-3.72.54-3.72.36-3.6.18-3.72.06-3.66.12c-10.08.24-16.37,2.88-25.56,7.02l-3.6,1.62-3.54,1.62"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "289.47 1170.54 284.01 1171.68 278.55 1172.94 267.69 1175.34 256.83 1177.62 251.43 1178.88 245.97 1180.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M284.37,1154.34l-6.24.54-6.3.42c-14.12.69-26.79.57-40.92,2.46l-3.12.24-3.12.12-3.18.12h-6.3l-3.12.06-3.18.12-6.3.42-3.12.18-3.12.06h-9.42l-1.56.06-1.62.12"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "202.23 1191.54 199.41 1192.26 196.53 1192.86 193.71 1193.4 190.83 1193.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M267.57,1150.5h-5.46l-5.46-.12c-12.86-.3-25.73-.49-38.58-1.14l-5.52-.12-5.46.18-5.46.24-2.76.06-2.76-.06-2.7-.24-2.76-.42-5.34-1.2-2.7-.54-2.76-.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M252.81,1145.22l-19.32-1.74-9.66-.78c-7.21-.55-14.4-2.09-21.66-2.34l-2.4-.12-4.86-.24c-4.9-.13-9.55-.83-14.34-1.92l-2.4-.42-2.4-.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M238.77,1139.7l-8.46-1.62c-19.03-3.13-38.31-7.44-57.18-10.02l-2.16-.06"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "224.67 1134 217.47 1131.9 213.87 1130.82 210.51 1129.86 203.31 1127.7 196.11 1125.6"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 188.19,
    y1: 1214.04,
    x2: 188.19,
    y2: 1200.12
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "262.65 934.26 253.95 936.9 245.31 939.66 236.67 942.36 228.03 945.36 219.39 948.54 215.07 950.1 210.69 951.54 206.43 952.92 202.11 954.12 197.79 955.2 193.47 956.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M206.19,935.4l2.34-.66,2.4-.54,2.4-.48,2.34-.42,4.62-.6,4.56-.48,4.56-.42,4.68-.42c9.42-.98,18.72-2.6,28.14-3.6l9.18-.9,9.06-.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M202.53,926.28l-4.62-.12c-4-.02-7.71,0-11.64.9l-2.28.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M208.71,943.92l3.78-1.2c15.35-4.98,31.1-6.22,46.74-10.2l7.08-1.62"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "208.71 943.92 204.27 944.64 199.83 945.18 195.39 945.54 190.95 945.96"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "193.47 956.16 200.49 954.54 204.03 953.58 207.57 952.56"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "206.19 935.4 201.63 936 197.01 936.72 194.79 937.14 192.51 937.62 190.29 938.22 188.07 938.94"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "240.03 943.26 238.41 943.68 236.79 944.34 235.23 945.06 233.61 945.9 230.37 947.52 227.13 949.08 214.17 955.38 207.69 958.5 201.21 961.68 197.97 963.24 194.73 964.74 191.55 966.36 189.93 967.32 188.31 968.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M202.53,926.28l4.26-.3c15.52-.34,30.77-1.76,46.2-2.28l16.56-.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M306.33,923.58l-1.62-.12c-5.51-.52-12.43.82-17.76,1.62l-6.48.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "281.67 927.48 277.83 928.2 273.93 929.1 266.31 930.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "284.79 922.26 277.17 922.8 269.55 923.22"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "239.01 910.38 230.49 908.82 213.69 905.7 209.73 905.04 205.53 904.32 201.39 903.54 197.25 902.82 188.85 901.2 184.65 900.48 180.51 899.94 176.31 899.4 174.21 898.98 172.11 898.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "197.43 917.88 193.05 917.52 188.73 917.22 184.41 917.1 179.97 917.22"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "211.47 911.16 193.71 909.48 184.83 908.76 180.39 908.34 178.17 908.04 175.89 907.68"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "197.43 917.88 211.17 918.12 224.97 918.24 238.71 918.54 252.51 919.02"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "211.47 911.16 221.25 912 231.21 913.02"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "253.05 915 247.59 914.58 242.13 914.04 231.21 913.02"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "267.87 919.2 264.03 919.26 260.19 919.2 252.51 919.02"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 140.91,
    y1: 161.1,
    x2: 139.59,
    y2: 161.7
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "142.83 210.72 142.59 210.6 142.47 210.36"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "144.27 199.92 144.51 200.04 144.63 200.28"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "144.63 200.34 144.33 202.38 143.85 204.36"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 142.41,
    y1: 210.66,
    x2: 142.83,
    y2: 210.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 144.27,
    y1: 199.92,
    x2: 142.41,
    y2: 199.56
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "141.27 161.28 141.21 161.16 141.09 161.1 140.91 161.1"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 142.47,
    y1: 210.36,
    x2: 142.47,
    y2: 210.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 144.63,
    y1: 200.28,
    x2: 144.63,
    y2: 200.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 142.41,
    y1: 199.56,
    x2: 142.41,
    y2: 210.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 225.15,
    y1: 463.32,
    x2: 225.21,
    y2: 463.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 142.65,
    y1: 209.04,
    x2: 142.83,
    y2: 210.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 116.07,
    y1: 791.7,
    x2: 115.23,
    y2: 791.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 54.27,
    y1: 808.02,
    x2: 54.27,
    y2: 835.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 75.21,
    y1: 811.86,
    x2: 75.21,
    y2: 811.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 174.99,
    y1: 682.26,
    x2: 175.89,
    y2: 684.42
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "254.07 675 254.07 674.76 253.95 674.7 253.89 674.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 225.15,
    y1: 678.3,
    x2: 225.21,
    y2: 678.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 224.97,
    y1: 678.42,
    x2: 225.03,
    y2: 678.42
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "55.35 1056.12 57.51 1056.54 59.61 1056.9"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 54.27,
    y1: 1028.88,
    x2: 75.21,
    y2: 1032.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 54.27,
    y1: 1055.82,
    x2: 55.35,
    y2: 1056.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 59.61,
    y1: 1056.9,
    x2: 65.55,
    y2: 1057.74
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "115.23 1012.2 116.07 1012.56 117.75 1012.98"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 54.27,
    y1: 1028.88,
    x2: 54.27,
    y2: 1055.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 75.21,
    y1: 1032.66,
    x2: 75.27,
    y2: 1032.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 80.13,
    y1: 322.2,
    x2: 80.13,
    y2: 295.26
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "99.93 336.06 93.75 331.8 86.97 326.76 83.55 324.36 81.87 323.22 80.13 322.2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 153.69,
    y1: 331.86,
    x2: 154.17,
    y2: 331.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 154.41,
    y1: 331.5,
    x2: 154.41,
    y2: 335.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 193.47,
    y1: 731.88,
    x2: 193.41,
    y2: 731.82
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "192.63 731.22 191.25 730.68 189.57 730.2 188.31 729.96"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 191.25,
    y1: 740.46,
    x2: 192.63,
    y2: 737.46
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "188.31 747.18 188.91 745.56 189.57 744"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M240.03,722.1l-1.62.48-1.62.6-9.78,4.8-13.02,6.3-3,1.5-3.24,1.56c-5.32,2.85-10.94,5.09-16.26,7.92l-1.56.9-1.62,1.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M241.29,719.64l.66-.24c5.42-1.81,10.85-3.58,16.26-5.4l2.34-.84"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 193.05,
    y1: 1121.22,
    x2: 192.93,
    y2: 1121.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 132.45,
    y1: 820.02,
    x2: 130.89,
    y2: 820.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 126.69,
    y1: 819.84,
    x2: 125.43,
    y2: 819.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 130.89,
    y1: 820.14,
    x2: 130.41,
    y2: 820.14
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "89.31 846.6 89.31 850.2 90.87 851.1 92.37 852.06 95.25 854.28 101.07 858.66 112.65 867.36"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 192.87,
    y1: 1121.04,
    x2: 193.05,
    y2: 1121.22
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "191.25 507 189.57 506.58 188.31 506.34"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "193.47 511.56 193.41 511.8 192.63 513.6"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "191.25 516.24 191.91 514.92 192.63 513.6"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 193.41,
    y1: 511.8,
    x2: 193.41,
    y2: 508.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M239.97,502.5l-3.24.96-3.24,1.2c-9.74,3.73-19.24,7.61-29.04,11.22l-3.24,1.38-1.62.78c-3.09,1.52-6.46,4.32-9.72,5.22l-1.56.24"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "119.37 792.84 119.31 792.54 119.07 792.42"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 117.87,
    y1: 805.14,
    x2: 117.75,
    y2: 805.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 119.07,
    y1: 792.42,
    x2: 118.53,
    y2: 792.3
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "67.71 817.08 67.65 816.78 67.41 816.6 65.79 816.3"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 193.65,
    y1: 457.68,
    x2: 193.53,
    y2: 457.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 117.57,
    y1: 792.06,
    x2: 116.07,
    y2: 791.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 117.75,
    y1: 805.02,
    x2: 117.75,
    y2: 803.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 75.21,
    y1: 585.72,
    x2: 92.55,
    y2: 577.68
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "117.75 566.04 117.75 565.98 116.07 565.62"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 253.05,
    y1: 688.44,
    x2: 253.23,
    y2: 688.44
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "176.79 975.78 174.09 975.9 173.67 975.96"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 180.63,
    y1: 1000.38,
    x2: 180.87,
    y2: 1000.2
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "174.09 1001.94 175.47 1001.88 176.79 1001.76"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 173.67,
    y1: 1001.94,
    x2: 174.09,
    y2: 1001.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 176.79,
    y1: 1001.76,
    x2: 176.91,
    y2: 1001.76
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "183.99 927.72 182.01 922.38 179.97 917.22"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "285.81 905.64 285.81 905.46 285.69 905.4"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 284.79,
    y1: 922.26,
    x2: 284.79,
    y2: 918.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 285.69,
    y1: 905.4,
    x2: 285.63,
    y2: 905.4
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "307.41 683.58 307.35 683.4 307.23 683.34"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 306.33,
    y1: 701.4,
    x2: 306.33,
    y2: 697.14
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M284.79,699.9l2.7.12c5.65.11,12.05-.6,17.58,1.02l1.26.36"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 307.23,
    y1: 683.34,
    x2: 307.11,
    y2: 683.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 247.05,
    y1: 707.82,
    x2: 246.93,
    y2: 707.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 315.21,
    y1: 225.24,
    x2: 306.39,
    y2: 230.46
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "306.09 234.36 315.21 233.58 312.57 233.88"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 315.21,
    y1: 225.24,
    x2: 315.21,
    y2: 233.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 176.37,
    y1: 956.34,
    x2: 169.89,
    y2: 960.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 193.35,
    y1: 731.76,
    x2: 193.41,
    y2: 731.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 193.89,
    y1: 732.66,
    x2: 193.47,
    y2: 734.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 193.41,
    y1: 730.32,
    x2: 193.41,
    y2: 729.24
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "178.71 963.3 178.77 963.12 178.83 963"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 180.63,
    y1: 976.02,
    x2: 180.69,
    y2: 976.02
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "180.81 975.78 180.63 974.1 180.21 971.46 179.61 968.76 179.13 966.06 178.71 963.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "180.87 976.08 180.63 976.08 180.63 976.02"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 180.87,
    y1: 1000.2,
    x2: 180.87,
    y2: 976.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 188.07,
    y1: 969.3,
    x2: 188.31,
    y2: 968.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 180.63,
    y1: 963.06,
    x2: 188.07,
    y2: 964.38
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "221.91 966.84 223.83 963.54 224.85 961.98 225.99 960.48 228.39 957.72 230.79 954.84 232.95 951.78 235.05 948.72 236.19 947.22 237.39 945.78 238.65 944.46 240.03 943.26"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 179.07,
    y1: 962.94,
    x2: 180.63,
    y2: 963.06
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M221.91,966.84l-.72,1.08-.72,1.02c-2.64,3.64-6.6,5.97-9.9,8.94l-2.52,2.04-5.1,3.9-2.46,1.86c-2.58,1.99-5.04,4.14-7.68,6.06l-1.38,1.02-1.2.9c-1.85,1.21-3.13,2.6-4.68,4.08l-.66.6-.72.6-.78.6"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "193.41 670.14 193.53 670.2 193.65 670.2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 193.47,
    y1: 670.08,
    x2: 193.53,
    y2: 670.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 135.27,
    y1: 398.82,
    x2: 132.15,
    y2: 399.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 142.05,
    y1: 435.6,
    x2: 142.05,
    y2: 435.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 140.25,
    y1: 446.94,
    x2: 140.31,
    y2: 446.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 112.11,
    y1: 429.78,
    x2: 112.11,
    y2: 433.2
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "142.05 435.54 141.93 435.24 141.69 435.12"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 140.25,
    y1: 444.3,
    x2: 140.25,
    y2: 446.94
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "226.05 664.86 226.05 664.68 225.93 664.56"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 210.21,
    y1: 677.58,
    x2: 210.03,
    y2: 677.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 225.93,
    y1: 664.56,
    x2: 225.87,
    y2: 664.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 223.23,
    y1: 681.24,
    x2: 224.97,
    y2: 681.84
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "154.41 320.46 159.15 318.3 159.15 326.4 155.61 336.72"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 159.15,
    y1: 318.3,
    x2: 159.09,
    y2: 318.24
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "120.15 267.42 111.81 265.92 91.89 277.32"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "193.83 508.26 193.89 510 193.47 511.56"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "262.65 489.3 264.87 488.4 267.15 487.62 271.83 486.12 276.51 484.74 281.25 483.54"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "226.41 211.26 226.41 211.08 226.35 210.96 226.23 211.02"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 225.51,
    y1: 222.54,
    x2: 225.45,
    y2: 222.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 172.77,
    y1: 1105.62,
    x2: 172.77,
    y2: 1105.44
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "163.65 1124.22 151.29 1117.08 145.11 1113.42 139.05 1109.58"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "171.45 1119.96 171.27 1119.96 171.21 1119.9 171.21 1119.78"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "172.77 1105.44 172.65 1105.38 172.53 1105.44"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "183.33 999.54 182.73 999.9 182.25 1000.14 181.77 1000.26 181.29 1000.26 180.87 1000.2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 178.89,
    y1: 963,
    x2: 184.11,
    y2: 959.04
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "180.87 1000.2 181.41 999.42 181.83 998.58 182.19 997.68 182.49 996.72 182.91 994.74 183.21 992.76 183.45 990.78 183.75 988.8 184.53 984.9 186.27 977.04 187.05 973.14 187.53 971.22 188.07 969.3"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 178.83,
    y1: 963,
    x2: 178.89,
    y2: 963
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 193.41,
    y1: 898.02,
    x2: 193.41,
    y2: 898.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 144.99,
    y1: 1066.44,
    x2: 144.57,
    y2: 1066.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 252.39,
    y1: 707.1,
    x2: 247.05,
    y2: 707.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 80.13,
    y1: 295.26,
    x2: 108.81,
    y2: 315.24
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "243.45 714.24 237.57 715.5 231.69 716.64"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "243.45 714.24 254.31 711.66 259.71 710.4 265.05 709.26 275.55 706.98 280.77 705.84 285.93 704.82"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 219.45,
    y1: 679.98,
    x2: 223.17,
    y2: 681.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 307.47,
    y1: 218.76,
    x2: 307.53,
    y2: 218.7
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "307.71 218.94 307.59 220.74 307.35 222.48"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 307.47,
    y1: 218.76,
    x2: 306.09,
    y2: 219.54
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "307.23 218.76 307.53 218.7 307.71 218.76 307.71 218.94"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 306.39,
    y1: 230.46,
    x2: 306.33,
    y2: 230.46
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "268.89 679.56 268.89 679.38 268.77 679.32"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 267.87,
    y1: 696.54,
    x2: 267.87,
    y2: 693.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 268.77,
    y1: 679.32,
    x2: 268.71,
    y2: 679.32
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "127.05 1029.06 127.05 1028.88 126.93 1028.76 126.69 1028.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M125.19,1042.08l-.06-.18c.39-3.99,1.24-7.53,1.74-11.46l.18-1.38"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 126.69,
    y1: 1028.64,
    x2: 125.19,
    y2: 1028.34
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "122.85 1027.98 123.03 1027.98 125.19 1028.34"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "91.23 1056.12 91.11 1055.82 90.87 1055.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M89.31,1068.96l.12-.9c.42-3.81,1.29-7.27,1.68-11.1l.12-.84"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 89.31,
    y1: 1069.26,
    x2: 89.61,
    y2: 1069.32
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M89.31,1072.92l-1.44-.78c-5.03-2.6-10.99-4.1-16.32-6l-6-2.1"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 65.55,
    y1: 1051.02,
    x2: 65.61,
    y2: 1051.02
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "125.13 1041.9 107.19 1055.46 89.31 1068.96"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "172.89 445.74 173.01 445.74 173.13 445.8"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 172.11,
    y1: 458.28,
    x2: 172.11,
    y2: 461.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 173.13,
    y1: 445.8,
    x2: 173.19,
    y2: 445.98
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "305.85 475.98 306.09 473.52 306.39 471.06"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "307.23 463.44 307.17 463.44 305.79 464.28"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "306.03 463.56 307.23 463.44 307.41 463.44 307.41 463.68"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 305.79,
    y1: 475.98,
    x2: 305.85,
    y2: 475.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 306.09,
    y1: 476.16,
    x2: 306.03,
    y2: 476.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 170.97,
    y1: 1128,
    x2: 170.49,
    y2: 1126.92
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "239.85 1121.94 239.79 1121.76 239.73 1121.7 239.67 1121.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 238.89,
    y1: 1136.04,
    x2: 238.95,
    y2: 1136.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 211.47,
    y1: 208.62,
    x2: 210.51,
    y2: 209.16
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "211.65 208.86 211.65 208.68 211.59 208.56 211.47 208.62"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 210.69,
    y1: 220.14,
    x2: 210.63,
    y2: 220.14
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "186.39 506.4 186.39 506.22 186.51 506.1"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "188.07 518.34 188.19 518.28 188.25 518.04 188.13 517.02 188.07 516.12"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 188.31,
    y1: 518.4,
    x2: 188.07,
    y2: 518.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 188.07,
    y1: 506.28,
    x2: 188.31,
    y2: 506.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 188.07,
    y1: 518.34,
    x2: 188.13,
    y2: 518.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 186.69,
    y1: 506.04,
    x2: 188.07,
    y2: 506.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 186.57,
    y1: 506.1,
    x2: 190.83,
    y2: 504
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 194.67,
    y1: 207.42,
    x2: 193.53,
    y2: 208.02
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "194.85 207.66 194.85 207.48 194.79 207.36 194.67 207.42"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 193.77,
    y1: 219,
    x2: 193.65,
    y2: 219
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "173.19 880.86 173.13 880.68 173.01 880.62 172.89 880.62"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "166.05 303.96 165.57 304.2 159.15 307.14"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "166.47 307.14 165.57 309.12 163.89 313.38 162.21 317.76 159.15 326.4"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 129.21,
    y1: 257.94,
    x2: 132.57,
    y2: 258.54
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "194.49 656.82 194.49 656.64 194.43 656.52"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "172.11 673.92 174.15 673.5 176.13 673.26"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "171.51 898.8 174.99 905.58 175.89 907.68"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "254.07 898.32 254.07 898.14 253.95 898.02 253.89 898.02"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "173.67 755.1 170.19 755.7 165.57 757.56"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 140.79,
    y1: 768.96,
    x2: 139.59,
    y2: 769.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 173.67,
    y1: 755.1,
    x2: 169.77,
    y2: 754.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 131.85,
    y1: 762.48,
    x2: 131.55,
    y2: 762.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 165.57,
    y1: 757.56,
    x2: 153.27,
    y2: 763.2
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "140.91 830.76 141.09 830.76 141.21 830.82 141.27 830.94"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 135.27,
    y1: 832.8,
    x2: 132.81,
    y2: 832.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 140.91,
    y1: 830.76,
    x2: 139.59,
    y2: 831.36
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "141.39 869.04 141.63 869.16 141.75 869.46"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 112.65,
    y1: 863.82,
    x2: 112.65,
    y2: 867.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M139.89,885.66l-3.3-2.52c-6.56-4.93-13.85-8.76-20.58-13.44l-3.36-2.34"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 141.75,
    y1: 869.46,
    x2: 141.75,
    y2: 869.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 172.29,
    y1: 669.42,
    x2: 172.17,
    y2: 669.36
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "173.67 975.96 170.19 976.56 165.57 978.42"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 140.79,
    y1: 989.82,
    x2: 139.59,
    y2: 990.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 173.67,
    y1: 975.96,
    x2: 169.77,
    y2: 975.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 131.85,
    y1: 983.34,
    x2: 131.55,
    y2: 983.16
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "165.57 978.42 157.47 982.14 153.39 984 151.35 984.9 150.33 985.38 149.37 985.86"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 158.19,
    y1: 1001.22,
    x2: 157.77,
    y2: 1001.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 286.11,
    y1: 220.26,
    x2: 285.99,
    y2: 220.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 285.09,
    y1: 231.9,
    x2: 285.03,
    y2: 231.9
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "119.55 1013.76 119.49 1013.46 119.25 1013.28"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "117.75 1026.54 118.11 1023.54 118.53 1020.72"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "117.75 1012.98 118.53 1013.16 119.25 1013.28"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "67.47 1037.88 67.41 1037.58 67.17 1037.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M65.61,1050.72l.12-.9c.34-3.72,1.31-7.37,1.68-11.1l.06-.84"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 67.17,
    y1: 1037.4,
    x2: 65.55,
    y2: 1037.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 172.11,
    y1: 669.12,
    x2: 172.17,
    y2: 669.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 172.29,
    y1: 458.16,
    x2: 172.17,
    y2: 458.1
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "183.75 1159.26 182.91 1155.96 181.95 1152.84 180.93 1149.78 179.85 1146.9"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 285.51,
    y1: 1136.52,
    x2: 285.57,
    y2: 1136.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 284.43,
    y1: 1150.74,
    x2: 284.85,
    y2: 1146.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 284.37,
    y1: 1154.34,
    x2: 284.37,
    y2: 1151.1
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "284.67 1136.58 285.57 1136.52 285.69 1136.58 285.75 1136.76"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 284.61,
    y1: 1150.98,
    x2: 284.55,
    y2: 1150.98
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "285.81 704.88 280.65 705.9 275.43 707.04 264.93 709.32 259.65 710.46 254.25 711.72 243.39 714.3"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 315.21,
    y1: 691.92,
    x2: 306.51,
    y2: 697.02
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M306.33,701.4l1.14.48c2.96,1.29,5.24,3.25,7.5,5.52l.24.12v-15.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M285.33,704.76h.06c.63-.04,1.68-.17,2.28-.3l1.44-.18"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "303.93 706.62 302.73 706.38 301.53 706.02"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 304.17,
    y1: 706.68,
    x2: 303.93,
    y2: 706.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 287.55,
    y1: 465.78,
    x2: 287.67,
    y2: 465.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 267.99,
    y1: 915.72,
    x2: 267.87,
    y2: 915.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 191.25,
    y1: 259.56,
    x2: 192.27,
    y2: 259.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 188.31,
    y1: 258.84,
    x2: 189.57,
    y2: 259.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 193.47,
    y1: 266.16,
    x2: 193.41,
    y2: 266.4
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "192.63 268.26 191.25 270.54 189.57 272.88 188.31 274.5"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 193.41,
    y1: 266.4,
    x2: 193.41,
    y2: 261.66
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "134.73 594.72 134.73 594.6 134.61 594.48 134.31 594.36"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "132.39 607.5 132.93 604.14 133.59 601.08 134.19 598.08 134.73 594.72"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 126.69,
    y1: 594.36,
    x2: 125.49,
    y2: 594.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 130.89,
    y1: 594.66,
    x2: 130.41,
    y2: 594.6
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "125.49 594.12 107.55 607.68 89.73 621.18"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 134.31,
    y1: 594.36,
    x2: 130.89,
    y2: 594.66
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "114.63 626.1 114.57 625.8 114.33 625.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M112.71,638.28l.06-.84c.5-3.56,1.3-6.94,1.8-10.5l.06-.84"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 112.65,
    y1: 638.64,
    x2: 113.01,
    y2: 638.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M89.73,621.18v1.68l1.56.96c3.66,2.71,6.46,5.74,9.96,8.58l11.4,9.72"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "132.39 607.5 122.49 622.92 112.71 638.28"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "225.81 1116.3 225.75 1116.12 225.69 1116 225.63 1116"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 224.91,
    y1: 1130.34,
    x2: 224.85,
    y2: 1130.4
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "141.81 217.14 134.31 216.42 126.75 215.82"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 102.21,
    y1: 212.1,
    x2: 91.47,
    y2: 209.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 126.69,
    y1: 163.2,
    x2: 126.15,
    y2: 163.08
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "130.41 163.44 130.89 163.5 135.27 163.14"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "134.07 387.24 134.07 387.06 133.95 386.94 133.71 386.88"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "131.79 398.76 132.27 395.76 132.57 394.32 132.99 392.82 133.29 391.56 133.59 390.24 134.07 387.24"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "130.41 387.06 130.89 387.12 133.71 386.88"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "114.09 418.44 114.03 418.14 113.79 418.02"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "112.17 429.42 112.59 426.48 112.83 425.22 113.13 423.9 113.43 422.64 113.67 421.38 114.09 418.44"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 112.11,
    y1: 429.78,
    x2: 112.47,
    y2: 429.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 89.19,
    y1: 413.52,
    x2: 89.19,
    y2: 417.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M112.11,433.2l-2.88-1.92c-6.32-4.2-11.82-9.6-18.54-13.2l-1.5-.78"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "131.79 398.76 121.89 414.12 112.17 429.42"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "211.29 660.24 211.29 660.06 211.17 659.94 211.11 659.94"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 131.55,
    y1: 983.52,
    x2: 131.85,
    y2: 983.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 172.17,
    y1: 669.12,
    x2: 172.35,
    y2: 669.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 225.63,
    y1: 1119.12,
    x2: 239.73,
    y2: 1121.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 161.01,
    y1: 263.7,
    x2: 161.25,
    y2: 263.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 194.43,
    y1: 656.52,
    x2: 194.25,
    y2: 656.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 287.31,
    y1: 465.84,
    x2: 287.55,
    y2: 465.78
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "238.77 1139.7 231.75 1136.82 224.67 1134"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "65.91 1051.08 65.67 1050.96 65.61 1050.72"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "314.97 707.4 313.59 707.16 312.27 707.1 306.81 706.98 305.49 706.86 304.23 706.68"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 141.81,
    y1: 204.36,
    x2: 142.41,
    y2: 210.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 141.87,
    y1: 193.26,
    x2: 142.41,
    y2: 199.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 117.75,
    y1: 1012.98,
    x2: 117.81,
    y2: 1012.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 173.67,
    y1: 1001.94,
    x2: 173.73,
    y2: 1001.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 307.11,
    y1: 223.8,
    x2: 315.21,
    y2: 225.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 286.89,
    y1: 704.64,
    x2: 285.93,
    y2: 704.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 112.23,
    y1: 429.6,
    x2: 112.29,
    y2: 429.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 253.77,
    y1: 679.02,
    x2: 268.77,
    y2: 679.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 159.15,
    y1: 318.3,
    x2: 159.15,
    y2: 318.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 168.75,
    y1: 975.6,
    x2: 164.13,
    y2: 975.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 144.99,
    y1: 987.84,
    x2: 144.57,
    y2: 988.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 144.99,
    y1: 1005.3,
    x2: 144.57,
    y2: 1005.54
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "118.05 1026.96 117.87 1026.78 117.75 1026.54"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 306.87,
    y1: 690.42,
    x2: 315.21,
    y2: 691.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 193.59,
    y1: 218.82,
    x2: 193.77,
    y2: 219
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 140.07,
    y1: 977.88,
    x2: 139.59,
    y2: 978.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 144.63,
    y1: 200.16,
    x2: 144.63,
    y2: 200.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 225.15,
    y1: 463.32,
    x2: 225.03,
    y2: 463.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 253.89,
    y1: 674.7,
    x2: 239.19,
    y2: 683.34
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "239.01 687.06 245.97 689.64 253.05 691.98"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 225.09,
    y1: 678.24,
    x2: 225.21,
    y2: 678.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 193.41,
    y1: 735.06,
    x2: 193.47,
    y2: 734.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 194.07,
    y1: 1106.76,
    x2: 193.95,
    y2: 1106.76
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "183.39 999.54 182.07 1000.32 181.35 1000.68 180.57 1000.98 178.95 1001.4 177.21 1001.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 307.11,
    y1: 683.4,
    x2: 284.97,
    y2: 696.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 193.41,
    y1: 735.06,
    x2: 193.35,
    y2: 735.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 193.47,
    y1: 670.08,
    x2: 193.65,
    y2: 670.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 211.29,
    y1: 660.3,
    x2: 225.93,
    y2: 664.56
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "225.39 222.48 225.51 222.48 225.33 222.6"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "139.47 1106.22 163.65 1110.66 163.65 1124.22"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 118.53,
    y1: 1027.08,
    x2: 118.05,
    y2: 1026.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 90.87,
    y1: 1055.64,
    x2: 65.91,
    y2: 1051.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 305.97,
    y1: 476.16,
    x2: 306.09,
    y2: 476.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 210.57,
    y1: 220.08,
    x2: 210.69,
    y2: 220.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 193.41,
    y1: 673.98,
    x2: 193.41,
    y2: 670.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 128.13,
    y1: 764.7,
    x2: 128.19,
    y2: 764.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 156.09,
    y1: 780.12,
    x2: 155.91,
    y2: 780.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 128.13,
    y1: 985.5,
    x2: 128.19,
    y2: 985.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 284.49,
    y1: 1150.98,
    x2: 284.61,
    y2: 1150.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 285.81,
    y1: 704.88,
    x2: 286.95,
    y2: 704.64
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "252.39 707.1 262.77 705.84 273.09 704.64 283.35 703.5 288.51 702.9 293.61 702.18"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "306.33 701.4 304.77 701.28 303.21 701.22 301.59 701.28 299.97 701.4 296.79 701.76 293.61 702.18"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "304.17 706.68 305.61 706.92 306.99 707.04 312.45 707.16 313.83 707.28 315.21 707.52"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 210.27,
    y1: 459.84,
    x2: 210.45,
    y2: 459.9
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "132.15 399.06 131.91 399 131.79 398.76"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "132.15 399.06 122.25 414.48 112.47 429.84"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "157.41 308.34 157.47 307.98 157.65 307.8"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "159.09 317.88 158.79 315.36 158.55 314.22 158.25 313.08 157.95 312 157.71 310.8 157.41 308.34"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 157.65,
    y1: 307.8,
    x2: 159.15,
    y2: 307.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 158.85,
    y1: 318.36,
    x2: 156.63,
    y2: 314.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 159.15,
    y1: 307.14,
    x2: 156.63,
    y2: 302.94
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "127.17 257.52 126.87 257.58 126.75 257.7 126.75 257.82 127.05 259.92 127.29 260.94 127.47 261.78"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 127.17,
    y1: 257.52,
    x2: 129.21,
    y2: 257.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 159.09,
    y1: 317.88,
    x2: 156.63,
    y2: 313.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 153.39,
    y1: 309.36,
    x2: 151.71,
    y2: 306.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 153.39,
    y1: 297.66,
    x2: 151.71,
    y2: 294.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 153.39,
    y1: 308.46,
    x2: 151.71,
    y2: 305.58
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "119.55 566.76 119.49 566.52 119.25 566.34"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "117.75 565.98 118.53 566.22 119.25 566.34"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "67.47 590.88 67.41 590.64 67.17 590.46"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 65.55,
    y1: 603.12,
    x2: 65.85,
    y2: 603.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 67.17,
    y1: 590.46,
    x2: 65.55,
    y2: 590.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 135.87,
    y1: 280.44,
    x2: 135.21,
    y2: 279.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 135.87,
    y1: 268.74,
    x2: 135.21,
    y2: 267.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 135.87,
    y1: 279.54,
    x2: 135.21,
    y2: 278.46
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "178.83 268.8 178.89 268.68 178.95 268.56"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "180.93 268.62 180.63 268.56 179.19 268.44"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 267.99,
    y1: 693.06,
    x2: 267.87,
    y2: 693.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 180.87,
    y1: 517.08,
    x2: 188.07,
    y2: 518.34
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M180.87,549.66l.78-1.38c3.09-6.45,3.8-13.85,5.52-20.76l.9-3.18"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 173.19,
    y1: 655.98,
    x2: 173.13,
    y2: 655.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 172.11,
    y1: 673.92,
    x2: 172.11,
    y2: 669.54
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M139.89,656.88v3.72l2.94,2.1c7.1,5.57,11.73,8.82,19.38,13.2l1.44,1.08"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "173.13 655.8 173.01 655.74 172.89 655.8"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 268.59,
    y1: 1132.56,
    x2: 268.65,
    y2: 1132.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 267.57,
    y1: 1150.5,
    x2: 267.57,
    y2: 1147.08
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "268.17 1132.56 268.65 1132.56 268.71 1132.62 268.77 1132.8"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 267.81,
    y1: 1146.96,
    x2: 267.75,
    y2: 1146.96
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "178.77 517.26 178.77 517.14 178.89 517.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M180.63,529.08l.18-.06.06-.18c-.29-3.38-1.18-5.87-1.74-9.12l-.36-2.46"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 180.63,
    y1: 517.08,
    x2: 180.87,
    y2: 517.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 180.63,
    y1: 529.14,
    x2: 180.63,
    y2: 529.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 179.13,
    y1: 516.96,
    x2: 180.63,
    y2: 517.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 193.47,
    y1: 266.16,
    x2: 193.47,
    y2: 261.78
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "193.83 262.5 193.89 264.48 193.47 266.16"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "92.55 1006.14 73.41 1017.48 54.39 1028.76"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 92.85,
    y1: 1006.2,
    x2: 92.55,
    y2: 1006.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 267.09,
    y1: 240.18,
    x2: 262.59,
    y2: 241.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 225.87,
    y1: 888.54,
    x2: 225.93,
    y2: 888.48
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "224.13 905.16 224.97 905.4 220.89 904.2 216.75 903.06"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "225.93 888.54 226.05 888.6 226.05 888.84"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "127.53 581.16 127.53 581.04 127.41 580.86 127.17 580.74"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "125.85 593.88 125.61 593.7 125.55 593.46 126.09 589.62 126.21 588.78 126.39 588 126.51 587.22 126.69 586.32 127.17 583.8 127.53 581.16"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 127.17,
    y1: 580.74,
    x2: 126.69,
    y2: 580.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 118.53,
    y1: 579.18,
    x2: 118.05,
    y2: 579.06
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "122.85 580.02 123.03 580.08 125.19 580.44 126.69 580.74"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "91.65 608.28 91.53 607.98 91.29 607.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M89.73,620.52l.12-.9c.38-3.54,1.33-6.98,1.68-10.5l.12-.84"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 89.73,
    y1: 620.82,
    x2: 90.03,
    y2: 620.88
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M65.55,616.2l6.12,1.26c5.51,1.53,11.44,2.04,16.62,4.62l1.44.78"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "125.55 593.46 107.61 607.02 89.73 620.52"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "90.03 620.88 89.85 620.76 89.73 620.52"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "193.41 894.6 193.65 894.48 193.65 894.42 193.47 894.3"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 193.65,
    y1: 894.48,
    x2: 193.53,
    y2: 894.42
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "254.49 216.96 254.43 216.78 254.37 216.72"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "253.35 217.26 254.31 216.72 254.37 216.72"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "92.55 559.2 73.35 570.54 54.27 581.94"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 92.85,
    y1: 559.26,
    x2: 92.55,
    y2: 559.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 54.21,
    y1: 581.94,
    x2: 54.21,
    y2: 608.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 135.27,
    y1: 607.62,
    x2: 132.75,
    y2: 607.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 140.91,
    y1: 605.58,
    x2: 139.59,
    y2: 606.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 141.75,
    y1: 644.34,
    x2: 141.75,
    y2: 644.28
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "112.65 642.12 119.49 646.62 133.05 655.98 139.89 660.6"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "141.27 605.76 141.21 605.64 141.09 605.58 140.91 605.58"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "141.75 644.28 141.63 643.98 141.39 643.86"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 253.47,
    y1: 228.18,
    x2: 253.53,
    y2: 228.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 40.17,
    y1: 162.12,
    x2: 40.17,
    y2: 188.82
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "163.59 86.88 167.19 87.54 154.77 96.6"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 305.73,
    y1: 1152.18,
    x2: 306.15,
    y2: 1148.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 307.05,
    y1: 1137.78,
    x2: 307.17,
    y2: 1137.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 305.73,
    y1: 1156.32,
    x2: 305.73,
    y2: 1152.54
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "305.67 1137.96 307.17 1137.78 307.29 1137.84 307.35 1138.02"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 305.97,
    y1: 1152.36,
    x2: 305.91,
    y2: 1152.36
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "194.25 881.1 194.43 881.1 194.49 881.16 194.49 881.34"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 112.23,
    y1: 143.52,
    x2: 106.23,
    y2: 147.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 157.77,
    y1: 110.34,
    x2: 155.91,
    y2: 111.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 160.89,
    y1: 108,
    x2: 161.25,
    y2: 107.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 88.59,
    y1: 144.84,
    x2: 82.35,
    y2: 149.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 140.07,
    y1: 287.28,
    x2: 139.05,
    y2: 285.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 140.07,
    y1: 275.58,
    x2: 139.05,
    y2: 273.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 140.07,
    y1: 286.38,
    x2: 139.05,
    y2: 284.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 131.91,
    y1: 274.02,
    x2: 131.55,
    y2: 273.36
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "118.05 579.06 117.87 578.88 117.75 578.64"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "65.85 603.18 65.67 603.06 65.61 602.82 65.97 599.82 66.51 596.88 67.05 593.88 67.47 590.88"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 267.87,
    y1: 692.76,
    x2: 267.87,
    y2: 693.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 178.89,
    y1: 517.02,
    x2: 178.89,
    y2: 516.96
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "284.85 235.32 290.13 235.32 295.41 235.14 300.75 234.78 306.09 234.36"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "134.13 1042.98 134.13 1042.8 134.01 1042.68 133.71 1042.62"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "131.85 1056.36 132.33 1052.88 132.99 1049.64 133.59 1046.4 134.13 1042.98"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 126.69,
    y1: 1042.56,
    x2: 125.43,
    y2: 1042.32
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "130.41 1042.8 130.89 1042.86 133.71 1042.62"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "114.15 1074.18 114.09 1073.88 113.79 1073.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M112.17,1087.02l.12-.9c.46-3.68,1.35-7.4,1.74-11.04l.12-.9"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 112.17,
    y1: 1087.38,
    x2: 112.47,
    y2: 1087.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 89.31,
    y1: 1069.26,
    x2: 89.31,
    y2: 1072.92
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M112.17,1090.74l-2.94-2.1c-6.23-4.66-12.02-10.46-18.42-14.76l-1.5-.96"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "131.85 1056.36 121.95 1071.72 112.17 1087.02"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "179.97 694.32 182.01 699.6 183.99 705.06"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "285.81 682.92 285.81 682.74 285.69 682.68 285.63 682.74"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "188.31 274.5 188.07 274.8 184.53 279.3 180.93 283.98"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 164.25,
    y1: 294.12,
    x2: 164.25,
    y2: 294.06
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "165.57 299.52 165.15 298.26 164.79 297 164.49 295.56 164.25 294.12"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 164.61,
    y1: 293.52,
    x2: 165.57,
    y2: 293.1
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "165.03 253.32 164.79 253.38 164.67 253.5 164.67 253.62"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 165.03,
    y1: 253.32,
    x2: 166.83,
    y2: 253.68
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "166.11 303.96 166.29 303.78 166.41 303.48"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 165.57,
    y1: 293.1,
    x2: 166.47,
    y2: 292.74
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "92.55 785.28 73.41 796.62 54.39 807.9"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 92.85,
    y1: 785.34,
    x2: 92.55,
    y2: 785.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 164.67,
    y1: 253.74,
    x2: 164.67,
    y2: 253.62
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "284.79 918.84 284.91 918.78 284.97 918.78"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 284.79,
    y1: 918.84,
    x2: 284.79,
    y2: 918.78
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "186.39 730.02 186.45 729.84 186.57 729.72"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "188.07 743.22 188.25 743.16 188.31 742.92 188.19 741.78 188.07 740.76"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 188.31,
    y1: 743.28,
    x2: 188.07,
    y2: 743.22
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "188.31 729.96 188.07 729.9 186.75 729.72"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 186.57,
    y1: 729.72,
    x2: 190.83,
    y2: 727.62
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "117.93 373.02 117.69 372.84 117.63 372.6"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "117.57 360.9 118.53 361.14 119.01 361.2 119.25 361.38 119.31 361.68"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 65.61,
    y1: 396.96,
    x2: 65.61,
    y2: 397.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 65.61,
    y1: 385.14,
    x2: 67.17,
    y2: 385.38
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "67.53 385.86 67.29 387.36 67.05 388.74 66.57 391.38 66.15 394.02 65.91 395.46 65.67 396.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "67.17 385.38 67.41 385.56 67.53 385.86"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 65.61,
    y1: 396.96,
    x2: 65.61,
    y2: 385.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 210.27,
    y1: 673.56,
    x2: 210.45,
    y2: 673.62
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "54.21 376.86 54.21 403.86 54.45 403.92"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 54.21,
    y1: 376.86,
    x2: 75.15,
    y2: 380.64
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "93.15 354 73.65 365.46 54.21 376.86"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 54.45,
    y1: 403.92,
    x2: 65.61,
    y2: 404.28
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "115.23 360.18 116.07 360.54 117.57 360.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "188.13 1199.76 188.07 1200 187.83 1200.06"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 188.13,
    y1: 1199.76,
    x2: 188.07,
    y2: 1198.98
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "188.19 1200.12 188.07 1200.06 187.83 1200.06"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 188.07,
    y1: 1200.06,
    x2: 188.07,
    y2: 1200
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "193.47 1215.96 193.41 1215.9 192.63 1215.3 191.25 1214.7 189.57 1214.28 188.19 1214.04"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "189.27 1186.38 188.07 1186.14 186.57 1185.9"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 186.39,
    y1: 1185.9,
    x2: 188.97,
    y2: 1184.7
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "180.63 279.66 176.79 279.36 174.15 279.48"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "180.93 283.98 180.63 284.4 176.79 289.44"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 176.55,
    y1: 289.68,
    x2: 174.15,
    y2: 293.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 123.03,
    y1: 806.22,
    x2: 125.13,
    y2: 806.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 118.53,
    y1: 805.32,
    x2: 120.63,
    y2: 805.74
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M65.85,843.24l5.88,1.5c5.37,1.67,10.97,2.64,16.2,4.74l1.38.72"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 75.15,
    y1: 380.7,
    x2: 75.15,
    y2: 380.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 188.07,
    y1: 274.8,
    x2: 188.07,
    y2: 269.88
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "212.31 262.08 209.67 263.7 206.97 265.32 201.63 268.86 196.41 272.4 194.01 274.14 191.73 275.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 176.79,
    y1: 289.44,
    x2: 176.55,
    y2: 289.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 172.29,
    y1: 893.94,
    x2: 172.17,
    y2: 893.94
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "180.63 529.14 176.79 528.78 174.09 528.9 173.67 529.02"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 180.63,
    y1: 550.02,
    x2: 180.87,
    y2: 549.72
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "176.79 553.32 177.87 552.66 178.89 551.88 179.79 550.98 180.63 550.02"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "174.09 554.04 175.47 553.74 176.79 553.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M174.09,554.04h-.42c-3.37.81-6.34.71-9.78.36l-3.3-.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "167.19 554.82 169.83 554.94 172.53 554.88 175.05 554.64 176.19 554.4 177.21 554.16"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 159.63,
    y1: 554.04,
    x2: 159.33,
    y2: 553.98
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M192.15,544.2l-2.76,2.22c-3.61,2.91-6.26,5.52-10.74,7.26l-1.38.48"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "192.15 544.2 189.27 546.48 186.33 548.88 185.61 549.42 184.89 549.9 184.17 550.32 183.45 550.56 182.73 550.68 182.07 550.62 181.77 550.44 181.41 550.26 181.11 550.02 180.87 549.72"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "90.27 277.56 90.03 277.74 89.91 277.98"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "91.53 288.48 91.77 288.3 91.83 288.06"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 91.89,
    y1: 277.32,
    x2: 90.27,
    y2: 277.56
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M89.91,277.98l.12,1.02c.28,2.89,1.4,5.15,1.68,8.04l.12,1.02"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "152.97 321.48 153.03 321.18 153.21 321 154.41 320.46"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "154.41 331.2 154.11 328.68 153.93 327.48 153.69 326.34 153.39 325.2 153.21 324 152.97 321.48"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 154.17,
    y1: 331.62,
    x2: 151.71,
    y2: 329.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 154.41,
    y1: 320.46,
    x2: 151.71,
    y2: 318.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 154.41,
    y1: 331.2,
    x2: 151.71,
    y2: 329.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 253.17,
    y1: 911.46,
    x2: 253.05,
    y2: 911.46
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "180.21 232.5 182.19 237.06 183.15 239.34 184.11 241.74"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 148.53,
    y1: 327.72,
    x2: 148.47,
    y2: 327.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 148.53,
    y1: 327.12,
    x2: 147.57,
    y2: 326.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 253.23,
    y1: 911.46,
    x2: 253.29,
    y2: 911.46
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "268.89 902.58 268.89 902.4 268.77 902.34"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 267.87,
    y1: 919.2,
    x2: 267.87,
    y2: 915.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 268.77,
    y1: 902.34,
    x2: 268.71,
    y2: 902.34
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "193.83 1206.84 193.89 1213.26 193.71 1216.32 211.83 1210.68 229.89 1204.98 266.01 1193.64"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 193.71,
    y1: 1216.32,
    x2: 193.47,
    y2: 1215.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 148.53,
    y1: 316.38,
    x2: 147.57,
    y2: 315.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 253.23,
    y1: 911.46,
    x2: 253.05,
    y2: 911.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 161.25,
    y1: 518.34,
    x2: 161.01,
    y2: 518.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 167.07,
    y1: 514.86,
    x2: 164.13,
    y2: 516.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 176.37,
    y1: 509.4,
    x2: 169.89,
    y2: 513.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 172.11,
    y1: 893.7,
    x2: 172.17,
    y2: 893.7
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "253.11 911.4 253.23 911.46 253.17 911.46"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 144.33,
    y1: 294.36,
    x2: 143.19,
    y2: 292.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 148.53,
    y1: 301.2,
    x2: 147.57,
    y2: 299.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 144.33,
    y1: 282.66,
    x2: 143.19,
    y2: 280.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 144.33,
    y1: 293.46,
    x2: 143.19,
    y2: 291.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 148.53,
    y1: 300.3,
    x2: 147.57,
    y2: 298.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 253.53,
    y1: 228.24,
    x2: 253.59,
    y2: 228.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 120.39,
    y1: 121.68,
    x2: 114.09,
    y2: 126.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 104.49,
    y1: 149.16,
    x2: 98.37,
    y2: 153.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 120.39,
    y1: 137.58,
    x2: 114.09,
    y2: 142.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 104.49,
    y1: 133.26,
    x2: 98.37,
    y2: 137.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 112.23,
    y1: 127.62,
    x2: 106.23,
    y2: 132
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 276.75,
    y1: 237.78,
    x2: 274.11,
    y2: 238.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 268.05,
    y1: 693,
    x2: 267.87,
    y2: 693.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 180.93,
    y1: 268.8,
    x2: 180.93,
    y2: 268.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 140.25,
    y1: 654.48,
    x2: 140.25,
    y2: 656.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 131.91,
    y1: 316.26,
    x2: 131.55,
    y2: 316.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 135.87,
    y1: 318.96,
    x2: 135.21,
    y2: 318.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 140.07,
    y1: 321.9,
    x2: 139.59,
    y2: 321.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 131.91,
    y1: 315.66,
    x2: 131.55,
    y2: 315.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 135.87,
    y1: 318.42,
    x2: 135.21,
    y2: 317.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 140.07,
    y1: 321.3,
    x2: 139.59,
    y2: 321
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 108.81,
    y1: 288.96,
    x2: 91.89,
    y2: 277.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 135.87,
    y1: 307.62,
    x2: 135.21,
    y2: 307.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 140.07,
    y1: 310.5,
    x2: 139.05,
    y2: 309.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 144.33,
    y1: 313.5,
    x2: 143.19,
    y2: 312.66
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "188.31 523.5 188.07 524.34 188.07 518.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M224.25,519.9l-2.4,2.4c-8.01,7.62-18.92,13.56-27.66,20.34l-1.8,1.38"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "65.85 836.34 62.91 836.04 60.03 835.74 57.09 835.38 54.27 835.02"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 112.77,
    y1: 790.44,
    x2: 112.29,
    y2: 790.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 112.77,
    y1: 1011.3,
    x2: 112.29,
    y2: 1011.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 91.65,
    y1: 288.54,
    x2: 80.13,
    y2: 295.26
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "108.81 342.06 106.59 340.5 104.37 339 99.93 336.06"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 192.69,
    y1: 727.86,
    x2: 192.75,
    y2: 727.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M240.03,502.44l2.64-1.92c5.47-3.78,10.88-7.1,16.92-9.9l3.06-1.32"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "65.55 609.84 59.91 609.42 54.21 608.94"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 115.23,
    y1: 565.2,
    x2: 116.07,
    y2: 565.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 112.77,
    y1: 564.36,
    x2: 112.29,
    y2: 564.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 180.51,
    y1: 976.08,
    x2: 176.79,
    y2: 975.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 184.11,
    y1: 951.72,
    x2: 177.57,
    y2: 955.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 141.51,
    y1: 1068.06,
    x2: 140.91,
    y2: 1068.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 210.45,
    y1: 673.62,
    x2: 210.21,
    y2: 673.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 120.63,
    y1: 1027.5,
    x2: 118.53,
    y2: 1027.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 144.99,
    y1: 841.86,
    x2: 144.57,
    y2: 842.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 156.63,
    y1: 262.92,
    x2: 157.83,
    y2: 263.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 151.71,
    y1: 262.02,
    x2: 153.39,
    y2: 262.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 147.57,
    y1: 261.24,
    x2: 148.53,
    y2: 261.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 143.19,
    y1: 260.46,
    x2: 144.39,
    y2: 260.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 139.05,
    y1: 259.68,
    x2: 140.07,
    y2: 259.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 131.91,
    y1: 761.88,
    x2: 131.55,
    y2: 762.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 135.87,
    y1: 759.54,
    x2: 135.21,
    y2: 759.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 153.39,
    y1: 753.78,
    x2: 151.71,
    y2: 753.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 157.83,
    y1: 754.08,
    x2: 156.63,
    y2: 753.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 131.55,
    y1: 762.66,
    x2: 131.85,
    y2: 762.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 144.99,
    y1: 766.98,
    x2: 144.57,
    y2: 767.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 172.17,
    y1: 457.86,
    x2: 172.35,
    y2: 458.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 129.15,
    y1: 594.54,
    x2: 126.69,
    y2: 594.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 112.65,
    y1: 642.12,
    x2: 112.71,
    y2: 642.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 164.13,
    y1: 264.24,
    x2: 164.61,
    y2: 264.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 268.41,
    y1: 1137.36,
    x2: 284.67,
    y2: 1136.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 124.77,
    y1: 766.62,
    x2: 124.83,
    y2: 766.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 268.05,
    y1: 915.72,
    x2: 267.87,
    y2: 915.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 268.65,
    y1: 906.24,
    x2: 285.69,
    y2: 905.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 285.63,
    y1: 685.98,
    x2: 307.23,
    y2: 683.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 141.51,
    y1: 989.46,
    x2: 140.79,
    y2: 989.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 141.51,
    y1: 1007.16,
    x2: 139.59,
    y2: 1008.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 131.91,
    y1: 982.74,
    x2: 131.55,
    y2: 982.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 213.27,
    y1: 1149.12,
    x2: 213.33,
    y2: 1149.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 129.15,
    y1: 163.38,
    x2: 126.69,
    y2: 163.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 188.37,
    y1: 523.26,
    x2: 188.43,
    y2: 523.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 120.63,
    y1: 579.6,
    x2: 118.53,
    y2: 579.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 125.49,
    y1: 594.12,
    x2: 125.55,
    y2: 594.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 89.73,
    y1: 621.18,
    x2: 89.73,
    y2: 620.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 140.25,
    y1: 879.36,
    x2: 140.25,
    y2: 881.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 129.15,
    y1: 115.26,
    x2: 122.61,
    y2: 120.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 141.51,
    y1: 106.26,
    x2: 139.59,
    y2: 107.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 144.99,
    y1: 103.74,
    x2: 144.57,
    y2: 104.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 149.19,
    y1: 100.68,
    x2: 148.11,
    y2: 101.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 129.15,
    y1: 131.22,
    x2: 122.61,
    y2: 136.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 141.51,
    y1: 122.22,
    x2: 139.59,
    y2: 123.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 144.99,
    y1: 119.64,
    x2: 144.57,
    y2: 119.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 149.19,
    y1: 116.64,
    x2: 148.11,
    y2: 117.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 285.45,
    y1: 1140.36,
    x2: 305.67,
    y2: 1137.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 129.15,
    y1: 1042.74,
    x2: 126.69,
    y2: 1042.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 122.85,
    y1: 806.16,
    x2: 123.03,
    y2: 806.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 157.83,
    y1: 520.38,
    x2: 156.63,
    y2: 521.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 148.53,
    y1: 289.5,
    x2: 147.57,
    y2: 287.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 186.33,
    y1: 262.98,
    x2: 186.87,
    y2: 262.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 150.03,
    y1: 84.42,
    x2: 149.97,
    y2: 84.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 96.69,
    y1: 154.86,
    x2: 91.05,
    y2: 158.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 96.69,
    y1: 138.9,
    x2: 90.33,
    y2: 143.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 178.95,
    y1: 516.96,
    x2: 184.11,
    y2: 513
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 268.59,
    y1: 683.52,
    x2: 285.69,
    y2: 682.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 253.77,
    y1: 902.04,
    x2: 268.77,
    y2: 902.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 186.33,
    y1: 264.54,
    x2: 187.23,
    y2: 263.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 187.35,
    y1: 512.16,
    x2: 186.33,
    y2: 512.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M191.49,275.88l-2.28,1.74c-3.93,2.87-7.65,6.07-10.8,9.78l-1.62,2.04"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 172.17,
    y1: 893.94,
    x2: 172.11,
    y2: 893.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 54.27,
    y1: 808.02,
    x2: 75.21,
    y2: 811.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 211.11,
    y1: 884.22,
    x2: 211.17,
    y2: 884.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 210.21,
    y1: 901.5,
    x2: 193.41,
    y2: 898.08
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "192.81 1125.12 190.11 1124.76 187.47 1124.46 182.07 1124.04 176.61 1123.8 171.15 1123.86"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 112.65,
    y1: 850.8,
    x2: 89.67,
    y2: 846.66
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "193.41 508.2 192.63 507.6 191.25 507"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "189.57 520.02 189.99 518.94 190.41 517.98 190.83 517.08 191.25 516.24"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "66.15 829.38 65.91 829.26 65.85 828.96 65.97 828.18 66.03 827.4 66.27 825.96 66.51 824.58 66.63 823.8 66.81 823.02 66.93 822.18 67.11 821.46 67.35 820.08 67.53 818.64 67.65 817.92 67.71 817.08"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 54.27,
    y1: 581.94,
    x2: 92.85,
    y2: 559.26
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "180.63 976.02 180.51 976.08 180.63 976.08"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 180.51,
    y1: 976.08,
    x2: 180.81,
    y2: 975.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 186.33,
    y1: 957.36,
    x2: 187.17,
    y2: 956.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M262.65,489.3l-2.16.48-2.16.54-2.16.6-2.16.72-8.64,2.94-8.7,2.82-8.64,2.88-8.64,2.94c-6.39,2.23-13.07,3.65-19.44,5.82l-6.48,2.52"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 274.59,
    y1: 484.92,
    x2: 274.65,
    y2: 484.92
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "225.45 222.54 225.39 222.42 225.39 222.24"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 268.71,
    y1: 679.32,
    x2: 253.23,
    y2: 688.44
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "253.05 691.98 260.43 694.32 267.87 696.54"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "125.43 1042.32 125.25 1042.26 125.19 1042.08"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "125.43 1042.32 107.49 1055.88 89.61 1069.32 89.43 1069.2 89.31 1068.96"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "140.25 446.94 163.65 451.2 163.65 465.48"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 238.77,
    y1: 1139.7,
    x2: 238.77,
    y2: 1136.16
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "193.41 673.98 189.27 673.38 186.33 672.9"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 253.89,
    y1: 898.02,
    x2: 239.19,
    y2: 906.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 144.99,
    y1: 783.72,
    x2: 144.57,
    y2: 783.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 141.39,
    y1: 869.04,
    x2: 113.01,
    y2: 863.88
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "284.37 1154.34 282.27 1154.1 280.11 1153.74 275.91 1152.84 271.71 1151.76 267.57 1150.5"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 189.57,
    y1: 259.08,
    x2: 191.25,
    y2: 259.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 193.41,
    y1: 266.4,
    x2: 192.63,
    y2: 268.26
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M242.85,248.94l-2.52.84c-9.32,3.28-18.21,6.62-26.82,11.64l-.9.48"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "132.75 607.8 132.51 607.74 132.39 607.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "132.75 607.8 122.85 623.28 113.01 638.7 112.77 638.58 112.71 638.28"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 114.33,
    y1: 625.62,
    x2: 89.73,
    y2: 621.18
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "220.89 1132.62 215.37 1130.64 209.79 1128.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "126.75 215.82 120.63 215.16 114.51 214.32 108.33 213.24 102.21 212.1"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 210.21,
    y1: 673.62,
    x2: 210.27,
    y2: 673.38
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "193.41 673.98 197.67 674.82 201.87 675.66 210.21 677.58"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "158.85 318.36 159.03 318.18 159.09 317.88"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 131.91,
    y1: 273.12,
    x2: 131.55,
    y2: 272.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 65.55,
    y1: 590.16,
    x2: 65.55,
    y2: 603.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 188.31,
    y1: 518.4,
    x2: 188.37,
    y2: 518.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 163.65,
    y1: 661.2,
    x2: 163.65,
    y2: 676.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 268.59,
    y1: 1132.56,
    x2: 252.99,
    y2: 1141.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 91.29,
    y1: 607.8,
    x2: 65.85,
    y2: 603.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 141.39,
    y1: 643.86,
    x2: 113.01,
    y2: 638.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 88.59,
    y1: 126.78,
    x2: 88.65,
    y2: 126.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 113.79,
    y1: 1073.76,
    x2: 89.61,
    y2: 1069.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 285.63,
    y1: 682.74,
    x2: 268.05,
    y2: 693
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 66.15,
    y1: 829.38,
    x2: 89.31,
    y2: 833.58
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "154.17 331.62 154.29 331.44 154.41 331.2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 108.81,
    y1: 299.7,
    x2: 91.83,
    y2: 288.06
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "268.11 234.06 272.25 234.54 276.45 234.9 280.59 235.2 284.85 235.32"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 268.71,
    y1: 902.34,
    x2: 253.23,
    y2: 911.46
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "267.87 919.2 260.43 917.16 253.05 915"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "305.79 479.82 290.01 479.46 287.37 479.28 284.79 478.98"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 225.15,
    y1: 901.92,
    x2: 225.21,
    y2: 901.92
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "127.11 807.24 126.99 807 126.75 806.88"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 125.19,
    y1: 819.24,
    x2: 125.25,
    y2: 819.24
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "125.43 819.6 107.49 833.16 89.67 846.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M125.19,819.24l.3-2.4c.4-2.96,1.13-5.8,1.5-8.76l.12-.84"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "125.13 806.58 125.19 806.58 126.69 806.88 126.75 806.88"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "91.23 834.3 91.17 834.06 90.93 833.88"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 89.31,
    y1: 846.6,
    x2: 89.67,
    y2: 846.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 90.93,
    y1: 833.88,
    x2: 89.31,
    y2: 833.58
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M89.37,846.24l.12-.84c.36-3.45,1.29-6.81,1.68-10.26l.06-.84"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 180.87,
    y1: 741.96,
    x2: 188.07,
    y2: 743.22
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "188.31 747.18 188.07 748.08 188.07 743.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M222.09,748.26l.9-1.8.84-1.86.9-1.8,1.08-1.68,1.2-1.62,2.52-3,1.2-1.56c2.32-3.25,4.01-6.92,6.6-10.02l1.26-1.44,1.44-1.38"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "307.41 906 307.35 905.82 307.23 905.76 307.11 905.76"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "193.41 953.22 193.47 953.16 193.47 952.98"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "193.41 953.28 193.47 953.4 193.47 956.16 193.89 954 193.89 953.22"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 193.41,
    y1: 951.84,
    x2: 193.41,
    y2: 950.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 193.41,
    y1: 953.28,
    x2: 193.41,
    y2: 953.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 193.89,
    y1: 953.22,
    x2: 193.95,
    y2: 953.22
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M306.33,923.58l-1.32-.42c-5.61-1.48-11.81-.82-17.52-.78l-2.7-.12"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "284.79 476.52 284.91 476.46 284.97 476.46"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "194.25 445.26 194.43 445.26 194.49 445.38 194.49 445.56"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 174.99,
    y1: 464.46,
    x2: 175.89,
    y2: 466.32
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "254.07 458.76 254.07 458.58 253.95 458.52"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 253.05,
    y1: 473.64,
    x2: 253.05,
    y2: 471.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 253.95,
    y1: 458.52,
    x2: 253.89,
    y2: 458.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 253.23,
    y1: 471,
    x2: 253.17,
    y2: 471
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 173.31,
    y1: 461.58,
    x2: 174.99,
    y2: 464.46
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "173.67 529.02 170.19 529.56 165.57 531.48"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 140.79,
    y1: 542.82,
    x2: 139.59,
    y2: 543.42
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "173.67 553.98 171.93 553.5 170.19 553.14"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 173.67,
    y1: 529.02,
    x2: 169.77,
    y2: 528.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 131.85,
    y1: 536.4,
    x2: 131.55,
    y2: 536.22
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "165.57 531.48 156.99 535.38 152.73 537.36 150.57 538.32 149.55 538.8 148.65 539.22"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 135.27,
    y1: 1056.42,
    x2: 132.15,
    y2: 1056.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 140.43,
    y1: 1054.62,
    x2: 139.59,
    y2: 1054.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 141.27,
    y1: 1093.02,
    x2: 141.27,
    y2: 1092.96
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "139.47 1106.22 139.23 1106.1 139.11 1105.86"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "139.47 1106.22 139.05 1106.16 139.05 1109.58"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 112.17,
    y1: 1087.38,
    x2: 112.17,
    y2: 1090.74
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "139.05 1109.58 132.27 1105.02 125.55 1100.34 115.47 1093.14 112.17 1090.74"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "140.79 1054.8 140.73 1054.62 140.61 1054.56 140.43 1054.62"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "141.27 1092.96 141.15 1092.72 140.91 1092.6"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 139.41,
    y1: 1103.76,
    x2: 139.47,
    y2: 1106.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 128.13,
    y1: 538.56,
    x2: 128.19,
    y2: 538.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 306.33,
    y1: 919.2,
    x2: 306.39,
    y2: 919.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 171.63,
    y1: 280.26,
    x2: 171.69,
    y2: 280.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 174.15,
    y1: 290.52,
    x2: 174.09,
    y2: 290.52
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "174.15 279.48 174.09 279.48 172.05 279.84"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 173.73,
    y1: 290.58,
    x2: 174.09,
    y2: 290.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 174.15,
    y1: 279.48,
    x2: 176.37,
    y2: 276
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 174.09,
    y1: 290.16,
    x2: 174.09,
    y2: 290.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 171.69,
    y1: 280.02,
    x2: 176.37,
    y2: 272.76
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "269.31 219.36 269.25 219.18 269.13 219.06"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "268.11 219.66 269.07 219.12 269.13 219.06"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 268.29,
    y1: 230.64,
    x2: 268.23,
    y2: 230.64
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "186.39 951.48 186.45 951.3 186.57 951.18"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "188.31 964.08 188.19 962.94 188.07 961.92"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 188.31,
    y1: 968.34,
    x2: 188.31,
    y2: 964.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 193.41,
    y1: 953.28,
    x2: 192.63,
    y2: 952.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 191.25,
    y1: 952.14,
    x2: 189.57,
    y2: 951.66
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "193.47 956.16 193.41 956.46 192.63 958.86 191.25 961.8"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "188.31 968.34 188.91 966.78 189.57 965.22"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 188.07,
    y1: 951.36,
    x2: 189.57,
    y2: 951.66
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "240.03 943.26 241.23 942.36 242.55 941.58 243.87 940.92 245.31 940.38 248.19 939.42 251.19 938.58 254.07 937.56 256.89 936.42 259.77 935.28 262.65 934.26"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 186.75,
    y1: 951.18,
    x2: 188.07,
    y2: 951.36
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "196.53 679.14 207.15 681.24 217.77 683.1 239.01 687.06"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "240.03 669.96 240.03 669.78 239.97 669.66"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 239.01,
    y1: 687.06,
    x2: 239.01,
    y2: 683.46
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "224.97 681.84 231.99 684.36 239.01 687.06"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 239.97,
    y1: 669.66,
    x2: 239.85,
    y2: 669.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 239.19,
    y1: 683.34,
    x2: 239.13,
    y2: 683.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 133.65,
    y1: 341.7,
    x2: 136.29,
    y2: 340.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 71.91,
    y1: 156.96,
    x2: 72.63,
    y2: 157.02
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "123.03 162.54 125.19 162.9 126.15 163.08"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "240.03 454.98 240.03 454.8 239.97 454.68 239.85 454.68"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 239.19,
    y1: 467.16,
    x2: 239.13,
    y2: 467.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 131.85,
    y1: 331.32,
    x2: 131.55,
    y2: 331.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 140.79,
    y1: 337.8,
    x2: 141.51,
    y2: 337.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 136.29,
    y1: 340.14,
    x2: 137.31,
    y2: 339.54
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "153.69 334.32 153.69 331.86 151.71 331.8"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 210.33,
    y1: 897.6,
    x2: 210.45,
    y2: 897.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 115.23,
    y1: 356.1,
    x2: 120.63,
    y2: 351.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 210.27,
    y1: 897.48,
    x2: 210.45,
    y2: 897.6
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "132.15 361.38 131.31 362.16 130.41 362.88"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 239.85,
    y1: 457.2,
    x2: 253.95,
    y2: 458.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 141.51,
    y1: 542.52,
    x2: 140.79,
    y2: 542.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 193.47,
    y1: 956.16,
    x2: 193.53,
    y2: 956.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 74.43,
    y1: 157.26,
    x2: 80.61,
    y2: 157.86
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "262.65 934.26 267.63 932.64 272.49 930.84 277.41 928.98 279.87 928.14 282.39 927.42"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 284.91,
    y1: 476.46,
    x2: 284.97,
    y2: 476.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 253.11,
    y1: 470.94,
    x2: 253.23,
    y2: 471
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 141.51,
    y1: 559.32,
    x2: 139.59,
    y2: 560.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 174.09,
    y1: 290.28,
    x2: 174.09,
    y2: 290.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 268.17,
    y1: 230.64,
    x2: 268.29,
    y2: 230.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 224.97,
    y1: 466.26,
    x2: 221.49,
    y2: 465.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 208.05,
    y1: 483,
    x2: 206.91,
    y2: 483.06
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "179.97 474.66 182.07 479.22 183.99 483.84"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "285.81 464.28 285.81 464.1 285.69 464.04 285.63 464.04"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 163.65,
    y1: 214.5,
    x2: 142.83,
    y2: 210.72
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "142.41 210.66 142.41 222.6 142.29 221.34 142.11 220.02 141.99 218.64 141.81 217.14"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 253.35,
    y1: 217.26,
    x2: 240.33,
    y2: 216
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "315.21 1158.42 310.53 1157.22 308.13 1156.74 305.73 1156.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M289.47,1170.54l1.5-.84c6.7-3.54,14.03-6.27,21-9.84l3.24-1.44"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "306.03 1152.36 315.21 1146.96 315.21 1158.42"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "136.29 992.16 133.65 993.72 131.25 995.46"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 126.69,
    y1: 374.76,
    x2: 126.57,
    y2: 374.7
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "126.93 375.12 126.87 374.94 126.69 374.76"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "125.19 386.52 125.07 386.34 125.01 386.16"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 125.31,
    y1: 386.58,
    x2: 125.19,
    y2: 386.52
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M125.01,386.16l.18-1.26c.33-2.98,1.23-5.83,1.62-8.82l.12-.96"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 126.57,
    y1: 374.7,
    x2: 125.19,
    y2: 374.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 118.53,
    y1: 373.2,
    x2: 120.63,
    y2: 373.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 125.19,
    y1: 374.46,
    x2: 123.03,
    y2: 374.1
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "91.11 402.18 90.99 401.88 90.75 401.76"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "89.25 413.22 89.61 410.22 89.85 408.96 90.45 406.44 90.69 405.12 91.11 402.18"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 89.19,
    y1: 413.52,
    x2: 89.49,
    y2: 413.58
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M89.19,417.3l-2.88-1.32c-4.86-1.99-9.57-2.78-14.76-3.66l-5.94-1.02"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "125.01 386.16 107.07 399.72 89.25 413.22"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "134.79 820.2 134.79 820.08 134.67 819.96 134.37 819.84"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "132.81 832.98 122.85 848.46 113.01 863.88"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "132.45 832.68 132.93 829.56 133.65 826.44 134.31 823.32 134.79 820.2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 134.37,
    y1: 819.84,
    x2: 132.45,
    y2: 820.02
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "114.63 851.58 114.57 851.28 114.33 851.1"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 112.65,
    y1: 863.82,
    x2: 113.01,
    y2: 863.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 114.33,
    y1: 851.1,
    x2: 112.65,
    y2: 850.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M112.71,863.46l.06-.84c.47-3.5,1.35-6.73,1.8-10.2l.06-.84"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "193.41 508.14 193.47 508.08 193.47 507.48"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "193.47 508.26 193.41 508.2 193.41 508.14"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "253.35 231.96 260.67 233.16 268.11 234.06"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 268.11,
    y1: 219.66,
    x2: 254.31,
    y2: 219.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 148.11,
    y1: 168.9,
    x2: 148.17,
    y2: 168.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 173.55,
    y1: 209.04,
    x2: 173.55,
    y2: 208.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 173.31,
    y1: 208.86,
    x2: 171.93,
    y2: 209.64
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "148.41 168.96 148.29 168.9 148.11 168.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "173.55 208.86 173.43 208.8 173.31 208.86"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 171.99,
    y1: 220.2,
    x2: 172.23,
    y2: 220.56
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "172.17 220.56 172.11 220.56 171.99 220.5"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 306.51,
    y1: 919.08,
    x2: 306.51,
    y2: 919.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 267.99,
    y1: 474.36,
    x2: 267.87,
    y2: 474.36
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "136.29 545.22 133.65 546.78 131.25 548.52"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 92.85,
    y1: 559.26,
    x2: 108.81,
    y2: 549.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M129.15,568.44l-.9.36c-1.43.59-2.87,1.18-4.26,1.86l-1.14.54"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "180.63 755.22 176.79 754.92 174.09 755.04 173.67 755.1"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "176.43 780.24 174.09 780.36 173.67 780.42 170.01 780.3"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 176.43,
    y1: 780.24,
    x2: 176.79,
    y2: 780.18
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "183.39 778.08 182.01 778.8 181.23 779.16 180.45 779.46 178.71 779.88 176.91 780.18"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 284.91,
    y1: 696.42,
    x2: 284.97,
    y2: 696.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 306.51,
    y1: 697.08,
    x2: 306.33,
    y2: 697.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 171.99,
    y1: 220.5,
    x2: 172.05,
    y2: 220.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 268.05,
    y1: 474.36,
    x2: 267.87,
    y2: 474.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 176.37,
    y1: 735.48,
    x2: 169.89,
    y2: 739.32
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "136.29 771.3 133.65 772.92 131.25 774.6"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 92.85,
    y1: 785.34,
    x2: 108.81,
    y2: 776.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 131.25,
    y1: 774.6,
    x2: 130.41,
    y2: 775.26
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "129.09 794.64 127.35 795.48 125.73 796.2 124.17 796.8 122.85 797.4"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 315.21,
    y1: 914.04,
    x2: 306.33,
    y2: 919.26
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M315.21,929.76l-2.1-1.98c-1.44-1.38-3.74-2.95-5.58-3.72l-1.2-.48"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 315.21,
    y1: 914.04,
    x2: 315.21,
    y2: 929.76
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "300.03 927.36 307.59 928.5 311.43 929.1 315.21 929.76"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 315.21,
    y1: 470.76,
    x2: 306.09,
    y2: 476.16
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "315.21 480.06 310.53 480 305.79 479.82"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "315.21 470.76 315.21 480.06 308.61 480.42"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "240.45 214.14 240.39 213.96 240.33 213.84"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "239.37 214.38 240.27 213.84 240.33 213.84"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 239.49,
    y1: 225.36,
    x2: 239.55,
    y2: 225.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 239.85,
    y1: 893.28,
    x2: 239.97,
    y2: 893.28
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "239.01 906.78 239.01 910.38 231.99 907.86 228.51 906.6 224.97 905.4"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "239.97 893.28 240.03 893.4 240.03 893.58"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 239.19,
    y1: 906.66,
    x2: 239.13,
    y2: 906.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 239.07,
    y1: 906.66,
    x2: 239.19,
    y2: 906.66
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "174.99 1135.74 172.95 1131.9 170.97 1128"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 175.77,
    y1: 1137.48,
    x2: 174.99,
    y2: 1135.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 253.77,
    y1: 1127.34,
    x2: 253.71,
    y2: 1127.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 253.89,
    y1: 1127.64,
    x2: 253.77,
    y2: 1129.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 252.81,
    y1: 1145.22,
    x2: 252.81,
    y2: 1141.8
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "253.77 1127.34 253.89 1127.4 253.89 1127.64"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 252.99,
    y1: 1141.68,
    x2: 252.93,
    y2: 1141.74
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "178.47 1198.98 178.47 1198.8 178.59 1198.68"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "180.21 1212.66 180.45 1212.6 180.57 1212.36 180.09 1208.88 179.49 1205.64 178.95 1202.4 178.47 1198.98"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 180.63,
    y1: 1198.74,
    x2: 187.83,
    y2: 1200.06
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "188.19 1214.04 188.07 1213.98 180.63 1212.66 180.21 1212.66"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 178.65,
    y1: 1198.68,
    x2: 184.11,
    y2: 1194.48
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "180.63 1198.74 178.83 1198.62 178.59 1198.68"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "211.11 447.48 211.17 447.48 211.29 447.54 211.29 447.72"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "210.99 1111.08 210.99 1110.9 210.87 1110.78 210.81 1110.78"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "180.63 755.22 180.75 755.1 180.81 754.92 180.75 754.02 180.63 753.24 180.21 750.54 179.61 747.72 179.13 744.96 178.71 742.14"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 180.87,
    y1: 755.28,
    x2: 180.63,
    y2: 755.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 180.63,
    y1: 741.9,
    x2: 180.87,
    y2: 741.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 180.63,
    y1: 755.22,
    x2: 180.69,
    y2: 755.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 179.07,
    y1: 741.78,
    x2: 180.63,
    y2: 741.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 170.19,
    y1: 291.18,
    x2: 173.73,
    y2: 290.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 166.47,
    y1: 307.14,
    x2: 166.47,
    y2: 303.84
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M174.15,293.04l-.06.12c-2.6,3.83-4.86,7.6-6.66,11.88l-.96,2.1"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 166.83,
    y1: 253.68,
    x2: 167.07,
    y2: 253.74
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "225.33 225.84 228.63 226.44 231.87 227.16 238.35 228.66 239.37 228.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "268.89 462.12 268.89 461.94 268.77 461.88 268.71 461.88"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "186.33 258.9 186.39 258.72 186.51 258.6"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "188.07 269.88 188.19 269.76 188.25 269.58"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 188.31,
    y1: 269.94,
    x2: 188.07,
    y2: 269.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 188.07,
    y1: 258.78,
    x2: 188.31,
    y2: 258.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 188.07,
    y1: 269.88,
    x2: 188.13,
    y2: 269.88
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "289.23 220.56 287.49 220.2 287.31 220.2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 225.87,
    y1: 450.84,
    x2: 225.93,
    y2: 450.84
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "210.21 463.08 213.93 463.74 217.65 464.52 221.31 465.36 224.97 466.26"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "225.93 450.84 226.05 450.96 226.05 451.14"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "178.71 742.14 178.77 741.96 178.83 741.84"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 187.95,
    y1: 269.88,
    x2: 188.07,
    y2: 269.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 193.41,
    y1: 460.86,
    x2: 193.41,
    y2: 457.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 188.07,
    y1: 269.88,
    x2: 187.95,
    y2: 269.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 268.71,
    y1: 464.82,
    x2: 285.69,
    y2: 464.04
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "129.15 776.22 125.97 778.74 122.85 781.26"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 210.03,
    y1: 1125.18,
    x2: 209.91,
    y2: 1125.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 188.13,
    y1: 268.56,
    x2: 188.19,
    y2: 268.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 172.41,
    y1: 216.6,
    x2: 172.47,
    y2: 216.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 190.83,
    y1: 726.9,
    x2: 186.33,
    y2: 729.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 161.25,
    y1: 744.42,
    x2: 161.01,
    y2: 744.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 252.87,
    y1: 1141.68,
    x2: 252.99,
    y2: 1141.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 239.37,
    y1: 214.38,
    x2: 226.41,
    y2: 212.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 205.53,
    y1: 444.9,
    x2: 225.93,
    y2: 450.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 306.33,
    y1: 919.14,
    x2: 306.33,
    y2: 918.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 135.87,
    y1: 533.4,
    x2: 135.21,
    y2: 533.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 137.31,
    y1: 544.62,
    x2: 136.29,
    y2: 545.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 149.19,
    y1: 555.42,
    x2: 148.11,
    y2: 555.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 137.31,
    y1: 1055.82,
    x2: 135.27,
    y2: 1056.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 153.39,
    y1: 527.64,
    x2: 151.71,
    y2: 527.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 128.19,
    y1: 338.7,
    x2: 128.13,
    y2: 338.7
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "129.15 363.6 127.53 364.38 125.85 365.04 124.29 365.7 122.85 366.24"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 128.19,
    y1: 333.42,
    x2: 128.13,
    y2: 333.48
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "137.31 359.94 135.03 360.48 132.93 361.08"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 141.51,
    y1: 358.86,
    x2: 139.59,
    y2: 359.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 144.57,
    y1: 336,
    x2: 144.99,
    y2: 335.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 139.59,
    y1: 338.34,
    x2: 140.79,
    y2: 337.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 130.41,
    y1: 344.1,
    x2: 131.25,
    y2: 343.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 144.99,
    y1: 540.9,
    x2: 144.57,
    y2: 541.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 225.99,
    y1: 452.16,
    x2: 239.97,
    y2: 454.68
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "173.73 290.58 173.91 290.52 174.03 290.4"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 306.87,
    y1: 912.48,
    x2: 315.21,
    y2: 914.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 253.83,
    y1: 461.58,
    x2: 268.77,
    y2: 461.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 225.15,
    y1: 901.92,
    x2: 225.03,
    y2: 901.86
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "180.87 778.62 181.41 777.9 181.89 777.12 182.31 776.22 182.61 775.32 183.03 773.4 183.33 771.42 183.87 767.46 184.59 763.5 186.21 755.76 187.05 751.86 187.53 750 188.07 748.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M222.09,748.26l-.66,1.14-.66,1.02c-2.37,3.71-6.61,5.41-9.78,8.28l-2.58,1.8-2.58,1.74c-6.94,4.91-14.35,9.25-20.88,14.7l-.72.6-.84.54"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 306.33,
    y1: 919.2,
    x2: 306.33,
    y2: 919.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 307.11,
    y1: 905.76,
    x2: 284.97,
    y2: 918.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 253.89,
    y1: 458.52,
    x2: 239.19,
    y2: 467.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 186.57,
    y1: 951.18,
    x2: 190.83,
    y2: 949.14
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "196.41 462.3 207.09 464.28 217.71 466.14 228.33 468.06 239.01 470.04"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 239.85,
    y1: 454.68,
    x2: 225.21,
    y2: 463.32
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "239.01 467.28 239.01 470.04 228.57 467.22"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 124.77,
    y1: 335.46,
    x2: 124.83,
    y2: 335.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 163.65,
    y1: 214.5,
    x2: 163.65,
    y2: 225.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 253.35,
    y1: 217.26,
    x2: 239.55,
    y2: 225.36
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "129.03 1015.56 127.35 1016.34 125.73 1017 124.23 1017.66 122.85 1018.2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 131.25,
    y1: 548.52,
    x2: 130.41,
    y2: 549.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 180.63,
    y1: 778.86,
    x2: 180.87,
    y2: 778.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 167.07,
    y1: 741,
    x2: 164.13,
    y2: 742.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 129.15,
    y1: 794.64,
    x2: 129.09,
    y2: 794.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 253.77,
    y1: 1127.34,
    x2: 253.83,
    y2: 1127.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 210.21,
    y1: 460.02,
    x2: 210.21,
    y2: 463.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 178.89,
    y1: 741.84,
    x2: 184.11,
    y2: 737.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 210.21,
    y1: 460.02,
    x2: 210.45,
    y2: 459.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 129.15,
    y1: 820.02,
    x2: 126.69,
    y2: 819.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 98.67,
    y1: 813.6,
    x2: 65.85,
    y2: 828.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 137.31,
    y1: 398.22,
    x2: 135.27,
    y2: 398.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 141.51,
    y1: 396.54,
    x2: 139.59,
    y2: 397.38
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "140.19 446.94 140.01 446.76 139.89 446.52"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 139.05,
    y1: 1106.16,
    x2: 139.11,
    y2: 1106.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 128.13,
    y1: 268.86,
    x2: 128.19,
    y2: 268.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 239.79,
    y1: 673.38,
    x2: 253.95,
    y2: 674.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 131.55,
    y1: 331.14,
    x2: 131.85,
    y2: 331.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 128.13,
    y1: 328.74,
    x2: 128.19,
    y2: 328.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 190.83,
    y1: 505.14,
    x2: 188.31,
    y2: 506.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 140.07,
    y1: 757.02,
    x2: 139.59,
    y2: 757.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 137.31,
    y1: 770.7,
    x2: 136.29,
    y2: 771.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 161.25,
    y1: 754.26,
    x2: 161.01,
    y2: 754.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 149.19,
    y1: 765.12,
    x2: 148.11,
    y2: 765.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 137.31,
    y1: 832.2,
    x2: 135.27,
    y2: 832.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 144.39,
    y1: 975.36,
    x2: 143.49,
    y2: 975.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 137.31,
    y1: 991.56,
    x2: 136.29,
    y2: 992.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 137.31,
    y1: 162.54,
    x2: 135.27,
    y2: 163.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 129.15,
    y1: 387,
    x2: 126.69,
    y2: 386.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 225.03,
    y1: 463.02,
    x2: 225.09,
    y2: 463.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 132.45,
    y1: 820.02,
    x2: 132.51,
    y2: 820.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 148.53,
    y1: 974.28,
    x2: 147.57,
    y2: 974.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 153.45,
    y1: 974.64,
    x2: 151.71,
    y2: 974.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 157.83,
    y1: 974.88,
    x2: 156.63,
    y2: 974.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 161.25,
    y1: 975.12,
    x2: 161.01,
    y2: 975.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 149.19,
    y1: 1003.5,
    x2: 148.11,
    y2: 1003.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 152.85,
    y1: 1002.18,
    x2: 152.25,
    y2: 1002.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 135.87,
    y1: 980.4,
    x2: 135.21,
    y2: 980.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 139.05,
    y1: 1106.16,
    x2: 139.11,
    y2: 1106.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 149.19,
    y1: 781.86,
    x2: 148.11,
    y2: 782.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 152.85,
    y1: 780.66,
    x2: 152.25,
    y2: 780.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 141.51,
    y1: 618.6,
    x2: 141.39,
    y2: 618.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 144.99,
    y1: 617.04,
    x2: 144.57,
    y2: 617.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 137.31,
    y1: 607.02,
    x2: 135.27,
    y2: 607.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 152.79,
    y1: 98.04,
    x2: 152.25,
    y2: 98.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 152.85,
    y1: 113.94,
    x2: 152.25,
    y2: 114.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M162.93,105.78l.66-.96c2.6-4.33,3.42-9.85,3.54-14.82l.06-2.46"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 72.63,
    y1: 156.48,
    x2: 71.91,
    y2: 156.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 80.61,
    y1: 150.66,
    x2: 74.43,
    y2: 155.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 123.27,
    y1: 101.58,
    x2: 122.61,
    y2: 102.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 112.77,
    y1: 359.22,
    x2: 112.29,
    y2: 359.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 173.67,
    y1: 553.98,
    x2: 173.67,
    y2: 554.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 183.99,
    y1: 483.84,
    x2: 183.99,
    y2: 484.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 153.39,
    y1: 85.02,
    x2: 153.45,
    y2: 85.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 156.81,
    y1: 85.68,
    x2: 156.87,
    y2: 85.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 130.41,
    y1: 259.8,
    x2: 129.21,
    y2: 257.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 128.19,
    y1: 313.68,
    x2: 128.13,
    y2: 313.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 128.19,
    y1: 313.08,
    x2: 128.13,
    y2: 313.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 141.51,
    y1: 843.48,
    x2: 141.39,
    y2: 843.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 141.51,
    y1: 768.6,
    x2: 140.79,
    y2: 768.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 269.19,
    y1: 221.1,
    x2: 286.05,
    y2: 220.26
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "137.31 1009.74 135.75 1010.76 134.13 1011.96 132.39 1013.28 131.43 1014 130.41 1014.72"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 239.79,
    y1: 896.7,
    x2: 253.95,
    y2: 898.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 253.59,
    y1: 1132.2,
    x2: 268.17,
    y2: 1132.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 136.35,
    y1: 92.04,
    x2: 136.23,
    y2: 92.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 139.71,
    y1: 89.52,
    x2: 139.71,
    y2: 89.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 137.31,
    y1: 109.38,
    x2: 130.41,
    y2: 114.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 137.31,
    y1: 125.28,
    x2: 130.41,
    y2: 130.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 184.11,
    y1: 504.78,
    x2: 177.57,
    y2: 508.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 190.11,
    y1: 501.18,
    x2: 186.33,
    y2: 503.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 148.53,
    y1: 525.9,
    x2: 147.57,
    y2: 526.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 153.39,
    y1: 523.02,
    x2: 151.71,
    y2: 524.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 240.39,
    y1: 215.4,
    x2: 254.37,
    y2: 216.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 186.33,
    y1: 511.32,
    x2: 187.05,
    y2: 510.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 184.11,
    y1: 514.62,
    x2: 180.87,
    y2: 517.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 68.13,
    y1: 141.72,
    x2: 40.17,
    y2: 162.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 210.27,
    y1: 897.3,
    x2: 210.21,
    y2: 897.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 148.53,
    y1: 972.84,
    x2: 147.57,
    y2: 973.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 153.39,
    y1: 969.96,
    x2: 151.71,
    y2: 970.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 157.83,
    y1: 967.32,
    x2: 156.63,
    y2: 968.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 161.25,
    y1: 965.28,
    x2: 161.01,
    y2: 965.46
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "193.41 502.68 198.51 501.96 203.61 501.12 208.65 500.16 213.75 499.02 218.85 497.7 223.95 496.32 229.05 495.06 234.15 493.92 244.35 491.7 254.61 489.42 259.71 488.28 264.39 487.2 274.59 484.92"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 141.51,
    y1: 785.64,
    x2: 139.59,
    y2: 786.84
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M273.51,238.56l-.3.06c-9.88,2.67-19.24,6.43-28.92,9.78l-1.26.48"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "164.25 294.06 164.37 293.7 164.61 293.52"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 172.17,
    y1: 893.7,
    x2: 172.35,
    y2: 893.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 128.19,
    y1: 302.34,
    x2: 128.13,
    y2: 302.28
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "261.93 480.42 269.79 480.06 277.71 479.58"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "217.71 482.4 224.85 482.22 231.93 481.92 246.15 481.14"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 240.03,
    y1: 720,
    x2: 240.03,
    y2: 720.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 285.63,
    y1: 908.34,
    x2: 307.23,
    y2: 905.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 144.39,
    y1: 528.36,
    x2: 143.19,
    y2: 529.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 157.83,
    y1: 527.94,
    x2: 156.63,
    y2: 527.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 161.25,
    y1: 528.18,
    x2: 161.01,
    y2: 528.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 168.75,
    y1: 528.66,
    x2: 164.13,
    y2: 528.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 131.55,
    y1: 536.58,
    x2: 131.85,
    y2: 536.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 186.33,
    y1: 260.34,
    x2: 186.51,
    y2: 260.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 183.15,
    y1: 265.38,
    x2: 184.11,
    y2: 263.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 177.57,
    y1: 274.08,
    x2: 179.25,
    y2: 271.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 179.13,
    y1: 268.38,
    x2: 184.11,
    y2: 260.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 177.57,
    y1: 270.84,
    x2: 178.83,
    y2: 268.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 180.69,
    y1: 279.66,
    x2: 180.75,
    y2: 279.66
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "188.07 964.38 188.25 964.32 188.31 964.08"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 170.97,
    y1: 674.22,
    x2: 171.21,
    y2: 674.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 91.47,
    y1: 198.18,
    x2: 40.17,
    y2: 188.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 122.61,
    y1: 162.48,
    x2: 123.03,
    y2: 162.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 88.59,
    y1: 158.7,
    x2: 82.35,
    y2: 158.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 104.49,
    y1: 160.38,
    x2: 98.37,
    y2: 159.72
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "112.23 161.22 111.57 161.16 110.79 161.04 109.29 160.92 106.23 160.56"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "120.39 162.12 117.21 161.82 114.09 161.46"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "122.85 350.04 125.97 347.52 129.15 345.06"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 108.81,
    y1: 344.82,
    x2: 93.15,
    y2: 354
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 144.99,
    y1: 170.34,
    x2: 144.57,
    y2: 170.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 175.83,
    y1: 223.62,
    x2: 176.19,
    y2: 224.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 306.51,
    y1: 1145.34,
    x2: 315.21,
    y2: 1146.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 129.15,
    y1: 1015.44,
    x2: 129.03,
    y2: 1015.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 128.19,
    y1: 990.72,
    x2: 128.13,
    y2: 990.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 130.41,
    y1: 996.12,
    x2: 131.25,
    y2: 995.46
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "122.85 1002.06 125.97 999.54 129.15 997.08"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "115.23 1008.18 117.99 1005.96 119.31 1004.88 120.63 1003.86"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 117.93,
    y1: 373.02,
    x2: 118.53,
    y2: 373.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 122.85,
    y1: 374.1,
    x2: 123.03,
    y2: 374.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 128.19,
    y1: 543.78,
    x2: 128.13,
    y2: 543.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 120.63,
    y1: 572.4,
    x2: 118.47,
    y2: 573.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 173.67,
    y1: 780.36,
    x2: 173.67,
    y2: 780.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 92.85,
    y1: 803.64,
    x2: 92.91,
    y2: 803.64
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "120.63 798.36 119.43 798.96 118.35 799.62"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 306.75,
    y1: 469.26,
    x2: 315.21,
    y2: 470.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 186.33,
    y1: 1192.8,
    x2: 187.05,
    y2: 1192.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 177.57,
    y1: 255.6,
    x2: 184.11,
    y2: 256.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 169.89,
    y1: 254.22,
    x2: 176.37,
    y2: 255.42
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "226.41 225.78 229.59 226.56 232.65 227.28 235.59 228 238.35 228.66"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 239.55,
    y1: 1126.02,
    x2: 253.77,
    y2: 1127.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 193.47,
    y1: 507.54,
    x2: 193.47,
    y2: 508.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 128.19,
    y1: 769.86,
    x2: 128.13,
    y2: 769.86
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "120.63 783 119.31 784.08 117.99 785.1 115.23 787.32"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 184.11,
    y1: 730.86,
    x2: 177.57,
    y2: 734.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 148.53,
    y1: 752.04,
    x2: 147.57,
    y2: 752.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 153.45,
    y1: 749.1,
    x2: 151.71,
    y2: 750.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 157.83,
    y1: 746.46,
    x2: 156.63,
    y2: 747.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 192.81,
    y1: 1121.34,
    x2: 192.87,
    y2: 1121.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 131.91,
    y1: 535.74,
    x2: 131.55,
    y2: 535.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 140.07,
    y1: 530.94,
    x2: 139.59,
    y2: 531.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 152.85,
    y1: 554.22,
    x2: 152.25,
    y2: 554.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 186.33,
    y1: 257.1,
    x2: 188.73,
    y2: 253.26
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "120.63 367.2 119.31 367.8 118.77 368.1 118.23 368.34"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 152.25,
    y1: 332.52,
    x2: 153.69,
    y2: 331.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 148.11,
    y1: 334.38,
    x2: 149.19,
    y2: 333.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 131.91,
    y1: 331.32,
    x2: 131.85,
    y2: 331.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 135.87,
    y1: 331.44,
    x2: 135.21,
    y2: 331.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 140.07,
    y1: 331.5,
    x2: 139.59,
    y2: 331.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 225.87,
    y1: 667.08,
    x2: 239.97,
    y2: 669.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 254.37,
    y1: 218.76,
    x2: 269.13,
    y2: 219.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 157.77,
    y1: 780.12,
    x2: 155.91,
    y2: 780.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 225.87,
    y1: 890.76,
    x2: 239.97,
    y2: 893.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 286.17,
    y1: 220.5,
    x2: 287.31,
    y2: 220.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 226.41,
    y1: 211.32,
    x2: 240.33,
    y2: 213.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 192.21,
    y1: 948.42,
    x2: 192.27,
    y2: 948.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 119.13,
    y1: 362.88,
    x2: 119.31,
    y2: 362.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 120.63,
    y1: 1019.16,
    x2: 118.65,
    y2: 1020.12
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "120.63 556.92 119.31 557.94 117.99 559.02 115.23 561.18"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "129.15 550.14 125.97 552.6 122.85 555.12"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 119.13,
    y1: 794.94,
    x2: 119.31,
    y2: 794.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 210.21,
    y1: 459.84,
    x2: 210.27,
    y2: 459.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 193.89,
    y1: 732,
    x2: 193.95,
    y2: 732
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 186.33,
    y1: 736.2,
    x2: 187.17,
    y2: 735.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 267.87,
    y1: 477,
    x2: 267.87,
    y2: 474.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 232.47,
    y1: 233.4,
    x2: 232.53,
    y2: 233.4
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "142.47 210.3 142.71 208.68 142.83 207.84 143.01 207.12 143.37 205.8 143.85 204.36"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 142.47,
    y1: 210.36,
    x2: 142.47,
    y2: 210.3
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "75.21 811.86 96.45 801.96 117.75 792.12"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "205.11 687.36 201.15 686.94 197.13 686.58 189.27 685.98"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "175.89 684.42 179.25 684.66 182.61 685.14 185.91 685.62 189.27 685.98"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "225.03 678 225.03 678.18 225.15 678.3 225.03 678.24"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 193.47,
    y1: 731.88,
    x2: 193.47,
    y2: 734.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 193.41,
    y1: 731.82,
    x2: 192.63,
    y2: 731.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 192.63,
    y1: 737.46,
    x2: 193.41,
    y2: 735.06
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "189.57 744 190.35 742.2 191.25 740.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M193.47,734.76l3-.66c13.55-2.4,25.59-8.94,38.82-12.6l6-1.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M240.03,722.1l1.08-.84c4.46-3.14,11.65-4.27,16.86-7.08l2.58-1.02"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "211.29 884.52 211.05 887.7 210.75 890.88 210.51 894.06 210.27 897.3"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 211.11,
    y1: 884.22,
    x2: 193.65,
    y2: 894.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 210.21,
    y1: 901.5,
    x2: 210.21,
    y2: 897.72
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "194.13 1107 194.13 1106.88 194.07 1106.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M192.81,1120.98l.12-.96c.21-4.04.92-8.02,1.14-12.06l.06-.96"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 192.81,
    y1: 1125.12,
    x2: 192.81,
    y2: 1121.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 193.95,
    y1: 1106.76,
    x2: 171.45,
    y2: 1119.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 192.93,
    y1: 1121.22,
    x2: 192.81,
    y2: 1120.98
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "188.31 523.5 188.61 522.54 188.97 521.64 189.27 520.8 189.57 520.02"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 118.53,
    y1: 792.3,
    x2: 117.57,
    y2: 792.06
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "118.53 798.42 118.77 797.1 119.01 795.72 119.37 792.84"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "117.87 805.14 91.95 817.26 66.15 829.38"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "117.57 792.06 91.65 804.24 65.79 816.3"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 65.79,
    y1: 829.32,
    x2: 66.15,
    y2: 829.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 193.47,
    y1: 457.38,
    x2: 193.41,
    y2: 457.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 193.53,
    y1: 457.68,
    x2: 193.41,
    y2: 457.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 54.21,
    y1: 581.94,
    x2: 75.21,
    y2: 585.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 93.15,
    y1: 577.44,
    x2: 117.75,
    y2: 565.98
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "253.05 688.14 253.05 688.32 253.17 688.44"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 253.05,
    y1: 688.56,
    x2: 253.05,
    y2: 688.14
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "173.67 1001.94 171.69 1001.88 169.71 1001.76 167.67 1001.58 165.63 1001.46 161.73 1001.28 157.77 1001.22"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 190.83,
    y1: 947.76,
    x2: 186.33,
    y2: 950.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 167.07,
    y1: 961.86,
    x2: 164.13,
    y2: 963.6
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "176.91 1001.76 177.93 1001.58 178.89 1001.34 179.79 1000.98 180.63 1000.38"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 285.63,
    y1: 905.4,
    x2: 268.05,
    y2: 915.72
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "284.79 922.26 282.63 922.14 280.47 921.9 278.37 921.6 276.21 921.18 272.01 920.28 267.87 919.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M188.07,716.82l1.8-.6,1.86-.54c10.98-1.93,22.57-3.63,33.6-5.16l3.72-.42,1.74-.18c4.19-.6,8.4-.99,12.6-1.62l1.74-.24,1.8-.24"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "284.79 699.9 278.43 700.32 272.13 700.68 259.47 701.34 234.15 702.6"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 289.23,
    y1: 220.56,
    x2: 290.49,
    y2: 220.74
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M312.57,233.88l-5.4.54c-10.92,1.28-22.26,2.12-33.06,3.96l-.24.06"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 206.43,
    y1: 722.46,
    x2: 202.29,
    y2: 723.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 199.17,
    y1: 723.6,
    x2: 195.87,
    y2: 723.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 193.47,
    y1: 731.46,
    x2: 193.41,
    y2: 730.32
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "193.41 731.76 193.47 731.7 193.47 731.46"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "190.95 724.32 191.55 725.52 192.09 726.66 192.69 727.74 193.23 728.76 193.83 730.32 193.89 731.52 193.89 732.66"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 193.35,
    y1: 731.76,
    x2: 193.41,
    y2: 731.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 193.89,
    y1: 732.66,
    x2: 193.89,
    y2: 731.76
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M287.55,704.64l-1.62.36c-6.74,2.41-13.86,3.62-20.46,6.42l-3.06,1.32"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 178.83,
    y1: 963,
    x2: 179.07,
    y2: 962.94
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "180.69 976.02 180.81 975.9 180.81 975.78"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 193.47,
    y1: 669.9,
    x2: 193.41,
    y2: 670.32
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "139.89 446.52 140.37 443.58 140.61 442.32 141.33 439.8 141.57 438.54 142.05 435.6"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 139.89,
    y1: 446.88,
    x2: 140.25,
    y2: 446.94
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "139.89 449.94 119.01 437.52 115.53 435.42 112.11 433.2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 141.69,
    y1: 435.12,
    x2: 112.47,
    y2: 429.84
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "142.17 398.46 142.05 417 142.05 435.54"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "210.03 677.46 217.47 679.62 224.97 681.84"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 224.97,
    y1: 678.42,
    x2: 225.03,
    y2: 678
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 225.87,
    y1: 664.56,
    x2: 210.45,
    y2: 673.62
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "210.21 677.58 216.75 679.26 219.99 680.16 223.23 681.24"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "193.23 507.06 192.63 506.22 192.03 505.26 191.43 504.18 190.83 502.92"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 193.83,
    y1: 508.26,
    x2: 193.23,
    y2: 507.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 226.23,
    y1: 211.02,
    x2: 225.33,
    y2: 211.56
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M171.21,1119.78l.06-.96c.36-4.06,1.05-8.15,1.44-12.24l.06-.96"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 171.15,
    y1: 1123.86,
    x2: 171.15,
    y2: 1120.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 172.53,
    y1: 1105.44,
    x2: 163.65,
    y2: 1110.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 306.09,
    y1: 230.64,
    x2: 306.39,
    y2: 230.46
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "306.33 230.46 306.21 230.46 306.15 230.28"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 267.87,
    y1: 693.12,
    x2: 267.87,
    y2: 693.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 144.57,
    y1: 407.22,
    x2: 144.99,
    y2: 406.98
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "173.19 445.98 173.01 447.54 172.89 449.04 172.65 451.92 172.41 454.8 172.29 456.3 172.17 457.86"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 163.65,
    y1: 451.2,
    x2: 172.89,
    y2: 445.74
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "306.03 476.16 305.91 476.16 305.85 475.98"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 239.67,
    y1: 1121.7,
    x2: 224.91,
    y2: 1130.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 238.89,
    y1: 1136.04,
    x2: 238.77,
    y2: 1135.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M210.51,219.9l.24-2.94c.21-1.72.5-3.43.66-5.16l.24-2.94"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "210.63 220.14 210.57 220.08 210.51 219.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "188.07 516.12 187.65 513.72 187.11 511.32 186.69 508.86 186.39 506.4"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 186.51,
    y1: 506.1,
    x2: 186.69,
    y2: 506.04
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M193.53,218.76l.3-3c.18-1.78.55-3.41.78-5.16l.24-2.94"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "193.65 219 193.59 218.88 193.53 218.76"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "172.17 893.64 172.65 887.28 172.89 884.1 173.19 880.86"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "172.89 880.62 163.65 886.08 139.89 881.76"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 163.65,
    y1: 886.08,
    x2: 163.65,
    y2: 901.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 193.47,
    y1: 669.9,
    x2: 194.49,
    y2: 656.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 194.25,
    y1: 656.52,
    x2: 172.35,
    y2: 669.42
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "176.13 673.26 177.45 673.02 178.77 672.84 180.03 672.72 181.35 672.66 183.87 672.66 186.33 672.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "253.05 911.58 253.05 915 245.97 912.78 239.01 910.38"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 168.75,
    y1: 754.8,
    x2: 164.13,
    y2: 754.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 148.53,
    y1: 753.42,
    x2: 147.57,
    y2: 753.36
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "137.31 788.52 135.81 789.6 135.03 790.26 134.19 790.92 133.35 791.64 132.39 792.36 130.35 793.86"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 139.89,
    y1: 881.76,
    x2: 141.75,
    y2: 869.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 172.11,
    y1: 669.54,
    x2: 172.35,
    y2: 669.42
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "172.11 669.3 172.17 669.36 172.11 669.12"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "158.19 1001.22 162.03 1001.28 165.93 1001.52 169.77 1001.76 173.67 1001.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M284.85,231.66l.24-2.7c.26-1.57.47-3.17.72-4.74l.3-2.64"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 285.99,
    y1: 220.26,
    x2: 284.85,
    y2: 220.92
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "285.03 231.9 284.91 231.84 284.85 231.66"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "118.05 1026.96 91.89 1039.08 65.91 1051.08"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "117.75 1026.54 91.65 1038.66 65.61 1050.72"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "65.91 1051.08 65.55 1051.08 65.55 1037.16"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "172.11 458.04 172.17 458.1 172.11 457.86"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 284.37,
    y1: 1151.1,
    x2: 284.61,
    y2: 1150.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 285.51,
    y1: 1136.52,
    x2: 267.81,
    y2: 1146.96
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "284.55 1150.98 284.49 1150.92 284.43 1150.74"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "191.13 724.62 197.61 724.02 200.85 723.6 204.15 723.12 207.39 722.46 210.69 721.68 217.23 720 220.53 719.16 223.77 718.38 230.31 717 236.85 715.68 243.39 714.3"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 306.51,
    y1: 697.02,
    x2: 306.33,
    y2: 697.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 210.21,
    y1: 460.02,
    x2: 210.21,
    y2: 459.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 268.05,
    y1: 915.72,
    x2: 267.99,
    y2: 915.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 267.87,
    y1: 915.42,
    x2: 267.87,
    y2: 915.84
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "267.99 915.72 267.93 915.66 267.87 915.42"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "224.67 1130.46 224.67 1134 220.89 1132.62"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 225.63,
    y1: 1116,
    x2: 210.03,
    y2: 1125.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 210.93,
    y1: 1111.68,
    x2: 225.69,
    y2: 1116
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "224.85 1130.4 224.73 1130.28 224.73 1130.1"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "91.47 184.14 141.81 193.26 141.81 217.14"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 126.69,
    y1: 386.82,
    x2: 125.19,
    y2: 386.52
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "112.47 429.84 112.23 429.66 112.17 429.42"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 113.79,
    y1: 418.02,
    x2: 89.49,
    y2: 413.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 210.21,
    y1: 673.74,
    x2: 210.21,
    y2: 673.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 211.11,
    y1: 659.94,
    x2: 193.65,
    y2: 670.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 210.21,
    y1: 677.58,
    x2: 210.21,
    y2: 673.74
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "118.53 573.24 119.13 570.06 119.55 566.76"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "118.05 579.06 91.89 591.12 65.85 603.18"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "117.75 578.64 91.65 590.76 65.61 602.82"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "180.63 279.66 180.81 279.6 180.93 279.36 180.87 278.7 180.75 278.1 180.63 277.08 180.21 275.04 179.61 273 179.13 270.96 178.83 268.8"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 180.93,
    y1: 268.62,
    x2: 184.11,
    y2: 266.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 180.93,
    y1: 279.72,
    x2: 180.63,
    y2: 279.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 179.01,
    y1: 268.5,
    x2: 184.11,
    y2: 264.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 178.95,
    y1: 268.56,
    x2: 179.19,
    y2: 268.44
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "268.05 693 267.99 693.06 267.93 692.94 267.87 692.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M188.37,523.26l.78-.12.84-.18c2.93-.83,5.41-2.8,8.04-4.26l1.62-.84,1.62-.78c10.71-4.32,21.61-8.19,32.34-12.48l3.24-1.2,3.18-.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M224.25,519.9l1.02-1.08c4.25-5.07,7.18-10.35,12.48-14.58l2.28-1.8"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "192.39 544.02 189.45 546.36 186.45 548.76 185.73 549.36 185.01 549.84 184.23 550.26 183.51 550.56 182.79 550.68 182.13 550.56 181.77 550.44 181.47 550.26 180.87 549.66"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "172.11 669.54 172.17 669.12 173.19 655.98"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "172.89 655.8 163.65 661.2 139.89 656.88"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "267.63 1146.72 267.69 1145.04 267.81 1143.54 267.99 1142.04 268.11 1140.36"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "267.57 1150.5 263.85 1149.24 260.19 1147.92 252.81 1145.22"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "267.75 1146.96 267.63 1146.9 267.63 1146.72"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 178.89,
    y1: 517.02,
    x2: 179.13,
    y2: 516.96
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "190.47 256.86 191.13 258.06 191.79 259.2 192.51 260.28 193.23 261.3 193.83 262.5"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 225.87,
    y1: 888.54,
    x2: 210.45,
    y2: 897.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 224.97,
    y1: 905.4,
    x2: 224.97,
    y2: 902.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 211.23,
    y1: 884.22,
    x2: 225.93,
    y2: 888.54
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "224.13 905.16 220.65 904.08 217.23 903.18 213.69 902.28 210.21 901.5"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 193.47,
    y1: 894.3,
    x2: 193.53,
    y2: 894.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 193.53,
    y1: 894.42,
    x2: 193.41,
    y2: 894.36
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "253.53 228.24 253.41 228.18 253.41 228"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "140.25 881.82 139.95 881.7 139.83 881.4"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 139.89,
    y1: 656.88,
    x2: 141.75,
    y2: 644.34
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "305.73 1156.32 303.09 1155.9 300.45 1155.6 295.05 1155.18 289.71 1154.82 284.37 1154.34"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 307.05,
    y1: 1137.78,
    x2: 284.61,
    y2: 1150.98
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "305.91 1152.36 305.79 1152.36 305.73 1152.18"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 194.25,
    y1: 881.1,
    x2: 172.35,
    y2: 893.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 172.11,
    y1: 894.06,
    x2: 172.11,
    y2: 898.62
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M193.41,894.6v3.48l-2.58-.48c-5.62-.79-10.37-.89-15.96.3l-2.76.72"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "285.09 231.9 306.09 219.54 306.09 234.36"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "132.15 1056.66 131.91 1056.6 131.85 1056.36"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "132.15 1056.66 122.31 1072.08 112.47 1087.44 112.29 1087.26 112.17 1087.02"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 284.79,
    y1: 699.9,
    x2: 284.79,
    y2: 696.54
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "267.87 696.54 272.01 697.68 276.21 698.7 278.37 699.12 280.47 699.48 282.63 699.72 284.79 699.9"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 180.93,
    y1: 268.62,
    x2: 187.95,
    y2: 269.88
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "166.41 303.48 166.11 301.44 165.87 300.42 165.57 299.52"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "166.47 292.74 166.71 273.18 166.83 253.68"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "172.23 220.56 193.53 208.02 193.53 222.78"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 193.53,
    y1: 208.02,
    x2: 155.91,
    y2: 179.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 210.21,
    y1: 673.74,
    x2: 210.21,
    y2: 673.62
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "188.07 740.76 187.65 738.12 187.17 735.36 186.75 732.72 186.39 730.02"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 186.57,
    y1: 729.72,
    x2: 186.75,
    y2: 729.72
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "119.31 361.68 119.13 363 118.95 364.26 118.53 366.6"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "117.93 373.02 91.89 385.2 66.03 397.26"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 117.63,
    y1: 372.6,
    x2: 65.67,
    y2: 396.9
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "66.03 397.26 65.79 397.14 65.67 396.9"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 65.61,
    y1: 397.2,
    x2: 66.03,
    y2: 397.26
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "65.61 385.14 91.53 373.02 117.57 360.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "75.15 380.64 96.33 370.8 117.57 360.9"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 186.39,
    y1: 1185.9,
    x2: 186.57,
    y2: 1185.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 180.63,
    y1: 284.4,
    x2: 180.63,
    y2: 279.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 117.75,
    y1: 805.08,
    x2: 118.53,
    y2: 805.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 172.11,
    y1: 894.06,
    x2: 172.35,
    y2: 893.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 172.17,
    y1: 893.94,
    x2: 172.11,
    y2: 893.7
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "140.25 656.94 139.95 656.82 139.83 656.52"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 167.19,
    y1: 554.82,
    x2: 160.35,
    y2: 554.1
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "193.77 219 210.51 209.16 210.51 223.98"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "193.53 222.78 197.79 223.02 201.99 223.32 210.51 223.98"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 210.51,
    y1: 209.16,
    x2: 176.67,
    y2: 193.8
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "253.05 911.16 253.05 911.34 253.17 911.46"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 253.05,
    y1: 911.58,
    x2: 253.05,
    y2: 911.16
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M184.11,241.74l3.12-.48c30.43-3.73,60.85-2.5,91.32-5.34l6.3-.6"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "268.29 230.64 284.85 220.92 284.85 235.32"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 284.85,
    y1: 220.92,
    x2: 269.13,
    y2: 221.7
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "190.83 1193.76 192.03 1198.44 192.57 1200.72 193.23 1203.12 193.83 1206.84"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 289.47,
    y1: 1170.54,
    x2: 266.01,
    y2: 1193.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 285.63,
    y1: 466.68,
    x2: 305.79,
    y2: 464.28
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "183.99 484.02 186.87 483.6 189.75 483.36 192.63 483.18 195.57 483"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 284.97,
    y1: 476.46,
    x2: 305.79,
    y2: 464.28
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M305.79,479.82l-7.38.84-7.44.9-7.38.96-7.26.9-14.82,1.74-3.54.42-3.6.48-7.56.96c-14.77,1.64-29.55,3.09-44.22,5.52l-7.44,1.02-7.38.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "225.03 901.62 225.03 901.8 225.15 901.92"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 224.97,
    y1: 902.04,
    x2: 225.03,
    y2: 902.04
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "125.43 819.6 125.25 819.48 125.19 819.24 107.19 832.74 89.37 846.24"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 125.19,
    y1: 819.24,
    x2: 125.25,
    y2: 819.24
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "89.67 846.66 89.43 846.48 89.37 846.24"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 193.47,
    y1: 952.98,
    x2: 193.41,
    y2: 951.84
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "193.23 950.16 192.69 949.2 192.09 948.18 191.55 947.1 190.95 945.96"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 193.83,
    y1: 951.66,
    x2: 193.23,
    y2: 950.16
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "193.89 954 193.89 952.86 193.83 951.66"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "284.79 476.16 284.85 476.4 284.91 476.46"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "194.49 445.56 194.37 447.12 194.25 448.62 193.95 451.5 193.71 454.32 193.59 455.82 193.47 457.38"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 172.35,
    y1: 458.16,
    x2: 194.25,
    y2: 445.26
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "203.07 468.96 215.55 470.28 228.03 471.36 246.81 473.16 253.05 473.64"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "203.07 468.96 198.69 468.48 194.37 468.06 190.05 467.7 187.95 467.58 185.91 467.52"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "239.01 470.04 245.97 471.9 253.05 473.64"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "253.17 471 253.11 470.88 253.05 470.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 144.99,
    y1: 557.34,
    x2: 144.57,
    y2: 557.52
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M137.31,562.2l-1.44,1.14c-1.42,1.22-2.9,2.41-4.38,3.54l-.96.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M139.11,1105.86l.12-.9c.45-3.82,1.46-7.23,1.92-11.04l.12-.9"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 140.91,
    y1: 1092.6,
    x2: 112.47,
    y2: 1087.44
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "174.09 290.16 173.67 287.64 173.31 286.38 172.89 285.24 172.47 284.04 172.11 282.84 171.63 280.26"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 187.83,
    y1: 257.94,
    x2: 189.63,
    y2: 255.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 174.09,
    y1: 290.52,
    x2: 174.09,
    y2: 290.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 171.93,
    y1: 279.84,
    x2: 171.99,
    y2: 279.84
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "171.69 280.02 171.87 279.9 172.05 279.84"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 174.03,
    y1: 290.4,
    x2: 174.09,
    y2: 290.22
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "268.23 230.64 268.17 230.58 268.11 230.4"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "188.07 961.92 187.65 959.34 187.17 956.7 186.75 954.12 186.39 951.48"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 192.63,
    y1: 952.68,
    x2: 191.25,
    y2: 952.14
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "189.57 965.22 190.35 963.48 191.25 961.8"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 186.57,
    y1: 951.18,
    x2: 186.75,
    y2: 951.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 239.85,
    y1: 669.66,
    x2: 225.21,
    y2: 678.3
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "239.13 683.34 239.07 683.28 239.01 683.04"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 131.25,
    y1: 343.44,
    x2: 133.65,
    y2: 341.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 107.55,
    y1: 174.36,
    x2: 40.17,
    y2: 162.12
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "210.69 220.14 225.33 211.56 225.33 225.84"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "210.51 223.98 214.23 224.34 217.95 224.76 221.67 225.3 225.33 225.84"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 225.33,
    y1: 211.56,
    x2: 205.05,
    y2: 205.62
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "196.41 462.3 191.91 461.4 187.41 460.56"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 224.97,
    y1: 466.26,
    x2: 228.57,
    y2: 467.22
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "239.13 467.16 239.07 467.04 239.01 466.86"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 224.97,
    y1: 466.2,
    x2: 228.51,
    y2: 467.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 148.29,
    y1: 331.74,
    x2: 148.11,
    y2: 331.74
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M208.05,483l9.66-.6c20.75-.87,41.49-1.81,62.22-2.94l4.86-.3"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 285.63,
    y1: 464.04,
    x2: 268.05,
    y2: 474.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 284.79,
    y1: 479.16,
    x2: 284.79,
    y2: 476.58
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "267.87 477 272.01 477.84 276.21 478.56 278.37 478.8 280.47 479.04 282.63 479.16 284.79 479.16"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "148.11 171.84 159.99 190.74 171.93 209.64 163.65 214.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M176.19,224.22l4.86.54c20.82,2.94,41.77,3.53,62.64,6l9.66,1.2v-14.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "239.37 228.9 246.33 230.58 249.87 231.3 253.35 231.96"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 108.81,
    y1: 996.84,
    x2: 92.85,
    y2: 1006.2
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "125.31 386.58 107.37 400.08 89.49 413.58 89.31 413.46 89.25 413.22"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 90.75,
    y1: 401.76,
    x2: 66.03,
    y2: 397.26
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "132.81 832.98 132.57 832.92 132.45 832.68 122.55 848.1 112.71 863.46"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "113.01 863.88 112.77 863.76 112.71 863.46"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "253.53 228.24 268.11 219.66 268.11 234.06"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 171.93,
    y1: 220.74,
    x2: 172.23,
    y2: 220.56
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M171.99,220.38l.3-3.06c.18-1.74.71-3.47.96-5.22l.3-3.06"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 171.99,
    y1: 220.5,
    x2: 171.99,
    y2: 220.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 306.51,
    y1: 919.08,
    x2: 306.45,
    y2: 919.14
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "306.51 919.14 306.39 919.02 306.39 918.78"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 268.05,
    y1: 474.36,
    x2: 267.99,
    y2: 474.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 267.87,
    y1: 474.06,
    x2: 267.87,
    y2: 474.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 268.05,
    y1: 474.36,
    x2: 267.93,
    y2: 474.36
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "267.99 474.36 267.93 474.3 267.87 474.06"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "176.79 780.18 177.81 780 178.83 779.76 179.79 779.4 180.63 778.86"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 284.91,
    y1: 696.42,
    x2: 284.97,
    y2: 696.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 306.51,
    y1: 697.02,
    x2: 306.51,
    y2: 697.08
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "280.65 927.66 280.83 927.6 281.07 927.54 281.67 927.42"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "239.49 225.36 239.43 225.3 239.37 225.12"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 239.85,
    y1: 893.28,
    x2: 225.21,
    y2: 901.92
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "239.13 906.72 239.07 906.6 239.01 906.36"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 252.81,
    y1: 1145.22,
    x2: 238.77,
    y2: 1139.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 253.71,
    y1: 1127.34,
    x2: 238.95,
    y2: 1136.04
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "252.93 1141.74 252.87 1141.62 252.81 1141.44"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "211.29 447.72 211.17 449.34 211.05 450.84 210.75 453.66 210.51 456.54 210.39 458.04 210.27 459.6"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 210.21,
    y1: 459.84,
    x2: 210.21,
    y2: 460.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 193.65,
    y1: 457.68,
    x2: 211.11,
    y2: 447.48
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "193.41 460.86 197.67 461.28 201.87 461.76 206.07 462.36 210.21 463.08"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 209.85,
    y1: 1125.12,
    x2: 210.03,
    y2: 1125.18
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "209.79 1125.3 209.79 1128.9 205.59 1127.7 201.39 1126.68 197.13 1125.78 192.81 1125.12"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 210.81,
    y1: 1110.78,
    x2: 193.05,
    y2: 1121.22
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "209.91 1125.18 209.85 1125.12 209.85 1124.94"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 178.83,
    y1: 741.84,
    x2: 179.07,
    y2: 741.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 166.47,
    y1: 292.74,
    x2: 170.19,
    y2: 291.18
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "208.83 223.86 216.45 225.06 224.13 226.14 227.91 226.68 231.75 227.34 235.53 228.06 239.37 228.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "225.51 222.48 239.37 214.38 239.37 228.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M179.97,474.66l2.16-.18c4.27-.03,8.44.93,12.66,1.2l2.16.12"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 268.71,
    y1: 461.88,
    x2: 253.23,
    y2: 471
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 253.05,
    y1: 473.64,
    x2: 267.87,
    y2: 477
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "188.25 269.58 188.13 268.68 188.07 267.9 187.65 265.62 187.11 263.4 186.63 261.18 186.33 258.9"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 186.69,
    y1: 258.54,
    x2: 188.07,
    y2: 258.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 188.31,
    y1: 258.84,
    x2: 190.83,
    y2: 257.64
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "190.41 256.68 186.51 258.6 186.69 258.54"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 225.03,
    y1: 463.02,
    x2: 224.97,
    y2: 463.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 210.45,
    y1: 459.9,
    x2: 225.87,
    y2: 450.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 224.97,
    y1: 463.44,
    x2: 224.97,
    y2: 466.26
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "141.27 161.28 142.89 180.72 144.63 200.16"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 225.09,
    y1: 463.26,
    x2: 225.21,
    y2: 463.32
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "225.03 463.02 225.03 463.2 225.15 463.32"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 225.21,
    y1: 463.32,
    x2: 224.97,
    y2: 463.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 92.85,
    y1: 785.34,
    x2: 54.27,
    y2: 808.02
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "205.11 687.36 217.11 688.68 223.11 689.22 229.05 689.76 247.05 691.56 253.05 691.98"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "171.21 674.64 173.13 678.6 174.99 682.26"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 253.05,
    y1: 688.14,
    x2: 254.07,
    y2: 675
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 253.05,
    y1: 691.98,
    x2: 253.05,
    y2: 688.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 225.21,
    y1: 678.3,
    x2: 224.97,
    y2: 678.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 92.85,
    y1: 1006.2,
    x2: 54.27,
    y2: 1028.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 188.31,
    y1: 729.96,
    x2: 190.83,
    y2: 728.76
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "241.29 719.64 246.51 717.96 251.79 716.22 257.01 714.42 262.23 712.56"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "179.01 869.58 211.17 884.22 211.29 884.28 211.29 884.52"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 192.81,
    y1: 1121.34,
    x2: 193.05,
    y2: 1121.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 155.91,
    y1: 1078.2,
    x2: 194.07,
    y2: 1106.76
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "117.75 803.58 118.11 800.94 118.53 798.42"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "193.47 457.56 193.65 457.68 193.41 457.8"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "193.53 457.68 193.47 457.56 193.47 457.38"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "253.11 688.44 253.23 688.44 253.05 688.56"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 284.79,
    y1: 918.9,
    x2: 285.81,
    y2: 905.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 183.99,
    y1: 705.06,
    x2: 188.07,
    y2: 716.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 306.33,
    y1: 697.14,
    x2: 307.41,
    y2: 683.58
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M187.95,251.46l1.2,2.76,1.32,2.64,5.16-.6c24.53-3.57,49.2-9.59,73.02-16.5l5.22-1.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M193.35,735.3l3.36-.78c15.08-3.52,28.96-10.73,43.92-14.7l6.78-2.16"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "262.41 712.74 256.53 714.6 250.59 716.58"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 193.41,
    y1: 670.32,
    x2: 193.65,
    y2: 670.2
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "193.53 670.2 193.47 670.08 193.47 669.9"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 139.89,
    y1: 449.88,
    x2: 139.89,
    y2: 446.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 225.03,
    y1: 678,
    x2: 226.05,
    y2: 664.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 224.97,
    y1: 681.84,
    x2: 224.97,
    y2: 678.42
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M225.39,222.24l.18-2.94c.25-1.69.39-3.41.66-5.1l.18-2.94"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 199.89,
    y1: 203.28,
    x2: 226.35,
    y2: 210.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 171.15,
    y1: 1120.14,
    x2: 171.45,
    y2: 1119.96
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "171.15 1123.86 167.43 1123.98 163.65 1124.22"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "148.11 1066.62 160.35 1086.06 172.77 1105.44"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 306.27,
    y1: 230.46,
    x2: 306.39,
    y2: 230.46
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "306.15 230.28 306.33 228.18 306.45 227.16 306.63 226.26 306.75 225.36 306.99 224.4 307.35 222.48"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 286.11,
    y1: 221.28,
    x2: 307.23,
    y2: 218.76
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M175.89,684.42l2.04,4.86,1.02,2.46,1.02,2.58,1.38-.18,1.38-.06c5.48.05,11,1.31,16.44,1.26l2.76.06,5.52-.06c16.46.45,32.92.59,49.38,1.08l5.52.12h5.52"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 267.87,
    y1: 692.76,
    x2: 268.89,
    y2: 679.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 65.55,
    y1: 1051.02,
    x2: 65.55,
    y2: 1064.04
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "163.65 465.48 165.75 464.28 167.91 463.32 170.01 462.48 172.11 461.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M139.89,449.88l2.94,1.98c6.61,4.6,12.45,8.45,19.38,12.6l1.44,1.02"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "148.11 406.38 160.53 426.06 173.13 445.8"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "307.41 463.68 307.23 465.66 307.11 466.62 306.99 467.52 306.75 469.2 306.39 471.06"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 305.79,
    y1: 476.34,
    x2: 306.09,
    y2: 476.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 285.69,
    y1: 466.02,
    x2: 306.03,
    y2: 463.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 238.83,
    y1: 1135.98,
    x2: 238.95,
    y2: 1136.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 170.49,
    y1: 1126.92,
    x2: 168.69,
    y2: 1123.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 238.77,
    y1: 1136.16,
    x2: 238.95,
    y2: 1136.04
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M238.77,1135.8l.06-.96c.23-4.01.75-7.92.96-11.94l.06-.96"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 210.51,
    y1: 220.26,
    x2: 210.69,
    y2: 220.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 173.01,
    y1: 191.04,
    x2: 211.59,
    y2: 208.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 193.53,
    y1: 219.12,
    x2: 193.77,
    y2: 219
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 155.91,
    y1: 178.2,
    x2: 194.79,
    y2: 207.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 172.11,
    y1: 894.06,
    x2: 172.17,
    y2: 893.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M172.11,898.62l-2.1.66-2.16.84-2.1.84-2.1,1.02-3-2.04c-6.48-3.86-12.02-7.12-17.82-11.94l-2.94-2.34"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "148.11 841.26 160.53 860.94 173.13 880.68"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 155.91,
    y1: 627.72,
    x2: 194.43,
    y2: 656.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 253.05,
    y1: 911.16,
    x2: 254.07,
    y2: 898.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 156.09,
    y1: 780.12,
    x2: 157.77,
    y2: 780.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 139.89,
    y1: 885.66,
    x2: 139.89,
    y2: 881.76
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "141.27 830.94 141.45 850.2 141.75 869.46"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 284.97,
    y1: 231.9,
    x2: 285.09,
    y2: 231.9
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "286.11 220.26 286.17 220.38 286.17 220.5 286.11 221.58"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 284.85,
    y1: 232.02,
    x2: 285.09,
    y2: 231.9
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "118.53 1020.72 119.13 1017.24 119.55 1013.76"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 117.75,
    y1: 1012.98,
    x2: 65.55,
    y2: 1037.16
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "172.35 458.16 172.11 458.28 172.11 457.86"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "285.75 1136.76 285.33 1141.38 284.85 1146.06"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "188.07 716.82 189.45 720.66 190.23 722.52 190.95 724.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M301.53,706.02l-1.86-.48c-4.58-.97-9.63-1.18-14.28-.78h-.06"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "210.27 459.6 210.27 459.78 210.33 459.9 210.21 459.84"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 210.33,
    y1: 459.9,
    x2: 210.45,
    y2: 459.9
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "287.55 465.78 287.43 465.84 287.67 465.78"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 267.93,
    y1: 915.72,
    x2: 268.05,
    y2: 915.72
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "188.31 274.5 194.37 271.74 197.43 270.3 200.43 268.74 203.49 267.12 206.55 265.44 212.61 261.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "224.79 1130.34 224.91 1130.34 224.67 1130.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M224.73,1130.1l.06-.9c.21-4.04.72-7.97.96-12l.06-.9"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 91.47,
    y1: 209.94,
    x2: 91.47,
    y2: 184.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 210.27,
    y1: 673.32,
    x2: 211.29,
    y2: 660.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 180.09,
    y1: 645.84,
    x2: 211.17,
    y2: 659.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 159.15,
    y1: 318.24,
    x2: 158.85,
    y2: 318.36
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "117.75 578.64 118.11 575.88 118.53 573.24"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 117.75,
    y1: 565.98,
    x2: 65.55,
    y2: 590.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 267.93,
    y1: 693,
    x2: 268.05,
    y2: 693
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "163.65 676.98 165.75 676.02 167.91 675.18 170.01 674.46 172.11 673.92"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "148.11 616.38 160.53 636.12 173.13 655.8"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 267.69,
    y1: 1146.96,
    x2: 267.81,
    y2: 1146.96
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "179.85 1146.9 177.81 1142.1 175.77 1137.48"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "268.77 1132.8 268.47 1136.76 268.29 1138.56 268.23 1139.4 268.11 1140.36"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 267.57,
    y1: 1147.08,
    x2: 267.81,
    y2: 1146.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 180.87,
    y1: 529.14,
    x2: 180.63,
    y2: 529.14
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M193.47,266.16l3.12-.84c13.69-3.79,26.68-9.87,40.2-14.34l6.24-2.1"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "226.05 888.84 225.81 892.14 225.51 895.44 225.27 898.68 224.97 902.04"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "125.85 593.88 107.91 607.38 90.03 620.88"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 65.55,
    y1: 603.12,
    x2: 65.55,
    y2: 616.2
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "193.53 894.42 193.47 894.3 193.47 894.18"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 253.35,
    y1: 228.3,
    x2: 253.53,
    y2: 228.24
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M253.41,228l.18-3c.22-1.68.49-3.35.66-5.04l.24-3"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 112.65,
    y1: 638.64,
    x2: 112.65,
    y2: 642.12
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "141.27 605.76 141.45 625.02 141.75 644.28"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 305.85,
    y1: 1152.36,
    x2: 306.03,
    y2: 1152.36
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "187.71 1178.28 185.85 1168.62 184.83 1163.88 184.35 1161.54 183.75 1159.26"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "307.35 1138.02 307.11 1140.72 306.75 1143.48 306.63 1144.74 306.45 1145.82 306.33 1146.96 306.15 1148.28"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 305.73,
    y1: 1152.54,
    x2: 306.03,
    y2: 1152.36
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "194.49 881.34 194.19 884.7 193.95 887.94 193.71 891.24 193.41 894.6"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 155.91,
    y1: 852.3,
    x2: 194.43,
    y2: 881.1
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "184.11 241.74 187.95 251.46 191.67 250.5 195.33 249.66 202.71 248.16 210.15 246.9 217.53 245.7 224.91 244.68 232.29 243.78 247.05 241.92 261.81 239.82 269.19 238.8 276.57 237.84 291.33 236.1 298.71 235.26 306.09 234.36"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 306.09,
    y1: 219.54,
    x2: 286.05,
    y2: 221.94
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "183.99 705.06 185.49 704.58 187.05 704.28 188.61 704.04 190.23 703.98 193.35 703.92 196.47 704.04 199.65 704.16 202.77 704.22 205.89 704.1 209.07 703.92 215.37 703.44 221.67 703.14 228.09 702.84 234.15 702.6"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 284.79,
    y1: 696.54,
    x2: 285.81,
    y2: 682.92
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "180.93 283.98 183.63 281.7 186.33 279.66 191.73 275.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 166.47,
    y1: 303.84,
    x2: 166.05,
    y2: 303.96
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "164.25 294.06 164.49 273.9 164.67 253.74"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 284.91,
    y1: 918.78,
    x2: 284.97,
    y2: 918.78
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "284.79 918.48 284.85 918.72 284.91 918.78"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 284.97,
    y1: 918.78,
    x2: 284.79,
    y2: 918.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M171.93,224.22l5.4-.84c4.56-.59,8.91-.77,13.5-.72l2.7.12"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "210.27 673.32 210.27 673.56 210.33 673.62 210.21 673.62"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 210.33,
    y1: 673.62,
    x2: 210.45,
    y2: 673.62
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "118.53 366.6 118.05 369.42 117.87 370.98 117.63 372.6"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "186.21 1186.2 186.27 1186.02 186.39 1185.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "188.07 1198.98 187.65 1195.74 187.11 1192.5 186.63 1189.44 186.21 1186.2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 65.85,
    y1: 829.32,
    x2: 65.85,
    y2: 843.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 154.41,
    y1: 331.5,
    x2: 154.17,
    y2: 331.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 108.81,
    y1: 300.3,
    x2: 91.53,
    y2: 288.48
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "179.97 917.22 177.99 912.36 175.89 907.68"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 267.87,
    y1: 915.42,
    x2: 268.89,
    y2: 902.58
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "187.77 494.46 185.91 489.12 184.95 486.54 183.99 484.02"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 305.79,
    y1: 479.82,
    x2: 305.79,
    y2: 464.28
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "225.09 901.86 225.21 901.92 224.97 902.04"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "125.13 806.58 107.19 820.14 89.31 833.58"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "182.91 778.32 182.37 778.56 181.89 778.68 181.35 778.74 180.87 778.62"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "188.07 938.94 186.03 933.36 183.99 927.72"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 306.39,
    y1: 918.78,
    x2: 307.41,
    y2: 906
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 306.33,
    y1: 923.58,
    x2: 306.33,
    y2: 919.2
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "284.79 476.16 284.79 476.58 284.97 476.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M172.11,461.88l1.38-.3c5.16-1.18,11.96-1.05,17.28-.9l2.64.18"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 155.91,
    y1: 416.46,
    x2: 194.43,
    y2: 445.26
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "175.89 466.32 178.41 466.56 180.93 466.86 185.91 467.52"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 253.05,
    y1: 471.12,
    x2: 253.23,
    y2: 471
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 253.05,
    y1: 470.7,
    x2: 254.07,
    y2: 458.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 148.53,
    y1: 527.34,
    x2: 147.57,
    y2: 527.28
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "159.33 554.04 162.99 554.34 166.59 554.58 168.39 554.58 170.19 554.52 171.93 554.34 173.67 553.98"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "140.79 1054.8 140.97 1073.88 141.27 1092.96"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 174.09,
    y1: 290.52,
    x2: 173.73,
    y2: 290.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 268.11,
    y1: 230.76,
    x2: 268.29,
    y2: 230.64
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M268.11,230.4l.24-2.94c.21-1.72.5-3.38.72-5.1l.24-3"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 188.31,
    y1: 964.44,
    x2: 188.07,
    y2: 964.38
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "196.53 679.14 192.33 678.3 188.19 677.58 184.05 676.92 180.03 676.32"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 239.07,
    y1: 683.34,
    x2: 239.19,
    y2: 683.34
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "171.21 674.64 173.43 675 175.65 675.42 180.03 676.32"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 239.01,
    y1: 683.46,
    x2: 239.19,
    y2: 683.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 239.01,
    y1: 683.04,
    x2: 240.03,
    y2: 669.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 96.69,
    y1: 159.54,
    x2: 90.33,
    y2: 158.88
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "239.07 467.1 239.19 467.16 239.01 467.28"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "239.01 466.86 239.13 465.3 239.31 463.8 239.55 460.92 239.79 458.04 239.91 456.54 240.03 454.98"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 148.11,
    y1: 351.84,
    x2: 149.19,
    y2: 350.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 152.25,
    y1: 344.94,
    x2: 152.85,
    y2: 343.92
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "210.27 897.3 210.27 897.48 210.33 897.6"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 210.45,
    y1: 897.6,
    x2: 210.21,
    y2: 897.72
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M183.99,483.84l1.38-.42c5.79-1.39,12.64.23,18.66-.24l2.88-.12"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 284.79,
    y1: 476.16,
    x2: 285.81,
    y2: 464.28
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "171.93 209.64 171.93 224.22 163.65 225.6"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "142.41 222.6 147.75 223.14 153.03 223.86 158.31 224.64 163.65 225.6"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "190.83 1193.76 189.99 1189.98 189.21 1186.08 187.71 1178.28"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 65.61,
    y1: 397.2,
    x2: 65.61,
    y2: 411.3
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "112.65 850.8 122.49 835.44 132.45 820.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M176.19,224.22l2.04,4.08,1.98,4.2h2.76c24.72.55,49.44.78,74.16,1.5l10.98.06"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "148.41 168.96 160.89 188.94 173.55 208.86"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 306.33,
    y1: 919.2,
    x2: 306.51,
    y2: 919.08
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "284.79 696.12 284.85 696.3 284.91 696.42"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 284.97,
    y1: 696.42,
    x2: 284.79,
    y2: 696.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 306.51,
    y1: 697.02,
    x2: 306.33,
    y2: 697.08
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "306.51 697.08 306.39 696.96 306.33 696.72"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "140.25 446.94 139.95 446.82 139.83 446.52"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "190.95 945.96 190.23 944.28 189.45 942.54 188.07 938.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M300.03,927.36l-2.46-.3-2.46-.18h-1.26l-1.2-.06-1.38.06h-1.38l-3,.12-3,.24c-.99.11-2.17.29-3.18.36l-.12.06h-.06"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "190.83 502.92 190.05 500.94 189.27 498.9 187.77 494.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M308.61,480.42l-.84.06-.96.06c-9.74.48-20.39,1.94-30,3.9l-1.26.24-.54.12-.42.12c-5.1,1.17-10.24,2.31-15.36,3.42l-15.84,3.6c-14.22,2.32-27.82,7.37-42.06,9.54l-5.22.84-2.64.36-2.64.24"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 239.43,
    y1: 225.36,
    x2: 239.55,
    y2: 225.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M239.37,225.12l.24-2.94c.13-1.7.5-3.39.6-5.1l.24-2.94"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 239.37,
    y1: 225.48,
    x2: 239.55,
    y2: 225.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 239.01,
    y1: 906.78,
    x2: 239.19,
    y2: 906.66
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "240.03 893.58 239.79 896.82 239.55 900 239.31 903.12 239.01 906.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M252.81,1141.44l.12-1.56c.24-3.13.48-6.23.78-9.36l.06-.78"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 252.81,
    y1: 1141.8,
    x2: 252.99,
    y2: 1141.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 175.89,
    y1: 431.4,
    x2: 211.17,
    y2: 447.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 209.79,
    y1: 1125.3,
    x2: 210.03,
    y2: 1125.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M209.85,1124.94l.06-.96c.21-4.01.77-7.99,1.02-12l.06-.9"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 181.71,
    y1: 1097.52,
    x2: 210.87,
    y2: 1110.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 174.15,
    y1: 290.52,
    x2: 174.15,
    y2: 293.04
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M203.85,475.8l4.02-.06c18.66.57,37.32.79,55.98,1.32l4.02-.06"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 203.85,
    y1: 475.8,
    x2: 196.95,
    y2: 475.8
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "175.89 466.32 177.93 470.4 178.95 472.5 179.97 474.66"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 267.87,
    y1: 474.06,
    x2: 268.89,
    y2: 462.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 286.11,
    y1: 221.22,
    x2: 289.23,
    y2: 220.56
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "226.05 451.14 225.93 452.7 225.81 454.2 225.51 457.08 225.27 459.96 225.15 461.46 225.03 463.02"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg005);
export default __webpack_public_path__ + "static/media/005.6cce7624fb5a89e6d7a2ad9e61116b77.svg";
export { ForwardRef as ReactComponent };